import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: { [key: string]: any } | any[]; output: { [key: string]: any } | any[]; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: { [key: string]: any }; output: { [key: string]: any }; }
};

/** Account entity */
export type Account = {
  __typename?: 'Account';
  /** Creation date of the account */
  createdAt: Scalars['DateTime']['output'];
  /** Document number of the account */
  documentNumber: Scalars['String']['output'];
  /** Expiration date of the account */
  expiredAt: Scalars['DateTime']['output'];
  /** ID of the account */
  id: Scalars['ID']['output'];
  /** Is the account active */
  isActive: Scalars['Boolean']['output'];
  /** Name of the account */
  name: Scalars['String']['output'];
  /** Update date of the account */
  updatedAt: Scalars['DateTime']['output'];
};

/** Representa uma funcionalidade contratada por uma conta no sistema */
export type AccountFeature = {
  __typename?: 'AccountFeature';
  /** Data de ativação da funcionalidade da conta */
  activatedAt: Scalars['DateTime']['output'];
  /** Data de cancelamento da funcionalidade da conta */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Preço contratado da funcionalidade em centavos */
  contractedPriceCents: Scalars['Int']['output'];
  /** Data de criação da funcionalidade da conta */
  createdAt: Scalars['DateTime']['output'];
  /** Data de início do período atual da funcionalidade da conta */
  currentPeriodStartsAt: Scalars['DateTime']['output'];
  /** Funcionalidade vinculada a conta */
  feature: Feature;
  /** Identificador único da funcionalidade da conta */
  id: Scalars['ID']['output'];
  /** Limite da funcionalidade do tipo licença atrelada a uma entidade */
  licenseLimit?: Maybe<Scalars['Int']['output']>;
  /** Orçamento de uso da funcionalidade do tipo medido em centavos */
  meteredBudgetCents?: Maybe<Scalars['Int']['output']>;
  /** Status da funcionalidade da conta */
  status: AccountFeatureStatus;
  /** Records de uso da funcionalidade vinculada a conta */
  usageRecords: PaginatedAccountFeatureUsageRecord;
};


/** Representa uma funcionalidade contratada por uma conta no sistema */
export type AccountFeatureUsageRecordsArgs = {
  filters?: InputMaybe<PaginatedAccountFeatureUsageRecordFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAccountFeatureUsageRecordSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Representa uma funcionalidade contratada por uma conta no sistema */
export type AccountFeatureActive = {
  __typename?: 'AccountFeatureActive';
  /** Data de ativação da funcionalidade da conta */
  activatedAt: Scalars['DateTime']['output'];
  /** Data de criação da funcionalidade da conta */
  createdAt: Scalars['DateTime']['output'];
  /** Funcionalidade vinculada a conta */
  feature: Feature;
  /** Identificador único da funcionalidade da conta */
  id: Scalars['ID']['output'];
  /** Status da funcionalidade da conta */
  status: AccountFeatureStatus;
};

export type AccountFeatureEdge = {
  __typename?: 'AccountFeatureEdge';
  cursor: Scalars['String']['output'];
  node: AccountFeature;
};

/** O status da funcionalidade da conta */
export enum AccountFeatureStatus {
  /** Funcionalidade ativa */
  Active = 'ACTIVE',
  /** Funcionalidade inativa */
  Inactive = 'INACTIVE',
  /** Limite da funcionalidade atingido */
  LimitReached = 'LIMIT_REACHED'
}

/** Representa uma funcionalidade contratada por uma conta no sistema */
export type AccountFeatureUsageRecord = {
  __typename?: 'AccountFeatureUsageRecord';
  /** Data de criação do registro de uso da funcionalidade da conta */
  createdAt: Scalars['DateTime']['output'];
  /** ID do registro de uso da funcionalidade da conta */
  id: Scalars['String']['output'];
  /** ID da entidade licenciada */
  licenseEntityId?: Maybe<Scalars['String']['output']>;
  /** Quantidade de uso da funcionalidade da conta */
  usageAmount: Scalars['Float']['output'];
};

export type AccountFeatureUsageRecordEdge = {
  __typename?: 'AccountFeatureUsageRecordEdge';
  cursor: Scalars['String']['output'];
  node: AccountFeatureUsageRecord;
};

export type AccountPublic = {
  __typename?: 'AccountPublic';
  /** Name of the account */
  name: Scalars['String']['output'];
};

export type AddCardTaskAssigneeInput = {
  cardTaskId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type AddCardTaskAssigneesInput = {
  /** ID da tarefa */
  cardTaskId: Scalars['ID']['input'];
  /** IDs dos novos responsáveis */
  newAssigneesIds: Array<Scalars['ID']['input']>;
};

/** Entrada para adicionar um campo ao esquema do banco de dados */
export type AddDatabaseSchemaFieldInput = {
  /** ID do esquema do banco de dados */
  databaseSchemaId: Scalars['ID']['input'];
  /** Campo a ser adicionado ao esquema do banco de dados */
  field: DatabaseFieldInput;
};

/** Add or remove card task label */
export type AddOrRemoveCardTaskLabelDto = {
  /** The id of the pipe label */
  labelId: Scalars['ID']['input'];
  /** The id of the card task */
  taskId: Scalars['ID']['input'];
};

/** Answer card task field */
export type AnswerCardTaskFieldInput = {
  /** The id of the field */
  id: Scalars['String']['input'];
  /** A single value */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Multiple values */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ApproveReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type AssigneeInput = {
  userId: Scalars['ID']['input'];
};

/** The attachment field */
export type AttachmentField = FieldType & {
  __typename?: 'AttachmentField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export type AttributesCardInput = {
  /** The description of the card */
  description?: InputMaybe<FieldMapInput>;
  /** The name of the card */
  name: FieldMapInput;
};

export type AuthenticatedUser = {
  __typename?: 'AuthenticatedUser';
  accountId?: Maybe<Scalars['String']['output']>;
  mfaToken?: Maybe<Scalars['String']['output']>;
  realtimeToken?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Automation = {
  __typename?: 'Automation';
  /** The action to be performed when the event is triggered */
  action: AutomationAction;
  actions: Array<AutomationAction>;
  /** The status of the automation */
  active: Scalars['Boolean']['output'];
  /** The archive status of the automation */
  archived: Scalars['Boolean']['output'];
  /** The date the automation was created */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the automation */
  description?: Maybe<Scalars['String']['output']>;
  /** The event that triggers the automation */
  event: Scalars['String']['output'];
  /** The ID of the automation */
  id: Scalars['ID']['output'];
  /** The flag to define the automation as synchronous */
  isSync: Scalars['Boolean']['output'];
  /** The name of the automation */
  name: Scalars['String']['output'];
  /** The direction of the automation */
  runDirection?: Maybe<Scalars['String']['output']>;
  /** The flag to run the automation only once */
  runOnlyOnce?: Maybe<Scalars['Boolean']['output']>;
  /** The stage to attach the automation */
  stage: Stage;
  /** The date the automation was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Interface of automation actions */
export type AutomationAction = {
  /** The ID of the automation action */
  id: Scalars['ID']['output'];
  /** The type of the automation action */
  type: Scalars['String']['output'];
};

/** The parameters to assign a person in a task */
export type AutomationActionAssigneePersonData = AutomationAction & {
  __typename?: 'AutomationActionAssigneePersonData';
  /** There one or more person to assignee in tasks */
  assignees: Array<User>;
  /** The ID of the automation action */
  id: Scalars['ID']['output'];
  /** The type of the automation action */
  type: Scalars['String']['output'];
  /** The type of assignee person automation: fixed | round_robin */
  typeAssignee: Scalars['String']['output'];
};

/** The parameters to perform a assignee person */
export type AutomationActionAssigneesInput = {
  /** The id of the person */
  id: Scalars['String']['input'];
};

export type AutomationActionCreateCardData = AutomationAction & {
  __typename?: 'AutomationActionCreateCardData';
  /** The description of the card */
  description: Scalars['String']['output'];
  /** Fields of the card */
  fields?: Maybe<Scalars['JSON']['output']>;
  form_id: Scalars['String']['output'];
  /** The ID of the automation action */
  id: Scalars['ID']['output'];
  /** The name of the card */
  name: Scalars['String']['output'];
  pipe: Pipe;
  /** The pipe of card */
  pipe_id: Scalars['ID']['output'];
  stage: Stage;
  /** The stage of card */
  stage_id: Scalars['ID']['output'];
  /** The type of the automation action */
  type: Scalars['String']['output'];
};

/** Data of the automation action to create a task */
export type AutomationActionCreateTaskData = AutomationAction & {
  __typename?: 'AutomationActionCreateTaskData';
  /** The ID of the automation action */
  id: Scalars['ID']['output'];
  /** The template of the task */
  templates: Array<AutomationActionCreateTaskDataTemplate>;
  /** The type of the automation action */
  type: Scalars['String']['output'];
};

export type AutomationActionCreateTaskDataDueAt = {
  __typename?: 'AutomationActionCreateTaskDataDueAt';
  /** Amount of time */
  amount: Scalars['Float']['output'];
  /** Flags for the due date */
  flags: Scalars['Float']['output'];
  /** Time unit */
  unit: Scalars['String']['output'];
};

export type AutomationActionCreateTaskDataTemplate = {
  __typename?: 'AutomationActionCreateTaskDataTemplate';
  /** The description of the task */
  description?: Maybe<Scalars['String']['output']>;
  /** The due date of the task */
  dueAt?: Maybe<AutomationActionCreateTaskDataDueAt>;
  /** The priority of the task */
  priority?: Maybe<CardTaskPriorityEnum>;
  /** The title of the task */
  title: Scalars['String']['output'];
};

/** The parameters to perform an HTTP request */
export type AutomationActionHttpRequestData = AutomationAction & {
  __typename?: 'AutomationActionHttpRequestData';
  /** The authentication to use in the request */
  authentication?: Maybe<AutomationActionParamHttpAuth>;
  /** The data to send in the request */
  body?: Maybe<Scalars['String']['output']>;
  /** The status code to expect in the response */
  expected_status_code: Scalars['Float']['output'];
  /** The headers to send in the request */
  headers?: Maybe<Scalars['String']['output']>;
  /** The ID of the automation action */
  id: Scalars['ID']['output'];
  /** The HTTP method to use */
  method: Scalars['String']['output'];
  /** The type of the automation action */
  type: Scalars['String']['output'];
  /** The URL to perform the request */
  url: Scalars['String']['output'];
};

export type AutomationActionParamAssigneeInput = {
  /** The persons to assignees */
  assignees: Array<InputMaybe<AutomationActionAssigneesInput>>;
  /** The type of assignee person */
  type_assignee: Scalars['String']['input'];
};

/** The parameters to perform a create card */
export type AutomationActionParamCreateCardInput = {
  /** The priority of the task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fields of the card */
  fields?: InputMaybe<Array<AutomationActionParamField>>;
  /** The form id of the card */
  form_id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the card */
  name: Scalars['String']['input'];
  /** The pipe of the card */
  pipe_id: Scalars['ID']['input'];
  /** The stage of the card */
  stage_id: Scalars['ID']['input'];
};

/** The parameters of the due date of the task */
export type AutomationActionParamCreateTaskDueAtInput = {
  /** Amount of time */
  amount: Scalars['Int']['input'];
  /** Flags related to this due date */
  flags: Scalars['Int']['input'];
  /** Time unit */
  unit: AutomationActionParamCreateTaskInputDueAtUnitEnum;
};

/** The parameters to perform a create task */
export type AutomationActionParamCreateTaskInput = {
  /** The priority of the task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The due date of the task */
  dueAt?: InputMaybe<AutomationActionParamCreateTaskDueAtInput>;
  /** The priority of the task */
  priority?: InputMaybe<CardTaskPriorityEnum>;
  /** The title of the task */
  title: Scalars['String']['input'];
};

/** The time unit of the due date of the task */
export enum AutomationActionParamCreateTaskInputDueAtUnitEnum {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week'
}

/** The fields to response form a create card action */
export type AutomationActionParamField = {
  /** The question id of the field */
  question_id: Scalars['ID']['input'];
  /** The type of the field */
  type: LegacyFieldTypeEnum;
  /** The answer id of the field */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The authentication input to perform an HTTP request */
export type AutomationActionParamHttpAuth = {
  __typename?: 'AutomationActionParamHttpAuth';
  /** The api key to send in the request */
  authentication_api_key?: Maybe<Scalars['String']['output']>;
  /** The api value to send in the request */
  authentication_api_value?: Maybe<Scalars['String']['output']>;
  /** The authentication token to use in the request */
  authentication_token?: Maybe<Scalars['String']['output']>;
  /** The authentication type to use in the request */
  authentication_type?: Maybe<Scalars['String']['output']>;
};

/** The authentication input to perform an HTTP request */
export type AutomationActionParamHttpAuthInput = {
  /** The api key to send in the request */
  authentication_api_key?: InputMaybe<Scalars['String']['input']>;
  /** The api value to send in the request */
  authentication_api_value?: InputMaybe<Scalars['String']['input']>;
  /** The authentication token to use in the request */
  authentication_token?: InputMaybe<Scalars['String']['input']>;
  /** The authentication type to use in the request */
  authentication_type?: InputMaybe<Scalars['String']['input']>;
};

/** The parameters to perform an HTTP request */
export type AutomationActionParamHttpRequestInput = {
  /** The authentication to use in the request */
  authentication?: InputMaybe<AutomationActionParamHttpAuthInput>;
  /** The data to send in the request */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The status code to expect in the response */
  expected_status_code: Scalars['Int']['input'];
  /** The headers to send in the request */
  headers?: InputMaybe<Scalars['String']['input']>;
  /** The HTTP method to use */
  method: Scalars['String']['input'];
  /** The URL to perform the request */
  url: Scalars['String']['input'];
};

export type AutomationActionParamsInput = {
  /** Fields to assignees person */
  assignee_person?: InputMaybe<AutomationActionParamAssigneeInput>;
  /** Fields to create card related */
  createCardRelatedParams?: InputMaybe<CreateCardRelatedActionParams>;
  /** Fields create in the task */
  create_task?: InputMaybe<Array<AutomationActionParamCreateTaskInput>>;
  /** The fields to create in the card */
  fields_create_card?: InputMaybe<AutomationActionParamCreateCardInput>;
  /** The fields to update in the card */
  fields_update_card?: InputMaybe<AutomationActionParamCreateCardInput>;
  /** Fields to http request */
  http_request_params?: InputMaybe<AutomationActionParamHttpRequestInput>;
  /** The ID of the stage to move or create the card */
  to_stage_id?: InputMaybe<Scalars['String']['input']>;
};

/** The type of automation action */
export enum AutomationActionType {
  /** Atribui usuários a um card. */
  AddCardAssignee = 'ADD_CARD_ASSIGNEE',
  /** Adiciona um comentário a um card. */
  AddCardComment = 'ADD_CARD_COMMENT',
  /** Adiciona uma etiqueta a um card pelo ID ou nome. */
  AddCardLabel = 'ADD_CARD_LABEL',
  /** Adiciona variáveis personalizadas para serem usadas em automações. */
  AddCustomVariables = 'ADD_CUSTOM_VARIABLES',
  /** Cria um prazo para um card. */
  CreateCardDeadline = 'CREATE_CARD_DEADLINE',
  /** Cria uma revisão para um card. */
  CreateCardReview = 'CREATE_CARD_REVIEW',
  /** Cria uma tarefa dentro de um card. */
  CreateCardTask = 'CREATE_CARD_TASK',
  /** Cria um card relacionado ao card atual. */
  CreateRelatedCard = 'CREATE_RELATED_CARD',
  /** Gera um documento com base em parâmetros especificados. */
  GenerateDocument = 'GENERATE_DOCUMENT',
  /** Faz uma requisição HTTP para uma URL especificada. */
  MakeHttpRequest = 'MAKE_HTTP_REQUEST',
  /** Move um card para uma etapa especificada. */
  MoveCardToStage = 'MOVE_CARD_TO_STAGE',
  /** Remove usuários de um card. */
  RemoveCardAssignee = 'REMOVE_CARD_ASSIGNEE',
  /** Remove uma etiqueta de um card pelo ID ou nome. */
  RemoveCardLabel = 'REMOVE_CARD_LABEL',
  /** Solicita alterações do formulário inicial ao solicitante. */
  RequestSolicitationChanges = 'REQUEST_SOLICITATION_CHANGES',
  /** Retorna uma aprovação com status de 'alterações solicitadas' para 'pendente'. */
  ResubmitForApproval = 'RESUBMIT_FOR_APPROVAL',
  /** Envia um e-mail para os destinatários especificados. */
  SendEmail = 'SEND_EMAIL',
  /** Alterna o estado de arquivamento de um card. */
  ToggleCardArchived = 'TOGGLE_CARD_ARCHIVED',
  /** Alterna o estado de bloqueio de um card. */
  ToggleCardLock = 'TOGGLE_CARD_LOCK',
  /** Atualiza o valor de um campo específico em um card. */
  UpdateCardFieldValue = 'UPDATE_CARD_FIELD_VALUE',
  /** Atualiza o nome de um card. */
  UpdateCardName = 'UPDATE_CARD_NAME',
  /** Atualiza o status de uma tarefa dentro de um card. */
  UpdateCardTaskStatus = 'UPDATE_CARD_TASK_STATUS'
}

/** The entity type for automation autocomplete */
export enum AutomationAutocompleteEntity {
  /** Entidade de autocompletar para modelos de prazo */
  DeadlineTemplate = 'DEADLINE_TEMPLATE',
  /** Entidade de autocompletar para perguntas de formulário */
  FormQuestion = 'FORM_QUESTION',
  /** Entidade de autocompletar para etiquetas */
  Label = 'LABEL',
  /** Entidade de autocompletar para pipes */
  Pipe = 'PIPE',
  /** Entidade de autocompletar para membros do pipe */
  PipeMember = 'PIPE_MEMBER',
  /** Entidade de autocompletar para modelos de revisão */
  ReviewTemplate = 'REVIEW_TEMPLATE',
  /** Entidade de autocompletar para etapas */
  Stage = 'STAGE',
  /** Entidade de autocompletar para modelos de tarefa */
  TaskTemplate = 'TASK_TEMPLATE',
  /** Entidade de autocompletar para usuários */
  User = 'USER'
}

export type AutomationDocContent = {
  __typename?: 'AutomationDocContent';
  actionType?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AutomationExecution = {
  __typename?: 'AutomationExecution';
  /** Actions of the automation execution */
  actions: Array<AutomationExecutionAction>;
  /** Automation of the automation execution */
  automation: Automation;
  /** The date the automation execution was created */
  createdAt: Scalars['DateTime']['output'];
  /** Direction of the automation execution */
  direction: StageAutomationExecutionsRunDirection;
  /** The ID of the automation execution */
  id: Scalars['ID']['output'];
  /** Status of the automation execution */
  status: StageAutomationExecutionsActionsStatus;
};

export type AutomationExecutionAction = {
  __typename?: 'AutomationExecutionAction';
  /** The date the automation execution action was created */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the automation execution action */
  id: Scalars['ID']['output'];
  /** Whether the automation execution action is sync */
  isSync: Scalars['Boolean']['output'];
  /** The date the automation execution action was created */
  lastHeartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  /** Logs of the automation execution action */
  logs: Array<AutomationExecutionActionLog>;
  /** Status of the automation execution action */
  status: StageAutomationExecutionsActionsStatus;
  /** Type of the automation execution action */
  type: StageAutomationActionTypeEnum;
};

export type AutomationExecutionActionLog = {
  __typename?: 'AutomationExecutionActionLog';
  /** The date the automation execution action log was created */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the automation execution action log */
  id: Scalars['ID']['output'];
  /** Message of the automation execution action log */
  message: Scalars['String']['output'];
  /** Status of the automation execution action log */
  status: StageAutomationExecutionsActionsStatus;
};

/** The status of an automation execution action */
export enum AutomationExecutionActionStatus {
  /** The automation execution has failed. */
  Failed = 'failed',
  /** The automation execution is pending and has not started yet. */
  Pending = 'pending',
  /** The automation execution has been skipped. */
  Skipped = 'skipped',
  /** The automation execution has completed successfully. */
  Success = 'success'
}

/** The status of an automation execution */
export enum AutomationExecutionStatus {
  /** The automation execution has been cancelled. */
  Cancelled = 'cancelled',
  /** The automation execution has completed successfully. */
  Completed = 'completed',
  /** The automation execution has failed. */
  Failed = 'failed',
  /** The automation execution is pending and has not started yet. */
  Pending = 'pending',
  /** The automation execution is currently running. */
  Running = 'running'
}

/** Supported languages for automation metadata definitions */
export enum AutomationMetadataDefinitionLang {
  /** English (United States) */
  EnUs = 'en_US',
  /** Spanish (Spain) */
  EsEs = 'es_ES',
  /** Portuguese (Brazil) */
  PtBr = 'pt_BR'
}

/** The status of the automation */
export enum AutomationStatusEnum {
  /** The automation is currently active and running */
  Active = 'active',
  /** The automation has been archived and is no longer active */
  Archived = 'archived',
  /** The automation is currently inactive and not running */
  Inactive = 'inactive'
}

/** The type of automation trigger or action */
export enum AutomationTriggerAndActionType {
  /** Atribui usuários a um card. */
  AddCardAssignee = 'ADD_CARD_ASSIGNEE',
  /** Adiciona um comentário a um card. */
  AddCardComment = 'ADD_CARD_COMMENT',
  /** Adiciona uma etiqueta a um card pelo ID ou nome. */
  AddCardLabel = 'ADD_CARD_LABEL',
  /** Adiciona variáveis personalizadas para serem usadas em automações. */
  AddCustomVariables = 'ADD_CUSTOM_VARIABLES',
  /** Cria um prazo para um card. */
  CreateCardDeadline = 'CREATE_CARD_DEADLINE',
  /** Cria uma revisão para um card. */
  CreateCardReview = 'CREATE_CARD_REVIEW',
  /** Cria uma tarefa dentro de um card. */
  CreateCardTask = 'CREATE_CARD_TASK',
  /** Cria um card relacionado ao card atual. */
  CreateRelatedCard = 'CREATE_RELATED_CARD',
  /** Gera um documento com base em parâmetros especificados. */
  GenerateDocument = 'GENERATE_DOCUMENT',
  /** Faz uma requisição HTTP para uma URL especificada. */
  MakeHttpRequest = 'MAKE_HTTP_REQUEST',
  /** Move um card para uma etapa especificada. */
  MoveCardToStage = 'MOVE_CARD_TO_STAGE',
  OnCardAssigneeAdded = 'ON_CARD_ASSIGNEE_ADDED',
  OnCardAssigneeRemoved = 'ON_CARD_ASSIGNEE_REMOVED',
  OnCardCommentAdded = 'ON_CARD_COMMENT_ADDED',
  /** Acionado quando um card é criado. */
  OnCardCreated = 'ON_CARD_CREATED',
  /** Acionado quando um campo em um card muda. */
  OnCardFieldChanged = 'ON_CARD_FIELD_CHANGED',
  OnCardLabelAdded = 'ON_CARD_LABEL_ADDED',
  OnCardLabelRemoved = 'ON_CARD_LABEL_REMOVED',
  /** Acionado quando um card é movido para outra etapa. */
  OnCardMoved = 'ON_CARD_MOVED',
  /** Acionado quando a situação de uma aprovação em um card muda. */
  OnCardReviewSituationChanged = 'ON_CARD_REVIEW_SITUATION_CHANGED',
  /** Acionado quando a situação de um card muda, ou seja, ele é arquivado ou desarquivado. */
  OnCardSituationChanged = 'ON_CARD_SITUATION_CHANGED',
  /** Acionado quando um dos responsáveis pelo card solicita alterações no formulário inicial ao solicitante, acionado apenas em solicitações. */
  OnCardSolicitationRequestChanges = 'ON_CARD_SOLICITATION_REQUEST_CHANGES',
  /** Acionado quando o solicitante devolve as alterações solicitadas por um dos responsáveis pelo card, acionado apenas em solicitações. */
  OnCardSolicitationReturnChanges = 'ON_CARD_SOLICITATION_RETURN_CHANGES',
  OnCardTaskAssigneeAdded = 'ON_CARD_TASK_ASSIGNEE_ADDED',
  OnCardTaskAssigneeRemoved = 'ON_CARD_TASK_ASSIGNEE_REMOVED',
  /** Acionado quando uma tarefa é criada em um card. */
  OnCardTaskCreated = 'ON_CARD_TASK_CREATED',
  OnCardTaskDueDateReached = 'ON_CARD_TASK_DUE_DATE_REACHED',
  OnCardTaskLabelAdded = 'ON_CARD_TASK_LABEL_ADDED',
  OnCardTaskLabelRemoved = 'ON_CARD_TASK_LABEL_REMOVED',
  /** Acionado quando a situação de uma tarefa em um card muda. */
  OnCardTaskSituationChanged = 'ON_CARD_TASK_SITUATION_CHANGED',
  OnCardTaskXUnitsOverdue = 'ON_CARD_TASK_X_UNITS_OVERDUE',
  OnCardXUnitsInStage = 'ON_CARD_X_UNITS_IN_STAGE',
  OnRecurringEvent = 'ON_RECURRING_EVENT',
  /** Remove usuários de um card. */
  RemoveCardAssignee = 'REMOVE_CARD_ASSIGNEE',
  /** Remove uma etiqueta de um card pelo ID ou nome. */
  RemoveCardLabel = 'REMOVE_CARD_LABEL',
  /** Solicita alterações do formulário inicial ao solicitante. */
  RequestSolicitationChanges = 'REQUEST_SOLICITATION_CHANGES',
  /** Retorna uma aprovação com status de 'alterações solicitadas' para 'pendente'. */
  ResubmitForApproval = 'RESUBMIT_FOR_APPROVAL',
  /** Envia um e-mail para os destinatários especificados. */
  SendEmail = 'SEND_EMAIL',
  Test = 'TEST',
  /** Alterna o estado de arquivamento de um card. */
  ToggleCardArchived = 'TOGGLE_CARD_ARCHIVED',
  /** Alterna o estado de bloqueio de um card. */
  ToggleCardLock = 'TOGGLE_CARD_LOCK',
  /** Atualiza o valor de um campo específico em um card. */
  UpdateCardFieldValue = 'UPDATE_CARD_FIELD_VALUE',
  /** Atualiza o nome de um card. */
  UpdateCardName = 'UPDATE_CARD_NAME',
  /** Atualiza o status de uma tarefa dentro de um card. */
  UpdateCardTaskStatus = 'UPDATE_CARD_TASK_STATUS'
}

export type AutomationTriggerConditionAllowedValue = {
  __typename?: 'AutomationTriggerConditionAllowedValue';
  /** The label of the allowed value */
  description: Scalars['String']['output'];
  /** The label of the allowed value */
  label: Scalars['String']['output'];
  /** The value of the allowed value */
  value: Scalars['String']['output'];
};

/** The operator used in automation trigger conditions */
export enum AutomationTriggerConditionOperators {
  /** The value contains the specified substring. */
  Contains = 'CONTAINS',
  /** The value ends with the specified substring. */
  EndsWith = 'ENDS_WITH',
  /** The value is equal to the specified value. */
  Equals = 'EQUALS',
  /** The value is greater than the specified value. */
  GreaterThan = 'GREATER_THAN',
  /** The value is greater than or equal to the specified value. */
  GreaterThanOrEquals = 'GREATER_THAN_OR_EQUALS',
  /**  * The value is in the specified list of values. */
  In = 'IN',
  /** The value is null or empty. */
  IsEmpty = 'IS_EMPTY',
  /** The value is not null or empty. */
  IsNotEmpty = 'IS_NOT_EMPTY',
  /** The value is not null. */
  IsNotNull = 'IS_NOT_NULL',
  /** The value is null. */
  IsNull = 'IS_NULL',
  /** The value is less than the specified value. */
  LessThan = 'LESS_THAN',
  /** The value is less than or equal to the specified value. */
  LessThanOrEquals = 'LESS_THAN_OR_EQUALS',
  /** The value does not contain the specified substring. */
  NotContains = 'NOT_CONTAINS',
  /** The value does not end with the specified substring. */
  NotEndsWith = 'NOT_ENDS_WITH',
  /** The value is not equal to the specified value. */
  NotEquals = 'NOT_EQUALS',
  /** The value is not in the specified list of values. */
  NotIn = 'NOT_IN',
  /** The value does not start with the specified substring. */
  NotStartsWith = 'NOT_STARTS_WITH',
  /** The value starts with the specified substring. */
  StartsWith = 'STARTS_WITH'
}

/** The type of automation trigger */
export enum AutomationTriggerType {
  OnCardAssigneeAdded = 'ON_CARD_ASSIGNEE_ADDED',
  OnCardAssigneeRemoved = 'ON_CARD_ASSIGNEE_REMOVED',
  OnCardCommentAdded = 'ON_CARD_COMMENT_ADDED',
  /** Acionado quando um card é criado. */
  OnCardCreated = 'ON_CARD_CREATED',
  /** Acionado quando um campo em um card muda. */
  OnCardFieldChanged = 'ON_CARD_FIELD_CHANGED',
  OnCardLabelAdded = 'ON_CARD_LABEL_ADDED',
  OnCardLabelRemoved = 'ON_CARD_LABEL_REMOVED',
  /** Acionado quando um card é movido para outra etapa. */
  OnCardMoved = 'ON_CARD_MOVED',
  /** Acionado quando a situação de uma aprovação em um card muda. */
  OnCardReviewSituationChanged = 'ON_CARD_REVIEW_SITUATION_CHANGED',
  /** Acionado quando a situação de um card muda, ou seja, ele é arquivado ou desarquivado. */
  OnCardSituationChanged = 'ON_CARD_SITUATION_CHANGED',
  /** Acionado quando um dos responsáveis pelo card solicita alterações no formulário inicial ao solicitante, acionado apenas em solicitações. */
  OnCardSolicitationRequestChanges = 'ON_CARD_SOLICITATION_REQUEST_CHANGES',
  /** Acionado quando o solicitante devolve as alterações solicitadas por um dos responsáveis pelo card, acionado apenas em solicitações. */
  OnCardSolicitationReturnChanges = 'ON_CARD_SOLICITATION_RETURN_CHANGES',
  OnCardTaskAssigneeAdded = 'ON_CARD_TASK_ASSIGNEE_ADDED',
  OnCardTaskAssigneeRemoved = 'ON_CARD_TASK_ASSIGNEE_REMOVED',
  /** Acionado quando uma tarefa é criada em um card. */
  OnCardTaskCreated = 'ON_CARD_TASK_CREATED',
  OnCardTaskDueDateReached = 'ON_CARD_TASK_DUE_DATE_REACHED',
  OnCardTaskLabelAdded = 'ON_CARD_TASK_LABEL_ADDED',
  OnCardTaskLabelRemoved = 'ON_CARD_TASK_LABEL_REMOVED',
  /** Acionado quando a situação de uma tarefa em um card muda. */
  OnCardTaskSituationChanged = 'ON_CARD_TASK_SITUATION_CHANGED',
  OnCardTaskXUnitsOverdue = 'ON_CARD_TASK_X_UNITS_OVERDUE',
  OnCardXUnitsInStage = 'ON_CARD_X_UNITS_IN_STAGE',
  OnRecurringEvent = 'ON_RECURRING_EVENT',
  Test = 'TEST'
}

/** Represents an automation in the system */
export type AutomationV2 = {
  __typename?: 'AutomationV2';
  /** The actions associated with the automation */
  actions: PaginatedAutomationV2Action;
  /** Date when the automation was created */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the automation */
  createdBy: User;
  /** Description of the automation */
  description: Scalars['String']['output'];
  /** The executions associated with the automation */
  executions: PaginatedAutomationV2Execution;
  /** Unique identifier for the automation */
  id: Scalars['ID']['output'];
  /** Name of the automation */
  name: Scalars['String']['output'];
  /** The pipe associated with the automation */
  pipe?: Maybe<Pipe>;
  /** The roles associated with the automation */
  roles: PaginatedAutomationV2Role;
  /** Status of the automation */
  status: AutomationStatusEnum;
  /** The trigger associated with the automation */
  trigger?: Maybe<AutomationV2Trigger>;
  /** Date when the automation was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who updated the automation */
  updatedBy: User;
};


/** Represents an automation in the system */
export type AutomationV2ActionsArgs = {
  filters?: InputMaybe<PaginatedAutomationV2ActionFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAutomationV2ActionSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an automation in the system */
export type AutomationV2ExecutionsArgs = {
  filters?: InputMaybe<PaginatedAutomationV2ExecutionFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAutomationV2ExecutionSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an automation in the system */
export type AutomationV2RolesArgs = {
  filters?: InputMaybe<PaginatedAutomationV2RoleFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAutomationV2RoleSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an automation action in the system */
export type AutomationV2Action = {
  __typename?: 'AutomationV2Action';
  /** Date when the automation action was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the automation */
  id: Scalars['ID']['output'];
  /** The position of this action on the execution */
  position: Scalars['Float']['output'];
  /** Properties of the action in JSON format */
  properties?: Maybe<Scalars['JSONObject']['output']>;
  /** The type of the action */
  type: AutomationActionType;
  /** Date when the automation action was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type AutomationV2ActionEdge = {
  __typename?: 'AutomationV2ActionEdge';
  cursor: Scalars['String']['output'];
  node: AutomationV2Action;
};

export type AutomationV2ActionMetadata = {
  __typename?: 'AutomationV2ActionMetadata';
  /** The description associated with the automation context */
  description: Scalars['String']['output'];
  /** The label associated with the automation context */
  label: Scalars['String']['output'];
  /** Properties required for the automation action, yup describe format */
  properties?: Maybe<Scalars['JSONObject']['output']>;
  /** The type of the automation Action */
  type: AutomationActionType;
};


export type AutomationV2ActionMetadataDescriptionArgs = {
  lang?: InputMaybe<AutomationMetadataDefinitionLang>;
};


export type AutomationV2ActionMetadataLabelArgs = {
  lang?: InputMaybe<AutomationMetadataDefinitionLang>;
};

export type AutomationV2AutocompleteOption = {
  __typename?: 'AutomationV2AutocompleteOption';
  /** The description of the autocomplete option */
  description?: Maybe<Scalars['String']['output']>;
  /** The label of the autocomplete option */
  label: Scalars['String']['output'];
  /** The value of the autocomplete option */
  value: Scalars['String']['output'];
};

export type AutomationV2AutocompleteOptionEdge = {
  __typename?: 'AutomationV2AutocompleteOptionEdge';
  cursor: Scalars['String']['output'];
  node: AutomationV2AutocompleteOption;
};

export type AutomationV2ContextMetadata = {
  __typename?: 'AutomationV2ContextMetadata';
  /** The category of the path */
  category: Scalars['String']['output'];
  /** The description associated with the automation context */
  description: Scalars['String']['output'];
  /** The label associated with the automation context */
  label: Scalars['String']['output'];
  /** The path */
  path: Scalars['String']['output'];
  /** The type of the path */
  type: Scalars['String']['output'];
};


export type AutomationV2ContextMetadataDescriptionArgs = {
  lang?: InputMaybe<AutomationMetadataDefinitionLang>;
};


export type AutomationV2ContextMetadataLabelArgs = {
  lang?: InputMaybe<AutomationMetadataDefinitionLang>;
};

export type AutomationV2Edge = {
  __typename?: 'AutomationV2Edge';
  cursor: Scalars['String']['output'];
  node: AutomationV2;
};

/** Represents an automation execution in the system */
export type AutomationV2Execution = {
  __typename?: 'AutomationV2Execution';
  /** The actions associated with the automation execution */
  actions: PaginatedAutomationV2ExecutionAction;
  /** The actions associated with the automation execution */
  automation: AutomationV2;
  /** Timestamp when the automation completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contextual information for the automation */
  context?: Maybe<Scalars['JSONObject']['output']>;
  /** Unique identifier for the automation */
  id: Scalars['ID']['output'];
  /** Result data for the automation */
  resultData?: Maybe<Scalars['JSONObject']['output']>;
  /** Timestamp when the automation started */
  startedAt: Scalars['DateTime']['output'];
  /** Status of the automation */
  status: AutomationExecutionStatus;
  /** Data associated with the trigger */
  triggerData?: Maybe<Scalars['JSONObject']['output']>;
  /** Type of trigger for the automation */
  triggerType: Scalars['String']['output'];
};


/** Represents an automation execution in the system */
export type AutomationV2ExecutionActionsArgs = {
  filters?: InputMaybe<PaginatedAutomationV2ExecutionActionFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAutomationV2ExecutionActionSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an automation execution action in the system */
export type AutomationV2ExecutionAction = {
  __typename?: 'AutomationV2ExecutionAction';
  /** Unique identifier for action executed, this ID points to the action in the automation version and may not be the same as the action ID on the live automation */
  actionIdInVersion?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the automation execution action completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Error data for the automation execution action, if any */
  error?: Maybe<Scalars['JSONObject']['output']>;
  /** Unique identifier for the automation execution action */
  id: Scalars['ID']['output'];
  /** Input data for the automation execution action */
  inputData?: Maybe<Scalars['JSONObject']['output']>;
  /** Result data for the automation execution action */
  outputData?: Maybe<Scalars['JSONObject']['output']>;
  /** Timestamp when the automation execution action started */
  startedAt: Scalars['DateTime']['output'];
  /** Status of the automation execution action */
  status: AutomationExecutionActionStatus;
  /** Unique identifier for the trigger executed, this ID points to the trigger in the automation version and may not be the same as the trigger ID on the live automation */
  triggerIdInVersion?: Maybe<Scalars['ID']['output']>;
  /** If action_id is not null, this is the type of action executed, if trigger_id is not null, this is the type of trigger executed */
  typeInVersion: Scalars['String']['output'];
};

export type AutomationV2ExecutionActionEdge = {
  __typename?: 'AutomationV2ExecutionActionEdge';
  cursor: Scalars['String']['output'];
  node: AutomationV2ExecutionAction;
};

export type AutomationV2ExecutionEdge = {
  __typename?: 'AutomationV2ExecutionEdge';
  cursor: Scalars['String']['output'];
  node: AutomationV2Execution;
};

/** Represents an automation role in the system, which defines the permissions and access control for automations. */
export type AutomationV2Role = {
  __typename?: 'AutomationV2Role';
  /** Date when the automation was created */
  createdAt: Scalars['DateTime']['output'];
  /** O banco de dados associado ao papel de automação, se não estiver presente, o papel será um papel global */
  database?: Maybe<Database>;
  /** Unique identifier for the automation role */
  id: Scalars['String']['output'];
  /** The pipe associated with the automation role, if not present, the role will be a global role */
  pipe?: Maybe<Pipe>;
  /** The role associated with the automation role */
  role: Role;
  /** Date when the automation was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type AutomationV2RoleEdge = {
  __typename?: 'AutomationV2RoleEdge';
  cursor: Scalars['String']['output'];
  node: AutomationV2Role;
};

/** Represents an automation trigger in the system */
export type AutomationV2Trigger = {
  __typename?: 'AutomationV2Trigger';
  /** The conditions associated with the automation trigger */
  conditions: PaginatedAutomationV2TriggerCondition;
  /** Date when the automation trigger was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the automation */
  id: Scalars['ID']['output'];
  /** Properties of the trigger in JSON format */
  properties?: Maybe<Scalars['JSONObject']['output']>;
  /** The type of the trigger */
  type: AutomationTriggerType;
  /** Date when the automation trigger was last updated */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents an automation trigger in the system */
export type AutomationV2TriggerConditionsArgs = {
  filters?: InputMaybe<PaginatedAutomationV2TriggerConditionFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAutomationV2TriggerConditionSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a condition for an automation trigger in the system */
export type AutomationV2TriggerCondition = {
  __typename?: 'AutomationV2TriggerCondition';
  /** Date when the automation trigger condition was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the automation */
  id: Scalars['ID']['output'];
  /** If true, the values in the property field will be considered interpolated strings */
  isInterpolated: Scalars['Boolean']['output'];
  /** The operator used for evaluation */
  operator: AutomationTriggerConditionOperators;
  /** The property being evaluated, will be in the format of "propertyName.propertySubName" */
  property: Scalars['String']['output'];
  /** Date when the automation trigger condition was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The value being evaluated, the value can be null if the operator requires multiple values */
  value?: Maybe<Scalars['String']['output']>;
  /** The list of values being evaluated, used when the operator requires multiple values */
  values: Array<Scalars['String']['output']>;
};

export type AutomationV2TriggerConditionEdge = {
  __typename?: 'AutomationV2TriggerConditionEdge';
  cursor: Scalars['String']['output'];
  node: AutomationV2TriggerCondition;
};

export type AutomationV2TriggerMetadata = {
  __typename?: 'AutomationV2TriggerMetadata';
  /** Properties required for the automation trigger, yup describe format */
  conditions: Array<AutomationV2TriggerMetadataCondition>;
  /** The description associated with the automation trigger */
  description: Scalars['String']['output'];
  /** The label associated with the automation trigger */
  label: Scalars['String']['output'];
  /** Properties required for the automation trigger, yup describe format */
  properties: Scalars['JSONObject']['output'];
  /** The type of the automation trigger */
  type: AutomationTriggerType;
};


export type AutomationV2TriggerMetadataDescriptionArgs = {
  lang?: InputMaybe<AutomationMetadataDefinitionLang>;
};


export type AutomationV2TriggerMetadataLabelArgs = {
  lang?: InputMaybe<AutomationMetadataDefinitionLang>;
};

export type AutomationV2TriggerMetadataCondition = {
  __typename?: 'AutomationV2TriggerMetadataCondition';
  /** The allowed operators for the condition */
  allowedOperators: Array<AutomationTriggerConditionOperators>;
  /** The allowed values for the condition, if any */
  allowedValues: Array<AutomationTriggerConditionAllowedValue>;
  /** The allowed values for the condition, if any */
  autocompleteEntity?: Maybe<AutomationAutocompleteEntity>;
  /** The description associated with the automation trigger */
  description: Scalars['String']['output'];
  /** The label associated with the automation trigger */
  label: Scalars['String']['output'];
  /** The property to evaluate */
  property: Scalars['String']['output'];
  /** The type of the property to evaluate */
  type: Scalars['String']['output'];
};


export type AutomationV2TriggerMetadataConditionAllowedValuesArgs = {
  lang?: InputMaybe<AutomationMetadataDefinitionLang>;
};


export type AutomationV2TriggerMetadataConditionDescriptionArgs = {
  lang?: InputMaybe<AutomationMetadataDefinitionLang>;
};


export type AutomationV2TriggerMetadataConditionLabelArgs = {
  lang?: InputMaybe<AutomationMetadataDefinitionLang>;
};

export type AutomationsWhereInput = {
  /** The archive status of the automation */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the automation */
  automationId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the automation */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The pipe of the automation */
  pipeId: Scalars['ID']['input'];
};

export type BatchActionError = {
  __typename?: 'BatchActionError';
  /** Código do erro ocorrido durante a ação em massa */
  code: Scalars['String']['output'];
  /** Dados do item que causou o erro durante a ação em massa */
  data: Scalars['JSONObject']['output'];
  /** Mensagem descritiva do erro ocorrido durante a ação em massa */
  message: Scalars['String']['output'];
};

/** Resultado da exclusão em lote de registros de banco de dados */
export type BatchDeleteDatabaseRecord = {
  __typename?: 'BatchDeleteDatabaseRecord';
  /** Lista de itens afetados pela ação em massa */
  affectedItems: Array<Scalars['ID']['output']>;
  /** Lista de itens que falharam durante a ação em massa */
  erroredItems: Array<BatchActionError>;
  /** Número de falhas ocorridas durante a ação em massa */
  failureCount: Scalars['Int']['output'];
  /** Número de sucessos ocorridos durante a ação em massa */
  successCount: Scalars['Int']['output'];
};

/** Resultado da exclusão em lote de registros de banco de dados */
export type BatchDeleteDatabaseRecordInput = {
  /** Lista de dados para a ação em massa */
  data: Array<Scalars['ID']['input']>;
  /** ID do banco de dados onde os registros serão excluídos */
  databaseId: Scalars['ID']['input'];
};

export type BatchUpsertAutomationV2ActionInput = {
  /**
   * The ID of the action.
   * If provided, the action with this ID will be updated; if not found, a new one will be created with this ID. If omitted, a new action with a generated ID will always be created.
   * Any existing actions not included in the batch will be deleted.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The position of the action in the sequence */
  position: Scalars['Float']['input'];
  /** Properties of the action in JSON format, this properties will be validated against the action type */
  properties: Scalars['JSONObject']['input'];
  /** The type of the action */
  type: AutomationActionType;
};

export type BatchUpsertAutomationV2Input = {
  /** List of actions for the automation */
  actions: Array<BatchUpsertAutomationV2ActionInput>;
  /** The ID of the automation to update. */
  automationId: Scalars['ID']['input'];
  /** Triggers for the automation */
  trigger: BatchUpsertAutomationV2TriggerInput;
};

export type BatchUpsertAutomationV2TriggerConditionInput = {
  /**
   * The ID of the trigger condition.
   * If provided, the trigger condition with this ID will be updated; if not found, a new one will be created with this ID. If omitted, a new trigger condition with a generated ID will always be created.
   * Any existing trigger conditions not included in the batch will be deleted.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** If true, the values in the property field will be considered interpolated strings */
  isInterpolated: Scalars['Boolean']['input'];
  /** The operator for the condition. This will be validated against the trigger type. */
  operator: AutomationTriggerConditionOperators;
  /** The property being evaluated in the condition. This will be validated against the trigger type and should follow the format: "prop.sub.prop". */
  property: Scalars['String']['input'];
  /** The value to compare against in the condition. */
  value?: InputMaybe<Scalars['String']['input']>;
  /** An array of values to compare against in the condition. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BatchUpsertAutomationV2TriggerInput = {
  /** Conditions that must be met for the trigger to activate */
  conditions: Array<BatchUpsertAutomationV2TriggerConditionInput>;
  /**
   * The ID of the trigger.
   * If provided, the trigger with this ID will be updated; if not found, a new one will be created with this ID. If omitted, a new trigger with a generated ID will always be created.
   * Any existing triggers not included in the batch will be deleted.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Properties of the trigger in JSON format, this properties will be validated against the trigger type */
  properties: Scalars['JSONObject']['input'];
  /** The type of the trigger */
  type: AutomationTriggerType;
};

/** Resultado da criação em lote de registros de banco de dados */
export type BatchUpsertDatabaseRecord = {
  __typename?: 'BatchUpsertDatabaseRecord';
  /** Lista de itens afetados pela ação em massa */
  affectedItems: Array<DatabaseRecord>;
  /** Lista de itens que falharam durante a ação em massa */
  erroredItems: Array<BatchActionError>;
  /** Número de falhas ocorridas durante a ação em massa */
  failureCount: Scalars['Int']['output'];
  /** Número de sucessos ocorridos durante a ação em massa */
  successCount: Scalars['Int']['output'];
};

/** Dados para a criação em lote de registros de banco de dados */
export type BatchUpsertDatabaseRecordDataInput = {
  /** Dados do registro de banco de dados a ser criado */
  data: Scalars['JSONObject']['input'];
  /** Hash do registro de banco de dados, fornecer esse valor irá evitar que registros não modificados sejam atualizados */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** ID do registro de banco de dados (se existir, o registro será atualizado) */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Resultado da criação em lote de registros de banco de dados */
export type BatchUpsertDatabaseRecordInput = {
  /** Lista de dados para a ação em massa */
  data: Array<BatchUpsertDatabaseRecordDataInput>;
  /** ID do banco de dados onde os registros serão criados */
  databaseId: Scalars['ID']['input'];
};

/** Representa uma ação em massa */
export type BulkAction = {
  __typename?: 'BulkAction';
  /** Data e hora em que a ação em massa foi criada */
  createdAt: Scalars['DateTime']['output'];
  /** Usuário que criou a ação em massa */
  createdBy: User;
  /** Data e hora em que a ação em massa foi enviada para processamento */
  dispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID da entidade afetada, a qual entidade esse ID se refere irá depender do tipo de ação */
  entityId: Scalars['ID']['output'];
  /** Número de itens que falharam ao serem processados na ação em massa */
  failureCount?: Maybe<Scalars['Int']['output']>;
  /** ID da ação em massa */
  id: Scalars['ID']['output'];
  /** Caminho do arquivo de entrada da ação em massa com URL assinada */
  inputFilePath?: Maybe<Scalars['String']['output']>;
  /** Caminho do arquivo de saída da ação em massa com URL assinada */
  outputFilePath?: Maybe<Scalars['String']['output']>;
  /** Parâmetros da ação em massa */
  parameters: Scalars['JSONObject']['output'];
  /** Status da ação em massa */
  status: BulkActionStatusEnum;
  /** Número de itens processados com sucesso na ação em massa */
  successCount?: Maybe<Scalars['Int']['output']>;
  /** Número total de itens processados na ação em massa */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Tipo da ação em massa */
  type: BulkActionTypeEnum;
  /** Data e hora em que a ação em massa foi atualizada pela última vez */
  updatedAt: Scalars['DateTime']['output'];
  /** Usuário que atualizou a ação em massa */
  updatedBy?: Maybe<User>;
};

export type BulkActionEdge = {
  __typename?: 'BulkActionEdge';
  cursor: Scalars['String']['output'];
  node: BulkAction;
};

/** O status de uma ação em massa */
export enum BulkActionStatusEnum {
  /** Ação em massa foi concluída com sucesso */
  Completed = 'completed',
  /** Ação em massa falhou */
  Failed = 'failed',
  /** Ação em massa está em andamento */
  InProgress = 'in_progress',
  /** Ação em massa está pendente */
  Pending = 'pending'
}

/** O tipo de uma ação em massa */
export enum BulkActionTypeEnum {
  /** Importação de registros para o banco de dados */
  DatabaseImportRecords = 'database_import_records',
  /** Importação de cards para o pipe */
  PipeImportCards = 'pipe_import_cards'
}

/** Resultado da atualização em massa de aprovadores por aprovação de card */
export type BulkUpdateReviewers = {
  __typename?: 'BulkUpdateReviewers';
  /** Número de erros */
  errorCount: Scalars['Int']['output'];
  /** Lista de erros */
  errors: Array<ReviewersError>;
  /** Número de atualizações bem-sucedidas */
  successCount: Scalars['Int']['output'];
  /** IDs das aprovações atualizadas com sucesso */
  updatedReviewIds: Array<Scalars['ID']['output']>;
  /** List of updated reviews */
  updatedReviews: Array<Review>;
};

/** Entrada para atualização em massa de aprovadores por aprovação de card */
export type BulkUpdateReviewersInput = {
  /** IDs dos novos aprovadores */
  newReviewersIds: Array<Scalars['ID']['input']>;
  /** ID do pipe que contém as aprovações a serem atualizadas */
  pipeId: Scalars['ID']['input'];
  /** Remove os aprovadores existentes antes de adicionar os novos */
  removeExistingReviewers?: Scalars['Boolean']['input'];
  /** IDs das aprovações a serem atualizadas */
  reviewsIds: Array<Scalars['ID']['input']>;
};

/** Resultado da atualização em massa de responsáveis por tarefas de card */
export type BulkUpdateTaskAssignees = {
  __typename?: 'BulkUpdateTaskAssignees';
  /** Número de erros */
  errorCount: Scalars['Int']['output'];
  /** Lista de erros */
  errors: Array<TaskAssigneeError>;
  /** Número de atualizações bem-sucedidas */
  successCount: Scalars['Int']['output'];
  /** List of updated card tasks */
  updatedTasks: Array<CardTask>;
  /** IDs das tarefas atualizadas com sucesso */
  updatedTasksIds: Array<Scalars['String']['output']>;
};

/** Entrada para atualização em massa de responsáveis por tarefas de card */
export type BulkUpdateTaskAssigneesInput = {
  /** IDs dos novos responsáveis */
  newAssigneesIds: Array<Scalars['String']['input']>;
  /** ID do pipe que contém as tarefas a serem atualizadas */
  pipeId: Scalars['ID']['input'];
  /** Remove os responsáveis existentes antes de adicionar os novos */
  removeExistingAssignees?: Scalars['Boolean']['input'];
  /** IDs das tarefas a serem atualizadas */
  taskIds: Array<Scalars['String']['input']>;
};

/** Dados para cancelar uma ação em massa antes de ser processada */
export type CancelBulkActionInput = {
  /** ID da ação em massa a ser cancelada */
  bulkActionId: Scalars['String']['input'];
};

export type CancelReviewInput = {
  id: Scalars['ID']['input'];
};

/** Card */
export type Card = {
  __typename?: 'Card';
  /** Age of the card */
  age: Scalars['Int']['output'];
  /** Whether the card is archived */
  archived: Scalars['Boolean']['output'];
  arrivedAt: Scalars['DateTime']['output'];
  /** Automation execution of the card in that stage */
  automations: Array<AutomationExecution>;
  /** Whether the authenticated user can answer the initial form */
  canAnswerInitialForm: Scalars['Boolean']['output'];
  /** Count of comments in the card */
  commentCount: CardCommentCount;
  createdAt: Scalars['DateTime']['output'];
  /** User who created the card */
  createdBy: User;
  /** Current stage of the card */
  currentStage: Stage;
  /** Current stage deadline of the card */
  currentStageDeadline?: Maybe<RealDeadline>;
  currentStageFields: FieldTypesConnection;
  current_stage_id: Scalars['String']['output'];
  /** Card description */
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  fields: Array<FieldType>;
  form: Form;
  id: Scalars['ID']['output'];
  /** Position of the card in the stage */
  index?: Maybe<Scalars['Float']['output']>;
  /** Who is responsible for the initial form of the card */
  initialFormResponsible: CardInitialFormResponsible;
  isAuthenticatedUserAssignee: Scalars['Boolean']['output'];
  /** Whether the card has been locked by a supervisor/owner */
  isForceLocked: Scalars['Boolean']['output'];
  /** Whether the card is a solicitation */
  isSolicitation: Scalars['Boolean']['output'];
  labels: Array<CardLabel>;
  lastAssignees: Array<User>;
  /** Last review of the card in the current stage */
  lastReview?: Maybe<Review>;
  /** Whether the card is late */
  late?: Maybe<Scalars['Boolean']['output']>;
  leftAt?: Maybe<Scalars['DateTime']['output']>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: CardPermissions;
  pipe: Pipe;
  /** Pipe deadline of the card */
  pipeDeadline?: Maybe<RealDeadline>;
  /** Whether the card is readonly */
  readonly: Scalars['Boolean']['output'];
  /** Get all reviews of a card */
  reviews?: Maybe<Array<Review>>;
  /** Deadlines of the card */
  stagesDeadlines?: Maybe<Array<Maybe<RealDeadline>>>;
  /** When the card first entered the current stage */
  startedCurrentPhaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** Count of tasks in the card */
  taskCount: CardTaskCount;
  updatedAt: Scalars['DateTime']['output'];
};

/** Assignee of a card */
export type CardAssignee = {
  __typename?: 'CardAssignee';
  /** When the assignee was created */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the assignee, this is not the user ID */
  id: Scalars['String']['output'];
  /** User associated with the card assignee */
  user: User;
};

export type CardAssigneeEdge = {
  __typename?: 'CardAssigneeEdge';
  cursor: Scalars['String']['output'];
  node: CardAssignee;
};

/** Card attachment */
export type CardAttachment = {
  __typename?: 'CardAttachment';
  /** Creation date of the card attachment */
  createdAt: Scalars['DateTime']['output'];
  /** Entity type of the card attachment */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Extensão do arquivo */
  extension: Scalars['String']['output'];
  /** Unique identifier for the card attachment */
  id: Scalars['ID']['output'];
  /** Name of the card attachment */
  name: Scalars['String']['output'];
  /** Path to the card attachment in storage */
  path: Scalars['String']['output'];
  /** Link permanente para download do anexo */
  permaLink: Scalars['String']['output'];
  /** Link para download do anexo assinado */
  preSignedUrl?: Maybe<Scalars['String']['output']>;
  /** Revisor ao qual este anexo pertence, se houver */
  reviewer?: Maybe<CardAttachmentSource>;
  /** Size of the card attachment in bytes */
  size: Scalars['Int']['output'];
  /** Etapa na qual esse anexo faz parte, caso alguma */
  stage?: Maybe<CardAttachmentSource>;
  /** Tarefa à qual este anexo pertence, se houver */
  task?: Maybe<CardAttachmentSource>;
  /** MIME type of the card attachment */
  type: Scalars['String']['output'];
};

export type CardAttachmentEdge = {
  __typename?: 'CardAttachmentEdge';
  cursor: Scalars['String']['output'];
  node: CardAttachment;
};

export type CardAttachmentSource = {
  __typename?: 'CardAttachmentSource';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Card comment */
export type CardComment = {
  __typename?: 'CardComment';
  /** Attachments associated with the card comment */
  attachments: PaginatedCardAttachment;
  /** Card comment content */
  content: Scalars['String']['output'];
  /** Card comment created at */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Card comment updated at */
  updatedAt: Scalars['DateTime']['output'];
  /** User associated with the card comment */
  user: User;
};


/** Card comment */
export type CardCommentAttachmentsArgs = {
  filters: PaginatedCardAttachmentFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardAttachmentSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Count of comments in the card */
export type CardCommentCount = {
  __typename?: 'CardCommentCount';
  /** Whether there are new comments for the authenticated user */
  hasNew: Scalars['Boolean']['output'];
  /** Total number of comments */
  total: Scalars['Int']['output'];
};

export type CardCommentEdge = {
  __typename?: 'CardCommentEdge';
  cursor: Scalars['String']['output'];
  node: CardComment;
};

/** Card connection */
export type CardConnection = {
  __typename?: 'CardConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Card>;
};

export type CardEdge = {
  __typename?: 'CardEdge';
  cursor: Scalars['String']['output'];
  node: Card;
};

export type CardHistory = {
  __typename?: 'CardHistory';
  stage: CardHistoryStageConnection;
};

export type CardHistoryInStage = {
  __typename?: 'CardHistoryInStage';
  /** Fields with values of the card in the current stage */
  fields: Array<FieldType>;
  stageId: Scalars['ID']['output'];
};

/** Card history stage */
export type CardHistoryStage = {
  __typename?: 'CardHistoryStage';
  /** When the card arrived at the stage */
  cardArrivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Card id */
  cardId?: Maybe<Scalars['ID']['output']>;
  /** Stage color */
  color?: Maybe<Scalars['String']['output']>;
  /** Stage duration */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Questions without answer in forms in the stage */
  fields: FieldTypesConnection;
  /** When the stage expired */
  hasFields?: Maybe<Scalars['Boolean']['output']>;
  /** Card stage id */
  id: Scalars['ID']['output'];
  /** Stage index */
  index?: Maybe<Scalars['Float']['output']>;
  /** Whether the stage is the current phase */
  isCurrentPhase?: Maybe<Scalars['Boolean']['output']>;
  /** Stage name */
  name?: Maybe<Scalars['String']['output']>;
  /** Card stage id */
  stageId?: Maybe<Scalars['ID']['output']>;
};

/** Card stage history connection */
export type CardHistoryStageConnection = {
  __typename?: 'CardHistoryStageConnection';
  edges: Array<CardHistoryStageEdge>;
  nodes: Array<CardHistoryStage>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CardHistoryStageEdge = {
  __typename?: 'CardHistoryStageEdge';
  cursor: Scalars['String']['output'];
  node: CardHistoryStage;
};

/** Who is responsible for the initial form of the card */
export enum CardInitialFormResponsible {
  /** Qualquer usuário com permissão para editar o card pode responder o formulário inicial. */
  Any = 'any',
  /** Apenas os responsáveis pelo card podem responder o formulário inicial. */
  Assignee = 'assignee',
  /** Apenas o solicitante do card pode responder o formulário inicial. */
  Solicitor = 'solicitor'
}

/** CardsLabel */
export type CardLabel = {
  __typename?: 'CardLabel';
  /** When this label was created */
  createdAt: Scalars['DateTime']['output'];
  /** Label associated with the card label */
  label: Label;
};

export type CardLabelEdge = {
  __typename?: 'CardLabelEdge';
  cursor: Scalars['String']['output'];
  node: CardLabel;
};

export type CardLogs = {
  __typename?: 'CardLogs';
  actionReason?: Maybe<Scalars['String']['output']>;
  /** Actor of the event */
  actor?: Maybe<User>;
  actorId?: Maybe<Scalars['String']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  cardId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['JSONObject']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  eventType: CardsLogEventTypeEnum;
  id: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  relatedEventId?: Maybe<Scalars['String']['output']>;
  stageFromId?: Maybe<Scalars['String']['output']>;
  stageToId?: Maybe<Scalars['String']['output']>;
};

export type CardLogsEdge = {
  __typename?: 'CardLogsEdge';
  cursor: Scalars['String']['output'];
  node: CardLogs;
};

/** Paginate card logs input */
export type CardLogsPaginateInput = {
  after?: InputMaybe<Scalars['ID']['input']>;
  cardId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<CardsLogEventTypeEnum>>;
};

/** Paginated card logs */
export type CardLogsPaginated = {
  __typename?: 'CardLogsPaginated';
  edges: Array<CardLogsEdge>;
  nodes: Array<CardLogs>;
  pageInfo: PageInfo;
};

/** Card permissions */
export type CardPermissions = {
  __typename?: 'CardPermissions';
  /** Whether the user can delete card */
  canDeleteCard: Scalars['Boolean']['output'];
  /** Whether the user can download files */
  canDownloadFiles: Scalars['Boolean']['output'];
  /** Whether the user can manage any cards */
  canEditAnyCard: Scalars['Boolean']['output'];
  /** Whether the user can edit the pipe */
  canEditPipe: Scalars['Boolean']['output'];
  /** Whether the user can see all cards */
  canShowAllCards: Scalars['Boolean']['output'];
};

export type CardRelation = CardRelationComplete | CardRelationRestricted;

export type CardRelationBase = {
  /** Card relação do pai, o argumento de filters.cardId vai ser ignorado nesse resolver. */
  childrenCards: PaginatedCardRelation;
  /** ID do card */
  id: Scalars['ID']['output'];
  /** Nome do card */
  name: Scalars['String']['output'];
  /** Card relação do pai */
  parentCard?: Maybe<CardRelation>;
};


export type CardRelationBaseChildrenCardsArgs = {
  filters: PaginatedCardRelationFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardRelationSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CardRelationComplete = CardRelationBase & {
  __typename?: 'CardRelationComplete';
  /** Responsáveis do card, o argumento de filters.cardId vai ser ignorado nesse resolver. */
  assignees: PaginatedCardAssignee;
  /** Card relação do pai, o argumento de filters.cardId vai ser ignorado nesse resolver. */
  childrenCards: PaginatedCardRelation;
  /** Etapa atual do card */
  currentStage: Stage;
  /** Current stage deadline */
  currentStageDeadline?: Maybe<RealDeadline>;
  /** ID do card */
  id: Scalars['ID']['output'];
  /** Etiquetas do card, o argumento de filters.cardId vai ser ignorado nesse resolver. */
  labels: PaginatedCardLabel;
  /** Nome do card */
  name: Scalars['String']['output'];
  /** Card relação do pai */
  parentCard?: Maybe<CardRelation>;
  /** Pipe do card */
  pipe: Stage;
  /** Pipe deadline */
  pipeDeadline?: Maybe<RealDeadline>;
};


export type CardRelationCompleteAssigneesArgs = {
  filters: PaginatedCardAssigneeFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardAssigneeSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type CardRelationCompleteChildrenCardsArgs = {
  filters: PaginatedCardRelationFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardRelationSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type CardRelationCompleteLabelsArgs = {
  filters: PaginatedCardLabelFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardLabelSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CardRelationRestricted = CardRelationBase & {
  __typename?: 'CardRelationRestricted';
  /** Card relação do pai, o argumento de filters.cardId vai ser ignorado nesse resolver. */
  childrenCards: PaginatedCardRelation;
  /** ID do card */
  id: Scalars['ID']['output'];
  /** Nome do card */
  name: Scalars['String']['output'];
  /** Card relação do pai */
  parentCard?: Maybe<CardRelation>;
};


export type CardRelationRestrictedChildrenCardsArgs = {
  filters: PaginatedCardRelationFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardRelationSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Card review entity */
export type CardReview = {
  __typename?: 'CardReview';
  /** Whether the can request review */
  canRequestReview: Scalars['Boolean']['output'];
  /** Current stage of the card */
  currentStage: Stage;
  /** ID of the card where this review is located */
  id: Scalars['String']['output'];
  /** Last review of the card */
  lastReview?: Maybe<Review>;
  last_review_id: Scalars['String']['output'];
  /** History of review requests */
  reviewRequests?: Maybe<Array<Maybe<Review>>>;
  /** All reviews of the card */
  reviews: Array<Review>;
};

/** Solicitation detail with card data and logs */
export type CardSolicitation = {
  __typename?: 'CardSolicitation';
  /** Responsáveis pelo card */
  assignees: Array<User>;
  /** Whether the authenticated user can answer the initial form */
  canAnswerInitialForm: Scalars['Boolean']['output'];
  /** Comment count and read status */
  commentCount?: Maybe<CardCommentCount>;
  /** Created at date */
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  currentStage: CardSolicitationStage;
  fields: Array<FieldType>;
  id: Scalars['ID']['output'];
  /** O responsável atual pela resposta do formulário inicial do card */
  initialFormResponsible: CardInitialFormResponsible;
  /** The last review for the card */
  lastReview?: Maybe<Review>;
  /** Quando o cartão está bloqueado */
  locked: Scalars['Boolean']['output'];
  logs: CardLogsPaginated;
  /** Card name */
  name: Scalars['String']['output'];
  pipe: CardSolicitationPipe;
  /** Pipe deadline */
  pipeDeadline?: Maybe<CardSolicitationDeadline>;
  /** Whether the card is readonly */
  readonly: Scalars['Boolean']['output'];
};


/** Solicitation detail with card data and logs */
export type CardSolicitationLogsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CardSolicitationDeadline = {
  __typename?: 'CardSolicitationDeadline';
  cardFinishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of card stage associated with the deadline */
  cardStageId?: Maybe<Scalars['String']['output']>;
  deadlineAt?: Maybe<Scalars['DateTime']['output']>;
  deadlineRaw?: Maybe<Scalars['JSON']['output']>;
  deadlineRiskAt?: Maybe<Scalars['DateTime']['output']>;
  deadlineStartedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

/** The pipe associated with a card solicitation */
export type CardSolicitationPipe = {
  __typename?: 'CardSolicitationPipe';
  /** Caso verdadeiro, permite enviar comentários quando o card estiver bloqueado */
  allowCommentsWhenCardLocked: Scalars['Boolean']['output'];
  /** Caso verdadeiro, permite a visibilidade da aba de anexos nos detalhes das solicitações desse fluxo */
  attachmentsTabVisibility: Scalars['Boolean']['output'];
  /** Unique identifier for the pipe */
  id: Scalars['ID']['output'];
  /** Pipe name */
  name: Scalars['String']['output'];
  /** Start form of the pipe */
  startForm?: Maybe<Form>;
};

/** The stage associated with a card solicitation */
export type CardSolicitationStage = {
  __typename?: 'CardSolicitationStage';
  /** Stage color */
  color?: Maybe<Scalars['String']['output']>;
  /** Stage description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the stage is done */
  done: Scalars['Boolean']['output'];
  /** Unique identifier for the stage */
  id: Scalars['ID']['output'];
  /** Stage name */
  name: Scalars['String']['output'];
};

export type CardStageTaskEdge = {
  __typename?: 'CardStageTaskEdge';
  cursor: Scalars['String']['output'];
  node: CardTask;
};

/** Status of the card */
export enum CardStatusEnum {
  /** Not archived card */
  Active = 'active',
  /** Archived card */
  Archived = 'archived'
}

/** Card task */
export type CardTask = {
  __typename?: 'CardTask';
  /** Assignees of the card task. */
  assignees: Array<CardTaskAssignee>;
  card: Card;
  /** Date when the card task was completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date when the card task was created */
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** Description of the card task */
  description?: Maybe<Scalars['String']['output']>;
  /** Due date of the card task */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  fields: Array<CardTaskField>;
  first_completed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Date when the card task was submitted */
  formSubmittedAt?: Maybe<Scalars['String']['output']>;
  /** Who submitted the form for the card task */
  formSubmittedBy?: Maybe<User>;
  form_submitted_by_user_id?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the card task */
  id: Scalars['ID']['output'];
  labels: Array<CardTaskLabel>;
  /** Metadata for the card task */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** The parent task of the card task */
  parentTask?: Maybe<CardTask>;
  parent_task_id?: Maybe<Scalars['String']['output']>;
  /** Priority of the card task */
  priority?: Maybe<CardTaskPriorityEnum>;
  /** Whether a comment is required to finish the task */
  requiredCommentToFinish: Scalars['Boolean']['output'];
  /** Comments of the card task */
  resolutionComment?: Maybe<CardTaskComment>;
  stage?: Maybe<Stage>;
  /** Status of the card task */
  status: CardTaskStatusEnum;
  template_task_id?: Maybe<Scalars['String']['output']>;
  /** Title of the card task */
  title: Scalars['String']['output'];
  /** Date when the card task was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type CardTaskAssignee = {
  __typename?: 'CardTaskAssignee';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export type CardTaskAssigneeEdge = {
  __typename?: 'CardTaskAssigneeEdge';
  cursor: Scalars['String']['output'];
  node: CardTaskAssignee;
};

export type CardTaskByPipeWhereInputDto = {
  /** Assignee filter behavior (default: some) */
  assigneeFilterBehavior?: InputMaybe<MultiSelectFilterBehaviorEnum>;
  /** Assignees ids */
  assigneesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Card status */
  cardStatus?: InputMaybe<CardStatusEnum>;
  /** Conclusion date of the card task gte */
  conclusionDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Conclusion date of the card task lte */
  conclusionDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Description of the card task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Due date of the card task gte */
  dueDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Due date of the card task lte */
  dueDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Labels filter behavior (default: some) */
  labelsFilterBehavior?: InputMaybe<MultiSelectFilterBehaviorEnum>;
  /** Labels ids */
  labelsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of the card task */
  name?: InputMaybe<Scalars['String']['input']>;
  pipeId: Scalars['String']['input'];
  /** Priority of the card task */
  priority?: InputMaybe<CardTaskWherePriorityEnum>;
  /** Status of the card task */
  status?: InputMaybe<CardTaskStatusEnum>;
};

/** Comments from a card task */
export type CardTaskComment = {
  __typename?: 'CardTaskComment';
  /** Comment of the card task */
  comment: Scalars['String']['output'];
  /** Date when the card task comment was created */
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** Unique identifier of the card task comment */
  id: Scalars['ID']['output'];
  /** Type of the card task comment */
  type: CardTaskCommentTypeEnum;
};

/** Type of the card task comment */
export enum CardTaskCommentTypeEnum {
  Reopen = 'reopen',
  Resolution = 'resolution'
}

/** Paginated card tasks */
export type CardTaskCount = {
  __typename?: 'CardTaskCount';
  /** Number of completed tasks */
  completed: Scalars['Int']['output'];
  /** Max number of tasks */
  max: Scalars['Int']['output'];
  /** Number of pending tasks */
  pending: Scalars['Int']['output'];
  /** Total number of tasks */
  total: Scalars['Int']['output'];
};

export type CardTaskEdge = {
  __typename?: 'CardTaskEdge';
  cursor: Scalars['String']['output'];
  node: CardTask;
};

export type CardTaskField = {
  __typename?: 'CardTaskField';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  conditions: Array<CardTaskFieldCondition>;
  createdAt: Scalars['DateTime']['output'];
  database?: Maybe<SharedFieldDatabase>;
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<CardTaskFieldOption>;
  orientationMessage?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

/** Card task field condition */
export type CardTaskFieldCondition = {
  __typename?: 'CardTaskFieldCondition';
  /** Card task field condition created at */
  createdAt: Scalars['DateTime']['output'];
  /** The card task field this condition depends on */
  dependsOnField: CardTaskField;
  /** Card task field condition expected value array */
  expectedValueArray?: Maybe<Array<Scalars['String']['output']>>;
  /** Card task field condition expected value string */
  expectedValueString?: Maybe<Scalars['String']['output']>;
  /** Card task field condition id */
  id: Scalars['ID']['output'];
  /** Card task field condition operator */
  operator: FieldConditionOperator;
  /** Card task field condition updated at */
  updatedAt: Scalars['DateTime']['output'];
};

export type CardTaskFieldOption = {
  __typename?: 'CardTaskFieldOption';
  label: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

/** Card task label */
export type CardTaskLabel = {
  __typename?: 'CardTaskLabel';
  /** The color of the pipe label */
  color: Scalars['String']['output'];
  /** When the card task label was created */
  createdAt: Scalars['DateTime']['output'];
  /** The id of the pipe label */
  id: Scalars['ID']['output'];
  /** The name of the pipe label */
  name: Scalars['String']['output'];
};

/** Priority of the card task */
export enum CardTaskPriorityEnum {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

/** Field to sort */
export enum CardTaskSortFieldEnum {
  CompletedAt = 'completed_at',
  CreatedAt = 'created_at',
  DueAt = 'due_at',
  Priority = 'priority',
  Title = 'title'
}

/** Sort input for card task */
export type CardTaskSortInputDto = {
  /** Sort direction */
  direction: Scalars['String']['input'];
  /** Field to sort */
  field: CardTaskSortFieldEnum;
};

/** Status of the card task */
export enum CardTaskStatusEnum {
  Completed = 'completed',
  Open = 'open',
  Reopened = 'reopened'
}

/** Due date of the card task */
export enum CardTaskWhereDueDateEnum {
  AfterToday = 'afterToday',
  Empty = 'empty',
  Expired = 'expired',
  NextWeek = 'nextWeek',
  NotExpired = 'notExpired',
  ThisWeek = 'thisWeek',
  Today = 'today',
  Tomorrow = 'tomorrow'
}

/** Where input for card task */
export type CardTaskWhereInputDto = {
  /** Blocked tasks */
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Card ID */
  cardId?: InputMaybe<Scalars['String']['input']>;
  /** Card status */
  cardStatus?: InputMaybe<CardStatusEnum>;
  /** Created after date */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Created before date */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Description of the card task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Due date of the card task */
  dueDate?: InputMaybe<CardTaskWhereDueDateEnum>;
  /** Name of the card task */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Pipe ID */
  pipeId?: InputMaybe<Scalars['String']['input']>;
  /** Priority of the card task */
  priority?: InputMaybe<CardTaskWherePriorityEnum>;
  /** Process name contains */
  processNameContains?: InputMaybe<Scalars['String']['input']>;
  /** Stages IDs */
  stagesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Status of the card task */
  status?: InputMaybe<CardTaskStatusEnum>;
};

/** Priority of the card task */
export enum CardTaskWherePriorityEnum {
  /** High priority */
  High = 'high',
  /** Low priority */
  Low = 'low',
  /** Medium priority */
  Medium = 'medium',
  /** No priority */
  None = 'none'
}

/** O tipo de evento do log */
export enum CardsLogEventTypeEnum {
  /** Um responsável foi adicionado por uma automação */
  AutomationAddedAssignee = 'AUTOMATION_ADDED_ASSIGNEE',
  /** Uma etiqueta foi adicionada por uma automação */
  AutomationAddedTag = 'AUTOMATION_ADDED_TAG',
  /** Esse card foi criado por uma automação */
  AutomationCreatedCard = 'AUTOMATION_CREATED_CARD',
  /** Um responsável foi removido por uma automação */
  AutomationRemovedAssignee = 'AUTOMATION_REMOVED_ASSIGNEE',
  /** Uma etiqueta foi removida por uma automação */
  AutomationRemovedTag = 'AUTOMATION_REMOVED_TAG',
  /** Um responsável foi adicionado a esse card */
  CardAddedAssignee = 'CARD_ADDED_ASSIGNEE',
  /** Um anexo foi adicionado a esse card */
  CardAddedAttachment = 'CARD_ADDED_ATTACHMENT',
  /** Uma descrição foi adicionada a esse card */
  CardAddedDescription = 'CARD_ADDED_DESCRIPTION',
  /** Uma etiqueta foi adicionada a esse card */
  CardAddedTag = 'CARD_ADDED_TAG',
  /** Esse card foi arquivado */
  CardArchived = 'CARD_ARCHIVED',
  /** Uma automação foi revertida nesse card */
  CardAutomationRollback = 'CARD_AUTOMATION_ROLLBACK',
  /** Uma automação foi acionada nesse card */
  CardAutomationTriggered = 'CARD_AUTOMATION_TRIGGERED',
  /** Esse card foi criado */
  CardCreated = 'CARD_CREATED',
  /** Um comentário foi criado nesse card */
  CardCreatedComment = 'CARD_CREATED_COMMENT',
  /** Um campo foi atualizado nesse card */
  CardFieldUpdated = 'CARD_FIELD_UPDATED',
  /** Esse card foi bloqueado */
  CardLocked = 'CARD_LOCKED',
  /** Esse card foi movido para trás */
  CardMovedBackward = 'CARD_MOVED_BACKWARD',
  /** Esse card foi movido para frente */
  CardMovedForward = 'CARD_MOVED_FORWARD',
  /** Um prazo do fluxo foi criado para esse card */
  CardPipeDeadlineCreated = 'CARD_PIPE_DEADLINE_CREATED',
  /** Um responsável foi removido a esse card */
  CardRemovedAssignee = 'CARD_REMOVED_ASSIGNEE',
  /** Um anexo foi removido a esse card */
  CardRemovedAttachment = 'CARD_REMOVED_ATTACHMENT',
  /** Uma etiqueta foi removida a esse card */
  CardRemovedTag = 'CARD_REMOVED_TAG',
  /** Um revisor aprovou o card */
  CardReviewerApproved = 'CARD_REVIEWER_APPROVED',
  /** Um revisor foi modificado */
  CardReviewerChanged = 'CARD_REVIEWER_CHANGED',
  /** Um pedido de revisão foi cancelado nesse card */
  CardReviewCanceled = 'CARD_REVIEW_CANCELED',
  /** Um pedido de revisão foi solicitado nesse card */
  CardReviewRequested = 'CARD_REVIEW_REQUESTED',
  /** Um pedido de revisão foi aprovado nesse card */
  CardReviewRequestApproved = 'CARD_REVIEW_REQUEST_APPROVED',
  /** Um revisor pediu a alterações no card */
  CardReviewRequestChange = 'CARD_REVIEW_REQUEST_CHANGE',
  /** Um pedido de revisão foi rejeitado nesse card */
  CardReviewRequestRejected = 'CARD_REVIEW_REQUEST_REJECTED',
  /** A solicitação do card foi retornada ao solicitante */
  CardSolicitationReturnToSolicitor = 'CARD_SOLICITATION_RETURN_TO_SOLICITOR',
  /** O retorno da solicitação do card ao solicitante foi cancelado */
  CardSolicitationReturnToSolicitorCanceled = 'CARD_SOLICITATION_RETURN_TO_SOLICITOR_CANCELED',
  /** A solicitação do card foi enviada a um responsável */
  CardSolicitationSentToAssignee = 'CARD_SOLICITATION_SENT_TO_ASSIGNEE',
  /** Um prazo da etapa foi criado para esse card */
  CardStageDeadlineCreated = 'CARD_STAGE_DEADLINE_CREATED',
  /** Um campo de estágio foi atualizado nesse card */
  CardStageFieldUpdated = 'CARD_STAGE_FIELD_UPDATED',
  /** Um responsável foi adicionado a uma tarefa nesse card */
  CardTaskAssigneeAdded = 'CARD_TASK_ASSIGNEE_ADDED',
  /** Um responsável foi removido de uma tarefa nesse card */
  CardTaskAssigneeRemoved = 'CARD_TASK_ASSIGNEE_REMOVED',
  /** Uma tarefa foi concluída nesse card */
  CardTaskCompleted = 'CARD_TASK_COMPLETED',
  /** Uma tarefa foi criada nesse card */
  CardTaskCreated = 'CARD_TASK_CREATED',
  /** Uma tarefa foi deletada nesse card */
  CardTaskDeleted = 'CARD_TASK_DELETED',
  /** Uma etiqueta foi adicionada a uma tarefa nesse card */
  CardTaskLabelAdded = 'CARD_TASK_LABEL_ADDED',
  /** Uma etiqueta foi removida de uma tarefa nesse card */
  CardTaskLabelRemoved = 'CARD_TASK_LABEL_REMOVED',
  /** Uma tarefa foi reaberta nesse card */
  CardTaskReopened = 'CARD_TASK_REOPENED',
  /** Uma tarefa foi atualizada nesse card */
  CardTaskUpdated = 'CARD_TASK_UPDATED',
  /** Esse card foi desarquivado */
  CardUnarchived = 'CARD_UNARCHIVED',
  /** Esse card foi desbloqueado */
  CardUnlocked = 'CARD_UNLOCKED',
  /** Um comentário foi atualizado nesse card */
  CardUpdatedComment = 'CARD_UPDATED_COMMENT',
  /** A descrição desse card foi atualizada */
  CardUpdatedDescription = 'CARD_UPDATED_DESCRIPTION',
  /** Esse card teve o nome atualizado */
  CardUpdatedName = 'CARD_UPDATED_NAME',
  /** Uma nova solicitação foi criada */
  NewSolicitationCreated = 'NEW_SOLICITATION_CREATED'
}

export type CardsSharedLink = {
  __typename?: 'CardsSharedLink';
  accountId: Scalars['String']['output'];
  cardId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customMessage?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedEmails?: Maybe<Array<Scalars['String']['output']>>;
  isEditable: Scalars['Boolean']['output'];
  isRequiredAuthenticated: Scalars['Boolean']['output'];
  publicLink?: Maybe<Scalars['String']['output']>;
  sharedBy: Scalars['String']['output'];
  stageId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CardsTasksSharedLink = {
  __typename?: 'CardsTasksSharedLink';
  accountId: Scalars['String']['output'];
  cardId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customMessage?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedEmails?: Maybe<Array<Scalars['String']['output']>>;
  isEditable: Scalars['Boolean']['output'];
  isRequiredAuthenticated: Scalars['Boolean']['output'];
  publicLink?: Maybe<Scalars['String']['output']>;
  sharedBy: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Change card name input */
export type ChangeCardNameInput = {
  cardId: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
};

export type ChangeReviewerInput = {
  /** ID do novo usuário revisor */
  newUserId: Scalars['ID']['input'];
  /** ID do revisor a ser substituído */
  reviewerId: Scalars['ID']['input'];
};

export type ChangeReviewersInput = {
  /** Lista de mudanças de revisores */
  changes: Array<ChangeReviewerInput>;
  /** ID da solicitação de revisão */
  reviewId: Scalars['ID']['input'];
};

export type CheckboxAnswer = {
  __typename?: 'CheckboxAnswer';
  /** Count */
  count: Scalars['Int']['output'];
  /** Values */
  values: Array<Scalars['String']['output']>;
};

/** The checkboxes field */
export type CheckboxesField = FieldType & {
  __typename?: 'CheckboxesField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export enum ConfirmMoveCardEnum {
  Hard = 'hard',
  None = 'none',
  Normal = 'normal'
}

export type ConfirmPasswordResetInput = {
  /** New user password */
  password: Scalars['String']['input'];
  /** Token to confirm new password */
  token: Scalars['String']['input'];
};

/** Connection between the pipes or databases */
export type Connection = {
  /** List of the children connections */
  childrenConnections: Array<Connection>;
  /** Unique identifier of the connection */
  id: Scalars['ID']['output'];
  /** List of the parents connections */
  parentsConnections: Array<Connection>;
};

/** Connection card model */
export type ConnectionCard = Connection & {
  __typename?: 'ConnectionCard';
  /** Age of the card */
  age?: Maybe<Scalars['Int']['output']>;
  /** Whether the card is archived */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Last assignees of the card */
  assignees: Array<User>;
  /** Automation execution of the card in that stage */
  automations?: Maybe<Array<AutomationExecution>>;
  /** List of the children connections */
  childrenConnections: Array<Connection>;
  /** Count of comments in the card */
  commentCount?: Maybe<CardCommentCount>;
  /** When the card was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the card */
  createdBy?: Maybe<User>;
  /** Current stage of the card */
  currentStage?: Maybe<Stage>;
  /** Current stage deadline of the card */
  currentStageDeadline?: Maybe<RealDeadline>;
  /** Fields with values of the card in the current phase */
  currentStageFields?: Maybe<FieldTypesConnection>;
  current_stage_id?: Maybe<Scalars['String']['output']>;
  /** Card description */
  description?: Maybe<Scalars['String']['output']>;
  /** Card initial form fields */
  fields?: Maybe<Array<FieldType>>;
  /** Form of the card */
  form?: Maybe<Form>;
  /** Unique identifier of the connection */
  id: Scalars['ID']['output'];
  /** Position of the card in the stage */
  index?: Maybe<Scalars['Float']['output']>;
  /** Who is responsible for the initial form of the card */
  initialFormResponsible?: Maybe<CardInitialFormResponsible>;
  /** Whether the card is a solicitation */
  isSolicitation?: Maybe<Scalars['Boolean']['output']>;
  /** Labels linked to card */
  labels?: Maybe<Array<CardLabel>>;
  /** Last assignees of the card */
  lastAssignees?: Maybe<Array<User>>;
  /** Last review of the card in the current stage */
  lastReview?: Maybe<Review>;
  /** Whether the card is late */
  late?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** List of the parents connections */
  parentsConnections: Array<Connection>;
  /**
   * Card permissions
   * @deprecated Esse campo será removido em uma versão futura.
   */
  permissions?: Maybe<CardPermissions>;
  /** Pipe of the card */
  pipe?: Maybe<Pipe>;
  /** Pipe deadline of the card */
  pipeDeadline?: Maybe<RealDeadline>;
  /** Whether the card is readonly */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** Get all reviews of a card */
  reviews?: Maybe<Array<Review>>;
  /** Deadlines of the card */
  stagesDeadlines?: Maybe<Array<RealDeadline>>;
  /** When the card first entered the current stage */
  startedCurrentPhaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** Count of tasks in the card */
  taskCount?: Maybe<CardTaskCount>;
  /** When the card was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CreateAutomationInput = {
  /** The action to be performed when the event is triggered */
  action: StageAutomationActionTypeEnum;
  /** The actions parameters */
  action_params: AutomationActionParamsInput;
  /** The description of the automation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The direction of the event */
  direction?: InputMaybe<StageAutomationRunDirectionEnum>;
  /** The event that triggers the automation */
  event: StageAutomationTypeEnum;
  /** Whether the automation is synchronous */
  isSync?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the automation */
  name: Scalars['String']['input'];
  /** Whether the automation should run only once */
  runOnlyOnce?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the stage to attach the automation */
  stageId: Scalars['String']['input'];
};

export type CreateAutomationRoleInput = {
  /** The ID of the automation */
  automationId: Scalars['ID']['input'];
  /** The ID of the pipe to which the automation belongs */
  pipeId?: InputMaybe<Scalars['String']['input']>;
  /** O contexto da entidade de papel (pipeId ou databaseId) à qual o papel será atribuído */
  roleEntityContext?: InputMaybe<RoleEntityContextInput>;
  /**
   * The type of role to be assigned, if pipe id is provided, it must be a valid pipe role type, otherwise it must be a valid global role type.
   * You must have permission to assign this role type (global:roles:manage_users for global) or (pipes:roles:manage_users in the specified pipe).
   */
  roleType: RoleTypeEnum;
};

export type CreateAutomationV2Input = {
  /** Description of the automation */
  description: Scalars['String']['input'];
  /** Name of the automation */
  name: Scalars['String']['input'];
  /** Pipe where this automation is scoped to run */
  pipeId?: InputMaybe<Scalars['ID']['input']>;
  /** Status of the automation */
  status: AutomationStatusEnum;
};

/** Dados para criar uma nova ação em massa */
export type CreateBulkActionInput = {
  /** Dados adicionais necessários para criar a ação em massa */
  data: Scalars['JSONObject']['input'];
  /** Id da entidade associada à ação em massa */
  entityId: Scalars['String']['input'];
  /** Tipo da ação em massa a ser criada */
  type: BulkActionTypeEnum;
};

/** Create card assignee input */
export type CreateCardAssigneeInput = {
  /** Card id */
  cardId: Scalars['ID']['input'];
  /** User email */
  userEmail?: InputMaybe<Scalars['ID']['input']>;
  /** User id */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for creating a card attachment */
export type CreateCardAttachmentInput = {
  /** ID of the card to which the attachment belongs */
  cardId: Scalars['ID']['input'];
  /** Key of the attachment in storage */
  key: Scalars['String']['input'];
  /** MIME type of the attachment */
  mimeType: Scalars['String']['input'];
  /** Name of the attachment */
  name: Scalars['String']['input'];
  /** Size of the attachment in bytes */
  size: Scalars['Int']['input'];
};

/** Card create input */
export type CreateCardCommentAttachmentInput = {
  /** Id do anexo */
  cardAttachmentId: Scalars['ID']['input'];
  /** Id do comentário */
  cardCommentId: Scalars['ID']['input'];
};

/** Card create input */
export type CreateCardCommentInput = {
  /** Card comment belongs to a card */
  cardId: Scalars['ID']['input'];
  /** Card comment content */
  content: Scalars['String']['input'];
};

/** Cria um prazo para um card */
export type CreateCardDeadlineInput = {
  /** Id do Card */
  cardId: Scalars['ID']['input'];
  /** Id do modelo de Prazo */
  deadlineId: Scalars['ID']['input'];
  /** Id da Etapa, caso fornecido, o prazo será criado na etapa */
  stageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCardInput = {
  /** Answers the form questions */
  fields: Array<InputMaybe<Scalars['JSON']['input']>>;
  /** parentCardId */
  parentCardId?: InputMaybe<Scalars['ID']['input']>;
  /** pipeId */
  pipeId: Scalars['ID']['input'];
  /** The create from stage */
  stageId?: InputMaybe<Scalars['ID']['input']>;
};

/** Create label for card input */
export type CreateCardLabelInput = {
  /** Card id */
  cardId: Scalars['ID']['input'];
  /** Label id */
  labelId: Scalars['ID']['input'];
};

export type CreateCardRelatedActionParams = {
  /** The fields to update in the card */
  attributes: AttributesCardInput;
  /** The fields map */
  fieldsMap: Array<FieldMapInput>;
  /** The target relation id */
  targetId: Scalars['ID']['input'];
  /** The relation stage id */
  targetStageId: Scalars['ID']['input'];
};

/** Create card task input */
export type CreateCardTaskInputDto = {
  assignees?: InputMaybe<Array<AssigneeInput>>;
  /** Card ID */
  cardId: Scalars['ID']['input'];
  /** Description of the card task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Due date of the card task */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** User ID */
  fields?: InputMaybe<Array<FieldInput>>;
  /** Metadata for the card task */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pipeLabelsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Priority of the card task */
  priority?: InputMaybe<CardTaskPriorityEnum>;
  /** Whether a comment is required to finish the task */
  requiredCommentToFinish?: InputMaybe<Scalars['Boolean']['input']>;
  stageId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Title of the card task */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Entrada para criar um novo banco de dados */
export type CreateDatabaseInput = {
  /** Descrição do banco de dados */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nome do banco de dados */
  name: Scalars['String']['input'];
  /** Esquema do banco de dados */
  schema: DatabaseSchemaInput;
};

/** Input para criação de um membro do banco de dados */
export type CreateDatabaseMemberInput = {
  /** ID do banco de dados ao qual o membro será associado */
  databaseId: Scalars['ID']['input'];
  /** ID do papel que será atribuído ao membro do banco de dados */
  roleId: Scalars['ID']['input'];
  /** ID do usuário que será adicionado como membro do banco de dados */
  userIdentifier: UserIdentifiableInput;
};

export type CreateDeadlineInput = {
  considerHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  deadline?: InputMaybe<Scalars['Int']['input']>;
  deadlineDisplayUnit?: InputMaybe<DeadlinesTimeDisplayUnitsEnum>;
  deadlineRisk?: InputMaybe<Scalars['Int']['input']>;
  deadlineRiskDisplayUnit?: InputMaybe<DeadlinesTimeDisplayUnitsEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasOfficeHours?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  officeHours?: InputMaybe<OfficeHours>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLabelInput = {
  /** The label color */
  color: Scalars['String']['input'];
  /** The label order */
  name: Scalars['String']['input'];
  /** pipeId */
  pipeId: Scalars['ID']['input'];
};

export type CreateNotificationPipePreferenceDto = {
  enabled: Scalars['Boolean']['input'];
  pipeId: Scalars['ID']['input'];
  preference: UpdateOrCreateNotificationPreferenceDto;
  starred: Scalars['Boolean']['input'];
};

export type CreatePipeInput = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Name  */
  name: Scalars['String']['input'];
};

/** Get pre-signed post to upload a file */
export type CreatePreSignedPostInput = {
  extraEntities?: InputMaybe<Array<ExtraEntitiesInput>>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pipeId: Scalars['ID']['input'];
};

export type CreatePublicCardStageFormLinkInput = {
  cardId: Scalars['ID']['input'];
  customMessage?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  invitedEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  isEditable: Scalars['Boolean']['input'];
  isRequiredAuthenticated: Scalars['Boolean']['input'];
  stageId: Scalars['ID']['input'];
};

export type CreatePublicCardTaskFormLinkInput = {
  cardId: Scalars['ID']['input'];
  customMessage?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  invitedEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  isEditable: Scalars['Boolean']['input'];
  isRequiredAuthenticated: Scalars['Boolean']['input'];
  taskId: Scalars['ID']['input'];
};

/** Entrada para criar um novo registro no banco de dados */
export type CreateRecordInput = {
  /** ID do banco de dados onde o registro será criado */
  databaseId: Scalars['ID']['input'];
  /** Dados do novo registro em formato JSON */
  row: Scalars['JSONObject']['input'];
};

export type CreateStageInput = {
  /** Whether the stage can move cards without tasks being done */
  canMoveCardWithoutTasksBeingDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the stage can receive cards directly from draft */
  canReceiveCardDirectlyFromDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the stage can receive cards without tasks being done */
  canReceiveCardWithoutTasksBeingDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stage color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Confirmation to move card */
  confirmMoveCard?: InputMaybe<ConfirmMoveCardEnum>;
  /** Stage description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the stage is done */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answers the form questions */
  fields?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Stage form uuid */
  formId?: InputMaybe<Scalars['ID']['input']>;
  /** Id of the stage */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Stage order */
  index?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum reviews required */
  minimumReviewsRequired?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the stage will move cards to the next stage automatically */
  moveCardToNextStageWhenDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stage name */
  name: Scalars['String']['input'];
  /** Pipe uuid */
  pipeId: Scalars['ID']['input'];
  /** Revision required at this stage */
  reviewRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Review type */
  reviewType?: InputMaybe<ReviewTypeEnum>;
};

/** Dados para criar uma nova equipe */
export type CreateTeamInput = {
  /** Descrição da equipe */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nome da equipe */
  name: Scalars['String']['input'];
};

/** Dados para adicionar um membro a uma equipe */
export type CreateTeamMemberInput = {
  /** ID da equipe */
  teamId: Scalars['ID']['input'];
  /** Identificador do usuário */
  user: UserIdentifiableInput;
};

/** Input para criação de template de prazo */
export type CreateTemplateDeadlineInput = {
  /** Se deve considerar feriados ao calcular o prazo */
  considerHoliday: Scalars['Boolean']['input'];
  /** Valor do prazo na unidade especificada */
  deadline: Scalars['Int']['input'];
  /** Unidade de tempo para exibir o prazo */
  deadlineDisplayUnit: TemplateDeadlineTimeDisplayUnitEnum;
  /** Valor de risco do prazo na unidade especificada */
  deadlineRisk: Scalars['Int']['input'];
  /** Unidade de tempo para exibir o risco do prazo */
  deadlineRiskDisplayUnit: TemplateDeadlineTimeDisplayUnitEnum;
  /** Descrição do template de prazo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Se o prazo possui restrições de horário comercial */
  hasOfficeHours: Scalars['Boolean']['input'];
  /** Nome do template de prazo */
  name: Scalars['String']['input'];
  /** Configuração de horário comercial para o prazo */
  officeHours?: InputMaybe<OfficeHours>;
  /** ID do fluxo na qual esse template será associado */
  pipeId: Scalars['ID']['input'];
};

/** Create Template Review Input */
export type CreateTemplateReviewInput = {
  /** The description of the template review */
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<FieldInput>>;
  minimumReviewsRequired?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the template review */
  name: Scalars['String']['input'];
  /** The orientation message of the template review */
  orientationMessage?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the template review */
  pipeId: Scalars['ID']['input'];
  requiredCommentToApproveOrReject?: InputMaybe<Scalars['Boolean']['input']>;
  /** The response type of the reviewers in the template review */
  responseType: Scalars['String']['input'];
  /** The ID of the template review */
  reviewers: Array<CreateTemplateReviewReviewerInput>;
  /** The type of the template review */
  type: ReviewTypeEnum;
};

/** Create Template Review Reviewer Input */
export type CreateTemplateReviewReviewerInput = {
  /** The ID of the reviewer */
  id: Scalars['ID']['input'];
  /** The position of the reviewer in the template review */
  position: Scalars['Int']['input'];
};

export type CreateTemplateTaskInput = {
  assigneesUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<FieldInput>>;
  name: Scalars['String']['input'];
  pipeId: Scalars['ID']['input'];
  pipeLabelsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  priority?: InputMaybe<TemplateTaskPriorityEnum>;
  requiredCommentToFinish?: InputMaybe<Scalars['Boolean']['input']>;
  timeToDueFlags?: InputMaybe<Scalars['Int']['input']>;
  timeToDueUnit?: InputMaybe<TemplateTaskTimeToDueUnitEnum>;
  timeToDueValue?: InputMaybe<Scalars['Int']['input']>;
};

/** Cria um convite de usuário */
export type CreateUserInviteInput = {
  /** O email do usuário a ser convidado */
  email: Scalars['String']['input'];
  /** O tipo de papel a ser atribuído ao usuário ao aceitar o convite */
  givenRoleType: RoleTypeEnum;
  /** O nome do usuário a ser convidado */
  name: Scalars['String']['input'];
};

/** The currency field */
export type CurrencyField = FieldType & {
  __typename?: 'CurrencyField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** The currency type */
  currency?: Maybe<Scalars['String']['output']>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Resposta do formulário atual */
export type CurrentAnswerInput = {
  /** Nome do campo */
  fieldName: Scalars['String']['input'];
  /** Valor do campo */
  fieldValue?: InputMaybe<Scalars['String']['input']>;
};

/** Entidade do banco de dados representando um esquema de banco de dados */
export type Database = {
  __typename?: 'Database';
  /** Descrição do banco de dados */
  description?: Maybe<Scalars['String']['output']>;
  /** Identificador único do banco de dados */
  id: Scalars['ID']['output'];
  /** Nome do banco de dados */
  name: Scalars['String']['output'];
  /** Esquema do banco de dados */
  schema: DatabaseSchema;
};

export type DatabaseEdge = {
  __typename?: 'DatabaseEdge';
  cursor: Scalars['String']['output'];
  node: Database;
};

/** The database field */
export type DatabaseField = FieldType & {
  __typename?: 'DatabaseField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  /** The database information */
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Entrada para criar um novo campo do banco de dados */
export type DatabaseFieldInput = {
  /** Valor padrão do campo */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Descrição do campo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nome de exibição do campo */
  displayName: Scalars['String']['input'];
  /** Nome do campo */
  name: Scalars['String']['input'];
  /** Posição do campo */
  position: Scalars['Float']['input'];
  /** Se o campo é uma chave primária */
  primaryKey?: Scalars['Boolean']['input'];
  /** Se o campo é obrigatório */
  required?: Scalars['Boolean']['input'];
  /** Tipo do campo */
  type: DatabaseFieldTypeEnum;
  /** Se o campo é único */
  unique?: Scalars['Boolean']['input'];
};

/** Tipo de campo do banco de dados */
export enum DatabaseFieldTypeEnum {
  /** Campo do tipo booleano */
  Boolean = 'boolean',
  /** Campo do tipo data */
  Date = 'date',
  /** Campo do tipo enumeração (não suportado atualmente) */
  Enum = 'enum',
  /** Campo do tipo JSON (não suportado atualmente) */
  Json = 'json',
  /** Campo do tipo numérico */
  Number = 'number',
  /** Campo do tipo string */
  String = 'string'
}

/** Entidade do log do banco de dados representando uma ação realizada no banco de dados */
export type DatabaseLog = {
  __typename?: 'DatabaseLog';
  /** Ação realizada no banco de dados */
  action: DatabaseLogActionEnum;
  /** Data e hora em que o log foi criado */
  createdAt: Scalars['DateTime']['output'];
  /** Usuário que realizou a ação registrada no log do banco de dados */
  createdBy: User;
  /** Detalhes adicionais sobre a ação realizada no banco de dados */
  details?: Maybe<Scalars['JSONObject']['output']>;
  /** Identificador único do log do banco de dados */
  id: Scalars['ID']['output'];
  /** Razão da ação realizada */
  reason?: Maybe<Scalars['String']['output']>;
  /** Registro do banco de dados associado ao log */
  record?: Maybe<DatabaseRecord>;
};

/** Enum representando as ações possíveis em logs de banco de dados */
export enum DatabaseLogActionEnum {
  /** Ação de criar um novo banco de dados */
  CreateDatabase = 'create_database',
  /** Ação de adicionar um novo membro ao banco de dados */
  CreateDatabaseMember = 'create_database_member',
  /** Ação de criar um novo registro no banco de dados */
  CreateRecord = 'create_record',
  /** Ação de criar um novo campo no esquema do banco de dados */
  CreateSchemaField = 'create_schema_field',
  /** Ação de remover um membro do banco de dados */
  DeleteDatabaseMember = 'delete_database_member',
  /** Ação de deletar um registro existente no banco de dados */
  DeleteRecord = 'delete_record',
  /** Ação de deletar um campo existente no esquema do banco de dados */
  DeleteSchemaField = 'delete_schema_field',
  /** Ação de atualizar um banco de dados existente */
  UpdateDatabase = 'update_database',
  /** Ação de atualizar um membro existente do banco de dados */
  UpdateDatabaseMember = 'update_database_member',
  /** Ação de atualizar um registro existente no banco de dados */
  UpdateRecord = 'update_record',
  /** Ação de atualizar um campo existente no esquema do banco de dados */
  UpdateSchemaField = 'update_schema_field'
}

export type DatabaseLogEdge = {
  __typename?: 'DatabaseLogEdge';
  cursor: Scalars['String']['output'];
  node: DatabaseLog;
};

/** Representa um membro de um banco de dados */
export type DatabaseMember = {
  __typename?: 'DatabaseMember';
  /** Data de criação do membro do banco de dados */
  createdAt: Scalars['DateTime']['output'];
  /** ID do membro do banco de dados */
  id: Scalars['String']['output'];
  /** Papel atribuído ao membro do banco de dados */
  roleType?: Maybe<RoleTypeEnum>;
  user: User;
};

export type DatabaseMemberEdge = {
  __typename?: 'DatabaseMemberEdge';
  cursor: Scalars['String']['output'];
  node: DatabaseMember;
};

/** Entidade de registro do banco de dados */
export type DatabaseRecord = {
  __typename?: 'DatabaseRecord';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** ID do usuário que criou o registro */
  createdBy: Scalars['ID']['output'];
  /** Dados do registro em formato JSON */
  data: Scalars['JSONObject']['output'];
  /** Hash do registro para detecção de alterações */
  hash?: Maybe<Scalars['String']['output']>;
  /** ID do registro */
  id: Scalars['ID']['output'];
  /** Data da última atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** ID do usuário que atualizou o registro pela última vez */
  updatedBy: Scalars['ID']['output'];
};

export type DatabaseRecordEdge = {
  __typename?: 'DatabaseRecordEdge';
  cursor: Scalars['String']['output'];
  node: DatabaseRecord;
};

/** Operadores para filtrar registros do banco de dados por campo e valor */
export enum DatabaseRecordFilterByFieldOperators {
  /** O valor contém a substring especificada. */
  Contains = 'CONTAINS',
  /** O valor termina com a substring especificada. */
  EndsWith = 'ENDS_WITH',
  /** O valor é igual ao valor especificado. */
  Equals = 'EQUALS',
  /** O valor é maior que o valor especificado. */
  GreaterThan = 'GREATER_THAN',
  /** O valor é maior ou igual ao valor especificado. */
  GreaterThanOrEquals = 'GREATER_THAN_OR_EQUALS',
  /** O valor está na lista de valores especificada. */
  In = 'IN',
  /** O valor é nulo ou vazio. */
  IsEmpty = 'IS_EMPTY',
  /** O valor não é nulo nem vazio. */
  IsNotEmpty = 'IS_NOT_EMPTY',
  /** O valor não é nulo. */
  IsNotNull = 'IS_NOT_NULL',
  /** O valor é nulo. */
  IsNull = 'IS_NULL',
  /** O valor é menor que o valor especificado. */
  LessThan = 'LESS_THAN',
  /** O valor é menor ou igual ao valor especificado. */
  LessThanOrEquals = 'LESS_THAN_OR_EQUALS',
  /** O valor não contém a substring especificada. */
  NotContains = 'NOT_CONTAINS',
  /** O valor não termina com a substring especificada. */
  NotEndsWith = 'NOT_ENDS_WITH',
  /** O valor não é igual ao valor especificado. */
  NotEquals = 'NOT_EQUALS',
  /** O valor não está na lista de valores especificada. */
  NotIn = 'NOT_IN',
  /** O valor não começa com a substring especificada. */
  NotStartsWith = 'NOT_STARTS_WITH',
  /** O valor começa com a substring especificada. */
  StartsWith = 'STARTS_WITH'
}

/** Entidade de registro do banco de dados restrito */
export type DatabaseRecordRestricted = {
  __typename?: 'DatabaseRecordRestricted';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Dados do registro em formato JSON */
  data: Scalars['JSONObject']['output'];
  /** Hash do registro para detecção de alterações */
  hash?: Maybe<Scalars['String']['output']>;
  /** ID do registro */
  id: Scalars['ID']['output'];
  /** Data da última atualização */
  updatedAt: Scalars['DateTime']['output'];
};

export type DatabaseRecordRestrictedEdge = {
  __typename?: 'DatabaseRecordRestrictedEdge';
  cursor: Scalars['String']['output'];
  node: DatabaseRecordRestricted;
};

/** Esquema do banco de dados */
export type DatabaseSchema = {
  __typename?: 'DatabaseSchema';
  /** Campos do esquema do banco de dados */
  fields: Array<DatabaseSchemaField>;
  /** ID do esquema */
  id: Scalars['String']['output'];
};

/** Campo do esquema do banco de dados */
export type DatabaseSchemaField = {
  __typename?: 'DatabaseSchemaField';
  /** Descrição do campo */
  description?: Maybe<Scalars['String']['output']>;
  /** Nome de exibição do campo */
  displayName: Scalars['String']['output'];
  /** ID do campo */
  id: Scalars['ID']['output'];
  /** Nome do campo */
  name: Scalars['String']['output'];
  /** Posição do campo */
  position: Scalars['Float']['output'];
  /** O campo é uma chave primária? */
  primaryKey?: Maybe<Scalars['Boolean']['output']>;
  /** O campo é obrigatório? */
  required: Scalars['Boolean']['output'];
  /** Tipo do campo */
  type: DatabaseFieldTypeEnum;
  /** O campo é único? */
  unique?: Maybe<Scalars['Boolean']['output']>;
};

/** Campo do esquema do banco de dados restrito */
export type DatabaseSchemaFieldRestricted = {
  __typename?: 'DatabaseSchemaFieldRestricted';
  /** Nome de exibição do campo */
  displayName: Scalars['String']['output'];
  /** Nome do campo */
  name: Scalars['String']['output'];
  /** Tipo do campo */
  type: DatabaseFieldTypeEnum;
};

/** Entrada para criar um esquema de banco de dados */
export type DatabaseSchemaInput = {
  /** Campos do esquema do banco de dados */
  fields: Array<DatabaseFieldInput>;
};

/** The date field */
export type DateField = FieldType & {
  __typename?: 'DateField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export type Deadline = {
  __typename?: 'Deadline';
  accountId?: Maybe<Scalars['ID']['output']>;
  archived: Scalars['Boolean']['output'];
  considerHoliday: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deadlineDisplayUnit: Scalars['String']['output'];
  deadlineMinutes: Scalars['Int']['output'];
  deadlineRiskDisplayUnit: Scalars['String']['output'];
  deadlineRiskMinutes: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hasOfficeHours: Scalars['Boolean']['output'];
  /** The id of the deadline */
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  officeHours?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Unit of time to display deadlines */
export enum DeadlinesTimeDisplayUnitsEnum {
  Days = 'days',
  Hours = 'hours',
  Minutes = 'minutes'
}

/** Input para criação de um membro do banco de dados */
export type DeleteDatabaseMemberInput = {
  /** ID do banco de dados ao qual o membro será associado */
  databaseId: Scalars['ID']['input'];
  /** ID do usuário que será adicionado como membro do banco de dados */
  userIdentifier: UserIdentifiableInput;
};

export type DisableMfa = {
  __typename?: 'DisableMfa';
  /** Success status */
  success: Scalars['Boolean']['output'];
};

export type DisableMfaInput = {
  /** User password */
  password: Scalars['String']['input'];
};

/** Dados para despachar uma ação em massa, ou seja, iniciar seu processamento */
export type DispatchBulkActionInput = {
  /** ID da ação em massa a ser despachada */
  bulkActionId: Scalars['String']['input'];
  /** O path no s3 onde os arquivos de entrada da ação em massa estão localizados */
  inputFilePath: Scalars['String']['input'];
};

/** The document field */
export type DocumentField = FieldType & {
  __typename?: 'DocumentField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

/** The dropdown field */
export type DropdownField = FieldType & {
  __typename?: 'DropdownField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export type EditTemplateTaskInput = {
  assigneesUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<FieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pipeId?: InputMaybe<Scalars['ID']['input']>;
  pipeLabelsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  priority?: InputMaybe<TemplateTaskPriorityEnum>;
  requiredCommentToFinish?: InputMaybe<Scalars['Boolean']['input']>;
  templateId: Scalars['ID']['input'];
  timeToDueFlags?: InputMaybe<Scalars['Int']['input']>;
  timeToDueUnit?: InputMaybe<TemplateTaskTimeToDueUnitEnum>;
  timeToDueValue?: InputMaybe<Scalars['Int']['input']>;
};

/** The email field */
export type EmailField = FieldType & {
  __typename?: 'EmailField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Representa uma validação de email */
export type EmailValidation = {
  __typename?: 'EmailValidation';
  /** Se o email é válido */
  isValid: Scalars['Boolean']['output'];
  /** O motivo pelo qual o email não é válido */
  reason?: Maybe<Scalars['String']['output']>;
};

export type EnableMfa = {
  __typename?: 'EnableMfa';
  /** Success status */
  success: Scalars['Boolean']['output'];
};

export type EnableMfaInput = {
  /** MFA secret */
  secret: Scalars['String']['input'];
  /** MFA session */
  session: Scalars['String']['input'];
  /** MFA code */
  token: Scalars['String']['input'];
};

export type ExportCardInput = {
  filters?: InputMaybe<FilterCardsParamsInput>;
  /** Pipe ID */
  pipeId: Scalars['ID']['input'];
  selectedPages: Array<ExportCardPages>;
};

export enum ExportCardPages {
  Cards = 'cards',
  InitialForms = 'initialForms',
  StageForms = 'stageForms'
}

/** Input para exportar um banco de dados */
export type ExportDatabaseInput = {
  /** ID do banco de dados a ser exportado */
  databaseId: Scalars['String']['input'];
  /** Estratégia de exportação */
  exportStrategy: ExportWorkbookStrategy;
  /** Fuso horário do usuário */
  timezone: Scalars['String']['input'];
};

export type ExportTasksIncludePagesInput = {
  /** Include the modal forms on the export */
  forms: Scalars['Boolean']['input'];
};

export type ExportTasksInput = {
  /** Card ID */
  cardId?: InputMaybe<Scalars['String']['input']>;
  /** Export strategy */
  exportStrategy: ExportWorkbookStrategy;
  /** Export task ID */
  filters: CardTaskByPipeWhereInputDto;
  /** Include pages in the export */
  includePages?: InputMaybe<ExportTasksIncludePagesInput>;
  /** Pipe ID */
  pipeId: Scalars['String']['input'];
  /** User timezone */
  timezone: Scalars['String']['input'];
};

/** A estratégia de exportação a ser usada */
export enum ExportWorkbookStrategy {
  /** Formato legível para pessoas, nomes das colunas amigáveis e não mostra ids */
  HumanReadable = 'human_readable',
  /** Formato legível para máquinas, inclui todos os ids e formatos que podem ser re-importados */
  MachineReadable = 'machine_readable'
}

/** Extra entites to add */
export type ExtraEntitiesInput = {
  entity: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** Representa uma funcionalidade no sistema */
export type Feature = {
  __typename?: 'Feature';
  /** Data de criação da funcionalidade */
  createdAt: Scalars['DateTime']['output'];
  /** Preço padrão da funcionalidade em centavos */
  defaultPriceCents: Scalars['Float']['output'];
  /** Descrição da funcionalidade */
  description?: Maybe<Scalars['String']['output']>;
  /** Tipo da entidade atrelada a uma funcionalidade do tipo licença */
  entityType?: Maybe<FeatureEntityType>;
  /** Quantos dias para resetar a contagem de uma funcionalidade do tipo medido */
  meteredResetPeriodDays?: Maybe<Scalars['Float']['output']>;
  /** Nome da funcionalidade */
  name: Scalars['String']['output'];
  /** Slug da funcionalidade */
  slug: FeatureSlug;
  /** Tipo da funcionalidade */
  type: FeatureType;
  /** Data de atualização da funcionalidade */
  updatedAt: Scalars['DateTime']['output'];
};

/** O tipo da entidade atrelada a uma funcionalidade do tipo licença */
export enum FeatureEntityType {
  /** Entidade do tipo armazenamento (ex: arquivos, imagens, vídeos) */
  Storage = 'STORAGE',
  /** Entidade do tipo usuário (ex: membros da equipe, clientes) */
  User = 'USER'
}

/** Feature Flag */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /** Feature flag accounts */
  accounts: FeatureFlagAccountPaginated;
  /** Feature flag status */
  active: Scalars['Boolean']['output'];
  /** Feature flag creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Feature flag purpose and description */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Feature flag metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Feature flag unique readable identifier */
  slug: Scalars['String']['output'];
  /** Feature flag last update date */
  updatedAt: Scalars['DateTime']['output'];
  /** Feature flag is only available for whitelisted accounts or all accounts */
  whitelistOnly: Scalars['Boolean']['output'];
};


/** Feature Flag */
export type FeatureFlagAccountsArgs = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

/** Feature Flag Account */
export type FeatureFlagAccount = {
  __typename?: 'FeatureFlagAccount';
  /** Account ID */
  accountId: Scalars['String']['output'];
  /** Feature flag account creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Feature flag ID */
  featureFlagId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FeatureFlagAccountEdge = {
  __typename?: 'FeatureFlagAccountEdge';
  cursor: Scalars['String']['output'];
  node: FeatureFlagAccount;
};

/** Feature Flag account connection */
export type FeatureFlagAccountPaginated = {
  __typename?: 'FeatureFlagAccountPaginated';
  edges: Array<FeatureFlagAccountEdge>;
  nodes: Array<FeatureFlagAccount>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FeatureFlagEdge = {
  __typename?: 'FeatureFlagEdge';
  cursor: Scalars['String']['output'];
  node: FeatureFlag;
};

/** Feature Flag connection */
export type FeatureFlagPaginated = {
  __typename?: 'FeatureFlagPaginated';
  edges: Array<FeatureFlagEdge>;
  nodes: Array<FeatureFlag>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FeatureFlagWhereInput = {
  /** Feature flag status */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feature flag unique readable identifier */
  slugContains?: InputMaybe<Scalars['String']['input']>;
  /** Feature flag is only available for whitelisted accounts or all accounts */
  whitelistOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** O slug da funcionalidade */
export enum FeatureSlug {
  /** Funcionalidade de licença para operator de usuário */
  UserOperatorLicense = 'UserOperatorLicense'
}

/** O tipo da funcionalidade */
export enum FeatureType {
  /** Funcionalidade do tipo booleano (ativada/desativada) */
  Boolean = 'BOOLEAN',
  /** Funcionalidade do tipo licença (baseado em licença e atrelado a uma entidade) */
  License = 'LICENSE',
  /** Funcionalidade do tipo medido (baseado em uso) */
  Metered = 'METERED'
}

export type FieldCondition = {
  __typename?: 'FieldCondition';
  /** The condition ID */
  id: Scalars['ID']['output'];
  /** The condition operator */
  operator: Scalars['String']['output'];
  /** The condition field */
  question?: Maybe<Scalars['JSON']['output']>;
  /** The condition value */
  value: Scalars['String']['output'];
};

/** Representa o tipo de dependência de uma condição de campo. */
export enum FieldConditionDependencyType {
  /** Dependência baseada em campo. */
  Field = 'FIELD',
  /** Dependência baseada em status de aprovação. */
  ReviewStatus = 'REVIEW_STATUS'
}

/** Condição para exibir ou habilitar campos baseada em outro campo */
export type FieldConditionInput = {
  /** Tipo de dependência da condição (campo ou status de aprovação) */
  dependencyType?: FieldConditionDependencyType;
  /** Chave do campo do qual esta condição depende */
  dependsOnFieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Valor esperado (array de strings) para a condição */
  expectedValueArray?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Valor esperado (string) para a condição */
  expectedValueString?: InputMaybe<Scalars['String']['input']>;
  /** Operador da condição (ex: igual, diferente, etc.) */
  operator: FieldConditionOperator;
};

/** Representa um operador de condição para campos personalizados. */
export enum FieldConditionOperator {
  /** Verifica se o valor do campo contém o valor esperado. */
  Contains = 'CONTAINS',
  /** Verifica se o valor do campo é igual ao valor esperado. */
  Equals = 'EQUALS',
  /** Verifica se o valor do campo está dentro do conjunto de valores esperados. (Valido apenas para campos do tipo array) */
  In = 'IN',
  /** Verifica se o valor do campo corresponde à expressão regular fornecida. */
  Matches = 'MATCHES',
  /** Verifica se o valor do campo não contém o valor esperado. */
  NotContains = 'NOT_CONTAINS',
  /** Verifica se o valor do campo é diferente do valor esperado. */
  NotEquals = 'NOT_EQUALS',
  /** Verifica se o valor do campo não está dentro do conjunto de valores esperados. (Valido apenas para campos do tipo array) */
  NotIn = 'NOT_IN',
  /** Verifica se o valor do campo não corresponde à expressão regular fornecida. */
  NotMatches = 'NOT_MATCHES'
}

export type FieldDatabase = {
  __typename?: 'FieldDatabase';
  /** The database information */
  database: FieldDatabaseInfo;
  /** Campos do banco de dados exibidos ao usuário */
  databaseDisplayFields: Array<Scalars['String']['output']>;
  /** Filtros padrão aplicados ao banco de dados */
  databaseFilters?: Maybe<Array<SharedFieldDatabaseFilter>>;
  /** Campo do banco de dados usado como rótulo */
  databaseLabelField: Scalars['String']['output'];
  /** Campos do banco de dados que podem ser pesquisados */
  databaseSearchableFields: Array<Scalars['String']['output']>;
  /** The database connection ID */
  id: Scalars['ID']['output'];
};

export type FieldDatabaseInfo = {
  __typename?: 'FieldDatabaseInfo';
  /** The database ID */
  id: Scalars['ID']['output'];
  /** The database name */
  name: Scalars['String']['output'];
};

/** Configuração de campo para campos do tipo database */
export type FieldDatabaseInput = {
  /** Campos do banco de dados exibidos ao usuário */
  databaseDisplayFields: Array<Scalars['String']['input']>;
  /** Campos do banco de dados exibidos ao usuário */
  databaseFilters?: InputMaybe<Array<FilterDatabaseFiltersInput>>;
  /** ID do banco de dados referenciado */
  databaseId: Scalars['ID']['input'];
  /** Campo do banco de dados usado como rótulo */
  databaseLabelField: Scalars['String']['input'];
  /** ID da versão do esquema do banco de dados referenciado */
  databaseSchemaVersionId: Scalars['ID']['input'];
  /** Campos do banco de dados que podem ser pesquisados */
  databaseSearchableFields: Array<Scalars['String']['input']>;
};

/** Input para configuração de campos dinâmicos em templates e formulários */
export type FieldInput = {
  /** Condições para exibir ou habilitar o campo */
  conditions?: InputMaybe<Array<FieldConditionInput>>;
  /** Configuração para campos do tipo database */
  database?: InputMaybe<FieldDatabaseInput>;
  /** Texto de ajuda exibido ao usuário */
  helpText?: InputMaybe<Scalars['String']['input']>;
  /** Chave única do campo (usada para identificação interna) */
  key: Scalars['String']['input'];
  /** Nome do campo apresentado ao usuário */
  name: Scalars['String']['input'];
  /** Opções disponíveis para campos do tipo select, checkbox, etc. */
  options?: InputMaybe<Array<FieldOptionInput>>;
  /** Mensagem de orientação exibida ao usuário */
  orientationMessage?: InputMaybe<Scalars['String']['input']>;
  /** Posição do campo no formulário */
  position: Scalars['Int']['input'];
  /** Indica se o campo é obrigatório */
  required?: Scalars['Boolean']['input'];
  /** Esquema de validação do campo */
  schema?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Tipo do campo (ex: texto, número, select, etc.) */
  type: FieldTypeEnum;
};

export type FieldMapInput = {
  /** The field content */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The field map id */
  map: Scalars['String']['input'];
};

export type FieldOption = {
  __typename?: 'FieldOption';
  /** The option ID */
  id: Scalars['ID']['output'];
  /** The option position */
  position: Scalars['String']['output'];
  /** The option value */
  value: Scalars['String']['output'];
};

/** Opção de campo para campos do tipo select, checkbox, etc. */
export type FieldOptionInput = {
  /** Rótulo da opção apresentada ao usuário */
  label: Scalars['String']['input'];
  /** Posição da opção na lista */
  position: Scalars['Int']['input'];
};

export type FieldPositionInput = {
  /** ID do campo */
  fieldId: Scalars['String']['input'];
  /** Nova posição do campo */
  position: Scalars['Float']['input'];
};

/** Tipos de fontes nas quais um campo pode estar presente */
export enum FieldSourceType {
  /** O campo está presente em uma tarefa */
  CardTask = 'cardTask',
  /** O campo está presente em um formulário inicial ou de etapa */
  LegacyAnswer = 'legacyAnswer',
  /** O campo está presente em uma pergunta de formulário que não foi respondida ainda */
  LegacyQuestion = 'legacyQuestion',
  /** O campo está presente em um revisor */
  Reviewer = 'reviewer'
}

/** Field information */
export type FieldType = {
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export type FieldTypeEdge = {
  __typename?: 'FieldTypeEdge';
  cursor: Scalars['String']['output'];
  node: FieldType;
};

/** Tipo do campo */
export enum FieldTypeEnum {
  /** Campo de anexo */
  Attachment = 'attachment',
  /** Campo de caixas de seleção */
  Checkboxes = 'checkboxes',
  /** Campo de moeda */
  Currency = 'currency',
  /** Campo de múltiplos itens do banco de dados */
  DatabaseMultiple = 'databaseMultiple',
  /** Campo de item único do banco de dados */
  DatabaseSingle = 'databaseSingle',
  /** Campo de data */
  Date = 'date',
  /** Campo de lista suspensa */
  Dropdown = 'dropdown',
  /** Campo de hora */
  Hour = 'hour',
  /** Campo de escolha múltipla */
  MultipleChoice = 'multipleChoice',
  /**
   * Campo de múltiplas imagens
   * @deprecated Use o campo de anexos em vez disso
   */
  MultiplePicture = 'multiplePicture',
  /** Campo numérico */
  Numeric = 'numeric',
  /** Campo de parágrafo */
  Paragraph = 'paragraph',
  /**
   * Campo de imagem
   * @deprecated Use o campo de anexos em vez disso
   */
  Picture = 'picture',
  /** Campo de resposta curta */
  ShortAnswer = 'shortAnswer',
  /** Campo de assinatura */
  Signature = 'signature',
  /** Campo tabular */
  Tabular = 'tabular',
  /** Campo de URL */
  Url = 'url'
}

/** Card connection */
export type FieldTypesConnection = {
  __typename?: 'FieldTypesConnection';
  edges: Array<FieldTypeEdge>;
  nodes: Array<FieldType>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FilterCardsParamsInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigneesFilterBehavior?: InputMaybe<Scalars['String']['input']>;
  assigneesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  deadline_gte?: InputMaybe<Scalars['DateTime']['input']>;
  deadline_lte?: InputMaybe<Scalars['DateTime']['input']>;
  filtersByForm?: InputMaybe<Array<FiltersCardsByFormInput>>;
  labelsFilterBehavior?: InputMaybe<Scalars['String']['input']>;
  labelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  stageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Filtros para registros do banco de dados */
export type FilterDatabaseFiltersInput = {
  /** Campo para buscar */
  field: Scalars['String']['input'];
  /** Operador para o filtro de campo */
  operator: DatabaseRecordFilterByFieldOperators;
  /** Valor para filtrar registros */
  value: Scalars['String']['input'];
};

export type FiltersCardsByFormInput = {
  /** Values that cannot be */
  notValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The title of the question */
  questionTitle: Scalars['String']['input'];
  /** A single value */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Multiple values */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FiltersCardsInput = {
  /** Filter by archived status */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Behavior for filtering by assignees */
  assigneesFilterBehavior?: InputMaybe<MultiSelectFilterBehaviorEnum>;
  /** Assignees ids separated by comma */
  assigneesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtrar pelas etapas que um card passou */
  cardsStages?: InputMaybe<Array<FiltersCardsStagesInput>>;
  /** Comportamento para filtrar pelas etapas que um card passou */
  cardsStagesFilterBehavior?: InputMaybe<MultiSelectFilterBehaviorEnum>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by creator ids */
  createdByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deadline_gte?: InputMaybe<Scalars['DateTime']['input']>;
  deadline_lte?: InputMaybe<Scalars['DateTime']['input']>;
  filtersByForm?: InputMaybe<Array<FiltersCardsByFormInput>>;
  /** Filter by card ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Behavior for filtering by labels */
  labelsFilterBehavior?: InputMaybe<MultiSelectFilterBehaviorEnum>;
  labelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by stage ids */
  stageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by card status */
  status?: InputMaybe<FiltersSelfCardsStatusEnum>;
};

/** Filtrar pelas etapas que um card passou */
export type FiltersCardsStagesInput = {
  /** Data de chegada na etapa (maior ou igual a) */
  arrivedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de chegada na etapa (menor ou igual a) */
  arrivedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de criação do card na etapa, pode ser interpretado como a primeira vez que o card entrou na etapa (maior ou igual a) */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de criação do card na etapa, pode ser interpretado como a primeira vez que o card entrou na etapa (menor ou igual a) */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de saída na etapa (maior ou igual a) */
  leftAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de saída na etapa (menor ou igual a) */
  leftAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Id da etapa */
  stageId: Scalars['ID']['input'];
  /** Data da última movimentação do card na etapa (maior ou igual a) */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data da última movimentação do card na etapa (menor ou igual a) */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FiltersFormInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
};

export type FiltersReportsDetailsInput = {
  endDate: Scalars['DateTime']['input'];
  stageId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type FiltersReportsInput = {
  endDate: Scalars['DateTime']['input'];
  formName?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type FiltersSelfCardsInput = {
  /** Assignees ids separated by comma */
  assigneesIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  hasNoDeadline?: InputMaybe<Scalars['Boolean']['input']>;
  isSolicitation?: InputMaybe<Scalars['Boolean']['input']>;
  labelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by pipe name */
  pipe?: InputMaybe<Scalars['String']['input']>;
  solicitationChangesRequested?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by stage name */
  stage?: InputMaybe<Scalars['String']['input']>;
  /** Filter by card status */
  status?: InputMaybe<FiltersSelfCardsStatusEnum>;
};

export enum FiltersSelfCardsStatusEnum {
  /** All cards */
  All = 'all',
  /** Only concluded cards (are in a final stage) */
  Concluded = 'concluded',
  /** Only not concluded cards (are not in a final stage) */
  NotConcluded = 'notConcluded'
}

export type FixedChoiceAnswer = {
  __typename?: 'FixedChoiceAnswer';
  /** Count */
  count: Scalars['Int']['output'];
  /** Value */
  value?: Maybe<Scalars['String']['output']>;
};

export type FluxDocContent = {
  __typename?: 'FluxDocContent';
  content?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Form = {
  __typename?: 'Form';
  /** ID hasheado do formulário */
  hashedId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Nome do formulário */
  name: Scalars['String']['output'];
  /** ID do pipe */
  pipe?: Maybe<Pipe>;
  questions: Array<FormQuestion>;
  questionsCount: Scalars['Int']['output'];
  /** Indica se os membros do time podem visualizar solicitações de outros membros do time */
  teamMembersCanViewOthersSolicitations?: Maybe<Scalars['Boolean']['output']>;
  /** Tipo do formulário */
  type: Scalars['String']['output'];
};

export type FormEdge = {
  __typename?: 'FormEdge';
  cursor: Scalars['String']['output'];
  node: Form;
};

/** Questão do formulário */
export type FormQuestion = {
  __typename?: 'FormQuestion';
  conditions: Array<FormQuestionCondition>;
  /** Validação customizada da questão */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Mensagem de validação customizada da questão */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FormQuestionDatabase>;
  /** Formulário da questão */
  form: Form;
  /** Texto de ajuda para a questão */
  helpText?: Maybe<Scalars['String']['output']>;
  /** ID da questão do formulário */
  id: Scalars['ID']['output'];
  /** Opções da questão */
  options: Array<FormQuestionOption>;
  /** Ordem da questão */
  position: Scalars['Int']['output'];
  /** Indica se a questão é obrigatória */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** Título da questão */
  title: Scalars['String']['output'];
  /** Tipo da questão */
  type: LegacyFieldTypeEnum;
};

export type FormQuestionAnswer = CheckboxAnswer | FixedChoiceAnswer | OpenChoiceAnswer;

export type FormQuestionCondition = {
  __typename?: 'FormQuestionCondition';
  /** Operador da condição da questão */
  operator: Scalars['String']['output'];
  question: FormQuestionConditionParentQuestion;
  /** Valor da condição da questão */
  value: Scalars['String']['output'];
};

export type FormQuestionConditionInput = {
  /** Operador da condição */
  operator: Scalars['String']['input'];
  /** Questão pai da condição */
  question: FormQuestionConditionParentQuestionInput;
  /** Valores da condição */
  value: Scalars['String']['input'];
};

export type FormQuestionConditionParentQuestion = {
  __typename?: 'FormQuestionConditionParentQuestion';
  /** ID da condição da questão */
  id: Scalars['ID']['output'];
  /** Título da condição da questão */
  title?: Maybe<Scalars['String']['output']>;
};

export type FormQuestionConditionParentQuestionInput = {
  /** ID da questão pai */
  id: Scalars['String']['input'];
  /** Título da questão pai */
  title: Scalars['String']['input'];
};

export type FormQuestionDatabase = {
  __typename?: 'FormQuestionDatabase';
  database: Database;
  /** Campos do banco de dados exibidos ao usuário */
  databaseDisplayFields: Array<Scalars['String']['output']>;
  /** Filtros padrão aplicados ao banco de dados */
  databaseFilters?: Maybe<Array<SharedFieldDatabaseFilter>>;
  /** Campo do banco de dados usado como rótulo */
  databaseLabelField: Scalars['String']['output'];
  /** ID da versão do esquema do banco de dados */
  databaseSchemaVersionId: Scalars['String']['output'];
  /** Campos do banco de dados que podem ser pesquisados */
  databaseSearchableFields: Array<Scalars['String']['output']>;
  /** ID do banco de dados da questão */
  id: Scalars['ID']['output'];
};

/** Configuração de campo para campos do tipo database */
export type FormQuestionDatabaseInput = {
  /** Campos do banco de dados exibidos ao usuário */
  databaseDisplayFields: Array<Scalars['String']['input']>;
  /** Filtros do banco de dados */
  databaseFilters?: InputMaybe<Array<FilterDatabaseFiltersInput>>;
  /** ID do banco de dados referenciado */
  databaseId: Scalars['ID']['input'];
  /** Campo do banco de dados usado como rótulo */
  databaseLabelField: Scalars['String']['input'];
  /** ID da versão do esquema do banco de dados referenciado */
  databaseSchemaVersionId: Scalars['ID']['input'];
  /** Campos do banco de dados que podem ser pesquisados */
  databaseSearchableFields: Array<Scalars['String']['input']>;
  /** ID da opção */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormQuestionInput = {
  /** Remover questão */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Condições da questão */
  conditions?: InputMaybe<Array<FormQuestionConditionInput>>;
  /** Validação customizada da questão */
  customValidation?: InputMaybe<Scalars['String']['input']>;
  /** Mensagem de validação customizada da questão */
  customValidationMessage?: InputMaybe<Scalars['String']['input']>;
  /** Configuração do banco de dados para questões do tipo banco de dados */
  database?: InputMaybe<FormQuestionDatabaseInput>;
  /** Texto de ajuda para a questão */
  helpText?: InputMaybe<Scalars['String']['input']>;
  /** ID da questão */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Opções da questão */
  options?: InputMaybe<Array<FormQuestionOptionsInput>>;
  /** Ordem da questão */
  position: Scalars['Int']['input'];
  /** Indica se a questão é obrigatória */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Esquema de validação do campo */
  schema?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Título da questão */
  title: Scalars['String']['input'];
  /** Tipo da questão */
  type: LegacyFieldTypeEnum;
};

export type FormQuestionOption = {
  __typename?: 'FormQuestionOption';
  /** Orientação da opção da questão */
  description?: Maybe<Scalars['String']['output']>;
  /** ID da opção da questão */
  id: Scalars['ID']['output'];
  /** Posição da opção da questão */
  position: Scalars['Float']['output'];
  /** Questão da opção */
  question: FormQuestion;
  /** Pontuação da opção da questão */
  score?: Maybe<Scalars['Float']['output']>;
  /** Valor da opção da questão */
  value: Scalars['String']['output'];
};

export type FormQuestionOptionsInput = {
  /** Remover opção */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Descrição da opção */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID da opção */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Ordem da opção */
  position: Scalars['Float']['input'];
  /** Pontuação da opção */
  score?: InputMaybe<Scalars['Float']['input']>;
  /** Valor da opção */
  value: Scalars['String']['input'];
};

export type FormReport = {
  __typename?: 'FormReport';
  /** Number of answers */
  answersCount: Scalars['Int']['output'];
  /** Form */
  form: Form;
  /** Is start form */
  isStartForm: Scalars['Boolean']['output'];
  /** Stages */
  stages?: Maybe<Array<Stage>>;
};

export type FormReportDetails = {
  __typename?: 'FormReportDetails';
  /** Position */
  position: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
  /** Type */
  type: Scalars['String']['output'];
  /** Answers */
  values: Array<FormQuestionAnswer>;
};

export type FormTeamAccessTeam = {
  __typename?: 'FormTeamAccessTeam';
  /** Descrição do time */
  description?: Maybe<Scalars['String']['output']>;
  /** Identificador único do time */
  id: Scalars['String']['output'];
  /** Nome do time */
  name: Scalars['String']['output'];
  /** Slug do time */
  slug: Scalars['String']['output'];
};

/** Form type enum */
export enum FormTypeEnum {
  Internal = 'internal',
  Private = 'private',
  Public = 'public'
}

export type FormUserAccessUser = {
  __typename?: 'FormUserAccessUser';
  /** URL do avatar do usuário */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** E-mail do usuário */
  email?: Maybe<Scalars['String']['output']>;
  /** Identificador único do usuário */
  id: Scalars['String']['output'];
  /** Nome do usuário */
  name: Scalars['String']['output'];
};

export type GetBatchTemplatesByStageInput = {
  stageId: Scalars['ID']['input'];
  templatesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetBulkActionPresignedPostInput = {
  /** List of file names for which presigned POST URLs are requested */
  bulkActionId: Scalars['ID']['input'];
  /** File name for which presigned POST URL is requested */
  fileName: Scalars['String']['input'];
  /** MIME type of the file for which presigned POST URL is requested */
  mimeType: Scalars['String']['input'];
};

/** Get pre-signed input */
export type GetPresignedProfileInput = {
  /** File name */
  fileName: Scalars['String']['input'];
  /** File MIME type */
  mimeType: Scalars['String']['input'];
};

/** Type of the form for which the pre-signed post is requested */
export enum GetPublicPreSignedFormTypeEnum {
  InitialForm = 'initial_form',
  StageForm = 'stage_form',
  TaskForm = 'task_form'
}

/** Get pre-signed post to see a file */
export type GetPublicPreSignedGetInput = {
  formHash: Scalars['String']['input'];
  formType: GetPublicPreSignedFormTypeEnum;
  key: Scalars['String']['input'];
};

/** Get pre-signed post to upload a file */
export type GetPublicPreSignedPostInput = {
  extraEntities?: InputMaybe<Array<ExtraEntitiesInput>>;
  formHash: Scalars['String']['input'];
  formType: GetPublicPreSignedFormTypeEnum;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GetRecoveryCodesInput = {
  /** User password */
  password: Scalars['String']['input'];
};

export enum GetUserInviteSortOrderEnum {
  AcceptedAt = 'accepted_at',
  CreatedAt = 'created_at',
  Email = 'email',
  Id = 'id',
  Name = 'name',
  RoleType = 'role_type',
  Status = 'status'
}

export enum GetUserSortOrderEnum {
  CreatedAt = 'created_at',
  Email = 'email',
  Id = 'id',
  LastSeenAt = 'last_seen_at',
  Name = 'name',
  RoleType = 'role_type'
}

export type GetUsersInvitesSortOrderInput = {
  field: GetUserInviteSortOrderEnum;
  order: SortOrderDirection;
};

export type GetUsersSortOrderInput = {
  field: GetUserSortOrderEnum;
  order: SortOrderDirection;
};

/** Filtros para a busca de usuários */
export type GetUsersWhereInput = {
  /** Se o usuário está ativo */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** O e-mail do usuário para pesquisar */
  email?: InputMaybe<Scalars['String']['input']>;
  /** O nome do usuário para pesquisar */
  name?: InputMaybe<Scalars['String']['input']>;
  /** O nome ou o e-mail do usuário para pesquisar */
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  /** O tipo de cargo do usuário para pesquisar */
  roleType?: InputMaybe<RoleTypeWithNone>;
  /** O tipo de usuário para pesquisar, o padrão é [user] */
  userType?: InputMaybe<Array<UserType>>;
};

/** The hour field */
export type HourField = FieldType & {
  __typename?: 'HourField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export type InviteUsersToPipeInput = {
  /** Pipe ID */
  pipeId: Scalars['ID']['input'];
  /** Users */
  users: Array<InviteUsersToPipeUsersInput>;
};

export type InviteUsersToPipePayload = {
  __typename?: 'InviteUsersToPipePayload';
  /** Errors */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Pipe ID */
  pipe: Pipe;
  /** Success */
  success: Scalars['Boolean']['output'];
  /** Users */
  users: Array<PipesMember>;
};

export type InviteUsersToPipeUsersInput = {
  /** User e-mail */
  email: Scalars['String']['input'];
  /** User role */
  role: RoleTypeEnum;
};

/** Label */
export type Label = {
  __typename?: 'Label';
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LabelEdge = {
  __typename?: 'LabelEdge';
  cursor: Scalars['String']['output'];
  node: Label;
};

export enum LegacyFieldTypeEnum {
  Attachment = 'attachment',
  Checkboxes = 'checkboxes',
  Currency = 'currency',
  DatabaseMultiple = 'databaseMultiple',
  DatabaseSingle = 'databaseSingle',
  Date = 'date',
  Dropdown = 'dropdown',
  Hour = 'hour',
  MultipleChoice = 'multipleChoice',
  MultiplePicture = 'multiplePicture',
  Numeric = 'numeric',
  Paragraph = 'paragraph',
  Picture = 'picture',
  ShortAnswer = 'shortAnswer',
  Signature = 'signature',
  Tabular = 'tabular',
  Url = 'url'
}

export type ListTemplatesByStage = {
  __typename?: 'ListTemplatesByStage';
  cursor: Scalars['String']['output'];
  node: StageTemplate;
};

export type ListTemplatesByStageResponse = {
  __typename?: 'ListTemplatesByStageResponse';
  edges: Array<ListTemplatesByStage>;
  nodes: Array<StageTemplate>;
  pageInfo: PageInfo;
};

/** Me */
export type Me = {
  __typename?: 'Me';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  loginProvider?: Maybe<UsersLoginProviderEnum>;
  mfa?: Maybe<Mfa>;
  name: Scalars['String']['output'];
  passwordChangedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Role in pipe */
  roleInPipe?: Maybe<RoleInPipeEnum>;
};


/** Me */
export type MeRoleInPipeArgs = {
  params?: InputMaybe<MeParamsInput>;
};

/** Me params input */
export type MeParamsInput = {
  /** Pipe id */
  pipeId?: InputMaybe<Scalars['String']['input']>;
};

/** Me presigned */
export type MePresigned = {
  __typename?: 'MePresigned';
  fields: Scalars['JSONObject']['output'];
  url: Scalars['String']['output'];
};

export type Mfa = {
  __typename?: 'Mfa';
  /** MFA createdAt */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** MFA enabled */
  enabled: Scalars['Boolean']['output'];
  /** MFA updatedAt */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Move card to stage */
export type MoveCardToStageInput = {
  afterStageId: Scalars['ID']['input'];
  beforeStageId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
  nextCardId?: InputMaybe<Scalars['ID']['input']>;
  previousCardId?: InputMaybe<Scalars['ID']['input']>;
};

/** Move stage axis input */
export type MoveStageAxisInput = {
  /** Next stage id */
  nextStageId?: InputMaybe<Scalars['ID']['input']>;
  /** Previous stage id */
  previousStageId?: InputMaybe<Scalars['ID']['input']>;
  /** Stage id */
  stageId: Scalars['ID']['input'];
};

/** Multi select filter behavior */
export enum MultiSelectFilterBehaviorEnum {
  All = 'all',
  Some = 'some'
}

/** The multipleChoice field */
export type MultipleChoiceField = FieldType & {
  __typename?: 'MultipleChoiceField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite?: Maybe<AuthenticatedUser>;
  addCardTaskAssignee: CardTaskAssignee;
  addCardTaskAssignees: Array<CardTaskAssignee>;
  addCardTaskLabel: CardTaskLabel;
  /** Adicionar um campo ao esquema do banco de dados */
  addDatabaseSchemaField: DatabaseSchemaField;
  addFormToStage: Stage;
  answerCardTaskField: CardTaskField;
  approveReview: Reviewer;
  /** Archive a card */
  archiveCard: Card;
  assignDeadlineToPipe: Deadline;
  assignDeadlineToStage: Deadline;
  attachTemplatesToStage: Array<Template>;
  /** Excluir múltiplos registros do banco de dados */
  batchDeleteDatabaseRecord: BatchDeleteDatabaseRecord;
  /** Update or replace actions, triggers and triggers conditions */
  batchUpsertAutomationV2Data: AutomationV2;
  /** Criar ou atualizar múltiplos registros do banco de dados */
  batchUpsertDatabaseRecord: BatchUpsertDatabaseRecord;
  bulkUpdateReviewers: BulkUpdateReviewers;
  bulkUpdateTaskAssignees: BulkUpdateTaskAssignees;
  /** Cancela a ação em massa antes de seu processamento */
  cancelBulkAction: BulkAction;
  /** Cancel a card return to the solicitor */
  cancelCardToSolicitor: Scalars['Boolean']['output'];
  /** Cancel a review request */
  cancelReview: Review;
  /** Change name of a card */
  changeCardName: Card;
  /** Change reviewers of a review request */
  changeReviewers: Review;
  confirmPasswordReset: PasswordResetResult;
  /** @deprecated This mutation is deprecated, use `createAutomationV2` instead. */
  createAutomation: Automation;
  /** Create a new automation */
  createAutomationV2: AutomationV2;
  /** Create a new automation role */
  createAutomationV2Role: AutomationV2Role;
  /** Cria uma nova ação em massa */
  createBulkAction: BulkAction;
  /** Create a card */
  createCard: Card;
  /** Create a new card assignee */
  createCardAssignee: CardAssignee;
  /** Create a card attachment */
  createCardAttachment: CardAttachment;
  /** Create a new comment */
  createCardComment: CardComment;
  /** Create a new comment attachment */
  createCardCommentAttachment: CardComment;
  /** Cria um prazo para um card */
  createCardDeadline: RealDeadline;
  /** Add a label to a card */
  createCardLabel: CardLabel;
  createCardTask: CardTask;
  /** Criar um novo banco de dados */
  createDatabase: Database;
  /** Adiciona um membro ao banco de dados */
  createDatabaseMember: DatabaseMember;
  /** Criar um novo registro no banco de dados */
  createDatabaseRecord: DatabaseRecord;
  createFeatureFlagAccount: FeatureFlagAccount;
  createLabel: Label;
  /** Create the notification preferences for the current user */
  createNotificationPipePreference: NotificationPipePreference;
  /** Cria um novo fluxo */
  createPipe: Pipe;
  createPublicCardStageFormLink: CardsSharedLink;
  createPublicCardTaskFormLink: CardsTasksSharedLink;
  createSolicitation: Card;
  createStage: Stage;
  /** Cria uma nova equipe */
  createTeam: Team;
  /** Adiciona um membro a uma equipe */
  createTeamMember: TeamMember;
  /** Create a new template deadline */
  createTemplateDeadline: Template;
  /** Create a new template review */
  createTemplateReview: Template;
  /** Create a new template task */
  createTemplateTask: Template;
  /** Cria um convite de usuário */
  createUserInvite: UserInvite;
  /** Delete a card attachment */
  deleteCardAttachment: CardAttachment;
  deleteCardTask: Scalars['Boolean']['output'];
  /** Remove um membro do banco de dados */
  deleteDatabaseMember: Scalars['Boolean']['output'];
  /** Excluir um registro do banco de dados */
  deleteDatabaseRecord: Scalars['Boolean']['output'];
  deleteFeatureFlagAccount: FeatureFlagAccount;
  deleteLabel: Scalars['Boolean']['output'];
  /** Arquiva (deleta) um fluxo */
  deletePipe: Scalars['Boolean']['output'];
  deleteStage: Scalars['Boolean']['output'];
  detachTemplateFromStage: Scalars['Boolean']['output'];
  disableFeatureFlag: FeatureFlag;
  disableFeatureFlagWhitelistOnly: FeatureFlag;
  disableMfa: DisableMfa;
  /** Envia a ação em massa para processamento */
  dispatchBulkAction: BulkAction;
  /** Edit a template task */
  editTemplateTask: Template;
  enableFeatureFlag: FeatureFlag;
  enableFeatureFlagWhitelistOnly: FeatureFlag;
  enableMfa: EnableMfa;
  /** Export card attachments */
  exportCardAttachments: Scalars['Boolean']['output'];
  /** Export cards */
  exportCards: Scalars['Boolean']['output'];
  /** Exportar bancos de dados */
  exportDatabases: Scalars['Boolean']['output'];
  /** Export tasks */
  exportTasks: Scalars['Boolean']['output'];
  /** Force refresh the feature flags cache */
  forceFeatureFlagCacheRefresh: Scalars['Boolean']['output'];
  inviteUsersToPipe: InviteUsersToPipePayload;
  /** Lock a card */
  lockCard: Card;
  /** Mark all comment notifications as read for a specific card */
  markCardCommentsAsRead: Scalars['Boolean']['output'];
  /** Move a card vertically */
  moveCard: Card;
  /** Move a card to a stage */
  moveCardToStage: Card;
  /** @deprecated Use orderStages instead */
  moveStage: Stage;
  moveStageAxisX: Stage;
  /** Reorders stages based on the provided list of stage IDs */
  orderStages: OrderStagesResult;
  publicAnswerCardStageForm: Scalars['Boolean']['output'];
  publicAnswerCardTaskForm: Scalars['Boolean']['output'];
  publicCreateCard: Card;
  publicSendCardStageAuthLink: Scalars['Boolean']['output'];
  publicSendCardTaskAuthLink: Scalars['Boolean']['output'];
  recreateRecoveryCodes: Array<RecoveryCode>;
  rejectReview: Reviewer;
  /** Remove an existing automation role */
  removeAutomationV2Role: AutomationV2Role;
  /** Remove an existing card assignee */
  removeCardAssignee: Scalars['Boolean']['output'];
  /** Delete card comment attachment */
  removeCardCommentAttachment: CardComment;
  /** Remove a label from a card */
  removeCardLabel: Scalars['Boolean']['output'];
  removeCardTaskAssignee: CardTaskAssignee;
  removeCardTaskLabel: Scalars['Boolean']['output'];
  /** Remover um campo do esquema do banco de dados */
  removeDatabaseSchemaField: DatabaseSchemaField;
  removeDeadlineFromPipe: Scalars['Boolean']['output'];
  removeDeadlineFromStage: Scalars['Boolean']['output'];
  removeMemberFromPipe: RemoveMemberFromPipePayload;
  /** Remove uma equipe */
  removeTeam: Scalars['Boolean']['output'];
  /** Remove um membro de uma equipe */
  removeTeamMember: Scalars['Boolean']['output'];
  removeUserRole: Scalars['Boolean']['output'];
  /** Reordenar campos do esquema do banco de dados */
  reorderDatabaseSchemaFields: Array<DatabaseSchemaField>;
  requestChangeReview: Reviewer;
  requestMfaSecret: RequestMfaSecret;
  requestPasswordReset: PasswordResetResult;
  /** Request a review */
  requestReview: Review;
  /** Request a review by template */
  requestReviewByTemplate: Review;
  resendReviewRequest: Reviewer;
  /** Reenvia um convite de usuário */
  resendUserInvite: UserInvite;
  /** Return a card to the assignee */
  returnCardToAssignee: Scalars['Boolean']['output'];
  /** Return a card to the solicitor */
  returnCardToSolicitor: Scalars['Boolean']['output'];
  setBulkUserRole: Role;
  setRolePermissions: Role;
  setUserRole: Role;
  signIn: AuthenticatedUser;
  signInWithSecondStep: AuthenticatedUser;
  /** @deprecated This mutation is deprecated, use `updateAutomationV2` instead. */
  toggleArchiveAutomation: Scalars['Boolean']['output'];
  /** Transfere a propriedade do fluxo para outro usuário */
  transferPipeOwnership: PipesMember;
  /** Unarchive a card */
  unarchiveCard: Card;
  /** Restaura um fluxo que foi arquivado (deletado) */
  undeletePipe: Scalars['Boolean']['output'];
  undeleteStage: Scalars['Boolean']['output'];
  /** Unlock a card */
  unlockCard: Card;
  /** @deprecated This mutation is deprecated, use `updateAutomationV2` instead. */
  updateAutomation: Automation;
  /** Update an existing automation */
  updateAutomationV2: AutomationV2;
  /** Update an existing automation status */
  updateAutomationV2Status: AutomationV2;
  /** Update a card attachment */
  updateCardAttachment: CardAttachment;
  /** Update an existing comment, only the creator can edit the comment */
  updateCardComment: CardComment;
  /** Change name of a card */
  updateCardDescription: Card;
  updateCardTask: CardTask;
  updateCardTaskParent: CardTask;
  updateCardTaskStatus: CardTask;
  /** Atualizar um banco de dados */
  updateDatabase: Database;
  /** Atualiza um membro do banco de dados */
  updateDatabaseMember: DatabaseMember;
  /** Atualizar um registro no banco de dados */
  updateDatabaseRecord: DatabaseRecord;
  /** Atualizar um campo no esquema do banco de dados */
  updateDatabaseSchemaField: DatabaseSchemaField;
  updateDeadlineToPipe: Deadline;
  updateDeadlineToStage: Deadline;
  updateFeatureFlag: FeatureFlag;
  updateField: UpdatedFieldResponse;
  updateFieldReviewer: ReviewerField;
  /** Atualiza a lista de times com acesso ao formulário */
  updateFormTeamAccess: UpdateFormTeamAccessResponse;
  /** Atualiza a lista de usuários com acesso ao formulário */
  updateFormUserAccess: UpdateFormUserAccessResponse;
  updateInitialForm: Form;
  updateLabel: Label;
  updateNotification: Notification;
  /** Update the notification preferences for the current user */
  updateNotificationPipePreference: NotificationPipePreference;
  /** Update the notification preferences for the current user */
  updateNotificationUserPreference: NotificationUserPreference;
  updatePassword: Me;
  /** Atualiza um fluxo existente */
  updatePipe: Pipe;
  updateProfile: Me;
  updateStage: Stage;
  updateStageForm: Form;
  /** Atualiza uma equipe existente */
  updateTeam: Team;
  /** Edit a template deadline */
  updateTemplateDeadline: Template;
  /** Edit a template review */
  updateTemplateReview: Template;
  updateUserLicenseType: User;
};


export type MutationAcceptInviteArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationAddCardTaskAssigneeArgs = {
  input: AddCardTaskAssigneeInput;
};


export type MutationAddCardTaskAssigneesArgs = {
  input: AddCardTaskAssigneesInput;
};


export type MutationAddCardTaskLabelArgs = {
  input: AddOrRemoveCardTaskLabelDto;
};


export type MutationAddDatabaseSchemaFieldArgs = {
  input: AddDatabaseSchemaFieldInput;
};


export type MutationAddFormToStageArgs = {
  formId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
};


export type MutationAnswerCardTaskFieldArgs = {
  input: AnswerCardTaskFieldInput;
};


export type MutationApproveReviewArgs = {
  input: ApproveReviewInput;
};


export type MutationArchiveCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignDeadlineToPipeArgs = {
  createDeadlineInput: CreateDeadlineInput;
  pipeId: Scalars['ID']['input'];
};


export type MutationAssignDeadlineToStageArgs = {
  createDeadlineInput: CreateDeadlineInput;
  stageId: Scalars['ID']['input'];
};


export type MutationAttachTemplatesToStageArgs = {
  parentId?: InputMaybe<Scalars['ID']['input']>;
  stageId: Scalars['ID']['input'];
  templatesIds: Array<Scalars['ID']['input']>;
};


export type MutationBatchDeleteDatabaseRecordArgs = {
  input: BatchDeleteDatabaseRecordInput;
};


export type MutationBatchUpsertAutomationV2DataArgs = {
  input: BatchUpsertAutomationV2Input;
};


export type MutationBatchUpsertDatabaseRecordArgs = {
  input: BatchUpsertDatabaseRecordInput;
};


export type MutationBulkUpdateReviewersArgs = {
  input: BulkUpdateReviewersInput;
};


export type MutationBulkUpdateTaskAssigneesArgs = {
  input: BulkUpdateTaskAssigneesInput;
};


export type MutationCancelBulkActionArgs = {
  input: CancelBulkActionInput;
};


export type MutationCancelCardToSolicitorArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationCancelReviewArgs = {
  input: CancelReviewInput;
};


export type MutationChangeCardNameArgs = {
  input: ChangeCardNameInput;
};


export type MutationChangeReviewersArgs = {
  input: ChangeReviewersInput;
};


export type MutationConfirmPasswordResetArgs = {
  input: ConfirmPasswordResetInput;
};


export type MutationCreateAutomationArgs = {
  createAutomationInput: CreateAutomationInput;
};


export type MutationCreateAutomationV2Args = {
  input: CreateAutomationV2Input;
};


export type MutationCreateAutomationV2RoleArgs = {
  input: CreateAutomationRoleInput;
};


export type MutationCreateBulkActionArgs = {
  input: CreateBulkActionInput;
};


export type MutationCreateCardArgs = {
  input: CreateCardInput;
};


export type MutationCreateCardAssigneeArgs = {
  input: CreateCardAssigneeInput;
};


export type MutationCreateCardAttachmentArgs = {
  input: CreateCardAttachmentInput;
};


export type MutationCreateCardCommentArgs = {
  input: CreateCardCommentInput;
};


export type MutationCreateCardCommentAttachmentArgs = {
  input: CreateCardCommentAttachmentInput;
};


export type MutationCreateCardDeadlineArgs = {
  input: CreateCardDeadlineInput;
};


export type MutationCreateCardLabelArgs = {
  input: CreateCardLabelInput;
};


export type MutationCreateCardTaskArgs = {
  input: CreateCardTaskInputDto;
};


export type MutationCreateDatabaseArgs = {
  input: CreateDatabaseInput;
};


export type MutationCreateDatabaseMemberArgs = {
  input: CreateDatabaseMemberInput;
};


export type MutationCreateDatabaseRecordArgs = {
  input: CreateRecordInput;
};


export type MutationCreateFeatureFlagAccountArgs = {
  accountId: Scalars['ID']['input'];
  slug: Scalars['ID']['input'];
};


export type MutationCreateLabelArgs = {
  createLabelInput: CreateLabelInput;
};


export type MutationCreateNotificationPipePreferenceArgs = {
  input: CreateNotificationPipePreferenceDto;
};


export type MutationCreatePipeArgs = {
  createPipeInput: CreatePipeInput;
};


export type MutationCreatePublicCardStageFormLinkArgs = {
  input: CreatePublicCardStageFormLinkInput;
};


export type MutationCreatePublicCardTaskFormLinkArgs = {
  input: CreatePublicCardTaskFormLinkInput;
};


export type MutationCreateSolicitationArgs = {
  data: CreateCardInput;
};


export type MutationCreateStageArgs = {
  createStageInput: CreateStageInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTeamMemberArgs = {
  input: CreateTeamMemberInput;
};


export type MutationCreateTemplateDeadlineArgs = {
  input: CreateTemplateDeadlineInput;
};


export type MutationCreateTemplateReviewArgs = {
  input: CreateTemplateReviewInput;
};


export type MutationCreateTemplateTaskArgs = {
  input: CreateTemplateTaskInput;
};


export type MutationCreateUserInviteArgs = {
  input: CreateUserInviteInput;
};


export type MutationDeleteCardAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCardTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDatabaseMemberArgs = {
  input: DeleteDatabaseMemberInput;
};


export type MutationDeleteDatabaseRecordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeatureFlagAccountArgs = {
  accountId: Scalars['ID']['input'];
  slug: Scalars['ID']['input'];
};


export type MutationDeleteLabelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePipeArgs = {
  pipeId: Scalars['ID']['input'];
};


export type MutationDeleteStageArgs = {
  stageId: Scalars['ID']['input'];
};


export type MutationDetachTemplateFromStageArgs = {
  stageId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationDisableFeatureFlagArgs = {
  slug: Scalars['String']['input'];
};


export type MutationDisableFeatureFlagWhitelistOnlyArgs = {
  removeAccounts: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
};


export type MutationDisableMfaArgs = {
  input: DisableMfaInput;
};


export type MutationDispatchBulkActionArgs = {
  input: DispatchBulkActionInput;
};


export type MutationEditTemplateTaskArgs = {
  input: EditTemplateTaskInput;
};


export type MutationEnableFeatureFlagArgs = {
  slug: Scalars['String']['input'];
};


export type MutationEnableFeatureFlagWhitelistOnlyArgs = {
  slug: Scalars['String']['input'];
};


export type MutationEnableMfaArgs = {
  input: EnableMfaInput;
};


export type MutationExportCardAttachmentsArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationExportCardsArgs = {
  exportCardInput: ExportCardInput;
};


export type MutationExportDatabasesArgs = {
  input: ExportDatabaseInput;
};


export type MutationExportTasksArgs = {
  exportTaskInput: ExportTasksInput;
};


export type MutationInviteUsersToPipeArgs = {
  inviteUsersToPipe: InviteUsersToPipeInput;
};


export type MutationLockCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkCardCommentsAsReadArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationMoveCardArgs = {
  cardId: Scalars['ID']['input'];
  nextCardId?: InputMaybe<Scalars['ID']['input']>;
  previousCardId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMoveCardToStageArgs = {
  moveCardToStageArgs: MoveCardToStageInput;
};


export type MutationMoveStageArgs = {
  direction: StageMoveDirection;
  id: Scalars['ID']['input'];
};


export type MutationMoveStageAxisXArgs = {
  input: MoveStageAxisInput;
};


export type MutationOrderStagesArgs = {
  input: OrderStagesInput;
};


export type MutationPublicAnswerCardStageFormArgs = {
  fields: Array<UpdateFieldInput>;
  hash: Scalars['String']['input'];
};


export type MutationPublicAnswerCardTaskFormArgs = {
  fields: Array<AnswerCardTaskFieldInput>;
  hash: Scalars['String']['input'];
};


export type MutationPublicCreateCardArgs = {
  input: CreateCardInput;
};


export type MutationPublicSendCardStageAuthLinkArgs = {
  email: Scalars['String']['input'];
  hash: Scalars['String']['input'];
};


export type MutationPublicSendCardTaskAuthLinkArgs = {
  email: Scalars['String']['input'];
  hash: Scalars['String']['input'];
};


export type MutationRecreateRecoveryCodesArgs = {
  input: RecreateRecoveryCodesInput;
};


export type MutationRejectReviewArgs = {
  input: RejectReviewInput;
};


export type MutationRemoveAutomationV2RoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCardAssigneeArgs = {
  input: RemoveCardAssigneeInput;
};


export type MutationRemoveCardCommentAttachmentArgs = {
  input: RemoveCardCommentAttachmentInput;
};


export type MutationRemoveCardLabelArgs = {
  input: RemoveCardLabelInput;
};


export type MutationRemoveCardTaskAssigneeArgs = {
  input: AddCardTaskAssigneeInput;
};


export type MutationRemoveCardTaskLabelArgs = {
  input: AddOrRemoveCardTaskLabelDto;
};


export type MutationRemoveDatabaseSchemaFieldArgs = {
  input: RemoveDatabaseSchemaFieldInput;
};


export type MutationRemoveDeadlineFromPipeArgs = {
  pipeId: Scalars['ID']['input'];
};


export type MutationRemoveDeadlineFromStageArgs = {
  stageId: Scalars['ID']['input'];
};


export type MutationRemoveMemberFromPipeArgs = {
  removeMemberFromPipe: RemoveMemberFromPipeInput;
};


export type MutationRemoveTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


export type MutationRemoveUserRoleArgs = {
  roleEntityContext?: InputMaybe<RoleEntityContextInput>;
  userId: Scalars['String']['input'];
};


export type MutationReorderDatabaseSchemaFieldsArgs = {
  input: ReorderDatabaseSchemaFieldsInput;
};


export type MutationRequestChangeReviewArgs = {
  input: RequestChangeReviewInput;
};


export type MutationRequestMfaSecretArgs = {
  input: RequestMfaSecretInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationRequestReviewArgs = {
  input: RequestReviewInput;
};


export type MutationRequestReviewByTemplateArgs = {
  input: RequestReviewByTemplateInput;
};


export type MutationResendReviewRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendUserInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationReturnCardToAssigneeArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationReturnCardToSolicitorArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationSetBulkUserRoleArgs = {
  roleEntityContext?: InputMaybe<RoleEntityContextInput>;
  roleType: RoleTypeEnum;
  userIds: Array<Scalars['String']['input']>;
};


export type MutationSetRolePermissionsArgs = {
  permissionIds: Array<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};


export type MutationSetUserRoleArgs = {
  roleEntityContext?: InputMaybe<RoleEntityContextInput>;
  roleType: RoleTypeEnum;
  userId: Scalars['String']['input'];
};


export type MutationSignInArgs = {
  input: SignInInput;
};


export type MutationSignInWithSecondStepArgs = {
  input: SignInWithSecondStepInput;
};


export type MutationToggleArchiveAutomationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTransferPipeOwnershipArgs = {
  input: TransferPipeOwnershipInput;
};


export type MutationUnarchiveCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUndeletePipeArgs = {
  pipeId: Scalars['ID']['input'];
};


export type MutationUndeleteStageArgs = {
  stageId: Scalars['ID']['input'];
};


export type MutationUnlockCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAutomationArgs = {
  updateAutomationInput: UpdateAutomationInput;
};


export type MutationUpdateAutomationV2Args = {
  id: Scalars['ID']['input'];
  input: UpdateAutomationV2Input;
};


export type MutationUpdateAutomationV2StatusArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAutomationV2StatusInput;
};


export type MutationUpdateCardAttachmentArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCardCommentArgs = {
  input: UpdateCardCommentInput;
};


export type MutationUpdateCardDescriptionArgs = {
  input: UpdateCardDescriptionInput;
};


export type MutationUpdateCardTaskArgs = {
  input: UpdateCardTaskInputDto;
};


export type MutationUpdateCardTaskParentArgs = {
  input: UpdateCardTaskParentInputDto;
};


export type MutationUpdateCardTaskStatusArgs = {
  input: UpdateCardTaskStatusInputDto;
};


export type MutationUpdateDatabaseArgs = {
  input: UpdateDatabaseInput;
};


export type MutationUpdateDatabaseMemberArgs = {
  input: UpdateDatabaseMemberInput;
};


export type MutationUpdateDatabaseRecordArgs = {
  input: UpdateRecordInput;
};


export type MutationUpdateDatabaseSchemaFieldArgs = {
  input: UpdateDatabaseSchemaFieldInput;
};


export type MutationUpdateDeadlineToPipeArgs = {
  pipeId: Scalars['ID']['input'];
  updateDeadlineInput: UpdateDeadlineInput;
};


export type MutationUpdateDeadlineToStageArgs = {
  stageId: Scalars['ID']['input'];
  updateDeadlineInput: UpdateDeadlineInput;
};


export type MutationUpdateFeatureFlagArgs = {
  input: UpdateFeatureFlagInput;
  slug: Scalars['String']['input'];
};


export type MutationUpdateFieldArgs = {
  input: UpdateFieldInput;
};


export type MutationUpdateFieldReviewerArgs = {
  input: UpdateFieldReviewerInput;
};


export type MutationUpdateFormTeamAccessArgs = {
  input: UpdateFormTeamAccessInput;
};


export type MutationUpdateFormUserAccessArgs = {
  input: UpdateFormUserAccessInput;
};


export type MutationUpdateInitialFormArgs = {
  input: UpdateInitialFormInput;
};


export type MutationUpdateLabelArgs = {
  data: UpdateLabelInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateNotificationArgs = {
  id: Scalars['String']['input'];
  input: UpdateNotificationInput;
};


export type MutationUpdateNotificationPipePreferenceArgs = {
  input: UpdateNotificationPipePreferenceDto;
};


export type MutationUpdateNotificationUserPreferenceArgs = {
  input: UpdateNotificationUserPreferenceDto;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePipeArgs = {
  pipeId: Scalars['ID']['input'];
  updatePipeInput: UpdatePipeInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateStageArgs = {
  updateStageInput: UpdateStageInput;
};


export type MutationUpdateStageFormArgs = {
  input: UpdateStageFormInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTemplateDeadlineArgs = {
  input: UpdateTemplateDeadlineInput;
};


export type MutationUpdateTemplateReviewArgs = {
  input: UpdateTemplateReviewInput;
};


export type MutationUpdateUserLicenseTypeArgs = {
  input: UpdateUserLicenseInput;
};

/** Filter for my turn or all reviews */
export enum MyTurnEnum {
  All = 'All',
  MyTurn = 'MyTurn'
}

export type Notification = {
  __typename?: 'Notification';
  accountId: Scalars['ID']['output'];
  /** @deprecated Use notificationData.assignedBy instead, new notifications will not have this field populated. */
  assignedBy?: Maybe<UserOrString>;
  /** @deprecated Use notificationData.card instead, new notifications will not have this field populated. */
  card?: Maybe<Card>;
  /** @deprecated Use notificationData.comment instead, new notifications will not have this field populated. */
  comment?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use notificationData.commentedBy instead, new notifications will not have this field populated. */
  commentedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Use notificationData.createdBy instead, new notifications will not have this field populated. */
  createdBy?: Maybe<UserOrString>;
  data?: Maybe<Scalars['JSON']['output']>;
  favoritedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notificationData: NotificationData;
  /** @deprecated Use notificationData.pipe instead, new notifications will not have this field populated. */
  pipe?: Maybe<Pipe>;
  /** @deprecated Use notificationData.previousStage instead, new notifications will not have this field populated. */
  previousStage?: Maybe<Stage>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use notificationData.currentStage instead, new notifications will not have this field populated. */
  stage?: Maybe<Stage>;
  tags?: Maybe<Scalars['JSON']['output']>;
  /** Type of notification */
  type: NotificationTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type NotificationData = {
  __typename?: 'NotificationData';
  actionTakenBy?: Maybe<UserOrString>;
  assignedBy?: Maybe<UserOrString>;
  card?: Maybe<Card>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedBy?: Maybe<UserOrString>;
  createdBy?: Maybe<UserOrString>;
  currentStage?: Maybe<Stage>;
  /** The identifier of the notification data, will be the same as the notification id */
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  pipe?: Maybe<Pipe>;
  previousStage?: Maybe<Stage>;
  review?: Maybe<Review>;
  task?: Maybe<CardTask>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type NotificationPipePreference = {
  __typename?: 'NotificationPipePreference';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pipe: Pipe;
  /** Notification preferences */
  preferences: NotificationPreference;
  starred: Scalars['Boolean']['output'];
  user: User;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  /** Notification for solicitation alerts */
  cardApprovalStatusChanged: Scalars['Int']['output'];
  /** Notification when a card is archived or unarchived */
  cardArchivedOrUnarchived: Scalars['Int']['output'];
  /** Notification when a card is assigned to me */
  cardAssignedToMe: Scalars['Int']['output'];
  /** Notification when a card is assigned to me */
  cardAssigneeTaskCompletedOrReopened: Scalars['Int']['output'];
  /** Notification when a card is assigned to me */
  cardAssigneeTaskCreated: Scalars['Int']['output'];
  /** Notification when a card is created */
  cardCreated: Scalars['Int']['output'];
  /** Notification when a card is near or past its deadline */
  cardDeadlineNearOrExpired: Scalars['Int']['output'];
  /** Notification when a user is mentioned in a comment */
  cardMentionedInComment: Scalars['Int']['output'];
  /** Notification when a card is moved */
  cardMoved: Scalars['Int']['output'];
  /** Notification when a card requires my approval */
  cardMyApprovalRequired: Scalars['Int']['output'];
  /** Daily summary of activities in my spaces, can only be 0 or 2 */
  dailyMySpaceSummary: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Notification when a pipe is added to me */
  pipeAddedToMe: Scalars['Int']['output'];
  /** Notification for security alerts */
  security: Scalars['Int']['output'];
  /** Notification for solicitation alerts */
  solicitation: Scalars['Int']['output'];
};

export enum NotificationTypeEnum {
  AddedToPipe = 'added_to_pipe',
  ApprovalRequired = 'approval_required',
  CardApprovalDenied = 'card_approval_denied',
  CardApprovalGranted = 'card_approval_granted',
  CardArchived = 'card_archived',
  CardAssigned = 'card_assigned',
  CardCommentCreated = 'card_comment_created',
  CardCompleted = 'card_completed',
  CardCreated = 'card_created',
  CardDeadlineExpired = 'card_deadline_expired',
  CardDeadlineNear = 'card_deadline_near',
  CardMoved = 'card_moved',
  CardMyApprovalRequired = 'card_my_approval_required',
  CardPipeDeadlineExpired = 'card_pipe_deadline_expired',
  CardPipeDeadlineNear = 'card_pipe_deadline_near',
  CardReachedFinalStage = 'card_reached_final_stage',
  CardRequestedChanges = 'card_requested_changes',
  CardStageDeadlineExpired = 'card_stage_deadline_expired',
  CardStageDeadlineNear = 'card_stage_deadline_near',
  CardTaskCompleted = 'card_task_completed',
  CardTaskCreated = 'card_task_created',
  CardTaskReopened = 'card_task_reopened',
  CardUnarchived = 'card_unarchived',
  CommentMention = 'comment_mention',
  SecurityLoginFailed = 'security_login_failed',
  SecurityLoginFailedMfa = 'security_login_failed_mfa',
  SecurityLoginFailedPassword = 'security_login_failed_password',
  SecurityMfaDeviceChanged = 'security_mfa_device_changed',
  SecurityMfaDisabled = 'security_mfa_disabled',
  SecurityMfaEnabled = 'security_mfa_enabled',
  SecurityNewLogin = 'security_new_login',
  SecurityPasswordChanged = 'security_password_changed',
  SolicitationCardArchived = 'solicitation_card_archived',
  SolicitationCardMoved = 'solicitation_card_moved',
  SolicitationReturnToSolicitor = 'solicitation_return_to_solicitor',
  SolicitationReturnToSolicitorCanceled = 'solicitation_return_to_solicitor_canceled',
  SolicitationSentToAssignee = 'solicitation_sent_to_assignee',
  StageDeadlineExpired = 'stage_deadline_expired',
  StageDeadlineNear = 'stage_deadline_near'
}

export type NotificationUserPreference = {
  __typename?: 'NotificationUserPreference';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Notification preferences */
  preferences: NotificationPreference;
  user: User;
};

/** Filter notifications */
export type NotificationWhereInput = {
  actionTakenByName?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  pipeId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationTypeEnum>;
  types?: InputMaybe<Array<NotificationTypeEnum>>;
};

/** The numeric field */
export type NumericField = FieldType & {
  __typename?: 'NumericField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export type OfficeHour = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type OfficeHours = {
  friday?: InputMaybe<OfficeHour>;
  monday?: InputMaybe<OfficeHour>;
  saturday?: InputMaybe<OfficeHour>;
  sunday?: InputMaybe<OfficeHour>;
  thursday?: InputMaybe<OfficeHour>;
  tuesday?: InputMaybe<OfficeHour>;
  wednesday?: InputMaybe<OfficeHour>;
};

export type OpenChoiceAnswer = {
  __typename?: 'OpenChoiceAnswer';
  /** Pipe created at */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Value */
  value?: Maybe<Scalars['String']['output']>;
};

export type OrderStagesInput = {
  /** The ID of the pipe containing the stages to be reordered */
  pipeId: Scalars['ID']['input'];
  /** List of stage IDs in the desired order */
  stageIdsInOrder: Array<Scalars['ID']['input']>;
};

export type OrderStagesResult = {
  __typename?: 'OrderStagesResult';
  /** List of stage IDs in the desired order */
  stageIdsInOrder: Array<Scalars['String']['output']>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Page info */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Page info offset */
export type PageInfoOffset = {
  __typename?: 'PageInfoOffset';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

/** Paginated account features */
export type PaginatedAccountFeature = {
  __typename?: 'PaginatedAccountFeature';
  edges: Array<AccountFeatureEdge>;
  nodes: Array<AccountFeature>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAccountFeatureFilters = {
  /** Filtrar pela data de ativação da funcionalidade da conta */
  activatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pela data de ativação da funcionalidade da conta */
  activatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pela data de cancelamento da funcionalidade da conta */
  cancelledAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pela data de cancelamento da funcionalidade da conta */
  cancelledAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pela data de criação da funcionalidade da conta */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pela data de criação da funcionalidade da conta */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pelo slug ou nome da funcionalidade */
  feature?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar pelo status da funcionalidade da conta */
  status?: InputMaybe<Array<AccountFeatureStatus>>;
};

export enum PaginatedAccountFeatureSortOrderEnum {
  ActivatedAt = 'activated_at',
  CancelledAt = 'cancelled_at',
  CreatedAt = 'created_at',
  Status = 'status'
}

export type PaginatedAccountFeatureSortOrderInput = {
  field: PaginatedAccountFeatureSortOrderEnum;
  order: SortOrderDirection;
};

/** Paginated account feature usage records */
export type PaginatedAccountFeatureUsageRecord = {
  __typename?: 'PaginatedAccountFeatureUsageRecord';
  edges: Array<AccountFeatureUsageRecordEdge>;
  nodes: Array<AccountFeatureUsageRecord>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAccountFeatureUsageRecordFilters = {
  /** Filtrar pelo ID da funcionalidade da conta */
  accountFeatureId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PaginatedAccountFeatureUsageRecordSortOrderEnum {
  CreatedAt = 'created_at',
  UsageAmount = 'usage_amount'
}

export type PaginatedAccountFeatureUsageRecordSortOrderInput = {
  field: PaginatedAccountFeatureUsageRecordSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedAutomationV2 = {
  __typename?: 'PaginatedAutomationV2';
  edges: Array<AutomationV2Edge>;
  nodes: Array<AutomationV2>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAutomationV2Action = {
  __typename?: 'PaginatedAutomationV2Action';
  edges: Array<AutomationV2ActionEdge>;
  nodes: Array<AutomationV2Action>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAutomationV2ActionFilters = {
  /** Filter by the ID of the automation to which the action belongs */
  automationId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the type of the automation action */
  type?: InputMaybe<AutomationActionType>;
};

export enum PaginatedAutomationV2ActionSortOrderEnum {
  CreatedAt = 'created_at',
  Position = 'position',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type PaginatedAutomationV2ActionSortOrderInput = {
  field: PaginatedAutomationV2ActionSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedAutomationV2AutocompleteOption = {
  __typename?: 'PaginatedAutomationV2AutocompleteOption';
  edges: Array<AutomationV2AutocompleteOptionEdge>;
  nodes: Array<AutomationV2AutocompleteOption>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAutomationV2AutocompleteOptionFilters = {
  /** Filter by the trigger id of the trigger condition */
  entity: AutomationAutocompleteEntity;
  /** Ids to load eagerly */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Pipe id to filter by, some entities may require this */
  pipeId?: InputMaybe<Scalars['ID']['input']>;
  /** Search term to filter the autocomplete options */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum PaginatedAutomationV2AutocompleteOptionSortOrderEnum {
  Value = 'value'
}

export type PaginatedAutomationV2AutocompleteOptionSortOrderInput = {
  field: PaginatedAutomationV2AutocompleteOptionSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedAutomationV2Execution = {
  __typename?: 'PaginatedAutomationV2Execution';
  edges: Array<AutomationV2ExecutionEdge>;
  nodes: Array<AutomationV2Execution>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAutomationV2ExecutionAction = {
  __typename?: 'PaginatedAutomationV2ExecutionAction';
  edges: Array<AutomationV2ExecutionActionEdge>;
  nodes: Array<AutomationV2ExecutionAction>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAutomationV2ExecutionActionFilters = {
  /** Filter by the ID of the trigger in the automation execution version */
  actionIdInVersion?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the ID of the automation of the automation execution */
  automationId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the completed date of the automation execution (greater than or equal to) */
  completedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the completed date of the automation execution (less than or equal to) */
  completedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the ID of the automation execution */
  executionId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter the presence of an error in the automation execution action */
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the start date of the automation execution (greater than or equal to) */
  startedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the start date of the automation execution (less than or equal to) */
  startedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the status of the automation execution action */
  status?: InputMaybe<AutomationExecutionActionStatus>;
  /** Filter by the ID of the action in the automation execution version */
  triggerIdInVersion?: InputMaybe<Scalars['ID']['input']>;
  /** Filter the presence of an error in the automation execution action */
  type?: InputMaybe<AutomationTriggerAndActionType>;
};

export enum PaginatedAutomationV2ExecutionActionSortOrderEnum {
  CompletedAt = 'completed_at',
  StartedAt = 'started_at',
  Status = 'status'
}

export type PaginatedAutomationV2ExecutionActionSortOrderInput = {
  field: PaginatedAutomationV2ExecutionActionSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedAutomationV2ExecutionFilters = {
  /** Filter by the ID of the card related to the automation execution */
  actorId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the ID of the automation of the automation execution */
  automationId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the ID of the card related to the automation execution */
  cardId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the ID of the card task related to the automation execution */
  cardTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the completed date of the automation execution (greater than or equal to) */
  completedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the completed date of the automation execution (less than or equal to) */
  completedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include skipped executions in the results, defaults to false */
  includeSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the ID of the pipe of the pipe execution */
  pipeId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the ID of the review related to the automation execution */
  reviewId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the start date of the automation execution (greater than or equal to) */
  startedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the start date of the automation execution (less than or equal to) */
  startedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the status of the automation execution */
  status?: InputMaybe<AutomationExecutionStatus>;
  /** Filter by the trigger type of the automation execution */
  triggerType?: InputMaybe<AutomationTriggerType>;
  /** Filter by the ID of the version of the automation execution */
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PaginatedAutomationV2ExecutionSortOrderEnum {
  CompletedAt = 'completed_at',
  StartedAt = 'started_at',
  Status = 'status'
}

export type PaginatedAutomationV2ExecutionSortOrderInput = {
  field: PaginatedAutomationV2ExecutionSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedAutomationV2Filters = {
  /** Filter by the creation date of the automation (greater than or equal to) */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the creation date of the automation (less than or equal to) */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the ID of the creator of automation */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the description of the automation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the name of the automation */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the ID of the pipe of the pipe execution */
  pipeId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the status of the automation */
  status?: InputMaybe<AutomationStatusEnum>;
  /** Filter by the last update date of the automation (greater than or equal to) */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the last update date of the automation (less than or equal to) */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the ID of the last updater of automation */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type PaginatedAutomationV2Role = {
  __typename?: 'PaginatedAutomationV2Role';
  edges: Array<AutomationV2RoleEdge>;
  nodes: Array<AutomationV2Role>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAutomationV2RoleFilters = {
  /** Filter by the automation ID to which the automation belongs */
  automationId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the creation date of the automation role (greater than or equal to) */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the creation date of the automation role (less than or equal to) */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by the pipe ID to which the automation belongs */
  pipeId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the type of the role assigned to the automation */
  roleType?: InputMaybe<RoleTypeEnum>;
};

export enum PaginatedAutomationV2RoleSortOrderEnum {
  CreatedAt = 'created_at',
  RoleType = 'role_type'
}

export type PaginatedAutomationV2RoleSortOrderInput = {
  field: PaginatedAutomationV2RoleSortOrderEnum;
  order: SortOrderDirection;
};

export enum PaginatedAutomationV2SortOrderEnum {
  CreatedAt = 'created_at',
  Name = 'name',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

export type PaginatedAutomationV2SortOrderInput = {
  field: PaginatedAutomationV2SortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedAutomationV2TriggerCondition = {
  __typename?: 'PaginatedAutomationV2TriggerCondition';
  edges: Array<AutomationV2TriggerConditionEdge>;
  nodes: Array<AutomationV2TriggerCondition>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAutomationV2TriggerConditionFilters = {
  /** Filter by the operator of the trigger condition */
  operator?: InputMaybe<AutomationTriggerConditionOperators>;
  /** Filter by the property of the trigger condition */
  property?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the trigger id of the trigger condition */
  triggerId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PaginatedAutomationV2TriggerConditionSortOrderEnum {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type PaginatedAutomationV2TriggerConditionSortOrderInput = {
  field: PaginatedAutomationV2TriggerConditionSortOrderEnum;
  order: SortOrderDirection;
};

/** Representa uma lista paginada de ações em massa */
export type PaginatedBulkAction = {
  __typename?: 'PaginatedBulkAction';
  edges: Array<BulkActionEdge>;
  nodes: Array<BulkAction>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Filtros para listar ações em massa de forma paginada */
export type PaginatedBulkActionFilters = {
  /** Filtrar ações em massa criadas a partir desta data e hora */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar ações em massa criadas até esta data e hora */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar ações em massa enviadas para processamento a partir desta data e hora */
  dispatchedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar ações em massa enviadas para processamento até esta data e hora */
  dispatchedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar ações em massa pelo ID da entidade afetada */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** Filtrar pelo status da ação em massa */
  status?: InputMaybe<BulkActionStatusEnum>;
  /** Filtrar pelo tipo da ação em massa */
  type?: InputMaybe<BulkActionTypeEnum>;
  /** Filtrar ações em massa atualizadas a partir desta data e hora */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar ações em massa atualizadas até esta data e hora */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum PaginatedBulkActionSortOrderEnum {
  CreatedAt = 'created_at',
  DispatchedAt = 'dispatched_at',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type PaginatedBulkActionSortOrderInput = {
  field: PaginatedBulkActionSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedCard = {
  __typename?: 'PaginatedCard';
  edges: Array<CardEdge>;
  nodes: Array<Card>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Paginated list of card assignees */
export type PaginatedCardAssignee = {
  __typename?: 'PaginatedCardAssignee';
  edges: Array<CardAssigneeEdge>;
  nodes: Array<CardAssignee>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCardAssigneeFilters = {
  /** Filter by the ID of the card to which the assignee belongs */
  cardId: Scalars['ID']['input'];
};

export enum PaginatedCardAssigneeSortOrderEnum {
  CreatedAt = 'created_at'
}

export type PaginatedCardAssigneeSortOrderInput = {
  field: PaginatedCardAssigneeSortOrderEnum;
  order: SortOrderDirection;
};

/** Paginated list of card attachments */
export type PaginatedCardAttachment = {
  __typename?: 'PaginatedCardAttachment';
  edges: Array<CardAttachmentEdge>;
  nodes: Array<CardAttachment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCardAttachmentFilters = {
  /** Filter by the ID of the comment tied to the attachment */
  cardCommentId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the ID of the card to which the assignee belongs */
  cardId: Scalars['ID']['input'];
};

export enum PaginatedCardAttachmentSortOrderEnum {
  CreatedAt = 'created_at'
}

export type PaginatedCardAttachmentSortOrderInput = {
  field: PaginatedCardAttachmentSortOrderEnum;
  order: SortOrderDirection;
};

/** Paginated list of card comments */
export type PaginatedCardComment = {
  __typename?: 'PaginatedCardComment';
  edges: Array<CardCommentEdge>;
  nodes: Array<CardComment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCardCommentFilters = {
  /** Filter by the ID of the card to which the comment belongs */
  cardId: Scalars['ID']['input'];
};

export enum PaginatedCardCommentSortOrderEnum {
  CreatedAt = 'created_at'
}

export type PaginatedCardCommentSortOrderInput = {
  field: PaginatedCardCommentSortOrderEnum;
  order: SortOrderDirection;
};

/** Paginated list of card labels */
export type PaginatedCardLabel = {
  __typename?: 'PaginatedCardLabel';
  edges: Array<CardLabelEdge>;
  nodes: Array<CardLabel>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCardLabelFilters = {
  /** Filter by the ID of the card to which the label belongs */
  cardId: Scalars['ID']['input'];
};

export enum PaginatedCardLabelSortOrderEnum {
  CreatedAt = 'created_at'
}

export type PaginatedCardLabelSortOrderInput = {
  field: PaginatedCardLabelSortOrderEnum;
  order: SortOrderDirection;
};

/** Paginated list of card relations */
export type PaginatedCardRelation = {
  __typename?: 'PaginatedCardRelation';
  edges: Array<UndefinedEdge>;
  nodes: Array<CardRelation>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCardRelationFilters = {
  /** Filter by the ID of the card to which the relation belongs */
  cardId: Scalars['ID']['input'];
};

export enum PaginatedCardRelationSortOrderEnum {
  CreatedAt = 'created_at'
}

export type PaginatedCardRelationSortOrderInput = {
  field: PaginatedCardRelationSortOrderEnum;
  order: SortOrderDirection;
};

/** Paginated card stage task */
export type PaginatedCardStageTask = {
  __typename?: 'PaginatedCardStageTask';
  edges: Array<CardStageTaskEdge>;
  nodes: Array<CardTask>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Paginated card tasks */
export type PaginatedCardTask = {
  __typename?: 'PaginatedCardTask';
  edges: Array<CardTaskEdge>;
  nodes: Array<CardTask>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCardTaskAssignee = {
  __typename?: 'PaginatedCardTaskAssignee';
  edges: Array<CardTaskAssigneeEdge>;
  nodes: Array<CardTaskAssignee>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedDatabase = {
  __typename?: 'PaginatedDatabase';
  edges: Array<DatabaseEdge>;
  nodes: Array<Database>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Entrada de logs paginados do banco de dados */
export type PaginatedDatabaseLog = {
  __typename?: 'PaginatedDatabaseLog';
  edges: Array<DatabaseLogEdge>;
  nodes: Array<DatabaseLog>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedDatabaseLogFilters = {
  /** Ação para filtrar logs */
  action?: InputMaybe<DatabaseLogActionEnum>;
  /** ID do usuário que criou o log */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  /** ID do banco de dados para filtrar registros */
  databaseId: Scalars['ID']['input'];
  /** ID do registro para filtrar logs */
  recordId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PaginatedDatabaseLogSortOrderEnum {
  CreatedAt = 'created_at'
}

export type PaginatedDatabaseLogSortOrderInput = {
  field: PaginatedDatabaseLogSortOrderEnum;
  order: SortOrderDirection;
};

/** Lista paginada de membros do banco de dados */
export type PaginatedDatabaseMember = {
  __typename?: 'PaginatedDatabaseMember';
  edges: Array<DatabaseMemberEdge>;
  nodes: Array<DatabaseMember>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Filtros para paginação de membros do banco de dados */
export type PaginatedDatabaseMemberFilters = {
  /** ID do banco de dados para filtrar registros */
  databaseId: Scalars['ID']['input'];
  /** Termo de pesquisa para filtrar membros do banco de dados */
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum PaginatedDatabaseMemberSortOrderEnum {
  CreatedAt = 'created_at'
}

export type PaginatedDatabaseMemberSortOrderInput = {
  field: PaginatedDatabaseMemberSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedDatabaseRecord = {
  __typename?: 'PaginatedDatabaseRecord';
  edges: Array<DatabaseRecordEdge>;
  nodes: Array<DatabaseRecord>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedDatabaseRecordFilters = {
  /** Filtrar pela data de criação do registro do banco de dados (maior ou igual a) */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pela data de criação do registro do banco de dados (menor ou igual a) */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Lista de IDs dos criadores dos registros (um dos) */
  createdByIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID do banco de dados para filtrar registros */
  databaseId: Scalars['ID']['input'];
  /** Filtros adicionais por campo e valor, os fields serão comparados com a versão mais recente do schema, qualquer campo não existente será descartados ou dará erro de acordo com o valor de filterByFieldStrict. */
  filterByField?: InputMaybe<Array<PaginatedDatabaseRecordFiltersByField>>;
  /** Se verdadeiro, qualquer campo não existente nos filtros por campo dará erro. Se falso ou não definido, campos não existentes serão simplesmente ignorados. */
  filterByFieldStrict?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lista de campos para retornar, caso não informado, todos os campos serão retornados */
  returningFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Lista de campos para buscar */
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Valor para filtrar registros */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar pela data de atualização do registro do banco de dados (maior ou igual a) */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pela data de atualização do registro do banco de dados (menor ou igual a) */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Lista de IDs dos atualizadores dos registros (um dos) */
  updatedByIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Filtros para registros do banco de dados */
export type PaginatedDatabaseRecordFiltersByField = {
  /** Campo para buscar */
  field: Scalars['String']['input'];
  /** Operador para o filtro de campo */
  operator: DatabaseRecordFilterByFieldOperators;
  /** Valor para filtrar registros */
  value: Scalars['String']['input'];
};

export type PaginatedDatabaseRecordRestricted = {
  __typename?: 'PaginatedDatabaseRecordRestricted';
  edges: Array<DatabaseRecordRestrictedEdge>;
  nodes: Array<DatabaseRecordRestricted>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum PaginatedDatabaseRecordSortOrderEnum {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type PaginatedDatabaseRecordSortOrderInput = {
  field: PaginatedDatabaseRecordSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedDatabasesFilters = {
  /** ID do banco de dados */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Nome do banco de dados */
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum PaginatedDatabasesSortOrderEnum {
  CreatedAt = 'created_at',
  Name = 'name',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

export type PaginatedDatabasesSortOrderInput = {
  field: PaginatedDatabasesSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedForm = {
  __typename?: 'PaginatedForm';
  edges: Array<FormEdge>;
  nodes: Array<Form>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedLabel = {
  __typename?: 'PaginatedLabel';
  edges: Array<LabelEdge>;
  nodes: Array<Label>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedNotificationPipe = {
  __typename?: 'PaginatedNotificationPipe';
  /** The list of all items */
  edges: Array<Pipe>;
  /** The cursor to continue from */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** The total count of all items */
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPipe = {
  __typename?: 'PaginatedPipe';
  edges: Array<PipeEdge>;
  nodes: Array<Pipe>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPipeFilters = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationStarred?: InputMaybe<Scalars['Boolean']['input']>;
  rolesInPipe?: InputMaybe<Array<RoleTypeEnum>>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum PaginatedPipeSortOrderEnum {
  CreatedAt = 'created_at',
  Name = 'name',
  UpdatedAt = 'updated_at'
}

export type PaginatedPipeSortOrderInput = {
  field: PaginatedPipeSortOrderEnum;
  order: SortOrderDirection;
};

/** Paginated PipesMember */
export type PaginatedPipesMember = {
  __typename?: 'PaginatedPipesMember';
  edges: Array<PipesMemberEdge>;
  nodes: Array<PipesMember>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedReview = {
  __typename?: 'PaginatedReview';
  edges: Array<PaginatedReviewEdge>;
  nodes: Array<Review>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedReviewEdge = {
  __typename?: 'PaginatedReviewEdge';
  cursor: Scalars['String']['output'];
  node: Review;
};

export type PaginatedReviewFilters = {
  /** Filter by card status */
  cardStatus?: InputMaybe<CardStatusEnum>;
  /** Filter by creation date (greater than or equal to) */
  createdAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by creation date (less than or equal to) */
  createdAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pela data de aprovacao (maior ou igual a) */
  lastReviewedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pela data de aprovacao (menor ou igual a) */
  lastReviewedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter for my turn or all reviews */
  myTurn?: InputMaybe<MyTurnEnum>;
  /** Filter by users who requested the review */
  requestedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Behavior for reviewer filter (some or all) */
  reviewerFilterBehavior?: InputMaybe<MultiSelectFilterBehaviorEnum>;
  /** Filter by reviewer IDs */
  reviewersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search term to filter reviews */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by stage IDs */
  stagesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by review status */
  status?: InputMaybe<ReviewStatusEnum>;
};

export enum PaginatedReviewSortOrderEnum {
  Card = 'card',
  CreatedAt = 'created_at',
  LastReviewedAt = 'last_reviewed_at',
  Pipe = 'pipe',
  RequestedBy = 'requested_by',
  Stage = 'stage',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

export type PaginatedReviewSortOrderInput = {
  field: PaginatedReviewSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedRole = {
  __typename?: 'PaginatedRole';
  edges: Array<RoleEdge>;
  nodes: Array<Role>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Resposta paginada para formulários de solicitação */
export type PaginatedSolicitationFormResponse = {
  __typename?: 'PaginatedSolicitationFormResponse';
  items: Array<Form>;
  pageInfo: PageInfoOffset;
  totalCount: Scalars['Float']['output'];
};

/** Representa uma lista paginada de equipes */
export type PaginatedTeam = {
  __typename?: 'PaginatedTeam';
  edges: Array<TeamEdge>;
  nodes: Array<Team>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Filtros para listar equipes de forma paginada */
export type PaginatedTeamFilters = {
  /** Filtrar equipes criadas a partir desta data */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar equipes criadas até esta data */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar pelo nome da equipe (busca parcial) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar se contem os usuários */
  usersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Comportamento do filtro de usuários, por padrão "Um dos" */
  usersIdsBehavior?: InputMaybe<MultiSelectFilterBehaviorEnum>;
};

/** Representa uma lista paginada de membros de uma equipe */
export type PaginatedTeamMember = {
  __typename?: 'PaginatedTeamMember';
  edges: Array<TeamMemberEdge>;
  nodes: Array<TeamMember>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Filtros para listar membros de uma equipe */
export type PaginatedTeamMemberFilters = {
  /** Filtrar pelo nome ou email do membro */
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar pelo papel do membro */
  role?: InputMaybe<TeamMemberRole>;
  /** ID da equipe */
  teamId: Scalars['ID']['input'];
};

export enum PaginatedTeamMemberSortOrderEnum {
  CreatedAt = 'created_at'
}

export type PaginatedTeamMemberSortOrderInput = {
  field: PaginatedTeamMemberSortOrderEnum;
  order: SortOrderDirection;
};

export enum PaginatedTeamSortOrderEnum {
  CreatedAt = 'created_at',
  Name = 'name',
  UpdatedAt = 'updated_at'
}

export type PaginatedTeamSortOrderInput = {
  field: PaginatedTeamSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedTemplatesFilters = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pipeId: Scalars['ID']['input'];
  templateType?: InputMaybe<Scalars['String']['input']>;
};

export enum PaginatedTemplatesSortOrderEnum {
  CreatedAt = 'created_at',
  Name = 'name',
  UpdatedAt = 'updated_at'
}

export type PaginatedTemplatesSortOrderInput = {
  field: PaginatedTemplatesSortOrderEnum;
  order: SortOrderDirection;
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  edges: Array<UserEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedUserInvite = {
  __typename?: 'PaginatedUserInvite';
  edges: Array<UserInviteEdge>;
  nodes: Array<UserInvite>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Pagination for Notification */
export type PaginationByOffsetNotification = {
  __typename?: 'PaginationByOffsetNotification';
  items: Array<Notification>;
  pageInfo: PageInfoOffset;
  totalCount: Scalars['Float']['output'];
};

/** The pagination for opened cards */
export type PaginationByOffsetUnopenedCards = {
  __typename?: 'PaginationByOffsetUnopenedCards';
  items: Array<Card>;
  pageInfo: PageInfoOffset;
  /** Identifier of the stage */
  suid: Scalars['ID']['output'];
  totalCount: Scalars['Float']['output'];
};

/** The paragraph field */
export type ParagraphField = FieldType & {
  __typename?: 'ParagraphField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export type PasswordResetResult = {
  __typename?: 'PasswordResetResult';
  success: Scalars['Boolean']['output'];
};

/** Permission scope */
export enum PermissionScope {
  Databases = 'databases',
  Global = 'global',
  Pipes = 'pipes'
}

/** System permissions */
export type Permissions = {
  __typename?: 'Permissions';
  /** Pipe permission */
  children: Array<Permissions>;
  /** Permission created at */
  createdAt: Scalars['DateTime']['output'];
  /** Permission description */
  description: Scalars['String']['output'];
  /** Permission ID */
  id: Scalars['ID']['output'];
  /** Whether the permission requires an operator license */
  isOperator: Scalars['Boolean']['output'];
  /** Localizations */
  localizations?: Maybe<Scalars['JSON']['output']>;
  /** Parent permission */
  parent: Permissions;
  /** Permission type */
  scope: PermissionScope;
  /** Permission name */
  title: Scalars['String']['output'];
};


/** System permissions */
export type PermissionsChildrenArgs = {
  scope?: InputMaybe<PermissionScope>;
};

export type PermissionsWhere = {
  parentId?: InputMaybe<Scalars['String']['input']>;
};

/** The phone field */
export type PhoneField = FieldType & {
  __typename?: 'PhoneField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Representa um fluxo */
export type Pipe = {
  __typename?: 'Pipe';
  account: Account;
  /** Caso verdadeiro, permite enviar comentários quando o card estiver bloqueado */
  allowCommentsWhenCardLocked: Scalars['Boolean']['output'];
  /** Caso verdadeiro, permite a visibilidade da aba de anexos nos detalhes das solicitações desse fluxo */
  attachmentsTabVisibility: Scalars['Boolean']['output'];
  canAccessPipe?: Maybe<Scalars['Boolean']['output']>;
  /** Comportamento de atualização do formulário inicial de cards desse fluxo */
  cardInitialFormUpdateBehavior: PipeCardInitialFormUpdateBehavior;
  /** Comportamento de atualização do formulário de solicitação de cards desse fluxo */
  cardSolicitationFormUpdateBehavior: PipeSolicitationFormUpdateBehavior;
  /** Comportamento de reabertura de tarefas de cards desse fluxo */
  cardTaskReopenBehavior: PipesCardTaskReopenBehaviorEnum;
  /** Define a visibilidade dos cards desse fluxo para membros */
  cardVisibilityBehavior: PipesCardVisibilityBehaviorEnum;
  cardsCount: Scalars['Int']['output'];
  /** Cor do fluxo */
  color?: Maybe<Scalars['String']['output']>;
  /** Quando esse fluxo foi criado */
  createdAt: Scalars['DateTime']['output'];
  deadline?: Maybe<Deadline>;
  /** Quando esse fluxo foi arquivado */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Descrição do Fluxo */
  description?: Maybe<Scalars['String']['output']>;
  documentation: PipeDoc;
  /**
   * Se esse fluxo é favoritado pelo usuário autenticado
   * @deprecated Esse campo não tem utilidade e será removido em uma versão futura.
   */
  favorite?: Maybe<Scalars['Boolean']['output']>;
  /** Ícone do fluxo */
  icon?: Maybe<Scalars['String']['output']>;
  /** Id do Fluxo */
  id: Scalars['ID']['output'];
  labels?: Maybe<Array<Label>>;
  members: Array<PipesMember>;
  /** Nome do Fluxo */
  name: Scalars['String']['output'];
  notificationPreferences?: Maybe<NotificationPipePreference>;
  /**
   * Caso verdadeiro, apenas administradores podem arquivar cards desse fluxo
   * @deprecated Atualmente, os isso é definido via a permissão de pipes:cards:delete_all e pipes:cards:delete_own
   */
  onlyAdminCanRemoveCards: Scalars['Boolean']['output'];
  /**
   * Caso verdadeiro, apenas responsáveis podem editar cards desse fluxo
   * @deprecated Atualmente, os isso é definido via a permissão de pipes:cards:update_all e pipes:cards:update_limited
   */
  onlyAssigneesCanEditCards: Scalars['Boolean']['output'];
  /** @deprecated Use the `canAccessPipe` field instead */
  permissions: PipePermissions;
  /** Caso verdadeiro, membros podem visualizar esse fluxo */
  private: Scalars['Boolean']['output'];
  /** Permitir ou negar a visibilidade de cards relacionados em outros fluxos */
  relatedCardVisibilityBehavior: PipesCardVisibilityBehaviorEnum;
  stages: Array<Stage>;
  startForm: Form;
  /** Quando esse fluxo foi atualizado */
  updatedAt: Scalars['DateTime']['output'];
};


/** Representa um fluxo */
export type PipeStagesArgs = {
  params?: InputMaybe<StagesParamsInput>;
};

/** Define as regras para atualização das respostas do formulário inicial do card. */
export enum PipeCardInitialFormUpdateBehavior {
  /** Sempre permite a atualização das respostas do formulário inicial do card. */
  Always = 'always',
  /** Permite a atualização das respostas do formulário inicial do card apenas antes do primeiro movimento do card para uma próxima etapa. */
  BeforeFirstMove = 'before_first_move',
  /** Nunca permite a atualização das respostas do formulário inicial do card. */
  Never = 'never',
  /** Permite a atualização das respostas do formulário inicial do card apenas quando o card estiver na etapa de criação. */
  OnlyOnCreationStage = 'only_on_creation_stage'
}

/** Card relation model */
export type PipeCardRelation = {
  __typename?: 'PipeCardRelation';
  /** List of the connections */
  childrenConnections: Array<Connection>;
  /** Primary connection between the cards */
  connection: Connection;
  /** List of the connections */
  parentsConnections: Array<Connection>;
};

export type PipeDoc = {
  __typename?: 'PipeDoc';
  flux: FluxDocContent;
  stages: Array<StageDocContent>;
};

export type PipeEdge = {
  __typename?: 'PipeEdge';
  cursor: Scalars['String']['output'];
  node: Pipe;
};

/** Pipes permission */
export type PipePermissions = {
  __typename?: 'PipePermissions';
  /** Whether the user can delete cards */
  canDeleteCard: Scalars['Boolean']['output'];
  /** Whether the user can download files */
  canDownloadFiles: Scalars['Boolean']['output'];
  /**
   * Whether the user can view any card
   * @deprecated Esse campo será removido em uma versão futura.
   */
  canEdit: Scalars['Boolean']['output'];
  /** Whether the user can edit any card */
  canEditAnyCard: Scalars['Boolean']['output'];
  /** Whether the user can edit cards */
  canEditCard: Scalars['Boolean']['output'];
  /** Whether the user can edit the pipe */
  canEditPipe: Scalars['Boolean']['output'];
  /** Whether the user can show all cards */
  canShowAllCards: Scalars['Boolean']['output'];
};

/** Define as regras para atualização das respostas do formulário de solicitação do card. */
export enum PipeSolicitationFormUpdateBehavior {
  /** Permite a atualização das respostas do formulário de solicitação do card apenas pelos responsáveis. */
  OnlyAssignees = 'only_assignees',
  /** Permite a atualização das respostas do formulário de solicitação do card apenas pelo solicitante. */
  OnlySolicitor = 'only_solicitor',
  /** Permite a atualização das respostas do formulário de solicitação do card tanto pelo solicitante quanto pelos responsáveis. */
  SolicitorAndAssignees = 'solicitor_and_assignees'
}

/** Pipe card task reopen behavior */
export enum PipesCardTaskReopenBehaviorEnum {
  /** Card assignees and card task assignees can reopen tasks */
  CardAssigneesAndCardTaskAssignees = 'card_assignees_and_card_task_assignees',
  /** Only card task assignees can reopen tasks */
  OnlyCardTaskAssignees = 'only_card_task_assignees'
}

/** Pipe card view behavior for members */
export enum PipesCardVisibilityBehaviorEnum {
  /** All members can see all cards */
  AllMembers = 'all_members',
  /** Members can see cards based on their permissions */
  PermissionDriven = 'permission_driven'
}

export type PipesMember = {
  __typename?: 'PipesMember';
  /** Member active */
  active: Scalars['Boolean']['output'];
  /** Member id */
  id: Scalars['ID']['output'];
  /**
   * Member role
   * @deprecated Use roleType instead
   */
  roleName: Scalars['String']['output'];
  roleType: RoleTypeEnum;
  /** Member */
  user: User;
};

export type PipesMemberEdge = {
  __typename?: 'PipesMemberEdge';
  cursor: Scalars['String']['output'];
  node: PipesMember;
};

/** Return of the presigned post to upload a file */
export type PresignedPostData = {
  __typename?: 'PresignedPostData';
  fields: Scalars['JSONObject']['output'];
  url: Scalars['String']['output'];
};

export type PublicCardStageFormLink = {
  __typename?: 'PublicCardStageFormLink';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  answeredBy?: Maybe<Scalars['String']['output']>;
  customMessage?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  fields: Array<FieldType>;
  isEditable: Scalars['Boolean']['output'];
  isRequiredAuthenticated: Scalars['Boolean']['output'];
  publicLink: Scalars['String']['output'];
  stage: Stage;
};

export type PublicCardTaskFormLink = {
  __typename?: 'PublicCardTaskFormLink';
  account: AccountPublic;
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  answeredBy?: Maybe<Scalars['String']['output']>;
  card?: Maybe<Card>;
  customMessage?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  fields: Array<CardTaskField>;
  isEditable: Scalars['Boolean']['output'];
  isRequiredAuthenticated: Scalars['Boolean']['output'];
  pipe: Pipe;
  publicLink: Scalars['String']['output'];
  task?: Maybe<CardTask>;
};

/** Feature Flag */
export type PublicFeatureFlag = {
  __typename?: 'PublicFeatureFlag';
  /** Feature flag status */
  active: Scalars['Boolean']['output'];
  /** Feature flag purpose and description */
  description?: Maybe<Scalars['String']['output']>;
  /** Feature flag metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Feature flag unique readable identifier */
  slug: Scalars['String']['output'];
};

/** Return of the presigned post to see a file */
export type PublicPresignedGet = {
  __typename?: 'PublicPresignedGet';
  /** URL to view the file */
  viewUrl: Scalars['String']['output'];
};

/** Return of the presigned post to upload a file */
export type PublicPresignedPost = {
  __typename?: 'PublicPresignedPost';
  fields: Scalars['JSONObject']['output'];
  /** URL to upload the file */
  url: Scalars['String']['output'];
};

/** Representa um convite de usuário público */
export type PublicUserInvite = {
  __typename?: 'PublicUserInvite';
  /** Quando o convite do usuário foi aceito */
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A conta à qual o convite do usuário pertence */
  account: AccountPublic;
  /** If the invite can be accepted using passwords */
  canUsePassword: Scalars['Boolean']['output'];
  /** E-mail do convite do usuário */
  email: Scalars['String']['output'];
  /** ID do convite do usuário */
  id: Scalars['ID']['output'];
  /** O status do convite do usuário */
  status: UserInviteStatus;
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  /** Pega uma funcionalidade da conta por id */
  accountFeature: AccountFeature;
  /** Pega uma funcionalidade da conta pelo slug da funcionalidade */
  accountFeatureBySlug: AccountFeature;
  /** Lista as funcionalidades da conta */
  accountFeatures: PaginatedAccountFeature;
  /** Lista as funcionalidades ativas da conta */
  accountFeaturesActive: Array<AccountFeatureActive>;
  activeFeatureFlags: Array<PublicFeatureFlag>;
  allTemplatesIdsByStage: Array<Scalars['ID']['output']>;
  /** @deprecated This query is deprecated, use `automationV2` instead. */
  automation: Automation;
  /** Get a paginated list of automations executions */
  automationExecutionsV2: PaginatedAutomationV2Execution;
  /** Get an automation by its ID */
  automationV2: AutomationV2;
  /** Get metadata for automations actions */
  automationV2ActionMetadata: Array<AutomationV2ActionMetadata>;
  /** Get a paginated list of automation autocomplete options */
  automationV2AutocompleteOptions: PaginatedAutomationV2AutocompleteOption;
  /** Get metadata for automations context */
  automationV2ContextMetadata: Array<AutomationV2ContextMetadata>;
  /** Get metadata for automations triggers */
  automationV2TriggerMetadata: Array<AutomationV2TriggerMetadata>;
  /** @deprecated This query is deprecated, use `automationsV2` instead. */
  automations: Array<Automation>;
  /** Get a paginated list of automations */
  automationsV2: PaginatedAutomationV2;
  batchTemplatesByStage: Array<StageTemplate>;
  /** Recupera uma ação em massa pelo ID */
  bulkAction: BulkAction;
  /** Recupera uma lista paginada de ações em massa */
  bulkActions: PaginatedBulkAction;
  /** Get a card by id */
  card: Card;
  cardHistory: CardHistory;
  cardHistoryInStage: CardHistoryInStage;
  cardLogs: CardLogsPaginated;
  /** Get a card relation by cardId */
  cardRelation: CardRelation;
  /** Card review entity */
  cardReview: CardReview;
  cardStageSharedLinkByCardId?: Maybe<CardsSharedLink>;
  cardStageTasks: PaginatedCardStageTask;
  cardTask: CardTask;
  cardTaskAssignee: CardTaskAssignee;
  cardTaskAssignees: PaginatedCardTaskAssignee;
  cardTaskFields: Array<CardTaskField>;
  cardTaskLabels: Array<CardTaskLabel>;
  cardTaskSharedLinkByTaskId?: Maybe<CardsTasksSharedLink>;
  /** Get all cards of a pipe */
  cards: PaginatedCard;
  /** Get paginated list of card assignees */
  cardsAssignees: PaginatedCardAssignee;
  /** Get paginated list of card attachments from all entities */
  cardsAttachments: PaginatedCardAttachment;
  /** Get paginated list of card attachments uploaded through the card */
  cardsAttachmentsFromCard: PaginatedCardAttachment;
  /** Get paginated list of card comments */
  cardsComments: PaginatedCardComment;
  /** Get all labels for a card */
  cardsLabels: PaginatedCardLabel;
  cardsTasks: PaginatedCardTask;
  cardsTasksByPipe: PaginatedCardTask;
  currentStageFields: FieldTypesConnection;
  /** Obter um banco de dados por ID */
  database: Database;
  /** Retorna os logs paginados do banco de dados */
  databaseLogs: PaginatedDatabaseLog;
  /** Retorna uma lista paginada de membros do banco de dados */
  databaseMembers: PaginatedDatabaseMember;
  /** Obter um registro específico do banco de dados pelo ID */
  databaseRecord: DatabaseRecord;
  /** Obter todos os registros de um banco de dados específico */
  databaseRecords: PaginatedDatabaseRecord;
  /** Obter o esquema do banco de dados atualmente suportado */
  databaseSchema: DatabaseSchema;
  /** Obter uma lista paginada de bancos de dados */
  databases: PaginatedDatabase;
  /** Pega uma funcionalidade pelo slug */
  feature: Feature;
  featureFlag?: Maybe<FeatureFlag>;
  featureFlags: FeatureFlagPaginated;
  /** Lista todas as funcionalidades */
  features: Array<Feature>;
  field: FieldType;
  /** Obtém os registros do banco de dados vinculados ao campo */
  fieldDatabaseRecords: PaginatedDatabaseRecordRestricted;
  /** Obtém os campos do schema do banco de dados vinculados ao campo */
  fieldDatabaseSchemaFields: Array<DatabaseSchemaFieldRestricted>;
  form: Form;
  /** Retorna os times com acesso ao formulário */
  formTeamAccess: Array<FormTeamAccessTeam>;
  /** Retorna os usuários com acesso ao formulário */
  formUserAccess: Array<FormUserAccessUser>;
  forms: PaginatedForm;
  getAssignableUsersForRole: Array<User>;
  getAuthenticatedUserRole?: Maybe<Role>;
  /** Obtém um presigned post para upload do arquivo de entrada da ação em massa */
  getBulkActionPresignedPost: PresignedPostData;
  getInviteByToken?: Maybe<PublicUserInvite>;
  getLabel: Label;
  getLabels: Array<Label>;
  getLabelsByIds: Array<Label>;
  /** Get the attachment pre signed url */
  getPreSigned: Scalars['String']['output'];
  /** Get the attachments of a card */
  getPreSignedPost: PresignedPostData;
  getPresignedProfile: MePresigned;
  getRoleUsers: PaginatedUser;
  /** Obtém uma lista de convites de usuário */
  getUserInvites: PaginatedUserInvite;
  getUsers: PaginatedUser;
  getUsersByIds: Array<User>;
  labels: PaginatedLabel;
  me: Me;
  mfa: Mfa;
  notification: Notification;
  /** Get the notification preferences for the current user */
  notificationPipePreferences?: Maybe<NotificationPipePreference>;
  /** Get all pipes that are being used for notification preferences */
  notificationPipes: PaginatedNotificationPipe;
  /** Get the notification preferences for the current user */
  notificationUserPreferences: NotificationUserPreference;
  notifications: PaginationByOffsetNotification;
  /** Get the reviews of the authenticated user */
  ownReviews: PaginatedReview;
  /** Get all permissions */
  permissions: Array<Permissions>;
  pipe: Pipe;
  pipeSolicitation?: Maybe<Pipe>;
  pipes: PaginatedPipe;
  pipesMembers: PaginatedPipesMember;
  pipesMembersByIds: Array<PipesMember>;
  publicCardStageFormLink?: Maybe<PublicCardStageFormLink>;
  publicCardTaskFormLink?: Maybe<PublicCardTaskFormLink>;
  publicForm?: Maybe<Form>;
  publicPresignedGet: PublicPresignedGet;
  publicPresignedPost: PublicPresignedPost;
  recoveryCodes: Array<RecoveryCode>;
  /** Refresh current user role and permissions */
  refreshAuthRole?: Maybe<RefreshAuthRole>;
  relationsByCard: PipeCardRelation;
  reportDetails: Array<FormReportDetails>;
  reportsByPipeId: Array<FormReport>;
  /** Get a review by id */
  review: Review;
  /** Get the reviews by pipe */
  reviewsByPipe: PaginatedReview;
  role: Role;
  roles: PaginatedRole;
  /** Get all cards of the authenticated user */
  selfCards: PaginatedCard;
  /** Get paginated list of solicitation attachments */
  solicitationAttachments: PaginatedCardAttachment;
  solicitationDetail: CardSolicitation;
  solicitationForms: PaginatedSolicitationFormResponse;
  stage: Stage;
  stages: Array<Stage>;
  /** Recupera uma equipe pelo ID */
  team: Team;
  /** Recupera uma lista paginada de membros de uma equipe */
  teamMembers: PaginatedTeamMember;
  /** Recupera uma lista paginada de equipes */
  teams: PaginatedTeam;
  /** Get template by id */
  template: Template;
  templateTask: Template;
  /** Get all templates */
  templates: TemplatePaginated;
  templatesByStage: ListTemplatesByStageResponse;
  /** Get all templates deadlines by pipe id */
  templatesDeadlines: TemplatePaginated;
  /** Get all templates tasks by pipe id */
  templatesTasks: TemplatePaginated;
  unopenedCards: PaginationByOffsetUnopenedCards;
  user: User;
  userNotifications?: Maybe<UserNotification>;
  /** Estatísticas do usuário para licença */
  userStatisticsForLicense: UserStatisticsForLicense;
  /**
   * Lista de usuários da conta paginada
   * @deprecated Use getUsers instead
   */
  usersAccount: UsersAccountPaginated;
  /** Valida um email de convite */
  validateInviteEmail: EmailValidation;
};


export type QueryAccountFeatureArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccountFeatureBySlugArgs = {
  slug: FeatureSlug;
};


export type QueryAccountFeaturesArgs = {
  filters?: InputMaybe<PaginatedAccountFeatureFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAccountFeatureSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTemplatesIdsByStageArgs = {
  stageId: Scalars['ID']['input'];
};


export type QueryAutomationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutomationExecutionsV2Args = {
  filters?: InputMaybe<PaginatedAutomationV2ExecutionFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAutomationV2ExecutionSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAutomationV2Args = {
  id: Scalars['ID']['input'];
};


export type QueryAutomationV2AutocompleteOptionsArgs = {
  filters: PaginatedAutomationV2AutocompleteOptionFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAutomationV2AutocompleteOptionSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAutomationsArgs = {
  params: AutomationsWhereInput;
};


export type QueryAutomationsV2Args = {
  filters?: InputMaybe<PaginatedAutomationV2Filters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAutomationV2SortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBatchTemplatesByStageArgs = {
  data: GetBatchTemplatesByStageInput;
};


export type QueryBulkActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkActionsArgs = {
  filters?: InputMaybe<PaginatedBulkActionFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedBulkActionSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCardHistoryArgs = {
  cardId: Scalars['ID']['input'];
};


export type QueryCardHistoryInStageArgs = {
  cardId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
};


export type QueryCardLogsArgs = {
  params: CardLogsPaginateInput;
};


export type QueryCardRelationArgs = {
  cardId: Scalars['String']['input'];
};


export type QueryCardReviewArgs = {
  cardId: Scalars['ID']['input'];
};


export type QueryCardStageSharedLinkByCardIdArgs = {
  cardId: Scalars['String']['input'];
};


export type QueryCardStageTasksArgs = {
  cardId: Scalars['ID']['input'];
  cardStageEntryId: Scalars['ID']['input'];
  hasFormSubmitted?: Scalars['Boolean']['input'];
};


export type QueryCardTaskArgs = {
  id: Scalars['String']['input'];
};


export type QueryCardTaskAssigneeArgs = {
  cardTaskAssigneeId: Scalars['ID']['input'];
};


export type QueryCardTaskAssigneesArgs = {
  cardTaskId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCardTaskFieldsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCardTaskLabelsArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryCardTaskSharedLinkByTaskIdArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryCardsArgs = {
  filters?: InputMaybe<FiltersCardsInput>;
  pipeId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<Array<SortOrderInput>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCardsAssigneesArgs = {
  filters: PaginatedCardAssigneeFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardAssigneeSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCardsAttachmentsArgs = {
  filters: PaginatedCardAttachmentFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardAttachmentSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCardsAttachmentsFromCardArgs = {
  filters: PaginatedCardAttachmentFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardAttachmentSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCardsCommentsArgs = {
  filters: PaginatedCardCommentFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardCommentSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCardsLabelsArgs = {
  filters: PaginatedCardLabelFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardLabelSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCardsTasksArgs = {
  skip: Scalars['Float']['input'];
  sort?: InputMaybe<CardTaskSortInputDto>;
  take: Scalars['Float']['input'];
  where: CardTaskWhereInputDto;
};


export type QueryCardsTasksByPipeArgs = {
  skip: Scalars['Float']['input'];
  sort?: InputMaybe<Array<SortOrderInput>>;
  take: Scalars['Float']['input'];
  where: CardTaskByPipeWhereInputDto;
};


export type QueryCurrentStageFieldsArgs = {
  cardId: Scalars['ID']['input'];
};


export type QueryDatabaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDatabaseLogsArgs = {
  filters: PaginatedDatabaseLogFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedDatabaseLogSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDatabaseMembersArgs = {
  filters: PaginatedDatabaseMemberFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedDatabaseMemberSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDatabaseRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDatabaseRecordsArgs = {
  filters: PaginatedDatabaseRecordFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedDatabaseRecordSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDatabaseSchemaArgs = {
  databaseId: Scalars['ID']['input'];
};


export type QueryDatabasesArgs = {
  filters?: InputMaybe<PaginatedDatabasesFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedDatabasesSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeatureArgs = {
  slug: FeatureSlug;
};


export type QueryFeatureFlagArgs = {
  slug: Scalars['String']['input'];
};


export type QueryFeatureFlagsArgs = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<FeatureFlagWhereInput>;
};


export type QueryFieldArgs = {
  id: Scalars['String']['input'];
};


export type QueryFieldDatabaseRecordsArgs = {
  currentAnswers?: InputMaybe<Array<CurrentAnswerInput>>;
  fieldId: Scalars['ID']['input'];
  fieldSource: FieldSourceType;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFieldDatabaseSchemaFieldsArgs = {
  fieldId: Scalars['ID']['input'];
  fieldSource: FieldSourceType;
};


export type QueryFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFormTeamAccessArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryFormUserAccessArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryFormsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FiltersFormInput>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetAssignableUsersForRoleArgs = {
  roleId: Scalars['String']['input'];
};


export type QueryGetAuthenticatedUserRoleArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pipeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBulkActionPresignedPostArgs = {
  input: GetBulkActionPresignedPostInput;
};


export type QueryGetInviteByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetLabelArgs = {
  labelId: Scalars['ID']['input'];
};


export type QueryGetLabelsArgs = {
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLabelsByIdsArgs = {
  labelsIds: Array<Scalars['ID']['input']>;
  pipeId: Scalars['ID']['input'];
};


export type QueryGetPreSignedArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetPreSignedPostArgs = {
  input: CreatePreSignedPostInput;
};


export type QueryGetPresignedProfileArgs = {
  input: GetPresignedProfileInput;
};


export type QueryGetRoleUsersArgs = {
  roleId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<GetUsersSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GetUsersWhereInput>;
};


export type QueryGetUserInvitesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<GetUsersInvitesSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserInviteWhereInput>;
};


export type QueryGetUsersArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<GetUsersSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GetUsersWhereInput>;
};


export type QueryGetUsersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  pipeId: Scalars['ID']['input'];
};


export type QueryMeArgs = {
  params?: InputMaybe<MeParamsInput>;
};


export type QueryNotificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationPipePreferencesArgs = {
  pipeId: Scalars['String']['input'];
};


export type QueryNotificationPipesArgs = {
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryOwnReviewsArgs = {
  filters?: InputMaybe<PaginatedReviewFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedReviewSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPermissionsArgs = {
  where?: InputMaybe<PermissionsWhere>;
};


export type QueryPipeArgs = {
  pipeId: Scalars['ID']['input'];
};


export type QueryPipeSolicitationArgs = {
  id: Scalars['String']['input'];
};


export type QueryPipesArgs = {
  filters?: InputMaybe<PaginatedPipeFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedPipeSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPipesMembersArgs = {
  notTheseUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  withoutMe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPipesMembersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  pipeId: Scalars['ID']['input'];
};


export type QueryPublicCardStageFormLinkArgs = {
  hash: Scalars['String']['input'];
};


export type QueryPublicCardTaskFormLinkArgs = {
  hash: Scalars['String']['input'];
};


export type QueryPublicFormArgs = {
  hashedId: Scalars['String']['input'];
};


export type QueryPublicPresignedGetArgs = {
  input: GetPublicPreSignedGetInput;
};


export type QueryPublicPresignedPostArgs = {
  input: GetPublicPreSignedPostInput;
};


export type QueryRecoveryCodesArgs = {
  input: GetRecoveryCodesInput;
};


export type QueryRefreshAuthRoleArgs = {
  roleEntityContext?: InputMaybe<RoleEntityContextInput>;
};


export type QueryRelationsByCardArgs = {
  cardId: Scalars['ID']['input'];
};


export type QueryReportDetailsArgs = {
  filters: FiltersReportsDetailsInput;
  formId: Scalars['ID']['input'];
  pipeId: Scalars['ID']['input'];
};


export type QueryReportsByPipeIdArgs = {
  filters: FiltersReportsInput;
  pipeId: Scalars['ID']['input'];
};


export type QueryReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewsByPipeArgs = {
  filters?: InputMaybe<PaginatedReviewFilters>;
  pipeId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedReviewSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRoleArgs = {
  id: Scalars['String']['input'];
};


export type QueryRolesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RolesWhereInput>;
};


export type QuerySelfCardsArgs = {
  filters?: InputMaybe<FiltersSelfCardsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortOrderInput>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySolicitationAttachmentsArgs = {
  filters: PaginatedCardAttachmentFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardAttachmentSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySolicitationDetailArgs = {
  id: Scalars['String']['input'];
};


export type QuerySolicitationFormsArgs = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where: WhereSolicitationFormsInput;
};


export type QueryStageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStagesArgs = {
  params: StagesParamsInput;
};


export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamMembersArgs = {
  filters: PaginatedTeamMemberFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedTeamMemberSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTeamsArgs = {
  filters?: InputMaybe<PaginatedTeamFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedTeamSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemplateTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemplatesArgs = {
  filters: PaginatedTemplatesFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedTemplatesSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemplatesByStageArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pipeId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
};


export type QueryTemplatesDeadlinesArgs = {
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryTemplatesTasksArgs = {
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryUnopenedCardsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UnopenedCardsSortInput>;
  stageId: Scalars['ID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FiltersCardsInput>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserStatisticsForLicenseArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUsersAccountArgs = {
  filters?: InputMaybe<UsersAccountFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidateInviteEmailArgs = {
  email: Scalars['String']['input'];
};

export type RealDeadline = {
  __typename?: 'RealDeadline';
  cardFinishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of card associated with the deadline */
  cardId?: Maybe<Scalars['String']['output']>;
  /** The id of card stage associated with the deadline */
  cardStageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineAt?: Maybe<Scalars['DateTime']['output']>;
  deadlineAtNotificationSent?: Maybe<Scalars['Boolean']['output']>;
  deadlineAtNotificationSentAt?: Maybe<Scalars['DateTime']['output']>;
  deadlineRaw?: Maybe<Scalars['JSON']['output']>;
  deadlineRiskAt?: Maybe<Scalars['DateTime']['output']>;
  deadlineRiskAtNotificationSent?: Maybe<Scalars['Boolean']['output']>;
  deadlineRiskAtNotificationSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The stage associated with the deadline */
  deadlineStage?: Maybe<Stage>;
  deadlineStartedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RecoveryCode = {
  __typename?: 'RecoveryCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Recovery code is used */
  used: Scalars['Boolean']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RecreateRecoveryCodesInput = {
  /** User password */
  password: Scalars['String']['input'];
};

/** Refresh auth role */
export type RefreshAuthRole = {
  __typename?: 'RefreshAuthRole';
  /** Cargo do banco de dados, se `roleEntityContext.databaseId` for fornecido */
  databaseRole?: Maybe<Role>;
  /** Cargo global do usuário autenticado */
  globalRole?: Maybe<Role>;
  /** Cargo do fluxo, se `roleEntityContext.pipeId` for fornecido */
  pipeRole?: Maybe<Role>;
};

export type RejectReviewInput = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type RelatedCardAction = AutomationAction & {
  __typename?: 'RelatedCardAction';
  /** Attributes of the related card */
  attributes?: Maybe<Scalars['JSON']['output']>;
  /** Fields mapping of the related card */
  fieldsMapping?: Maybe<Array<Scalars['JSON']['output']>>;
  /** The ID of the automation action */
  id: Scalars['ID']['output'];
  /** The target id of the related card */
  targetId: Scalars['ID']['output'];
  /** The target stage id of the related card */
  targetStageId?: Maybe<Scalars['ID']['output']>;
  /** The type of the automation action */
  type: Scalars['String']['output'];
};

/** Remove card assignee input */
export type RemoveCardAssigneeInput = {
  /** Card id */
  cardId: Scalars['ID']['input'];
  /** User email */
  userEmail?: InputMaybe<Scalars['ID']['input']>;
  /** User id */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Card create input */
export type RemoveCardCommentAttachmentInput = {
  /** Id do anexo */
  cardAttachmentId: Scalars['ID']['input'];
  /** Id do comentário */
  cardCommentId: Scalars['ID']['input'];
};

/** Remove label for card input */
export type RemoveCardLabelInput = {
  /** Card id */
  cardId: Scalars['ID']['input'];
  /** Label id */
  labelId: Scalars['ID']['input'];
};

/** Entrada para remover um campo do esquema do banco de dados */
export type RemoveDatabaseSchemaFieldInput = {
  /** ID do banco de dados */
  databaseId: Scalars['ID']['input'];
  /** ID do campo a ser removido do esquema do banco de dados */
  fieldId: Scalars['ID']['input'];
};

export type RemoveMemberFromPipeInput = {
  /** Pipe ID */
  pipeId: Scalars['ID']['input'];
  /** Member ID */
  removeUsers: Array<Scalars['ID']['input']>;
};

export type RemoveMemberFromPipePayload = {
  __typename?: 'RemoveMemberFromPipePayload';
  /** Errors */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Pipe ID */
  pipe: Pipe;
  /** Removed users */
  removedUsers: Array<Scalars['String']['output']>;
  /** Success */
  success: Scalars['Boolean']['output'];
};

/** Dados para remover um membro de uma equipe */
export type RemoveTeamMemberInput = {
  /** ID da equipe */
  teamId: Scalars['ID']['input'];
  /** Identificador do usuário */
  user: UserIdentifiableInput;
};

/** Entrada para reordenar campos do esquema do banco de dados */
export type ReorderDatabaseSchemaFieldsInput = {
  /** ID do banco de dados */
  databaseId: Scalars['String']['input'];
  /** Array de posições dos campos */
  fields: Array<FieldPositionInput>;
};

export type RequestChangeReviewInput = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type RequestMfaSecret = {
  __typename?: 'RequestMfaSecret';
  /** MFA secret */
  secret: Scalars['String']['output'];
  /** MFA session */
  session: Scalars['String']['output'];
};

export type RequestMfaSecretInput = {
  /** User password */
  password: Scalars['String']['input'];
};

export type RequestPasswordResetInput = {
  /** User email */
  email: Scalars['String']['input'];
};

/** Request review by template input */
export type RequestReviewByTemplateInput = {
  /** The id of the card */
  cardId: Scalars['ID']['input'];
  /** The data to be passed to the template */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Override reviewers */
  reviewers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The id of the template */
  templateId: Scalars['ID']['input'];
};

/** Request a review for a card */
export type RequestReviewInput = {
  /** The card id */
  cardId: Scalars['ID']['input'];
  /** Minimum required reviewers to approve the card */
  minimumReviewsRequired?: InputMaybe<Scalars['Int']['input']>;
  /** The orientation message for the reviewers */
  orientationMessage?: InputMaybe<Scalars['String']['input']>;
  /** Whether a comment is required to approve or reject the review */
  requiredCommentToApproveOrReject?: InputMaybe<Scalars['Boolean']['input']>;
  /** The reviewers of the card */
  reviewers: Array<ReviewerInput>;
  /** The stage id */
  stageId: Scalars['ID']['input'];
  /** The type of the review */
  type?: InputMaybe<ReviewTypeEnum>;
};

/** Review entity */
export type Review = {
  __typename?: 'Review';
  accountId: Scalars['ID']['output'];
  /** Can the review be approved? */
  canApprove: Scalars['Boolean']['output'];
  /** Can the review be canceled? */
  canCancel: Scalars['Boolean']['output'];
  /** Can the review be rejected? */
  canReject: Scalars['Boolean']['output'];
  /** Whether the can request review */
  canRequestReview: Scalars['Boolean']['output'];
  /** The card associated with the review */
  card: Card;
  cardId: Scalars['ID']['output'];
  completedReviewsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
  orientationMessage?: Maybe<Scalars['String']['output']>;
  /** User who requested the review */
  requestedBy: User;
  requestedById: Scalars['ID']['output'];
  requestedStageId: Scalars['ID']['output'];
  /** Whether the review comment is required to approve or reject */
  requiredCommentToApproveOrReject: Scalars['Boolean']['output'];
  /** Reviewers assigned to the review */
  reviewers: Array<Reviewer>;
  /** Stage of the review */
  stage: Stage;
  status: ReviewStatusEnum;
  /** The template used for the review */
  template?: Maybe<TemplateReview>;
  type: ReviewTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

/** The status of the review request */
export enum ReviewStatusEnum {
  Approved = 'approved',
  Canceled = 'canceled',
  Pending = 'pending',
  Rejected = 'rejected',
  RequestedChanges = 'requested_changes',
  Waiting = 'waiting'
}

/** The type of the review request */
export enum ReviewTypeEnum {
  Concurrent = 'concurrent',
  Ordered = 'ordered'
}

export type Reviewer = {
  __typename?: 'Reviewer';
  accountId: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  fields: Array<ReviewerField>;
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  /** Review request */
  reviewRequest: Review;
  review_request_id: Scalars['String']['output'];
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ReviewerStatusEnum;
  /** Reviewer user */
  user: User;
  userId: Scalars['ID']['output'];
};

export type ReviewerEdge = {
  __typename?: 'ReviewerEdge';
  cursor: Scalars['String']['output'];
  node: Reviewer;
};

/** Reviewer fields */
export type ReviewerField = {
  __typename?: 'ReviewerField';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reviewer field conditions */
  conditions: Array<ReviewerFieldCondition>;
  createdAt: Scalars['DateTime']['output'];
  /** Reviewer field database */
  database?: Maybe<SharedFieldDatabase>;
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<ReviewerFieldOption>;
  orientationMessage?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

/** Card task field condition */
export type ReviewerFieldCondition = {
  __typename?: 'ReviewerFieldCondition';
  /** Card task field condition created at */
  createdAt: Scalars['DateTime']['output'];
  /** Reviewer condition dependency type */
  dependencyType: FieldConditionDependencyType;
  /** The reviewer field this condition depends on */
  dependsOnField?: Maybe<ReviewerField>;
  /** Card task field condition expected value array */
  expectedValueArray?: Maybe<Array<Scalars['String']['output']>>;
  /** Card task field condition expected value string */
  expectedValueString?: Maybe<Scalars['String']['output']>;
  /** Card task field condition id */
  id: Scalars['ID']['output'];
  /** Card task field condition operator */
  operator: FieldConditionOperator;
  /** Card task field condition updated at */
  updatedAt: Scalars['DateTime']['output'];
};

export type ReviewerFieldOption = {
  __typename?: 'ReviewerFieldOption';
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type ReviewerInput = {
  /** The user email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The user id */
  id?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** The status of the reviewer */
export enum ReviewerStatusEnum {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
  RequestedChanges = 'requested_changes',
  Waiting = 'waiting'
}

/** Informações de erro para uma operação de aprovadores */
export type ReviewersError = {
  __typename?: 'ReviewersError';
  /** Código do erro */
  errorCode: Scalars['String']['output'];
  /** Mensagem de erro */
  message: Scalars['String']['output'];
  /** ID da aprovação com erro */
  reviewId: Scalars['ID']['output'];
};

/** Roles */
export type Role = {
  __typename?: 'Role';
  /** Account ID */
  accountId: Scalars['String']['output'];
  /** Role created at */
  createdAt: Scalars['DateTime']['output'];
  /** Database of the role */
  database?: Maybe<Database>;
  /** Role description */
  description?: Maybe<Scalars['String']['output']>;
  /** Role has any operator permission */
  hasOperatorPermission: Scalars['Boolean']['output'];
  /** Role ID */
  id: Scalars['ID']['output'];
  /** Role is managed by system */
  isLocked: Scalars['Boolean']['output'];
  /** Role is using default permissions */
  is_using_default_permissions: Scalars['Boolean']['output'];
  /** Role name */
  name: Scalars['String']['output'];
  /** Permissions of the role */
  permissions: RolePermissionsConnection;
  /** Pipe of the role */
  pipe?: Maybe<Pipe>;
  /** Role type */
  type: RoleTypeEnum;
  /** Role updated at */
  updatedAt: Scalars['DateTime']['output'];
  /** Last editor of the role */
  updatedBy?: Maybe<User>;
  /** Users of the role */
  users: RoleUsersConnection;
};


/** Roles */
export type RoleUsersArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type RoleEdge = {
  __typename?: 'RoleEdge';
  cursor: Scalars['String']['output'];
  node: Role;
};

/** Contexto da entidade de papel, como pipeId ou databaseId */
export type RoleEntityContextInput = {
  /** ID do banco de dados associado ao papel */
  databaseId?: InputMaybe<Scalars['String']['input']>;
  /** ID do pipe associado ao papel */
  pipeId?: InputMaybe<Scalars['String']['input']>;
};

/** Pipe roles for me */
export enum RoleInPipeEnum {
  GlobalOwner = 'global_owner',
  PipeEditor = 'pipe_editor',
  PipeEditorLimited = 'pipe_editor_limited',
  PipeOwner = 'pipe_owner',
  PipeReader = 'pipe_reader',
  PipeSupervisor = 'pipe_supervisor'
}

/** Role users connection */
export type RolePermissionsConnection = {
  __typename?: 'RolePermissionsConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Permissions>;
};

/** O tipo de cargo no sistema. */
export enum RoleTypeEnum {
  /** Cargo com permissões administrativas no banco de dados. */
  DatabaseAdmin = 'database_admin',
  /** Cargo com permissões de edição no banco de dados. */
  DatabaseEditor = 'database_editor',
  /** Cargo com todas as permissões no banco de dados, restrito ao dono do banco de dados. */
  DatabaseOwner = 'database_owner',
  /** Cargo com permissões de visualização no banco de dados. */
  DatabaseReader = 'database_reader',
  /** Cargo com permissões administrativas na conta. */
  GlobalAdmin = 'global_admin',
  /** Cargo com permissões de visualização na conta. */
  GlobalGuest = 'global_guest',
  /** Cargo com permissões padrão na conta. */
  GlobalMember = 'global_member',
  /** Cargo com todas as permissões na conta, restrito ao dono da conta. */
  GlobalOwner = 'global_owner',
  /** Cargo com permissões de edição no pipe. */
  PipeEditor = 'pipe_editor',
  /** Cargo com permissões de edição limitadas no pipe. */
  PipeEditorLimited = 'pipe_editor_limited',
  /** Cargo com todas as permissões no pipe, restrito ao dono do pipe. */
  PipeOwner = 'pipe_owner',
  /** Cargo com permissões de visualização no pipe. */
  PipeReader = 'pipe_reader',
  /** Cargo com permissões de supervisão no pipe. */
  PipeSupervisor = 'pipe_supervisor'
}

/** Filtro por tipo de cargo */
export enum RoleTypeWithNone {
  GlobalAdmin = 'global_admin',
  GlobalGuest = 'global_guest',
  GlobalMember = 'global_member',
  GlobalOwner = 'global_owner',
  None = 'none',
  PipeEditor = 'pipe_editor',
  PipeEditorLimited = 'pipe_editor_limited',
  PipeOwner = 'pipe_owner',
  PipeReader = 'pipe_reader',
  PipeSupervisor = 'pipe_supervisor'
}

export type RoleUser = {
  __typename?: 'RoleUser';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Role users connection */
export type RoleUsersConnection = {
  __typename?: 'RoleUsersConnection';
  edges: Array<RoleUser>;
  nodes: Array<User>;
  pageInfo: PageInfo;
  /** Total count of users in this role */
  totalCount: Scalars['Int']['output'];
};

export type RolesWhereInput = {
  /** The database id where the roles belong to */
  databaseId?: InputMaybe<Scalars['ID']['input']>;
  /** The pipe id where the roles belong to */
  pipeId?: InputMaybe<Scalars['ID']['input']>;
};

export type SharedFieldDatabase = {
  __typename?: 'SharedFieldDatabase';
  /** Campos do banco de dados exibidos ao usuário */
  databaseDisplayFields: Array<Scalars['String']['output']>;
  /** Filtros padrão aplicados ao banco de dados */
  databaseFilters?: Maybe<Array<SharedFieldDatabaseFilter>>;
  /** Id do banco de dados */
  databaseId: Scalars['ID']['output'];
  /** Campo do banco de dados usado como rótulo */
  databaseLabelField: Scalars['String']['output'];
  databaseName: Scalars['String']['output'];
  /** Id da versão do esquema do banco de dados */
  databaseSchemaVersionId: Scalars['ID']['output'];
  /** Campos do banco de dados que podem ser pesquisados */
  databaseSearchableFields: Array<Scalars['String']['output']>;
  /** Id da conexão do banco de dados */
  id: Scalars['ID']['output'];
};

export type SharedFieldDatabaseFilter = {
  __typename?: 'SharedFieldDatabaseFilter';
  /** Campo do banco de dados para filtrar */
  field: Scalars['String']['output'];
  /** Operador para o filtro do campo do banco de dados */
  operator: DatabaseRecordFilterByFieldOperators;
  /** Valor para filtrar no campo do banco de dados */
  value: Scalars['String']['output'];
};

/** The short answer field */
export type ShortAnswerField = FieldType & {
  __typename?: 'ShortAnswerField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

export type SignInInput = {
  /** Bradesco token to sign in */
  bradescoToken?: InputMaybe<Scalars['String']['input']>;
  /** Email to sign in */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Google token to sign in */
  googleToken?: InputMaybe<Scalars['String']['input']>;
  /** Password to sign in */
  password?: InputMaybe<Scalars['String']['input']>;
};

export type SignInWithSecondStepInput = {
  /** code generated by auth app or recovery */
  code: Scalars['String']['input'];
  /** token received to sign in with code */
  token: Scalars['String']['input'];
  /** mfa or recovery code */
  type: Scalars['String']['input'];
};

/** The signature field */
export type SignatureField = FieldType & {
  __typename?: 'SignatureField';
  /** The field answer date */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field conditions */
  conditions?: Maybe<Array<FieldCondition>>;
  /** Custom validation of the field */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Custom validation message of the field */
  customValidationMessage?: Maybe<Scalars['String']['output']>;
  database?: Maybe<FieldDatabase>;
  /** Help text for the field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** The field ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The field multiple options available values */
  options: Array<FieldOption>;
  /** The position of the field */
  position: Scalars['Int']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  /** The question title */
  title: Scalars['String']['output'];
  /** The field type */
  type: LegacyFieldTypeEnum;
  /** The signature value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Direção da ordenação: ascendente ou descendente */
export enum SortOrderDirection {
  /** Ordenação ascendente */
  Asc = 'asc',
  /** Ordenação descendente */
  Desc = 'desc'
}

export type SortOrderInput = {
  field: Scalars['String']['input'];
  order: Scalars['String']['input'];
  relation?: InputMaybe<Scalars['String']['input']>;
};

export type Stage = {
  __typename?: 'Stage';
  /** Whether the stage can move cards without tasks being done */
  canMoveCardWithoutTasksBeingDone?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the stage can receive cards directly from draft */
  canReceiveCardDirectlyFromDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the stage can receive cards without tasks being done */
  canReceiveCardWithoutTasksBeingDone?: Maybe<Scalars['Boolean']['output']>;
  cards: CardConnection;
  cardsCanBeMovedToStages: Array<Stage>;
  /** Count of cards in the stage */
  cardsCount?: Maybe<Scalars['Float']['output']>;
  /** Stage color */
  color?: Maybe<Scalars['String']['output']>;
  /** Confirm move card */
  confirmMoveCard?: Maybe<ConfirmMoveCardEnum>;
  /** Stage created at */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deadline?: Maybe<Deadline>;
  /** Stage deleted at */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Stage description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the stage is done */
  done?: Maybe<Scalars['Boolean']['output']>;
  /** Stage Fields */
  fields: Array<Maybe<FieldType>>;
  form?: Maybe<Form>;
  /** Stage id */
  id: Scalars['ID']['output'];
  /** Stage order */
  index: Scalars['Float']['output'];
  /** Minimum reviews required */
  minimumReviewsRequired?: Maybe<Scalars['Int']['output']>;
  /** Whether the stage will move cards to the next stage automatically */
  moveCardToNextStageWhenDone?: Maybe<Scalars['Boolean']['output']>;
  /** Stage name */
  name: Scalars['String']['output'];
  pipe: Pipe;
  /** Review required */
  reviewRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Review type */
  reviewType?: Maybe<ReviewTypeEnum>;
  /** Stage updated at */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Pipe uuid */
  uuid: Scalars['String']['output'];
};


export type StageCardsArgs = {
  filters?: InputMaybe<FiltersCardsInput>;
};


export type StageCardsCountArgs = {
  filters?: InputMaybe<FiltersCardsInput>;
};

/** Stage automation action type */
export enum StageAutomationActionTypeEnum {
  AssigneePerson = 'assignee_person',
  CreateCard = 'create_card',
  CreateRelatedCard = 'create_related_card',
  CreateTask = 'create_task',
  HttpRequest = 'http_request',
  UpdateCard = 'update_card'
}

/** Status of the automation execution */
export enum StageAutomationExecutionsActionsStatus {
  Done = 'done',
  Error = 'error',
  Pending = 'pending',
  Timeout = 'timeout'
}

/** Direction of the automation execution */
export enum StageAutomationExecutionsRunDirection {
  Backward = 'backward',
  Forward = 'forward'
}

/** Stage automation run direction */
export enum StageAutomationRunDirectionEnum {
  Backward = 'backward',
  Both = 'both',
  Forward = 'forward'
}

/** Stage automation type */
export enum StageAutomationTypeEnum {
  OnCardCreate = 'on_card_create',
  OnCardDelete = 'on_card_delete',
  OnCardTaskStatusChange = 'on_card_task_status_change',
  OnCardUpdate = 'on_card_update',
  OnFieldChange = 'on_field_change',
  OnStageEntry = 'on_stage_entry',
  OnStageLeave = 'on_stage_leave',
  OnStatusReviewChange = 'on_status_review_change'
}

export type StageDocContent = {
  __typename?: 'StageDocContent';
  automations?: Maybe<Array<AutomationDocContent>>;
  content?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Stage move direction */
export enum StageMoveDirection {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type StageTemplate = Template & {
  __typename?: 'StageTemplate';
  children: Array<StageTemplateChild>;
  /** Template Creation Date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Template Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Template Fields */
  fields?: Maybe<Array<TemplateField>>;
  /** Template ID */
  id: Scalars['ID']['output'];
  /** Template Name */
  name: Scalars['String']['output'];
  /** Template Pipe ID */
  pipeId: Scalars['String']['output'];
  /** Template Type */
  type: Scalars['String']['output'];
  /** Template Update Date */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StageTemplateChild = {
  __typename?: 'StageTemplateChild';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StagesParamsInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateCards?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pipeId?: InputMaybe<Scalars['ID']['input']>;
};

export type StringValue = {
  __typename?: 'StringValue';
  value: Scalars['String']['output'];
};

/** Error information for a task assignee operation */
export type TaskAssigneeError = {
  __typename?: 'TaskAssigneeError';
  /** Error code */
  errorCode: Scalars['String']['output'];
  /** Error message */
  message: Scalars['String']['output'];
  /** ID of the task with error */
  taskId: Scalars['ID']['output'];
};

/** Representa uma equipe no sistema */
export type Team = {
  __typename?: 'Team';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Descrição da equipe */
  description?: Maybe<Scalars['String']['output']>;
  /** ID único da equipe */
  id: Scalars['ID']['output'];
  /** Membros da equipe */
  members: PaginatedTeamMember;
  /** Nome da equipe */
  name: Scalars['String']['output'];
  /** Slug único da equipe */
  slug: Scalars['String']['output'];
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** Usuário associado à equipe */
  user: User;
};


/** Representa uma equipe no sistema */
export type TeamMembersArgs = {
  filters: PaginatedTeamMemberFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedTeamMemberSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamEdge = {
  __typename?: 'TeamEdge';
  cursor: Scalars['String']['output'];
  node: Team;
};

/** Representa um membro de uma equipe */
export type TeamMember = {
  __typename?: 'TeamMember';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** ID único do registro de membro */
  id: Scalars['ID']['output'];
  /** Papel do membro na equipe */
  role: TeamMemberRole;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** Usuário que é membro da equipe */
  user?: Maybe<User>;
};

export type TeamMemberEdge = {
  __typename?: 'TeamMemberEdge';
  cursor: Scalars['String']['output'];
  node: TeamMember;
};

/** Representa o cargo do usuário em um time. */
export enum TeamMemberRole {
  /** Líder do time, cada time pode ter apenas um líder. */
  Lead = 'lead',
  /** Membro do time. */
  Member = 'member'
}

export type Template = {
  /** Template Creation Date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Template Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Template Fields */
  fields?: Maybe<Array<TemplateField>>;
  /** Template ID */
  id: Scalars['ID']['output'];
  /** Template Name */
  name: Scalars['String']['output'];
  /** Template Pipe ID */
  pipeId: Scalars['String']['output'];
  /** Template Type */
  type: Scalars['String']['output'];
  /** Template Update Date */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Template de Prazo */
export type TemplateDeadline = Template & {
  __typename?: 'TemplateDeadline';
  /** Se deve considerar feriados ao calcular o prazo */
  considerHoliday: Scalars['Boolean']['output'];
  /** Template Creation Date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unidade de tempo para exibir o prazo */
  deadlineDisplayUnit: TemplateDeadlineTimeDisplayUnitEnum;
  /** Prazo em minutos */
  deadlineMinutes: Scalars['Int']['output'];
  /** Unidade de tempo para exibir o risco do prazo */
  deadlineRiskDisplayUnit: TemplateDeadlineTimeDisplayUnitEnum;
  /** Prazo de risco em minutos */
  deadlineRiskMinutes: Scalars['Int']['output'];
  /** Descrição do template de prazo */
  description?: Maybe<Scalars['String']['output']>;
  /** Template Fields */
  fields?: Maybe<Array<TemplateField>>;
  /** Se o prazo possui restrições de horário comercial */
  hasOfficeHours: Scalars['Boolean']['output'];
  /** ID do template de prazo */
  id: Scalars['ID']['output'];
  /** Nome do template de prazo */
  name: Scalars['String']['output'];
  /** Configuração de horário comercial para o prazo */
  officeHours?: Maybe<Scalars['JSON']['output']>;
  /** ID do pipe relacionado ao template de prazo */
  pipeId: Scalars['String']['output'];
  /** Template Type */
  type: Scalars['String']['output'];
  /** Template Update Date */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Unidade de tempo para exibir template de prazos */
export enum TemplateDeadlineTimeDisplayUnitEnum {
  /** Dias */
  Days = 'days',
  /** Horas */
  Hours = 'hours',
  /** Minutos */
  Minutes = 'minutes'
}

export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  cursor: Scalars['String']['output'];
  node: Template;
};

/** Template field */
export type TemplateField = {
  __typename?: 'TemplateField';
  account_id: Scalars['String']['output'];
  conditions: Array<TemplateFieldCondition>;
  /** Template field created at */
  createdAt: Scalars['DateTime']['output'];
  created_by_user_id?: Maybe<Scalars['String']['output']>;
  database?: Maybe<SharedFieldDatabase>;
  /** Template field help text */
  helpText?: Maybe<Scalars['String']['output']>;
  /** Template field ID */
  id: Scalars['ID']['output'];
  /** Template key for the field */
  key: Scalars['String']['output'];
  /** Template field name */
  name: Scalars['String']['output'];
  /** Template field options */
  options?: Maybe<Array<TemplateFieldOption>>;
  /** Template field message orientation */
  orientationMessage?: Maybe<Scalars['String']['output']>;
  /** Template field options */
  position?: Maybe<Scalars['Int']['output']>;
  /** Template field is required */
  required: Scalars['Boolean']['output'];
  /** Esquema de validação do campo */
  schema?: Maybe<Scalars['JSONObject']['output']>;
  template_id: Scalars['String']['output'];
  /** Template field type */
  type: FieldTypeEnum;
  /** Template field updated at */
  updatedAt: Scalars['DateTime']['output'];
  updated_by_last_user_id?: Maybe<Scalars['String']['output']>;
};

/** Template field condition */
export type TemplateFieldCondition = {
  __typename?: 'TemplateFieldCondition';
  /** Template field condition created at */
  createdAt: Scalars['DateTime']['output'];
  /** Template condition dependency type */
  dependencyType: FieldConditionDependencyType;
  /** The template field this condition depends on */
  dependsOnField?: Maybe<TemplateField>;
  /** Template field condition expected value array */
  expectedValueArray?: Maybe<Array<Scalars['String']['output']>>;
  /** Template field condition expected value string */
  expectedValueString?: Maybe<Scalars['String']['output']>;
  /** Template field condition id */
  id: Scalars['ID']['output'];
  /** Template field condition operator */
  operator: FieldConditionOperator;
  /** Template field condition updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Template field option */
export type TemplateFieldOption = {
  __typename?: 'TemplateFieldOption';
  /** Template field option id */
  id: Scalars['ID']['output'];
  /** Template field option label */
  label: Scalars['String']['output'];
  /** Template field option position */
  position: Scalars['Float']['output'];
};

/** Paginated templates */
export type TemplatePaginated = {
  __typename?: 'TemplatePaginated';
  edges: Array<TemplateEdge>;
  nodes: Array<Template>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Template Review */
export type TemplateReview = Template & {
  __typename?: 'TemplateReview';
  /** Template Creation Date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The description of template */
  description?: Maybe<Scalars['String']['output']>;
  /** Template Fields */
  fields?: Maybe<Array<TemplateField>>;
  id: Scalars['ID']['output'];
  minimumReviewsRequired?: Maybe<Scalars['Int']['output']>;
  /** The name of the template review */
  name: Scalars['String']['output'];
  orientationMessage?: Maybe<Scalars['String']['output']>;
  /** The pipe identifier of template */
  pipeId: Scalars['String']['output'];
  requiredCommentToApproveOrReject: Scalars['Boolean']['output'];
  responseType: TemplateReviewResponseTypeEnum;
  /** The type of review */
  reviewType: ReviewTypeEnum;
  /** The reviewers of the template review */
  reviewers: Array<TemplateReviewReviewer>;
  /** Template Type */
  type: Scalars['String']['output'];
  /** Template Update Date */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The type of response for the template review */
export enum TemplateReviewResponseTypeEnum {
  AllResponse = 'all_response',
  SingleResponse = 'single_response'
}

/** Template Review Reviewer */
export type TemplateReviewReviewer = {
  __typename?: 'TemplateReviewReviewer';
  /** The position of the reviewer in the template review */
  position: Scalars['Int']['output'];
  /** The reviewer of the template review */
  user: User;
};

/** Template Task */
export type TemplateTask = Template & {
  __typename?: 'TemplateTask';
  assignees?: Maybe<Array<User>>;
  /** Template Task Assignees User IDs */
  assigneesUserIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Template Creation Date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The description of template */
  description?: Maybe<Scalars['String']['output']>;
  /** Template Fields */
  fields?: Maybe<Array<TemplateField>>;
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  /** The name of the template task */
  name: Scalars['String']['output'];
  /** The pipe identifier of template */
  pipeId: Scalars['String']['output'];
  /** Template Task Priority */
  priority?: Maybe<Scalars['String']['output']>;
  /** Whether a comment is required to finish the task */
  requiredCommentToFinish: Scalars['Boolean']['output'];
  status?: Maybe<TemplateTaskStatusEnum>;
  timeToDueFlags?: Maybe<Scalars['Int']['output']>;
  timeToDueUnit?: Maybe<TemplateTaskTimeToDueUnitEnum>;
  timeToDueValue?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  /** Template Update Date */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum TemplateTaskPriorityEnum {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum TemplateTaskStatusEnum {
  Open = 'open'
}

export enum TemplateTaskTimeToDueUnitEnum {
  Days = 'days',
  Hours = 'hours',
  Months = 'months',
  Weeks = 'weeks'
}

/** Input para transferência de propriedade de um fluxo */
export type TransferPipeOwnershipInput = {
  /** Identificador do novo proprietário (userId ou email) */
  newOwner: UserIdentifiableInput;
  /** ID do fluxo que terá a propriedade transferida */
  pipeId: Scalars['ID']['input'];
};

export type UnopenedCardsSortInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAutomationActionParamsInput = {
  /** Fields to assignees person */
  assignee_person?: InputMaybe<AutomationActionParamAssigneeInput>;
  /** Fields to create card related */
  createCardRelatedParams?: InputMaybe<CreateCardRelatedActionParams>;
  /** Fields create in the task */
  create_task?: InputMaybe<Array<AutomationActionParamCreateTaskInput>>;
  /** The fields to create in the card */
  fields_create_card?: InputMaybe<AutomationActionParamCreateCardInput>;
  /** The fields to update in the card */
  fields_update_card?: InputMaybe<AutomationActionParamCreateCardInput>;
  /** Fields to http request */
  http_request_params?: InputMaybe<AutomationActionParamHttpRequestInput>;
  /** The id of automation action */
  stage_automation_action_id: Scalars['ID']['input'];
  /** The ID of the stage to move or create the card */
  to_stage_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAutomationInput = {
  /** The action to be performed when the event is triggered */
  action?: InputMaybe<StageAutomationActionTypeEnum>;
  /** The actions parameters */
  action_params?: InputMaybe<UpdateAutomationActionParamsInput>;
  /** Automation is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the automation */
  automationId: Scalars['String']['input'];
  /** The description of the automation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The direction of the event */
  direction?: InputMaybe<StageAutomationRunDirectionEnum>;
  /** The event that triggers the automation */
  event?: InputMaybe<StageAutomationTypeEnum>;
  /** Whether the is synchronous */
  isSync?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the automation */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the automation should run only once */
  runOnlyOnce?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the stage to attach the automation */
  stageId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAutomationV2Input = {
  /** Description of the automation */
  description: Scalars['String']['input'];
  /** Name of the automation */
  name: Scalars['String']['input'];
};

export type UpdateAutomationV2StatusInput = {
  /** Status of the automation */
  status: AutomationStatusEnum;
};

/** Card update input */
export type UpdateCardCommentInput = {
  /** Card comment id */
  commentId: Scalars['ID']['input'];
  /** Card comment content */
  content: Scalars['String']['input'];
};

/** Update card description input */
export type UpdateCardDescriptionInput = {
  cardId: Scalars['ID']['input'];
  newDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Update card task input */
export type UpdateCardTaskInputDto = {
  /** Description of the card task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Due date of the card task */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of the card task */
  id: Scalars['ID']['input'];
  /** ID of the parent card task */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Priority of the card task */
  priority?: InputMaybe<CardTaskPriorityEnum>;
  /** Title of the card task */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Update card task parent input */
export type UpdateCardTaskParentInputDto = {
  /** ID of the card task */
  id: Scalars['ID']['input'];
  /** ID of the parent card task, null if removing parent */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Status of the card task */
export enum UpdateCardTaskStatusEnum {
  Completed = 'completed',
  Reopened = 'reopened'
}

/** Update card task status input */
export type UpdateCardTaskStatusInputDto = {
  /** Comment for the status change */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** ID of the card task */
  id: Scalars['String']['input'];
  /** Status of the card task */
  status: UpdateCardTaskStatusEnum;
};

/** Entrada para atualizar um banco de dados */
export type UpdateDatabaseInput = {
  /** Descrição do banco de dados */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID do banco de dados a ser atualizado */
  id: Scalars['ID']['input'];
  /** Nome do banco de dados */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input para atualização de um membro do banco de dados */
export type UpdateDatabaseMemberInput = {
  /** ID do banco de dados ao qual o membro está associado */
  databaseId: Scalars['ID']['input'];
  /** ID do papel que será atribuído ao membro do banco de dados */
  roleId: Scalars['ID']['input'];
  /** ID do usuário que será atualizado */
  userIdentifier: UserIdentifiableInput;
};

/** Entrada para atualizar um campo do esquema do banco de dados */
export type UpdateDatabaseSchemaFieldInput = {
  /** Novos dados do campo */
  data: DatabaseFieldInput;
  /** ID do campo a ser atualizado */
  id: Scalars['ID']['input'];
};

export type UpdateDeadlineInput = {
  considerHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  deadline?: InputMaybe<Scalars['Int']['input']>;
  deadlineDisplayUnit?: InputMaybe<DeadlinesTimeDisplayUnitsEnum>;
  deadlineRisk?: InputMaybe<Scalars['Int']['input']>;
  deadlineRiskDisplayUnit?: InputMaybe<DeadlinesTimeDisplayUnitsEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasOfficeHours?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  officeHours?: InputMaybe<OfficeHours>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeatureFlagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateFieldInput = {
  /** The updated field card id */
  cardId?: InputMaybe<Scalars['ID']['input']>;
  /** The updated field form id */
  formId?: InputMaybe<Scalars['ID']['input']>;
  /** The updated field id */
  id: Scalars['ID']['input'];
  /** The updated field stage id */
  stageId?: InputMaybe<Scalars['ID']['input']>;
  /** The updated field value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Update field reviewer */
export type UpdateFieldReviewerInput = {
  /** The id of the field */
  id: Scalars['String']['input'];
  /** A single value */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Multiple values */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFormTeamAccessInput = {
  /** ID do formulário */
  formId: Scalars['ID']['input'];
  /** IDs dos times com acesso */
  teamIds: Array<Scalars['ID']['input']>;
};

export type UpdateFormTeamAccessResponse = {
  __typename?: 'UpdateFormTeamAccessResponse';
  /** Indica se a operação foi realizada com sucesso */
  success: Scalars['Boolean']['output'];
  /** Quantidade de times que possuem acesso ao formulário */
  teamsCount: Scalars['Int']['output'];
};

export type UpdateFormUserAccessInput = {
  /** ID do formulário */
  formId: Scalars['ID']['input'];
  /** IDs dos usuários com acesso */
  userIds: Array<Scalars['ID']['input']>;
};

export type UpdateFormUserAccessResponse = {
  __typename?: 'UpdateFormUserAccessResponse';
  /** Indica se a operação foi realizada com sucesso */
  success: Scalars['Boolean']['output'];
  /** Quantidade de usuários que possuem acesso ao formulário */
  usersCount: Scalars['Int']['output'];
};

/** Input para atualização do formulário inicial */
export type UpdateInitialFormInput = {
  /** Nome do formulário */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID do pipe */
  pipeId: Scalars['ID']['input'];
  /** Questões do formulário */
  questions?: InputMaybe<Array<FormQuestionInput>>;
  /** Indica se os membros do time podem visualizar solicitações de outros membros do time */
  teamMembersCanViewOthersSolicitations?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<FormTypeEnum>;
};

export type UpdateLabelInput = {
  /** The label color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** The label name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** pipeId */
  pipeId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNotificationInput = {
  isFavorited?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNotificationPipePreferenceDto = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  preference?: InputMaybe<UpdateOrCreateNotificationPreferenceDto>;
  starred: Scalars['Boolean']['input'];
};

export type UpdateNotificationUserPreferenceDto = {
  id: Scalars['ID']['input'];
  preference: UpdateOrCreateNotificationPreferenceDto;
};

export type UpdateOrCreateNotificationPreferenceDto = {
  /** Notification for when a card is approved or rejected */
  cardApprovalStatusChanged: Scalars['Int']['input'];
  /** Notification when a card is archived or unarchived */
  cardArchivedOrUnarchived: Scalars['Int']['input'];
  /** Notification when a card is assigned to me */
  cardAssignedToMe: Scalars['Int']['input'];
  /** Notification when a card is assigned to me */
  cardAssigneeTaskCompletedOrReopened: Scalars['Int']['input'];
  /** Notification when a card is assigned to me */
  cardAssigneeTaskCreated: Scalars['Int']['input'];
  /** Notification when a card is created */
  cardCreated: Scalars['Int']['input'];
  /** Notification when a card is near or past its deadline */
  cardDeadlineNearOrExpired: Scalars['Int']['input'];
  /** Notification when a user is mentioned in a comment */
  cardMentionedInComment: Scalars['Int']['input'];
  /** Notification when a card is moved */
  cardMoved: Scalars['Int']['input'];
  /** Notification when a card requires my approval */
  cardMyApprovalRequired: Scalars['Int']['input'];
  /** Notification for daily summary of my space, must be null for pipe preferences and must be 0 or 2 */
  dailyMySpaceSummary?: InputMaybe<Scalars['Int']['input']>;
  /** Notification when a pipe is added to me, must be null for pipe preferences */
  pipeAddedToMe?: InputMaybe<Scalars['Int']['input']>;
  /** Notification for security alerts, must be null for pipe preferences */
  security?: InputMaybe<Scalars['Int']['input']>;
  /** Notification for solicitation, must be null for pipe preferences */
  solicitation?: InputMaybe<Scalars['Int']['input']>;
};

/** Update password input */
export type UpdatePasswordInput = {
  /** Current password */
  currentPassword: Scalars['String']['input'];
  /** New password */
  newPassword: Scalars['String']['input'];
};

export type UpdatePipeInput = {
  /** Caso verdadeiro, permite enviar comentários quando o card estiver bloqueado */
  allowCommentsWhenCardLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Caso verdadeiro, permite a visibilidade da aba de anexos nos detalhes das solicitações desse fluxo */
  attachmentsTabVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  /** Comportamento de atualização do formulário inicial de cards desse fluxo */
  cardInitialFormUpdateBehavior?: InputMaybe<PipeCardInitialFormUpdateBehavior>;
  /** Comportamento de atualização do formulário de solicitação de cards desse fluxo */
  cardSolicitationFormUpdateBehavior?: InputMaybe<PipeSolicitationFormUpdateBehavior>;
  /** Card task reopen behavior */
  cardTaskReopenBehavior?: InputMaybe<PipesCardTaskReopenBehaviorEnum>;
  /** Card visibility behavior */
  cardVisibilityBehavior?: InputMaybe<PipesCardVisibilityBehaviorEnum>;
  /** Color  */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Description  */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Favorite  */
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Icon  */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Name  */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether only admin can remove cards from this pipe */
  onlyAdminCanRemoveCards?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether only assignees can edit cards from this pipe */
  onlyAssigneesCanEditCards?: InputMaybe<Scalars['Boolean']['input']>;
  /** Wheter only admin or members can show this pipe */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Related card visibility behavior */
  relatedCardVisibilityBehavior?: InputMaybe<PipesCardVisibilityBehaviorEnum>;
  /** Start Form ID */
  startFormId?: InputMaybe<Scalars['String']['input']>;
};

/** Me update profile input */
export type UpdateProfileInput = {
  /** New user avatar url */
  key?: InputMaybe<Scalars['String']['input']>;
  /** New user name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Entrada para atualizar um registro do banco de dados */
export type UpdateRecordInput = {
  /** ID do registro a ser atualizado */
  id: Scalars['ID']['input'];
  /** Dados atualizados do registro em formato JSON */
  row: Scalars['JSONObject']['input'];
  /** Não atualizar o registro se os dados não tiverem sido modificados (com base no hash) */
  skipIfUnchanged?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input para atualização do formulário de etapa */
export type UpdateStageFormInput = {
  /** Questões do formulário */
  questions: Array<FormQuestionInput>;
  /** ID da etapa */
  stageId: Scalars['ID']['input'];
};

export type UpdateStageInput = {
  /** Cards can be moved to this stage */
  canMoveCardTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether the stage can move cards without tasks being done */
  canMoveCardWithoutTasksBeingDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the stage can receive cards directly from draft */
  canReceiveCardDirectlyFromDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the stage can receive cards without tasks being done */
  canReceiveCardWithoutTasksBeingDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stage color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Confirmation to move card */
  confirmMoveCard?: InputMaybe<ConfirmMoveCardEnum>;
  /** Stage description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the stage is done */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answers the form questions */
  fields?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** The current form of the stage */
  formId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  /** Stage order */
  index?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum reviews required */
  minimumReviewsRequired?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the stage will move cards to the next stage automatically */
  moveCardToNextStageWhenDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stage name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Pipe uuid */
  pipeId?: InputMaybe<Scalars['ID']['input']>;
  /** Revision required at this stage */
  reviewRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Review type */
  reviewType?: InputMaybe<ReviewTypeEnum>;
};

/** Dados para atualizar uma equipe */
export type UpdateTeamInput = {
  /** Descrição da equipe */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID da equipe */
  id: Scalars['ID']['input'];
  /** Nome da equipe */
  name: Scalars['String']['input'];
};

/** Input para atualização de template de prazo */
export type UpdateTemplateDeadlineInput = {
  /** Se deve considerar feriados ao calcular o prazo */
  considerHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Valor do prazo na unidade especificada */
  deadline?: InputMaybe<Scalars['Int']['input']>;
  /** Unidade de tempo para exibir o prazo */
  deadlineDisplayUnit?: InputMaybe<TemplateDeadlineTimeDisplayUnitEnum>;
  /** Valor de risco do prazo na unidade especificada */
  deadlineRisk?: InputMaybe<Scalars['Int']['input']>;
  /** Unidade de tempo para exibir o risco do prazo */
  deadlineRiskDisplayUnit?: InputMaybe<TemplateDeadlineTimeDisplayUnitEnum>;
  /** Descrição do template de prazo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Se o prazo possui restrições de horário comercial */
  hasOfficeHours?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID do template de prazo a ser atualizado */
  id: Scalars['ID']['input'];
  /** Nome do template de prazo */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Configuração de horário comercial para o prazo */
  officeHours?: InputMaybe<OfficeHours>;
  /** ID do fluxo na qual esse template será associado */
  pipeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Update Template Review Input */
export type UpdateTemplateReviewInput = {
  /** The description of the template review */
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<FieldInput>>;
  minimumReviewsRequired?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the template review */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The orientation message of the template review */
  orientationMessage?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the template review */
  pipeId?: InputMaybe<Scalars['ID']['input']>;
  requiredCommentToApproveOrReject?: InputMaybe<Scalars['Boolean']['input']>;
  /** The response type of the reviewers in the template review */
  responseType?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the template review */
  reviewers?: InputMaybe<Array<CreateTemplateReviewReviewerInput>>;
  /** The ID of the template review */
  templateId: Scalars['ID']['input'];
  /** The type of the template review */
  type?: InputMaybe<ReviewTypeEnum>;
};

export type UpdateUserLicenseInput = {
  /** Novo tipo de licença do usuário */
  licenseType: UserLicenseType;
  /** ID do usuário que terá o tipo de licença atualizado */
  userId: Scalars['ID']['input'];
};

/** Updated field response */
export type UpdatedFieldResponse = {
  __typename?: 'UpdatedFieldResponse';
  /** The updated field id */
  id: Scalars['String']['output'];
  /** The updated field type */
  type: LegacyFieldTypeEnum;
  /** The updated field value */
  value: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  /** A URL do avatar do usuário */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Data de criação do usuário */
  createdAt: Scalars['DateTime']['output'];
  /** E-mail do usuário */
  email: Scalars['String']['output'];
  /** Data em que o usuário validou o e-mail */
  emailValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID do usuário */
  id: Scalars['ID']['output'];
  /** Data da última vez que o usuário foi visto */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** O tipo de licença do usuário */
  licenseType: UserLicenseType;
  /** Nome do usuário */
  name: Scalars['String']['output'];
  /** O tipo de papel do usuário na conta */
  roleType?: Maybe<RoleTypeEnum>;
  /** Tipo do usuário */
  type: UserType;
  /** Data de atualização do usuário */
  updatedAt: Scalars['DateTime']['output'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Input para uma identificação única de um usuário */
export type UserIdentifiableInput = {
  /** Email do usuário */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID do usuário */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Representa um convite de usuário */
export type UserInvite = {
  __typename?: 'UserInvite';
  /** Quando o convite de usuário foi aceito */
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Data de criação do convite de usuário */
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** E-mail do convite de usuário */
  email: Scalars['String']['output'];
  /** ID do convite de usuário */
  id: Scalars['ID']['output'];
  /** Status do convite de usuário */
  status: UserInviteStatus;
  /** Token do convite de usuário, estará presente apenas ao criar ou reenviar o convite. */
  token?: Maybe<Scalars['String']['output']>;
  /** Data de atualização do convite de usuário */
  updatedAt: Scalars['DateTime']['output'];
};

export type UserInviteEdge = {
  __typename?: 'UserInviteEdge';
  cursor: Scalars['String']['output'];
  node: UserInvite;
};

/** O status do convite de usuário */
export enum UserInviteStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  Pending = 'pending'
}

/** Representa um filtro de convite de usuário */
export type UserInviteWhereInput = {
  /** Data de aceitação (maior ou igual a) */
  acceptedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de aceitação (menor ou igual a) */
  acceptedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de criação (maior ou igual a) */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de criação (menor ou igual a) */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Os IDs dos usuários que criaram o convite */
  createdByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** O email do convite de usuário */
  email?: InputMaybe<Scalars['String']['input']>;
  /** O status do convite de usuário */
  status?: InputMaybe<UserInviteStatus>;
};

/** O tipo de licença do usuário */
export enum UserLicenseType {
  /** Usuário com licença de operador */
  Operator = 'operator',
  /** Usuário sem licença, chamado de solicitante */
  Requester = 'requester'
}

export type UserNotification = {
  __typename?: 'UserNotification';
  count: Scalars['Float']['output'];
  countFavorites?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export type UserOrString = StringValue | User;

export type UserStatisticsForLicense = {
  __typename?: 'UserStatisticsForLicense';
  /** ID do usuário */
  id: Scalars['ID']['output'];
  /** Numero de fluxos onde o papel do usuário e maior que leitor */
  pipesWhereRoleIsAboveReader: Scalars['Int']['output'];
  /** O papel global do usuário */
  userGlobalRole?: Maybe<RoleTypeEnum>;
};

/** O tipo do usuário */
export enum UserType {
  /** Representa um usuário que é um time. */
  Team = 'team',
  /** Representa um usuário normal. */
  User = 'user'
}

/** Filtros para a conta de usuários */
export type UsersAccountFilters = {
  /** Termo de busca para filtrar usuários pelo nome ou email */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Tipos de usuário para filtrar */
  userType?: InputMaybe<Array<UserType>>;
};

/** Lista paginada de usuários da organização */
export type UsersAccountPaginated = {
  __typename?: 'UsersAccountPaginated';
  /** Lista de usuários retornados */
  items: Array<User>;
  /** Informações de paginação */
  pageInfo: PageInfo;
  /** Total de usuários encontrados */
  totalCount: Scalars['Int']['output'];
};

/** Login provider for me */
export enum UsersLoginProviderEnum {
  Bradesco = 'bradesco',
  EmailPassword = 'email_password',
  Google = 'google'
}

/** Filtro para busca de formulários de solicitação */
export type WhereSolicitationFormsInput = {
  name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type UndefinedEdge = {
  __typename?: 'undefinedEdge';
  cursor: Scalars['String']['output'];
  node: CardRelation;
};

export type UsersQueryVariables = Exact<{
  where?: InputMaybe<GetUsersWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<GetUsersSortOrderInput>;
}>;


export type UsersQuery = { __typename?: 'Query', getUsers: { __typename?: 'PaginatedUser', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CardTaskByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CardTaskByIdQuery = { __typename?: 'Query', cardTask: { __typename?: 'CardTask', id: string, card: { __typename?: 'Card', id: string } } };

export type CreatePublicCardTaskFormLinkMutationVariables = Exact<{
  input: CreatePublicCardTaskFormLinkInput;
}>;


export type CreatePublicCardTaskFormLinkMutation = { __typename?: 'Mutation', createPublicCardTaskFormLink: { __typename?: 'CardsTasksSharedLink', publicLink?: string | null } };

export type CardTaskSharedLinkByTaskIdQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type CardTaskSharedLinkByTaskIdQuery = { __typename?: 'Query', cardTaskSharedLinkByTaskId?: { __typename?: 'CardsTasksSharedLink', id: string, publicLink?: string | null, invitedEmails?: Array<string> | null, isEditable: boolean, isRequiredAuthenticated: boolean, expiredAt?: string | null, customMessage?: string | null } | null };

export type GetRolesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RolesWhereInput>;
}>;


export type GetRolesQuery = { __typename?: 'Query', roles: { __typename?: 'PaginatedRole', nodes: Array<{ __typename?: 'Role', id: string, name: string, createdAt: string, description?: string | null, isLocked: boolean, type: RoleTypeEnum, updatedAt: string, pipe?: { __typename?: 'Pipe', id: string, name: string } | null, users: { __typename?: 'RoleUsersConnection', nodes: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }> }, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'Permissions', id: string, title: string, scope: PermissionScope, localizations?: { [key: string]: any } | any[] | null, description: string, createdAt: string }> }, updatedBy?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null, email: string } | null }> } };

export type GetRoleQueryVariables = Exact<{
  roleId: Scalars['String']['input'];
  usersSkip?: InputMaybe<Scalars['Int']['input']>;
  usersTake?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRoleQuery = { __typename?: 'Query', role: { __typename?: 'Role', id: string, name: string, createdAt: string, description?: string | null, isLocked: boolean, type: RoleTypeEnum, updatedAt: string, pipe?: { __typename?: 'Pipe', id: string, name: string } | null, users: { __typename?: 'RoleUsersConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } }, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'Permissions', id: string, title: string, scope: PermissionScope, localizations?: { [key: string]: any } | any[] | null, description: string, createdAt: string }> }, updatedBy?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null, email: string } | null } };

export type GetAssignableUsersForRoleQueryVariables = Exact<{
  roleId: Scalars['String']['input'];
}>;


export type GetAssignableUsersForRoleQuery = { __typename?: 'Query', getAssignableUsersForRole: Array<{ __typename?: 'User', email: string, id: string, name: string, updatedAt: string, createdAt: string, avatarUrl?: string | null }> };

export type GetPermissionsQueryVariables = Exact<{
  where?: InputMaybe<PermissionsWhere>;
  scope?: InputMaybe<PermissionScope>;
}>;


export type GetPermissionsQuery = { __typename?: 'Query', permissions: Array<{ __typename?: 'Permissions', id: string, title: string, description: string, createdAt: string, localizations?: { [key: string]: any } | any[] | null, scope: PermissionScope, children: Array<{ __typename?: 'Permissions', id: string, title: string, description: string, createdAt: string, localizations?: { [key: string]: any } | any[] | null, scope: PermissionScope }> }> };

export type SetBulkUserRoleMutationVariables = Exact<{
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  roleEntityContext?: InputMaybe<RoleEntityContextInput>;
  roleType: RoleTypeEnum;
}>;


export type SetBulkUserRoleMutation = { __typename?: 'Mutation', setBulkUserRole: { __typename?: 'Role', id: string, users: { __typename?: 'RoleUsersConnection', nodes: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null, createdAt: string }> } } };

export type SetRolePermissionsMutationVariables = Exact<{
  permissionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  roleId: Scalars['String']['input'];
}>;


export type SetRolePermissionsMutation = { __typename?: 'Mutation', setRolePermissions: { __typename?: 'Role', id: string, name: string } };

export type RemoveUserRoleMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  roleEntityContext?: InputMaybe<RoleEntityContextInput>;
}>;


export type RemoveUserRoleMutation = { __typename?: 'Mutation', removeUserRole: boolean };

export type FormQuestionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormQuestionsQuery = { __typename?: 'Query', form: { __typename?: 'Form', id: string, name: string, type: string, questionsCount: number, questions: Array<{ __typename?: 'FormQuestion', id: string, type: LegacyFieldTypeEnum, position: number, required: boolean, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, customValidation?: string | null, customValidationMessage?: string | null, options: Array<{ __typename?: 'FormQuestionOption', id: string, description?: string | null, position: number, score?: number | null, value: string }>, database?: { __typename?: 'FormQuestionDatabase', id: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'Database', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null, conditions: Array<{ __typename?: 'FormQuestionCondition', operator: string, value: string, question: { __typename?: 'FormQuestionConditionParentQuestion', id: string, title?: string | null } }> }> } };

type Fields_AttachmentField_Fragment = { __typename: 'AttachmentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_CheckboxesField_Fragment = { __typename: 'CheckboxesField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_CurrencyField_Fragment = { __typename: 'CurrencyField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_DatabaseField_Fragment = { __typename: 'DatabaseField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_DateField_Fragment = { __typename: 'DateField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_DocumentField_Fragment = { __typename: 'DocumentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_DropdownField_Fragment = { __typename: 'DropdownField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_EmailField_Fragment = { __typename: 'EmailField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_HourField_Fragment = { __typename: 'HourField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_MultipleChoiceField_Fragment = { __typename: 'MultipleChoiceField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_NumericField_Fragment = { __typename: 'NumericField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_ParagraphField_Fragment = { __typename: 'ParagraphField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_PhoneField_Fragment = { __typename: 'PhoneField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_ShortAnswerField_Fragment = { __typename: 'ShortAnswerField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

type Fields_SignatureField_Fragment = { __typename: 'SignatureField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null };

export type FieldsFragment = Fields_AttachmentField_Fragment | Fields_CheckboxesField_Fragment | Fields_CurrencyField_Fragment | Fields_DatabaseField_Fragment | Fields_DateField_Fragment | Fields_DocumentField_Fragment | Fields_DropdownField_Fragment | Fields_EmailField_Fragment | Fields_HourField_Fragment | Fields_MultipleChoiceField_Fragment | Fields_NumericField_Fragment | Fields_ParagraphField_Fragment | Fields_PhoneField_Fragment | Fields_ShortAnswerField_Fragment | Fields_SignatureField_Fragment;

export type SharedFieldDatabaseFilterFieldsFragment = { __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string };

export type SharedFieldDatabaseFieldsFragment = { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null };

export type FieldDatabaseSchemaQueryVariables = Exact<{
  fieldId: Scalars['ID']['input'];
  fieldSource: FieldSourceType;
}>;


export type FieldDatabaseSchemaQuery = { __typename?: 'Query', fieldDatabaseSchemaFields: Array<{ __typename?: 'DatabaseSchemaFieldRestricted', name: string, displayName: string }> };

export type FieldDatabaseRecordsQueryVariables = Exact<{
  fieldId: Scalars['ID']['input'];
  fieldSource: FieldSourceType;
  currentAnswers?: InputMaybe<Array<CurrentAnswerInput> | CurrentAnswerInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FieldDatabaseRecordsQuery = { __typename?: 'Query', fieldDatabaseRecords: { __typename?: 'PaginatedDatabaseRecordRestricted', totalCount: number, edges: Array<{ __typename?: 'DatabaseRecordRestrictedEdge', node: { __typename?: 'DatabaseRecordRestricted', data: { [key: string]: any }, id: string, createdAt: string, updatedAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type FormQuestionFieldsFragment = { __typename?: 'FormQuestion', id: string, type: LegacyFieldTypeEnum, position: number, required: boolean, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, customValidation?: string | null, customValidationMessage?: string | null, options: Array<{ __typename?: 'FormQuestionOption', id: string, description?: string | null, position: number, score?: number | null, value: string }>, database?: { __typename?: 'FormQuestionDatabase', id: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'Database', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null, conditions: Array<{ __typename?: 'FormQuestionCondition', operator: string, value: string, question: { __typename?: 'FormQuestionConditionParentQuestion', id: string, title?: string | null } }> };

export type CardOverviewFragment = { __typename?: 'Card', id: string, name: string, archived: boolean, locked: boolean, index?: number | null, age: number, createdAt: string, updatedAt: string, description?: string | null, initialFormResponsible: CardInitialFormResponsible, createdBy: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }, fields: Array<{ __typename: 'AttachmentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CheckboxesField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CurrencyField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DatabaseField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DateField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DocumentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DropdownField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'EmailField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'HourField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'MultipleChoiceField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'NumericField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ParagraphField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'PhoneField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ShortAnswerField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'SignatureField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }>, assignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, currentStage: { __typename?: 'Stage', id: string, name: string, color?: string | null } };

export type CardFieldsOnStageColumnFragment = { __typename?: 'Card', age: number, id: string, name: string, index?: number | null, locked: boolean, pipe: { __typename?: 'Pipe', id: string }, currentStage: { __typename?: 'Stage', id: string, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string }> }, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum, type: ReviewTypeEnum, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', avatarUrl?: string | null, name: string, email: string, id: string } }> } | null, commentCount: { __typename?: 'CardCommentCount', total: number, hasNew: boolean } };

export type CardFieldsOnStageColumnLightFragment = { __typename?: 'Card', age: number, id: string, name: string, index?: number | null, pipe: { __typename?: 'Pipe', id: string }, currentStage: { __typename?: 'Stage', id: string, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string }> } };

export type CardFieldsOnStageColumnHeavyFragment = { __typename?: 'Card', locked: boolean, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum, type: ReviewTypeEnum, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', avatarUrl?: string | null, name: string, email: string, id: string } }> } | null, commentCount: { __typename?: 'CardCommentCount', total: number, hasNew: boolean } };

export type CardFieldsOnTableFragment = { __typename?: 'Card', id: string, name: string, archived: boolean, createdAt: string, updatedAt: string, age: number, arrivedAt: string, duration?: number | null, locked: boolean, currentStage: { __typename?: 'Stage', id: string, name: string, color?: string | null, minimumReviewsRequired?: number | null }, createdBy: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum, type: ReviewTypeEnum, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', avatarUrl?: string | null, name: string, email: string, id: string } }> } | null, fields: Array<{ __typename?: 'AttachmentField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'CheckboxesField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'CurrencyField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DatabaseField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DateField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DocumentField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DropdownField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'EmailField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'HourField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'MultipleChoiceField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'NumericField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'ParagraphField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'PhoneField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'ShortAnswerField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'SignatureField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> }> };

export type CardFieldsOnTableLightFragment = { __typename?: 'Card', id: string, name: string, archived: boolean, createdAt: string, updatedAt: string, age: number, arrivedAt: string, duration?: number | null, currentStage: { __typename?: 'Stage', id: string, name: string, color?: string | null, minimumReviewsRequired?: number | null }, createdBy: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } };

export type CardFieldsOnTableHeavyFragment = { __typename?: 'Card', locked: boolean, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum, type: ReviewTypeEnum, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', avatarUrl?: string | null, name: string, email: string, id: string } }> } | null, fields: Array<{ __typename?: 'AttachmentField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'CheckboxesField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'CurrencyField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DatabaseField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DateField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DocumentField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DropdownField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'EmailField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'HourField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'MultipleChoiceField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'NumericField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'ParagraphField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'PhoneField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'ShortAnswerField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'SignatureField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> }> };

export type MySpaceCardFieldsFragment = { __typename?: 'Card', age: number, id: string, name: string, archived: boolean, createdAt: string, updatedAt: string, initialFormResponsible: CardInitialFormResponsible, arrivedAt: string, leftAt?: string | null, duration?: number | null, createdBy: { __typename?: 'User', id: string, email: string, avatarUrl?: string | null, name: string }, currentStage: { __typename?: 'Stage', id: string, color?: string | null, name: string, done?: boolean | null }, pipe: { __typename?: 'Pipe', id: string, name: string, color?: string | null }, lastAssignees: Array<{ __typename?: 'User', id: string, email: string, name: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', createdAt: string, label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string, cardFinishedAt?: string | null } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, commentCount: { __typename?: 'CardCommentCount', total: number, hasNew: boolean } };

export type DatabaseLogFieldsFragment = { __typename?: 'DatabaseLog', id: string, details?: { [key: string]: any } | null, action: DatabaseLogActionEnum, reason?: string | null, createdAt: string, record?: { __typename?: 'DatabaseRecord', id: string } | null, createdBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } };

export type DatabaseMemberFieldsFragment = { __typename?: 'DatabaseMember', createdAt: string, roleType?: RoleTypeEnum | null, id: string, user: { __typename?: 'User', avatarUrl?: string | null, createdAt: string, email: string, id: string, name: string, updatedAt: string, roleType?: RoleTypeEnum | null } };

export type FieldDatabaseRecordFieldsFragment = { __typename?: 'DatabaseRecordRestricted', data: { [key: string]: any }, id: string, createdAt: string, updatedAt: string };

export type ReviewsFieldsFragment = { __typename?: 'Review', id: string, accountId: string, completedReviewsCount: number, createdAt: string, lastReviewedAt?: string | null, orientationMessage?: string | null, requestedById: string, status: ReviewStatusEnum, updatedAt: string, type: ReviewTypeEnum, card: { __typename?: 'Card', id: string, name: string, archived: boolean, pipe: { __typename?: 'Pipe', id: string, name: string } }, stage: { __typename?: 'Stage', id: string, name: string, color?: string | null, minimumReviewsRequired?: number | null }, requestedBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null }, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, reviewedAt?: string | null, user: { __typename?: 'User', id: string, avatarUrl?: string | null, email: string, name: string } }> };

export type MeQueryVariables = Exact<{
  params?: InputMaybe<MeParamsInput>;
}>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'Me', roleInPipe?: RoleInPipeEnum | null, name: string, email: string, avatarUrl?: string | null, loginProvider?: UsersLoginProviderEnum | null, passwordChangedAt?: string | null, mfa?: { __typename?: 'Mfa', enabled: boolean, createdAt?: string | null, updatedAt?: string | null } | null } };

export type GetPresignedProfileQueryVariables = Exact<{
  input: GetPresignedProfileInput;
}>;


export type GetPresignedProfileQuery = { __typename?: 'Query', getPresignedProfile: { __typename?: 'MePresigned', fields: { [key: string]: any }, url: string } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Me', name: string, avatarUrl?: string | null } };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'Me', passwordChangedAt?: string | null } };

export type RequestMfaSecretMutationVariables = Exact<{
  input: RequestMfaSecretInput;
}>;


export type RequestMfaSecretMutation = { __typename?: 'Mutation', requestMfaSecret: { __typename?: 'RequestMfaSecret', session: string, secret: string } };

export type EnableMfaMutationVariables = Exact<{
  input: EnableMfaInput;
}>;


export type EnableMfaMutation = { __typename?: 'Mutation', enableMfa: { __typename?: 'EnableMfa', success: boolean } };

export type DisableMfaMutationVariables = Exact<{
  input: DisableMfaInput;
}>;


export type DisableMfaMutation = { __typename?: 'Mutation', disableMfa: { __typename?: 'DisableMfa', success: boolean } };

export type PipesQueryQueryVariables = Exact<{
  filters?: InputMaybe<PaginatedPipeFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedPipeSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PipesQueryQuery = { __typename?: 'Query', pipes: { __typename?: 'PaginatedPipe', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'PipeEdge', cursor: string, node: { __typename?: 'Pipe', id: string, icon?: string | null, name: string, color?: string | null, description?: string | null, deletedAt?: string | null, updatedAt: string, cardsCount: number, private: boolean, startForm: { __typename?: 'Form', id: string }, members: Array<{ __typename?: 'PipesMember', id: string, roleType: RoleTypeEnum, user: { __typename?: 'User', avatarUrl?: string | null, email: string, id: string, name: string } }>, stages: Array<{ __typename?: 'Stage', id: string, name: string, index: number, color?: string | null, done?: boolean | null }>, permissions: { __typename?: 'PipePermissions', canDeleteCard: boolean, canDownloadFiles: boolean, canEditAnyCard: boolean, canEditPipe: boolean, canShowAllCards: boolean } } }> } };

export type CreatePipeMutationMutationVariables = Exact<{
  createPipeInput: CreatePipeInput;
}>;


export type CreatePipeMutationMutation = { __typename?: 'Mutation', createPipe: { __typename?: 'Pipe', id: string, name: string, stages: Array<{ __typename?: 'Stage', name: string }> } };

export type UpdatePipeMutationMutationVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  updatePipeInput: UpdatePipeInput;
}>;


export type UpdatePipeMutationMutation = { __typename?: 'Mutation', updatePipe: { __typename?: 'Pipe', id: string } };

export type DeletePipeMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePipeMutationMutation = { __typename?: 'Mutation', deletePipe: boolean };

export type UndeletePipeMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UndeletePipeMutationMutation = { __typename?: 'Mutation', undeletePipe: boolean };

export type GetRecoveryCodesQueryVariables = Exact<{
  input: GetRecoveryCodesInput;
}>;


export type GetRecoveryCodesQuery = { __typename?: 'Query', recoveryCodes: Array<{ __typename?: 'RecoveryCode', code: string, used: boolean, usedAt?: string | null, createdAt: string }> };

export type RecreateRecoveryCodesMutationVariables = Exact<{
  input: RecreateRecoveryCodesInput;
}>;


export type RecreateRecoveryCodesMutation = { __typename?: 'Mutation', recreateRecoveryCodes: Array<{ __typename?: 'RecoveryCode', code: string, used: boolean, usedAt?: string | null, createdAt: string }> };

export type StageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StageQuery = { __typename?: 'Query', stage: { __typename?: 'Stage', canReceiveCardDirectlyFromDraft?: boolean | null, color?: string | null, createdAt?: string | null, deletedAt?: string | null, description?: string | null, done?: boolean | null, id: string, index: number, name: string, confirmMoveCard?: ConfirmMoveCardEnum | null, canMoveCardWithoutTasksBeingDone?: boolean | null, canReceiveCardWithoutTasksBeingDone?: boolean | null, moveCardToNextStageWhenDone?: boolean | null, reviewRequired?: boolean | null, reviewType?: ReviewTypeEnum | null, minimumReviewsRequired?: number | null, updatedAt?: string | null, pipe: { __typename?: 'Pipe', id: string, startForm: { __typename?: 'Form', id: string } }, form?: { __typename?: 'Form', id: string, name: string } | null, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string, name: string }>, deadline?: { __typename?: 'Deadline', id: string, name: string, description?: string | null, archived: boolean, deadlineMinutes: number, deadlineDisplayUnit: string, deadlineRiskMinutes: number, deadlineRiskDisplayUnit: string, considerHoliday: boolean, hasOfficeHours: boolean, officeHours?: { [key: string]: any } | any[] | null, createdAt?: string | null } | null } };

export type MoveCardToStageMutationVariables = Exact<{
  moveCardToStageArgs: MoveCardToStageInput;
}>;


export type MoveCardToStageMutation = { __typename?: 'Mutation', moveCardToStage: { __typename?: 'Card', id: string } };

export type DeleteStageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStageMutation = { __typename?: 'Mutation', deleteStage: boolean };

export type UndeleteStageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UndeleteStageMutation = { __typename?: 'Mutation', undeleteStage: boolean };

export type MoveStageMutationVariables = Exact<{
  direction: StageMoveDirection;
  moveStageId: Scalars['ID']['input'];
}>;


export type MoveStageMutation = { __typename?: 'Mutation', moveStage: { __typename?: 'Stage', id: string } };

export type UpdateStageMutationVariables = Exact<{
  updateStageInput: UpdateStageInput;
}>;


export type UpdateStageMutation = { __typename?: 'Mutation', updateStage: { __typename?: 'Stage', id: string } };

export type CreateStageMutationVariables = Exact<{
  createStageInput: CreateStageInput;
}>;


export type CreateStageMutation = { __typename?: 'Mutation', createStage: { __typename?: 'Stage', canReceiveCardDirectlyFromDraft?: boolean | null, color?: string | null, createdAt?: string | null, description?: string | null, done?: boolean | null, id: string, index: number, name: string, updatedAt?: string | null, pipe: { __typename?: 'Pipe', id: string } } };

export type UserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationsQuery = { __typename?: 'Query', userNotifications?: { __typename?: 'UserNotification', count: number } | null };

export type GetUsersQueryVariables = Exact<{
  where?: InputMaybe<GetUsersWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<GetUsersSortOrderInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: { __typename?: 'PaginatedUser', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, name: string, roleType?: RoleTypeEnum | null, licenseType: UserLicenseType, createdAt: string, updatedAt: string, lastSeenAt?: string | null, emailValidatedAt?: string | null, email: string, avatarUrl?: string | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetUsersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetUsersByIdsQuery = { __typename?: 'Query', getUsersByIds: Array<{ __typename?: 'User', id: string, name: string, roleType?: RoleTypeEnum | null, createdAt: string, updatedAt: string, lastSeenAt?: string | null, emailValidatedAt?: string | null, email: string, avatarUrl?: string | null }> };

export type PublicPreSignedGetQueryVariables = Exact<{
  input: GetPublicPreSignedGetInput;
}>;


export type PublicPreSignedGetQuery = { __typename?: 'Query', publicPresignedGet: { __typename?: 'PublicPresignedGet', viewUrl: string } };

export type CreateBulkActionMutationVariables = Exact<{
  input: CreateBulkActionInput;
}>;


export type CreateBulkActionMutation = { __typename?: 'Mutation', createBulkAction: { __typename?: 'BulkAction', id: string } };

export type GetBulkActionPresignedPostQueryVariables = Exact<{
  input: GetBulkActionPresignedPostInput;
}>;


export type GetBulkActionPresignedPostQuery = { __typename?: 'Query', getBulkActionPresignedPost: { __typename?: 'PresignedPostData', url: string, fields: { [key: string]: any } } };

export type CancelBulkActionMutationVariables = Exact<{
  input: CancelBulkActionInput;
}>;


export type CancelBulkActionMutation = { __typename?: 'Mutation', cancelBulkAction: { __typename?: 'BulkAction', id: string } };

export type DispatchBulkActionMutationVariables = Exact<{
  input: DispatchBulkActionInput;
}>;


export type DispatchBulkActionMutation = { __typename?: 'Mutation', dispatchBulkAction: { __typename?: 'BulkAction', id: string } };

export type GetAllPermissionsQueryVariables = Exact<{
  where?: InputMaybe<PermissionsWhere>;
}>;


export type GetAllPermissionsQuery = { __typename?: 'Query', permissions: Array<{ __typename?: 'Permissions', id: string, title: string }> };

export type GetActiveFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveFeatureFlagsQuery = { __typename?: 'Query', activeFeatureFlags: Array<{ __typename?: 'PublicFeatureFlag', slug: string, description?: string | null, active: boolean, metadata?: { [key: string]: any } | any[] | null }> };

export type GetPipeQueryForRelatedCardQueryVariables = Exact<{
  filters?: InputMaybe<PaginatedPipeFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPipeQueryForRelatedCardQuery = { __typename?: 'Query', pipes: { __typename?: 'PaginatedPipe', totalCount: number, edges: Array<{ __typename?: 'PipeEdge', node: { __typename?: 'Pipe', id: string, name: string, startForm: { __typename?: 'Form', id: string } } }> } };

export type AutomationExecutionsV2QueryVariables = Exact<{
  filters?: InputMaybe<PaginatedAutomationV2ExecutionFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedAutomationV2ExecutionSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AutomationExecutionsV2Query = { __typename?: 'Query', automationExecutionsV2: { __typename?: 'PaginatedAutomationV2Execution', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'AutomationV2ExecutionEdge', node: { __typename?: 'AutomationV2Execution', completedAt?: string | null, context?: { [key: string]: any } | null, resultData?: { [key: string]: any } | null, startedAt: string, id: string, status: AutomationExecutionStatus, triggerData?: { [key: string]: any } | null, triggerType: string, automation: { __typename?: 'AutomationV2', id: string, name: string, pipe?: { __typename?: 'Pipe', id: string, name: string } | null, trigger?: { __typename?: 'AutomationV2Trigger', type: AutomationTriggerType, conditions: { __typename?: 'PaginatedAutomationV2TriggerCondition', nodes: Array<{ __typename?: 'AutomationV2TriggerCondition', id: string, property: string, operator: AutomationTriggerConditionOperators, value?: string | null, values: Array<string>, isInterpolated: boolean }> } } | null }, actions: { __typename?: 'PaginatedAutomationV2ExecutionAction', nodes: Array<{ __typename?: 'AutomationV2ExecutionAction', actionIdInVersion?: string | null, completedAt?: string | null, error?: { [key: string]: any } | null, id: string, inputData?: { [key: string]: any } | null, outputData?: { [key: string]: any } | null, startedAt: string, status: AutomationExecutionActionStatus, triggerIdInVersion?: string | null, typeInVersion: string }> } } }> } };

export type AutomationsActionMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomationsActionMetadataQuery = { __typename?: 'Query', automationV2ActionMetadata: Array<{ __typename?: 'AutomationV2ActionMetadata', label: string, description: string, properties?: { [key: string]: any } | null, type: AutomationActionType }> };

export type AutomationsContextMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomationsContextMetadataQuery = { __typename?: 'Query', automationV2ContextMetadata: Array<{ __typename?: 'AutomationV2ContextMetadata', path: string, type: string, category: string, label: string, description: string }> };

export type AutomationsTriggerMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomationsTriggerMetadataQuery = { __typename?: 'Query', automationV2TriggerMetadata: Array<{ __typename?: 'AutomationV2TriggerMetadata', type: AutomationTriggerType, properties: { [key: string]: any }, label: string, description: string, conditions: Array<{ __typename?: 'AutomationV2TriggerMetadataCondition', type: string, property: string, label: string, description: string, allowedOperators: Array<AutomationTriggerConditionOperators>, autocompleteEntity?: AutomationAutocompleteEntity | null, allowedValues: Array<{ __typename?: 'AutomationTriggerConditionAllowedValue', value: string, label: string, description: string }> }> }> };

export type AutomationV2AutocompleteOptionsQueryVariables = Exact<{
  filters: PaginatedAutomationV2AutocompleteOptionFilters;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AutomationV2AutocompleteOptionsQuery = { __typename?: 'Query', automationV2AutocompleteOptions: { __typename?: 'PaginatedAutomationV2AutocompleteOption', nodes: Array<{ __typename?: 'AutomationV2AutocompleteOption', description?: string | null, label: string, value: string }> } };

export type CreateAutomationV2MutationVariables = Exact<{
  input: CreateAutomationV2Input;
}>;


export type CreateAutomationV2Mutation = { __typename?: 'Mutation', createAutomationV2: { __typename?: 'AutomationV2', id: string, name: string } };

export type UpdateAutomationV2MutationVariables = Exact<{
  updateAutomationV2Id: Scalars['ID']['input'];
  input: UpdateAutomationV2Input;
}>;


export type UpdateAutomationV2Mutation = { __typename?: 'Mutation', updateAutomationV2: { __typename?: 'AutomationV2', id: string } };

export type CreateAutomationV2RoleMutationVariables = Exact<{
  input: CreateAutomationRoleInput;
}>;


export type CreateAutomationV2RoleMutation = { __typename?: 'Mutation', createAutomationV2Role: { __typename?: 'AutomationV2Role', id: string } };

export type BatchUpsertAutomationV2DataMutationVariables = Exact<{
  input: BatchUpsertAutomationV2Input;
}>;


export type BatchUpsertAutomationV2DataMutation = { __typename?: 'Mutation', batchUpsertAutomationV2Data: { __typename?: 'AutomationV2', id: string, description: string, status: AutomationStatusEnum, updatedAt: string, name: string } };

export type AutomationsV2QueryVariables = Exact<{
  filters?: InputMaybe<PaginatedAutomationV2Filters>;
  sorts?: InputMaybe<PaginatedAutomationV2SortOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AutomationsV2Query = { __typename?: 'Query', automationsV2: { __typename?: 'PaginatedAutomationV2', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'AutomationV2Edge', node: { __typename?: 'AutomationV2', name: string, description: string, updatedAt: string, createdAt: string, status: AutomationStatusEnum, id: string, actions: { __typename?: 'PaginatedAutomationV2Action', nodes: Array<{ __typename?: 'AutomationV2Action', type: AutomationActionType }> }, trigger?: { __typename?: 'AutomationV2Trigger', type: AutomationTriggerType, conditions: { __typename?: 'PaginatedAutomationV2TriggerCondition', nodes: Array<{ __typename?: 'AutomationV2TriggerCondition', property: string }> } } | null } }> } };

export type AutomationV2QueryVariables = Exact<{
  automationV2Id: Scalars['ID']['input'];
}>;


export type AutomationV2Query = { __typename?: 'Query', automationV2: { __typename?: 'AutomationV2', id: string, name: string, description: string, trigger?: { __typename?: 'AutomationV2Trigger', id: string, properties?: { [key: string]: any } | null, type: AutomationTriggerType, conditions: { __typename?: 'PaginatedAutomationV2TriggerCondition', nodes: Array<{ __typename?: 'AutomationV2TriggerCondition', values: Array<string>, value?: string | null, property: string, id: string, operator: AutomationTriggerConditionOperators, isInterpolated: boolean }> } } | null, actions: { __typename?: 'PaginatedAutomationV2Action', nodes: Array<{ __typename?: 'AutomationV2Action', type: AutomationActionType, properties?: { [key: string]: any } | null, position: number, id: string }> }, roles: { __typename?: 'PaginatedAutomationV2Role', totalCount: number, nodes: Array<{ __typename?: 'AutomationV2Role', id: string, createdAt: string, pipe?: { __typename?: 'Pipe', id: string, name: string } | null, database?: { __typename?: 'Database', id: string, name: string } | null, role: { __typename?: 'Role', id: string, name: string, type: RoleTypeEnum } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } } };

export type UpdateAutomationV2StatusMutationVariables = Exact<{
  updateAutomationV2StatusId: Scalars['ID']['input'];
  input: UpdateAutomationV2StatusInput;
}>;


export type UpdateAutomationV2StatusMutation = { __typename?: 'Mutation', updateAutomationV2Status: { __typename?: 'AutomationV2', id: string } };

export type GetAndCreateCardTaskSharedFieldsFragment = { __typename?: 'CardTask', id: string, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, title: string, dueAt?: string | null, description?: string | null, requiredCommentToFinish: boolean, completedAt?: string | null, createdAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string }, card: { __typename?: 'Card', readonly: boolean, locked: boolean, isAuthenticatedUserAssignee: boolean, pipe: { __typename?: 'Pipe', cardTaskReopenBehavior: PipesCardTaskReopenBehaviorEnum }, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum } | null }, assignees: Array<{ __typename?: 'CardTaskAssignee', user: { __typename?: 'User', id: string } }>, parentTask?: { __typename?: 'CardTask', id: string, title: string, description?: string | null, status: CardTaskStatusEnum, fields: Array<{ __typename?: 'CardTaskField', createdAt: string, id: string, key: string, name: string, type: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, updatedAt: string, value?: string | null, values: Array<string>, options: Array<{ __typename?: 'CardTaskFieldOption', label: string }>, conditions: Array<{ __typename?: 'CardTaskFieldCondition', operator: FieldConditionOperator, expectedValueString?: string | null, dependsOnField: { __typename?: 'CardTaskField', key: string } }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> } | null, stage?: { __typename?: 'Stage', name: string, color?: string | null } | null };

export type GetCardTaskQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCardTaskQuery = { __typename?: 'Query', cardTask: { __typename?: 'CardTask', id: string, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, title: string, dueAt?: string | null, description?: string | null, requiredCommentToFinish: boolean, completedAt?: string | null, createdAt: string, updatedAt: string, stage?: { __typename?: 'Stage', name: string, color?: string | null } | null, resolutionComment?: { __typename?: 'CardTaskComment', id: string, createdAt: string, comment: string, type: CardTaskCommentTypeEnum, createdBy: { __typename?: 'User', id: string, name: string } } | null, labels: Array<{ __typename?: 'CardTaskLabel', id: string, name: string, color: string }>, createdBy: { __typename?: 'User', id: string, name: string }, card: { __typename?: 'Card', readonly: boolean, locked: boolean, isAuthenticatedUserAssignee: boolean, pipe: { __typename?: 'Pipe', cardTaskReopenBehavior: PipesCardTaskReopenBehaviorEnum }, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum } | null }, assignees: Array<{ __typename?: 'CardTaskAssignee', user: { __typename?: 'User', id: string } }>, parentTask?: { __typename?: 'CardTask', id: string, title: string, description?: string | null, status: CardTaskStatusEnum, fields: Array<{ __typename?: 'CardTaskField', createdAt: string, id: string, key: string, name: string, type: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, updatedAt: string, value?: string | null, values: Array<string>, options: Array<{ __typename?: 'CardTaskFieldOption', label: string }>, conditions: Array<{ __typename?: 'CardTaskFieldCondition', operator: FieldConditionOperator, expectedValueString?: string | null, dependsOnField: { __typename?: 'CardTaskField', key: string } }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> } | null } };

export type CardTaskAssigneesQueryVariables = Exact<{
  cardTaskId: Scalars['ID']['input'];
}>;


export type CardTaskAssigneesQuery = { __typename?: 'Query', cardTaskAssignees: { __typename?: 'PaginatedCardTaskAssignee', totalCount: number, nodes: Array<{ __typename?: 'CardTaskAssignee', createdAt: string, id: string, user: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type CreateCardTaskMutationVariables = Exact<{
  input: CreateCardTaskInputDto;
}>;


export type CreateCardTaskMutation = { __typename?: 'Mutation', createCardTask: { __typename?: 'CardTask', id: string, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, title: string, dueAt?: string | null, description?: string | null, requiredCommentToFinish: boolean, completedAt?: string | null, createdAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string }, card: { __typename?: 'Card', readonly: boolean, locked: boolean, isAuthenticatedUserAssignee: boolean, pipe: { __typename?: 'Pipe', cardTaskReopenBehavior: PipesCardTaskReopenBehaviorEnum }, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum } | null }, assignees: Array<{ __typename?: 'CardTaskAssignee', user: { __typename?: 'User', id: string } }>, parentTask?: { __typename?: 'CardTask', id: string, title: string, description?: string | null, status: CardTaskStatusEnum, fields: Array<{ __typename?: 'CardTaskField', createdAt: string, id: string, key: string, name: string, type: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, updatedAt: string, value?: string | null, values: Array<string>, options: Array<{ __typename?: 'CardTaskFieldOption', label: string }>, conditions: Array<{ __typename?: 'CardTaskFieldCondition', operator: FieldConditionOperator, expectedValueString?: string | null, dependsOnField: { __typename?: 'CardTaskField', key: string } }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> } | null, stage?: { __typename?: 'Stage', name: string, color?: string | null } | null } };

export type UpdateCardTaskStatusMutationVariables = Exact<{
  input: UpdateCardTaskStatusInputDto;
}>;


export type UpdateCardTaskStatusMutation = { __typename?: 'Mutation', updateCardTaskStatus: { __typename?: 'CardTask', id: string, status: CardTaskStatusEnum } };

export type UpdateCardTaskMutationVariables = Exact<{
  input: UpdateCardTaskInputDto;
}>;


export type UpdateCardTaskMutation = { __typename?: 'Mutation', updateCardTask: { __typename?: 'CardTask', id: string, dueAt?: string | null, description?: string | null, priority?: CardTaskPriorityEnum | null, title: string } };

export type DeleteCardTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCardTaskMutation = { __typename?: 'Mutation', deleteCardTask: boolean };

export type AnswerCardTaskFieldMutationVariables = Exact<{
  input: AnswerCardTaskFieldInput;
}>;


export type AnswerCardTaskFieldMutation = { __typename?: 'Mutation', answerCardTaskField: { __typename?: 'CardTaskField', id: string, name: string, value?: string | null, values: Array<string> } };

export type AddCardTaskLabelMutationVariables = Exact<{
  input: AddOrRemoveCardTaskLabelDto;
}>;


export type AddCardTaskLabelMutation = { __typename?: 'Mutation', addCardTaskLabel: { __typename?: 'CardTaskLabel', id: string, name: string, color: string, createdAt: string } };

export type RemoveCardTaskLabelMutationVariables = Exact<{
  input: AddOrRemoveCardTaskLabelDto;
}>;


export type RemoveCardTaskLabelMutation = { __typename?: 'Mutation', removeCardTaskLabel: boolean };

export type AddCardTaskAssigneesMutationVariables = Exact<{
  input: AddCardTaskAssigneesInput;
}>;


export type AddCardTaskAssigneesMutation = { __typename?: 'Mutation', addCardTaskAssignees: Array<{ __typename?: 'CardTaskAssignee', id: string }> };

export type RemoveCardTaskAssigneeMutationVariables = Exact<{
  input: AddCardTaskAssigneeInput;
}>;


export type RemoveCardTaskAssigneeMutation = { __typename?: 'Mutation', removeCardTaskAssignee: { __typename?: 'CardTaskAssignee', id: string } };

export type CreateDatabaseMemberMutationVariables = Exact<{
  input: CreateDatabaseMemberInput;
}>;


export type CreateDatabaseMemberMutation = { __typename?: 'Mutation', createDatabaseMember: { __typename?: 'DatabaseMember', createdAt: string, roleType?: RoleTypeEnum | null, id: string, user: { __typename?: 'User', avatarUrl?: string | null, createdAt: string, email: string, id: string, name: string, updatedAt: string, roleType?: RoleTypeEnum | null } } };

export type UpdateDatabaseMemberMutationVariables = Exact<{
  input: UpdateDatabaseMemberInput;
}>;


export type UpdateDatabaseMemberMutation = { __typename?: 'Mutation', updateDatabaseMember: { __typename?: 'DatabaseMember', createdAt: string, roleType?: RoleTypeEnum | null, id: string, user: { __typename?: 'User', avatarUrl?: string | null, createdAt: string, email: string, id: string, name: string, updatedAt: string, roleType?: RoleTypeEnum | null } } };

export type DeleteDatabaseMemberMutationVariables = Exact<{
  input: DeleteDatabaseMemberInput;
}>;


export type DeleteDatabaseMemberMutation = { __typename?: 'Mutation', deleteDatabaseMember: boolean };

export type DatabaseMembersQueryVariables = Exact<{
  filters: PaginatedDatabaseMemberFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DatabaseMembersQuery = { __typename?: 'Query', databaseMembers: { __typename?: 'PaginatedDatabaseMember', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes: Array<{ __typename?: 'DatabaseMember', createdAt: string, roleType?: RoleTypeEnum | null, id: string, user: { __typename?: 'User', avatarUrl?: string | null, createdAt: string, email: string, id: string, name: string, updatedAt: string, roleType?: RoleTypeEnum | null } }> } };

export type DatabaseLogsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedDatabaseLogSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  filters: PaginatedDatabaseLogFilters;
}>;


export type DatabaseLogsQuery = { __typename?: 'Query', databaseLogs: { __typename?: 'PaginatedDatabaseLog', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'DatabaseLog', id: string, details?: { [key: string]: any } | null, action: DatabaseLogActionEnum, reason?: string | null, createdAt: string, record?: { __typename?: 'DatabaseRecord', id: string } | null, createdBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }> } };

export type CreateDatabaseRecordMutationVariables = Exact<{
  input: CreateRecordInput;
}>;


export type CreateDatabaseRecordMutation = { __typename?: 'Mutation', createDatabaseRecord: { __typename?: 'DatabaseRecord', data: { [key: string]: any }, id: string, createdAt: string, updatedAt: string } };

export type DatabaseRecordsQueryVariables = Exact<{
  filters: PaginatedDatabaseRecordFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedDatabaseRecordSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DatabaseRecordsQuery = { __typename?: 'Query', databaseRecords: { __typename?: 'PaginatedDatabaseRecord', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DatabaseRecordEdge', node: { __typename?: 'DatabaseRecord', data: { [key: string]: any }, id: string, createdAt: string, updatedAt: string } }> } };

export type DatabaseRecordQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DatabaseRecordQuery = { __typename?: 'Query', databaseRecord: { __typename?: 'DatabaseRecord', data: { [key: string]: any }, id: string, createdAt: string, updatedAt: string } };

export type UpdateDatabaseRecordMutationVariables = Exact<{
  input: UpdateRecordInput;
}>;


export type UpdateDatabaseRecordMutation = { __typename?: 'Mutation', updateDatabaseRecord: { __typename?: 'DatabaseRecord', data: { [key: string]: any }, id: string, createdAt: string, updatedAt: string } };

export type DeleteDatabaseRecordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDatabaseRecordMutation = { __typename?: 'Mutation', deleteDatabaseRecord: boolean };

export type DatabaseSchemaQueryVariables = Exact<{
  databaseId: Scalars['ID']['input'];
}>;


export type DatabaseSchemaQuery = { __typename?: 'Query', databaseSchema: { __typename?: 'DatabaseSchema', id: string, fields: Array<{ __typename?: 'DatabaseSchemaField', id: string, name: string, displayName: string, position: number, primaryKey?: boolean | null, required: boolean, type: DatabaseFieldTypeEnum, unique?: boolean | null, description?: string | null }> } };

export type RemoveDatabaseSchemaFieldMutationVariables = Exact<{
  input: RemoveDatabaseSchemaFieldInput;
}>;


export type RemoveDatabaseSchemaFieldMutation = { __typename?: 'Mutation', removeDatabaseSchemaField: { __typename?: 'DatabaseSchemaField', id: string } };

export type AddDatabaseSchemaFieldMutationVariables = Exact<{
  input: AddDatabaseSchemaFieldInput;
}>;


export type AddDatabaseSchemaFieldMutation = { __typename?: 'Mutation', addDatabaseSchemaField: { __typename?: 'DatabaseSchemaField', id: string } };

export type UpdateDatabaseSchemaFieldMutationVariables = Exact<{
  input: UpdateDatabaseSchemaFieldInput;
}>;


export type UpdateDatabaseSchemaFieldMutation = { __typename?: 'Mutation', updateDatabaseSchemaField: { __typename?: 'DatabaseSchemaField', id: string, name: string, position: number, primaryKey?: boolean | null, required: boolean, type: DatabaseFieldTypeEnum, unique?: boolean | null, displayName: string, description?: string | null } };

export type ReorderDatabaseSchemaFieldsMutationVariables = Exact<{
  input: ReorderDatabaseSchemaFieldsInput;
}>;


export type ReorderDatabaseSchemaFieldsMutation = { __typename?: 'Mutation', reorderDatabaseSchemaFields: Array<{ __typename?: 'DatabaseSchemaField', id: string, name: string, displayName: string, position: number }> };

export type CreateDatabaseMutationVariables = Exact<{
  input: CreateDatabaseInput;
}>;


export type CreateDatabaseMutation = { __typename?: 'Mutation', createDatabase: { __typename?: 'Database', id: string, name: string } };

export type DatabasesQueryVariables = Exact<{
  filters?: InputMaybe<PaginatedDatabasesFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedDatabasesSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DatabasesQuery = { __typename?: 'Query', databases: { __typename?: 'PaginatedDatabase', totalCount: number, edges: Array<{ __typename?: 'DatabaseEdge', node: { __typename?: 'Database', description?: string | null, id: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } } };

export type DatabaseQueryVariables = Exact<{
  databaseId: Scalars['ID']['input'];
}>;


export type DatabaseQuery = { __typename?: 'Query', database: { __typename?: 'Database', id: string, name: string, description?: string | null } };

export type UpdateDatabaseMutationVariables = Exact<{
  input: UpdateDatabaseInput;
}>;


export type UpdateDatabaseMutation = { __typename?: 'Mutation', updateDatabase: { __typename?: 'Database', id: string, name: string, description?: string | null } };

export type ExportDatabasesMutationVariables = Exact<{
  input: ExportDatabaseInput;
}>;


export type ExportDatabasesMutation = { __typename?: 'Mutation', exportDatabases: boolean };

export type SolicitationDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SolicitationDetailQuery = { __typename?: 'Query', solicitationDetail: { __typename?: 'CardSolicitation', id: string, name: string, initialFormResponsible: CardInitialFormResponsible, canAnswerInitialForm: boolean, locked: boolean, createdAt: string, readonly: boolean, pipe: { __typename?: 'CardSolicitationPipe', id: string, name: string, attachmentsTabVisibility: boolean, allowCommentsWhenCardLocked: boolean, startForm?: { __typename?: 'Form', id: string, name: string, type: string } | null }, currentStage: { __typename?: 'CardSolicitationStage', id: string, name: string, color?: string | null, description?: string | null, done: boolean }, fields: Array<{ __typename: 'AttachmentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CheckboxesField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CurrencyField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DatabaseField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DateField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DocumentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DropdownField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'EmailField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'HourField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'MultipleChoiceField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'NumericField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ParagraphField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'PhoneField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ShortAnswerField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'SignatureField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }>, createdBy: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }, pipeDeadline?: { __typename?: 'CardSolicitationDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string, cardFinishedAt?: string | null } | null, logs: { __typename?: 'CardLogsPaginated', edges: Array<{ __typename?: 'CardLogsEdge', node: { __typename?: 'CardLogs', id: string, actorName?: string | null, newValue?: { [key: string]: any } | any[] | null, oldValue?: { [key: string]: any } | any[] | null, details?: { [key: string]: any } | null, createdAt: string, action: CardsLogEventTypeEnum, actor?: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } }, lastReview?: { __typename?: 'Review', lastReviewedAt?: string | null, status: ReviewStatusEnum, type: ReviewTypeEnum, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }> } | null, assignees: Array<{ __typename?: 'User', id: string, email: string, name: string, avatarUrl?: string | null }>, commentCount?: { __typename?: 'CardCommentCount', total: number, hasNew: boolean } | null } };

export type GetMoreSolicitationLogsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMoreSolicitationLogsQuery = { __typename?: 'Query', solicitationDetail: { __typename?: 'CardSolicitation', id: string, logs: { __typename?: 'CardLogsPaginated', edges: Array<{ __typename?: 'CardLogsEdge', node: { __typename?: 'CardLogs', id: string, actorName?: string | null, newValue?: { [key: string]: any } | any[] | null, oldValue?: { [key: string]: any } | any[] | null, details?: { [key: string]: any } | null, createdAt: string, action: CardsLogEventTypeEnum, actor?: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type ReturnCardToAssigneeMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type ReturnCardToAssigneeMutation = { __typename?: 'Mutation', returnCardToAssignee: boolean };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string, description?: string | null, slug: string } };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string, name: string, description?: string | null } };

export type RemoveTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveTeamMutation = { __typename?: 'Mutation', removeTeam: boolean };

export type CreateTeamMemberMutationVariables = Exact<{
  input: CreateTeamMemberInput;
}>;


export type CreateTeamMemberMutation = { __typename?: 'Mutation', createTeamMember: { __typename?: 'TeamMember', id: string, role: TeamMemberRole, user?: { __typename?: 'User', id: string, name: string, email: string } | null } };

export type RemoveTeamMemberMutationVariables = Exact<{
  input: RemoveTeamMemberInput;
}>;


export type RemoveTeamMemberMutation = { __typename?: 'Mutation', removeTeamMember: boolean };

export type GetTeamsQueryVariables = Exact<{
  filters?: InputMaybe<PaginatedTeamFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedTeamSortOrderInput>;
}>;


export type GetTeamsQuery = { __typename?: 'Query', teams: { __typename?: 'PaginatedTeam', totalCount: number, nodes: Array<{ __typename?: 'Team', id: string, name: string, description?: string | null, slug: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', email: string }, members: { __typename?: 'PaginatedTeamMember', totalCount: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetTeamQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string, description?: string | null, slug: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', email: string }, members: { __typename?: 'PaginatedTeamMember', totalCount: number, nodes: Array<{ __typename?: 'TeamMember', id: string, role: TeamMemberRole, createdAt: string, user?: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } | null }> } } };

export type GetTeamMembersQueryVariables = Exact<{
  filters: PaginatedTeamMemberFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedTeamMemberSortOrderInput>;
}>;


export type GetTeamMembersQuery = { __typename?: 'Query', teamMembers: { __typename?: 'PaginatedTeamMember', totalCount: number, nodes: Array<{ __typename?: 'TeamMember', id: string, role: TeamMemberRole, createdAt: string, user?: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type GetCardDetailQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type GetCardDetailQuery = { __typename?: 'Query', card: { __typename?: 'Card', age: number, archived: boolean, createdAt: string, updatedAt: string, description?: string | null, id: string, name: string, readonly: boolean, locked: boolean, isForceLocked: boolean, canAnswerInitialForm: boolean, initialFormResponsible: CardInitialFormResponsible, isSolicitation: boolean, pipe: { __typename?: 'Pipe', id: string, name: string, cardSolicitationFormUpdateBehavior: PipeSolicitationFormUpdateBehavior, allowCommentsWhenCardLocked: boolean }, createdBy: { __typename?: 'User', id: string, name: string, email: string }, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }>, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, currentStage: { __typename?: 'Stage', id: string, name: string, index: number, color?: string | null, reviewRequired?: boolean | null, reviewType?: ReviewTypeEnum | null, minimumReviewsRequired?: number | null, form?: { __typename?: 'Form', id: string } | null }, pipeDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, taskCount: { __typename?: 'CardTaskCount', pending: number }, commentCount: { __typename?: 'CardCommentCount', total: number, hasNew: boolean }, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum } | null } };

export type GetStartFormFieldsQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type GetStartFormFieldsQuery = { __typename?: 'Query', card: { __typename?: 'Card', fields: Array<{ __typename: 'AttachmentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CheckboxesField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CurrencyField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DatabaseField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DateField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DocumentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DropdownField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'EmailField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'HourField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'MultipleChoiceField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'NumericField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ParagraphField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'PhoneField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ShortAnswerField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'SignatureField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> } };

export type GetCurrentStageFieldsQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type GetCurrentStageFieldsQuery = { __typename?: 'Query', currentStageFields: { __typename?: 'FieldTypesConnection', nodes: Array<{ __typename: 'AttachmentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CheckboxesField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CurrencyField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DatabaseField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DateField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DocumentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DropdownField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'EmailField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'HourField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'MultipleChoiceField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'NumericField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ParagraphField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'PhoneField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ShortAnswerField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'SignatureField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> } };

export type GetPreSignedQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type GetPreSignedQuery = { __typename?: 'Query', getPreSigned: string };

export type GetCardHistoryInStageQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
}>;


export type GetCardHistoryInStageQuery = { __typename?: 'Query', cardHistoryInStage: { __typename?: 'CardHistoryInStage', fields: Array<{ __typename: 'AttachmentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CheckboxesField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CurrencyField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DatabaseField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DateField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DocumentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DropdownField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'EmailField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'HourField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'MultipleChoiceField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'NumericField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ParagraphField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'PhoneField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ShortAnswerField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'SignatureField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> } };

export type UpdateFieldMutationVariables = Exact<{
  input: UpdateFieldInput;
}>;


export type UpdateFieldMutation = { __typename?: 'Mutation', updateField: { __typename?: 'UpdatedFieldResponse', id: string } };

export type ChangeCardNameMutationVariables = Exact<{
  input: ChangeCardNameInput;
}>;


export type ChangeCardNameMutation = { __typename?: 'Mutation', changeCardName: { __typename?: 'Card', id: string } };

export type UpdateCardDescriptionMutationVariables = Exact<{
  input: UpdateCardDescriptionInput;
}>;


export type UpdateCardDescriptionMutation = { __typename?: 'Mutation', updateCardDescription: { __typename?: 'Card', id: string } };

export type UnarchiveCardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveCardMutation = { __typename?: 'Mutation', unarchiveCard: { __typename?: 'Card', id: string } };

export type ArchiveCardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveCardMutation = { __typename?: 'Mutation', archiveCard: { __typename?: 'Card', id: string } };

export type AddLabelCardMutationVariables = Exact<{
  input: CreateCardLabelInput;
}>;


export type AddLabelCardMutation = { __typename?: 'Mutation', createCardLabel: { __typename?: 'CardLabel', label: { __typename?: 'Label', id: string } } };

export type RemoveLabelCardMutationVariables = Exact<{
  input: RemoveCardLabelInput;
}>;


export type RemoveLabelCardMutation = { __typename?: 'Mutation', removeCardLabel: boolean };

export type LockCardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LockCardMutation = { __typename?: 'Mutation', lockCard: { __typename?: 'Card', id: string } };

export type UnlockCardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnlockCardMutation = { __typename?: 'Mutation', unlockCard: { __typename?: 'Card', id: string } };

export type ReturnCardToSolicitorMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type ReturnCardToSolicitorMutation = { __typename?: 'Mutation', returnCardToSolicitor: boolean };

export type CancelCardToSolicitorMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type CancelCardToSolicitorMutation = { __typename?: 'Mutation', cancelCardToSolicitor: boolean };

export type MarkCardCommentsAsReadMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type MarkCardCommentsAsReadMutation = { __typename?: 'Mutation', markCardCommentsAsRead: boolean };

export type GetPreSignedPostQueryVariables = Exact<{
  input: CreatePreSignedPostInput;
}>;


export type GetPreSignedPostQuery = { __typename?: 'Query', getPreSignedPost: { __typename?: 'PresignedPostData', fields: { [key: string]: any }, url: string } };

export type CreateCardAttachmentMutationVariables = Exact<{
  input: CreateCardAttachmentInput;
}>;


export type CreateCardAttachmentMutation = { __typename?: 'Mutation', createCardAttachment: { __typename?: 'CardAttachment', id: string, extension: string, name: string, path: string, preSignedUrl?: string | null, size: number, type: string } };

export type GetCardAttachmentsQueryVariables = Exact<{
  filters: PaginatedCardAttachmentFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardAttachmentSortOrderInput>;
}>;


export type GetCardAttachmentsQuery = { __typename?: 'Query', cardsAttachments: { __typename?: 'PaginatedCardAttachment', totalCount: number, nodes: Array<{ __typename?: 'CardAttachment', createdAt: string, extension: string, id: string, name: string, path: string, preSignedUrl?: string | null, entityType?: string | null, stage?: { __typename?: 'CardAttachmentSource', id: string, name: string } | null, task?: { __typename?: 'CardAttachmentSource', id: string, name: string } | null, reviewer?: { __typename?: 'CardAttachmentSource', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type DeleteCardAttachmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCardAttachmentMutation = { __typename?: 'Mutation', deleteCardAttachment: { __typename?: 'CardAttachment', id: string } };

export type GetSolicitationAttachmentsQueryVariables = Exact<{
  filters: PaginatedCardAttachmentFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardAttachmentSortOrderInput>;
}>;


export type GetSolicitationAttachmentsQuery = { __typename?: 'Query', solicitationAttachments: { __typename?: 'PaginatedCardAttachment', totalCount: number, nodes: Array<{ __typename?: 'CardAttachment', createdAt: string, extension: string, id: string, name: string, path: string, preSignedUrl?: string | null, entityType?: string | null, stage?: { __typename?: 'CardAttachmentSource', id: string, name: string } | null, task?: { __typename?: 'CardAttachmentSource', id: string, name: string } | null, reviewer?: { __typename?: 'CardAttachmentSource', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ExportCardAttachmentsMutationMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type ExportCardAttachmentsMutationMutation = { __typename?: 'Mutation', exportCardAttachments: boolean };

export type SearchAssigneesQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchAssigneesQuery = { __typename?: 'Query', pipesMembers: { __typename?: 'PaginatedPipesMember', nodes: Array<{ __typename?: 'PipesMember', id: string, user: { __typename?: 'User', avatarUrl?: string | null, email: string, id: string, name: string } }> } };

export type AddCardAssigneeMutationVariables = Exact<{
  input: CreateCardAssigneeInput;
}>;


export type AddCardAssigneeMutation = { __typename?: 'Mutation', createCardAssignee: { __typename?: 'CardAssignee', id: string } };

export type CardsAssigneesQueryVariables = Exact<{
  filters: PaginatedCardAssigneeFilters;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CardsAssigneesQuery = { __typename?: 'Query', cardsAssignees: { __typename?: 'PaginatedCardAssignee', nodes: Array<{ __typename?: 'CardAssignee', user: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } }> } };

export type RemoveCardAssigneeMutationVariables = Exact<{
  input: RemoveCardAssigneeInput;
}>;


export type RemoveCardAssigneeMutation = { __typename?: 'Mutation', removeCardAssignee: boolean };

export type GetCardHistoryQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type GetCardHistoryQuery = { __typename?: 'Query', cardHistory: { __typename?: 'CardHistory', stage: { __typename?: 'CardHistoryStageConnection', nodes: Array<{ __typename?: 'CardHistoryStage', cardArrivedAt?: string | null, cardId?: string | null, color?: string | null, index?: number | null, duration?: number | null, hasFields?: boolean | null, id: string, isCurrentPhase?: boolean | null, name?: string | null, stageId?: string | null }> } } };

export type CardStageTasksQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
  cardStageEntryId: Scalars['ID']['input'];
  hasFormSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CardStageTasksQuery = { __typename?: 'Query', cardStageTasks: { __typename?: 'PaginatedCardStageTask', nodes: Array<{ __typename?: 'CardTask', id: string, dueAt?: string | null, completedAt?: string | null, description?: string | null, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, formSubmittedAt?: string | null, title: string, createdAt: string, formSubmittedBy?: { __typename?: 'User', name: string } | null, createdBy: { __typename?: 'User', name: string } }> } };

export type CreateLabelMutationVariables = Exact<{
  createLabelInput: CreateLabelInput;
}>;


export type CreateLabelMutation = { __typename?: 'Mutation', createLabel: { __typename?: 'Label', updatedAt?: string | null, name: string, id: string, createdAt: string, color: string } };

export type UpdateLabelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateLabelInput;
}>;


export type UpdateLabelMutation = { __typename?: 'Mutation', updateLabel: { __typename?: 'Label', color: string, createdAt: string, id: string, name: string, updatedAt?: string | null } };

export type DeleteLabelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLabelMutation = { __typename?: 'Mutation', deleteLabel: boolean };

export type GetLabelsQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLabelsQuery = { __typename?: 'Query', getLabels: Array<{ __typename?: 'Label', updatedAt?: string | null, name: string, id: string, createdAt: string, color: string }> };

export type UsersAccountQueryVariables = Exact<{
  filters?: InputMaybe<UsersAccountFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UsersAccountQuery = { __typename?: 'Query', usersAccount: { __typename?: 'UsersAccountPaginated', totalCount: number, items: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type RequestReviewMutationVariables = Exact<{
  input: RequestReviewInput;
}>;


export type RequestReviewMutation = { __typename?: 'Mutation', requestReview: { __typename?: 'Review', id: string, status: ReviewStatusEnum, reviewers: Array<{ __typename?: 'Reviewer', position?: number | null, status: ReviewerStatusEnum, comment?: string | null, user: { __typename?: 'User', name: string, avatarUrl?: string | null } }> } };

export type CancelReviewMutationVariables = Exact<{
  input: CancelReviewInput;
}>;


export type CancelReviewMutation = { __typename?: 'Mutation', cancelReview: { __typename?: 'Review', id: string, status: ReviewStatusEnum } };

export type ChangeReviewersMutationVariables = Exact<{
  input: ChangeReviewersInput;
}>;


export type ChangeReviewersMutation = { __typename?: 'Mutation', changeReviewers: { __typename?: 'Review', id: string, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } }> } };

export type ReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReviewQuery = { __typename?: 'Query', review: { __typename?: 'Review', id: string, createdAt: string, orientationMessage?: string | null, type: ReviewTypeEnum, status: ReviewStatusEnum, completedReviewsCount: number, requiredCommentToApproveOrReject: boolean, canCancel: boolean, canApprove: boolean, canReject: boolean, canRequestReview: boolean, metadata?: { [key: string]: any } | any[] | null, stage: { __typename?: 'Stage', name: string, color?: string | null, minimumReviewsRequired?: number | null, pipe: { __typename?: 'Pipe', id: string } }, requestedBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null }, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, position?: number | null, comment?: string | null, reviewedAt?: string | null, fields: Array<{ __typename?: 'ReviewerField', createdAt: string, id: string, key: string, name: string, type: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, updatedAt: string, value?: string | null, values: Array<string>, options: Array<{ __typename?: 'ReviewerFieldOption', label: string }>, conditions: Array<{ __typename?: 'ReviewerFieldCondition', dependencyType: FieldConditionDependencyType, operator: FieldConditionOperator, expectedValueString?: string | null, expectedValueArray?: Array<string> | null, dependsOnField?: { __typename?: 'ReviewerField', key: string } | null }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }>, user: { __typename?: 'User', id: string, avatarUrl?: string | null, name: string, email: string } }>, card: { __typename?: 'Card', readonly: boolean, id: string, name: string, archived: boolean, locked: boolean, index?: number | null, age: number, createdAt: string, updatedAt: string, description?: string | null, initialFormResponsible: CardInitialFormResponsible, pipe: { __typename?: 'Pipe', id: string }, createdBy: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }, fields: Array<{ __typename: 'AttachmentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CheckboxesField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CurrencyField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DatabaseField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DateField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DocumentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DropdownField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'EmailField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'HourField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'MultipleChoiceField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'NumericField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ParagraphField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'PhoneField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ShortAnswerField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'SignatureField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }>, assignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, currentStage: { __typename?: 'Stage', id: string, name: string, color?: string | null } } } };

export type RejectReviewMutationVariables = Exact<{
  input: RejectReviewInput;
}>;


export type RejectReviewMutation = { __typename?: 'Mutation', rejectReview: { __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum } };

export type ApproveReviewMutationVariables = Exact<{
  input: ApproveReviewInput;
}>;


export type ApproveReviewMutation = { __typename?: 'Mutation', approveReview: { __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum } };

export type RequestChangeReviewMutationVariables = Exact<{
  input: RequestChangeReviewInput;
}>;


export type RequestChangeReviewMutation = { __typename?: 'Mutation', requestChangeReview: { __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum } };

export type UpdateFieldReviewerMutationVariables = Exact<{
  input: UpdateFieldReviewerInput;
}>;


export type UpdateFieldReviewerMutation = { __typename?: 'Mutation', updateFieldReviewer: { __typename?: 'ReviewerField', id: string } };

export type ResendReviewRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResendReviewRequestMutation = { __typename?: 'Mutation', resendReviewRequest: { __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, reviewedAt?: string | null } };

export type CardReviewRequestsQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type CardReviewRequestsQuery = { __typename?: 'Query', cardReview: { __typename?: 'CardReview', id: string, currentStage: { __typename?: 'Stage', name: string }, reviewRequests?: Array<{ __typename?: 'Review', id: string, type: ReviewTypeEnum, status: ReviewStatusEnum, lastReviewedAt?: string | null, createdAt: string, stage: { __typename?: 'Stage', name: string }, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', name: string, avatarUrl?: string | null } }> } | null> | null } };

export type CardReviewQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type CardReviewQuery = { __typename?: 'Query', cardReview: { __typename?: 'CardReview', id: string, canRequestReview: boolean, reviewRequests?: Array<{ __typename?: 'Review', id: string } | null> | null, currentStage: { __typename?: 'Stage', reviewRequired?: boolean | null, minimumReviewsRequired?: number | null }, lastReview?: { __typename?: 'Review', id: string, type: ReviewTypeEnum, status: ReviewStatusEnum, lastReviewedAt?: string | null, canCancel: boolean, canApprove: boolean, canReject: boolean, stage: { __typename?: 'Stage', id: string }, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', name: string, avatarUrl?: string | null, email: string, id: string } }> } | null } };

export type CreatePublicCardStageFormLinkMutationVariables = Exact<{
  input: CreatePublicCardStageFormLinkInput;
}>;


export type CreatePublicCardStageFormLinkMutation = { __typename?: 'Mutation', createPublicCardStageFormLink: { __typename?: 'CardsSharedLink', publicLink?: string | null } };

export type CardStageSharedLinkByCardIdQueryVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type CardStageSharedLinkByCardIdQuery = { __typename?: 'Query', cardStageSharedLinkByCardId?: { __typename?: 'CardsSharedLink', id: string, publicLink?: string | null, invitedEmails?: Array<string> | null, isEditable: boolean, isRequiredAuthenticated: boolean, expiredAt?: string | null, customMessage?: string | null } | null };

export type CardLogsQueryVariables = Exact<{
  params: CardLogsPaginateInput;
}>;


export type CardLogsQuery = { __typename?: 'Query', cardLogs: { __typename?: 'CardLogsPaginated', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CardLogsEdge', node: { __typename?: 'CardLogs', id: string, actorName?: string | null, newValue?: { [key: string]: any } | any[] | null, oldValue?: { [key: string]: any } | any[] | null, details?: { [key: string]: any } | null, reason?: string | null, createdAt: string, action: CardsLogEventTypeEnum, actor?: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } | null } }> } };

type CardRelationBaseFields_CardRelationComplete_Fragment = { __typename: 'CardRelationComplete', id: string, name: string, parentCard?: { __typename: 'CardRelationComplete', id: string } | { __typename: 'CardRelationRestricted', id: string } | null, childrenCards: { __typename?: 'PaginatedCardRelation', nodes: Array<{ __typename: 'CardRelationComplete', id: string } | { __typename: 'CardRelationRestricted', id: string }> } };

type CardRelationBaseFields_CardRelationRestricted_Fragment = { __typename: 'CardRelationRestricted', id: string, name: string, parentCard?: { __typename: 'CardRelationComplete', id: string } | { __typename: 'CardRelationRestricted', id: string } | null, childrenCards: { __typename?: 'PaginatedCardRelation', nodes: Array<{ __typename: 'CardRelationComplete', id: string } | { __typename: 'CardRelationRestricted', id: string }> } };

export type CardRelationBaseFieldsFragment = CardRelationBaseFields_CardRelationComplete_Fragment | CardRelationBaseFields_CardRelationRestricted_Fragment;

export type CardRelationQueryVariables = Exact<{
  cardId: Scalars['String']['input'];
  filters: PaginatedCardRelationFilters;
  labelsFilters: PaginatedCardLabelFilters;
  assigneesFilters: PaginatedCardAssigneeFilters;
  take: Scalars['Int']['input'];
}>;


export type CardRelationQuery = { __typename?: 'Query', cardRelation: { __typename: 'CardRelationComplete', id: string, name: string, pipe: { __typename?: 'Stage', id: string, name: string }, pipeDeadline?: { __typename?: 'RealDeadline', deadlineRiskAt?: string | null, deadlineAt?: string | null } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineRiskAt?: string | null, deadlineAt?: string | null } | null, currentStage: { __typename?: 'Stage', id: string, name: string, color?: string | null }, labels: { __typename?: 'PaginatedCardLabel', nodes: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }> }, assignees: { __typename?: 'PaginatedCardAssignee', totalCount: number, nodes: Array<{ __typename?: 'CardAssignee', id: string, user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }> }, parentCard?: { __typename: 'CardRelationComplete', id: string } | { __typename: 'CardRelationRestricted', id: string } | null, childrenCards: { __typename?: 'PaginatedCardRelation', nodes: Array<{ __typename: 'CardRelationComplete', id: string } | { __typename: 'CardRelationRestricted', id: string }> } } | { __typename: 'CardRelationRestricted', id: string, name: string, parentCard?: { __typename: 'CardRelationComplete', id: string } | { __typename: 'CardRelationRestricted', id: string } | null, childrenCards: { __typename?: 'PaginatedCardRelation', nodes: Array<{ __typename: 'CardRelationComplete', id: string } | { __typename: 'CardRelationRestricted', id: string }> } } };

export type GetCardsTasksQueryVariables = Exact<{
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
  where: CardTaskWhereInputDto;
  sort?: InputMaybe<CardTaskSortInputDto>;
}>;


export type GetCardsTasksQuery = { __typename?: 'Query', cardsTasks: { __typename?: 'PaginatedCardTask', totalCount: number, nodes: Array<{ __typename?: 'CardTask', id: string, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, title: string, dueAt?: string | null, description?: string | null, completedAt?: string | null, createdAt: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string }, stage?: { __typename?: 'Stage', name: string, color?: string | null } | null, assignees: Array<{ __typename?: 'CardTaskAssignee', user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }>, labels: Array<{ __typename?: 'CardTaskLabel', id: string, name: string, color: string }> }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } } };

export type CardTaskFieldsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CardTaskFieldsQuery = { __typename?: 'Query', cardTaskFields: Array<{ __typename?: 'CardTaskField', createdAt: string, id: string, key: string, name: string, type: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, updatedAt: string, value?: string | null, values: Array<string>, options: Array<{ __typename?: 'CardTaskFieldOption', label: string }>, conditions: Array<{ __typename?: 'CardTaskFieldCondition', operator: FieldConditionOperator, expectedValueString?: string | null, dependsOnField: { __typename?: 'CardTaskField', key: string } }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> };

export type GetPipeDocumentationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPipeDocumentationQuery = { __typename?: 'Query', pipe: { __typename?: 'Pipe', documentation: { __typename?: 'PipeDoc', stages: Array<{ __typename?: 'StageDocContent', content?: string | null, title: string, automations?: Array<{ __typename?: 'AutomationDocContent', content?: string | null, title: string, event?: string | null, actionType?: string | null }> | null }>, flux: { __typename?: 'FluxDocContent', content?: string | null, title: string } } } };

export type ExportCardsMutationVariables = Exact<{
  exportCardInput: ExportCardInput;
}>;


export type ExportCardsMutation = { __typename?: 'Mutation', exportCards: boolean };

export type ExportTasksMutationVariables = Exact<{
  exportTaskInput: ExportTasksInput;
}>;


export type ExportTasksMutation = { __typename?: 'Mutation', exportTasks: boolean };

export type ReportsByPipeIdQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  filters: FiltersReportsInput;
}>;


export type ReportsByPipeIdQuery = { __typename?: 'Query', reportsByPipeId: Array<{ __typename?: 'FormReport', isStartForm: boolean, answersCount: number, form: { __typename?: 'Form', id: string, name: string }, stages?: Array<{ __typename?: 'Stage', id: string, name: string, color?: string | null }> | null }> };

export type ReportDetailsQueryVariables = Exact<{
  formId: Scalars['ID']['input'];
  pipeId: Scalars['ID']['input'];
  filters: FiltersReportsDetailsInput;
}>;


export type ReportDetailsQuery = { __typename?: 'Query', reportDetails: Array<{ __typename?: 'FormReportDetails', title: string, type: string, position: number, values: Array<{ __typename?: 'CheckboxAnswer', values: Array<string>, count: number } | { __typename?: 'FixedChoiceAnswer', value?: string | null, count: number } | { __typename?: 'OpenChoiceAnswer', value?: string | null, answeredAt?: string | null }> }> };

export type GetSearchLabelsQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSearchLabelsQuery = { __typename?: 'Query', getLabels: Array<{ __typename?: 'Label', id: string, name: string, color: string }> };

export type LoadSearchLabelsQueryVariables = Exact<{
  labelsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pipeId: Scalars['ID']['input'];
}>;


export type LoadSearchLabelsQuery = { __typename?: 'Query', getLabelsByIds: Array<{ __typename?: 'Label', id: string, name: string, color: string }> };

export type GetSearchPipesMembersQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  pipeId: Scalars['ID']['input'];
  notTheseUsers?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetSearchPipesMembersQuery = { __typename?: 'Query', pipesMembers: { __typename?: 'PaginatedPipesMember', totalCount: number, nodes: Array<{ __typename?: 'PipesMember', id: string, user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null, email: string } }> } };

export type LoadPipesMembersQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pipeId: Scalars['ID']['input'];
}>;


export type LoadPipesMembersQuery = { __typename?: 'Query', pipesMembersByIds: Array<{ __typename?: 'PipesMember', id: string, user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }> };

export type CreateCardMutationVariables = Exact<{
  input: CreateCardInput;
}>;


export type CreateCardMutation = { __typename?: 'Mutation', createCard: { __typename?: 'Card', id: string } };

export type AddFormToStageMutationVariables = Exact<{
  formId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
}>;


export type AddFormToStageMutation = { __typename?: 'Mutation', addFormToStage: { __typename?: 'Stage', id: string } };

export type ArchivePipeMutationVariables = Exact<{
  pipeId: Scalars['ID']['input'];
}>;


export type ArchivePipeMutation = { __typename?: 'Mutation', deletePipe: boolean };

export type GetPipeSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPipeSettingsQuery = { __typename?: 'Query', pipe: { __typename?: 'Pipe', id: string, name: string, description?: string | null, icon?: string | null, color?: string | null, private: boolean, onlyAdminCanRemoveCards: boolean, onlyAssigneesCanEditCards: boolean, cardVisibilityBehavior: PipesCardVisibilityBehaviorEnum, relatedCardVisibilityBehavior: PipesCardVisibilityBehaviorEnum, cardTaskReopenBehavior: PipesCardTaskReopenBehaviorEnum, cardInitialFormUpdateBehavior: PipeCardInitialFormUpdateBehavior, cardSolicitationFormUpdateBehavior: PipeSolicitationFormUpdateBehavior, allowCommentsWhenCardLocked: boolean, attachmentsTabVisibility: boolean, updatedAt: string, deletedAt?: string | null, startForm: { __typename?: 'Form', id: string, name: string, type: string, hashedId?: string | null, teamMembersCanViewOthersSolicitations?: boolean | null } } };

export type PipeDeadlineQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
}>;


export type PipeDeadlineQuery = { __typename?: 'Query', pipeDeadline: { __typename?: 'Pipe', id: string, deadline?: { __typename?: 'Deadline', id: string, name: string, description?: string | null, archived: boolean, deadlineMinutes: number, deadlineDisplayUnit: string, deadlineRiskMinutes: number, deadlineRiskDisplayUnit: string, considerHoliday: boolean, hasOfficeHours: boolean, officeHours?: { [key: string]: any } | any[] | null, createdAt?: string | null } | null } };

export type GetFormUserAccessQueryVariables = Exact<{
  formId: Scalars['ID']['input'];
}>;


export type GetFormUserAccessQuery = { __typename?: 'Query', formUserAccess: Array<{ __typename?: 'FormUserAccessUser', id: string, name: string, email?: string | null, avatarUrl?: string | null }> };

export type GetFormTeamAccessQueryVariables = Exact<{
  formId: Scalars['ID']['input'];
}>;


export type GetFormTeamAccessQuery = { __typename?: 'Query', formTeamAccess: Array<{ __typename?: 'FormTeamAccessTeam', id: string, name: string, slug: string, description?: string | null }> };

export type UpdateFormUserAccessMutationVariables = Exact<{
  input: UpdateFormUserAccessInput;
}>;


export type UpdateFormUserAccessMutation = { __typename?: 'Mutation', updateFormUserAccess: { __typename?: 'UpdateFormUserAccessResponse', success: boolean, usersCount: number } };

export type UpdateFormTeamAccessMutationVariables = Exact<{
  input: UpdateFormTeamAccessInput;
}>;


export type UpdateFormTeamAccessMutation = { __typename?: 'Mutation', updateFormTeamAccess: { __typename?: 'UpdateFormTeamAccessResponse', success: boolean, teamsCount: number } };

export type AutomationFragmentFragment = { __typename?: 'Automation', name: string, id: string, event: string, description?: string | null, active: boolean, runOnlyOnce?: boolean | null, archived: boolean, isSync: boolean, direction?: string | null, stage: { __typename?: 'Stage', id: string, name: string }, action: { __typename: 'AutomationActionAssigneePersonData', typeAssignee: string, id: string, type: string, assignees: Array<{ __typename?: 'User', name: string, avatarUrl?: string | null, createdAt: string, email: string, id: string }> } | { __typename: 'AutomationActionCreateCardData', description: string, name: string, id: string, type: string, pipe: { __typename?: 'Pipe', id: string, name: string }, stage: { __typename?: 'Stage', id: string, name: string } } | { __typename: 'AutomationActionCreateTaskData', id: string, type: string, templates: Array<{ __typename?: 'AutomationActionCreateTaskDataTemplate', priority?: CardTaskPriorityEnum | null, title: string, description?: string | null, dueAt?: { __typename?: 'AutomationActionCreateTaskDataDueAt', unit: string, amount: number } | null }> } | { __typename: 'AutomationActionHttpRequestData', url: string, method: string, headers?: string | null, expected_status_code: number, body?: string | null, id: string, type: string, authentication?: { __typename?: 'AutomationActionParamHttpAuth', authentication_type?: string | null, authentication_token?: string | null, authentication_api_key?: string | null, authentication_api_value?: string | null } | null } | { __typename: 'RelatedCardAction', attributes?: { [key: string]: any } | any[] | null, fieldsMapping?: Array<{ [key: string]: any } | any[]> | null, targetId: string, targetStageId?: string | null, id: string, type: string } };

export type GetPipesAutomationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPipesAutomationQuery = { __typename?: 'Query', pipes: { __typename?: 'PaginatedPipe', edges: Array<{ __typename?: 'PipeEdge', node: { __typename?: 'Pipe', id: string, icon?: string | null, name: string, stages: Array<{ __typename?: 'Stage', id: string, name: string }>, startForm: { __typename?: 'Form', id: string } } }> } };

export type GetOnStagesAutomationQueryVariables = Exact<{
  params: StagesParamsInput;
}>;


export type GetOnStagesAutomationQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'Stage', id: string, name: string }> };

export type CreateAutomationMutationVariables = Exact<{
  createAutomationInput: CreateAutomationInput;
}>;


export type CreateAutomationMutation = { __typename?: 'Mutation', createAutomation: { __typename?: 'Automation', name: string, id: string, event: string, description?: string | null, active: boolean, runOnlyOnce?: boolean | null, archived: boolean, isSync: boolean, direction?: string | null, stage: { __typename?: 'Stage', id: string, name: string }, action: { __typename: 'AutomationActionAssigneePersonData', typeAssignee: string, id: string, type: string, assignees: Array<{ __typename?: 'User', name: string, avatarUrl?: string | null, createdAt: string, email: string, id: string }> } | { __typename: 'AutomationActionCreateCardData', description: string, name: string, id: string, type: string, pipe: { __typename?: 'Pipe', id: string, name: string }, stage: { __typename?: 'Stage', id: string, name: string } } | { __typename: 'AutomationActionCreateTaskData', id: string, type: string, templates: Array<{ __typename?: 'AutomationActionCreateTaskDataTemplate', priority?: CardTaskPriorityEnum | null, title: string, description?: string | null, dueAt?: { __typename?: 'AutomationActionCreateTaskDataDueAt', unit: string, amount: number } | null }> } | { __typename: 'AutomationActionHttpRequestData', url: string, method: string, headers?: string | null, expected_status_code: number, body?: string | null, id: string, type: string, authentication?: { __typename?: 'AutomationActionParamHttpAuth', authentication_type?: string | null, authentication_token?: string | null, authentication_api_key?: string | null, authentication_api_value?: string | null } | null } | { __typename: 'RelatedCardAction', attributes?: { [key: string]: any } | any[] | null, fieldsMapping?: Array<{ [key: string]: any } | any[]> | null, targetId: string, targetStageId?: string | null, id: string, type: string } } };

export type GetAutomationsOnPipeQueryVariables = Exact<{
  params: AutomationsWhereInput;
}>;


export type GetAutomationsOnPipeQuery = { __typename?: 'Query', automations: Array<{ __typename?: 'Automation', name: string, id: string, event: string, description?: string | null, active: boolean, runOnlyOnce?: boolean | null, archived: boolean, isSync: boolean, direction?: string | null, stage: { __typename?: 'Stage', id: string, name: string }, action: { __typename: 'AutomationActionAssigneePersonData', typeAssignee: string, id: string, type: string, assignees: Array<{ __typename?: 'User', name: string, avatarUrl?: string | null, createdAt: string, email: string, id: string }> } | { __typename: 'AutomationActionCreateCardData', description: string, name: string, id: string, type: string, pipe: { __typename?: 'Pipe', id: string, name: string }, stage: { __typename?: 'Stage', id: string, name: string } } | { __typename: 'AutomationActionCreateTaskData', id: string, type: string, templates: Array<{ __typename?: 'AutomationActionCreateTaskDataTemplate', priority?: CardTaskPriorityEnum | null, title: string, description?: string | null, dueAt?: { __typename?: 'AutomationActionCreateTaskDataDueAt', unit: string, amount: number } | null }> } | { __typename: 'AutomationActionHttpRequestData', url: string, method: string, headers?: string | null, expected_status_code: number, body?: string | null, id: string, type: string, authentication?: { __typename?: 'AutomationActionParamHttpAuth', authentication_type?: string | null, authentication_token?: string | null, authentication_api_key?: string | null, authentication_api_value?: string | null } | null } | { __typename: 'RelatedCardAction', attributes?: { [key: string]: any } | any[] | null, fieldsMapping?: Array<{ [key: string]: any } | any[]> | null, targetId: string, targetStageId?: string | null, id: string, type: string } }> };

export type UpdateAutomationMutationVariables = Exact<{
  updateAutomationInput: UpdateAutomationInput;
}>;


export type UpdateAutomationMutation = { __typename?: 'Mutation', updateAutomation: { __typename?: 'Automation', name: string, id: string, event: string, description?: string | null, active: boolean, runOnlyOnce?: boolean | null, archived: boolean, isSync: boolean, direction?: string | null, stage: { __typename?: 'Stage', id: string, name: string }, action: { __typename: 'AutomationActionAssigneePersonData', typeAssignee: string, id: string, type: string, assignees: Array<{ __typename?: 'User', name: string, avatarUrl?: string | null, createdAt: string, email: string, id: string }> } | { __typename: 'AutomationActionCreateCardData', description: string, name: string, id: string, type: string, pipe: { __typename?: 'Pipe', id: string, name: string }, stage: { __typename?: 'Stage', id: string, name: string } } | { __typename: 'AutomationActionCreateTaskData', id: string, type: string, templates: Array<{ __typename?: 'AutomationActionCreateTaskDataTemplate', priority?: CardTaskPriorityEnum | null, title: string, description?: string | null, dueAt?: { __typename?: 'AutomationActionCreateTaskDataDueAt', unit: string, amount: number } | null }> } | { __typename: 'AutomationActionHttpRequestData', url: string, method: string, headers?: string | null, expected_status_code: number, body?: string | null, id: string, type: string, authentication?: { __typename?: 'AutomationActionParamHttpAuth', authentication_type?: string | null, authentication_token?: string | null, authentication_api_key?: string | null, authentication_api_value?: string | null } | null } | { __typename: 'RelatedCardAction', attributes?: { [key: string]: any } | any[] | null, fieldsMapping?: Array<{ [key: string]: any } | any[]> | null, targetId: string, targetStageId?: string | null, id: string, type: string } } };

export type ToggleArchiveAutomationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ToggleArchiveAutomationMutation = { __typename?: 'Mutation', toggleArchiveAutomation: boolean };

export type AutomationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AutomationQuery = { __typename?: 'Query', automation: { __typename?: 'Automation', id: string, name: string, description?: string | null, active: boolean, runOnlyOnce?: boolean | null, archived: boolean, event: string, isSync: boolean, stage: { __typename?: 'Stage', id: string, name: string }, action: { __typename: 'AutomationActionAssigneePersonData', typeAssignee: string, id: string, type: string, assignees: Array<{ __typename?: 'User', name: string, avatarUrl?: string | null, createdAt: string, email: string, id: string }> } | { __typename: 'AutomationActionCreateCardData', description: string, name: string, id: string, type: string, pipe: { __typename?: 'Pipe', id: string, name: string }, stage: { __typename?: 'Stage', id: string, name: string } } | { __typename: 'AutomationActionCreateTaskData', id: string, type: string } | { __typename: 'AutomationActionHttpRequestData', url: string, method: string, headers?: string | null, expected_status_code: number, body?: string | null, id: string, type: string, authentication?: { __typename?: 'AutomationActionParamHttpAuth', authentication_type?: string | null, authentication_token?: string | null, authentication_api_key?: string | null, authentication_api_value?: string | null } | null } | { __typename: 'RelatedCardAction', attributes?: { [key: string]: any } | any[] | null, fieldsMapping?: Array<{ [key: string]: any } | any[]> | null, targetId: string, targetStageId?: string | null, id: string, type: string } } };

export type GetCurrentFormFieldsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCurrentFormFieldsQuery = { __typename?: 'Query', form: { __typename?: 'Form', id: string, name: string, type: string, questionsCount: number, questions: Array<{ __typename?: 'FormQuestion', id: string, type: LegacyFieldTypeEnum, position: number, required: boolean, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, customValidation?: string | null, customValidationMessage?: string | null, options: Array<{ __typename?: 'FormQuestionOption', id: string, description?: string | null, position: number, score?: number | null, value: string }>, database?: { __typename?: 'FormQuestionDatabase', id: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'Database', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null, conditions: Array<{ __typename?: 'FormQuestionCondition', operator: string, value: string, question: { __typename?: 'FormQuestionConditionParentQuestion', id: string, title?: string | null } }> }> } };

export type UpdateInitialFormMutationVariables = Exact<{
  input: UpdateInitialFormInput;
}>;


export type UpdateInitialFormMutation = { __typename?: 'Mutation', updateInitialForm: { __typename?: 'Form', id: string, name: string, type: string, teamMembersCanViewOthersSolicitations?: boolean | null, hashedId?: string | null } };

export type FormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormQuery = { __typename?: 'Query', form: { __typename?: 'Form', id: string, name: string, type: string, hashedId?: string | null, questionsCount: number, questions: Array<{ __typename?: 'FormQuestion', id: string, type: LegacyFieldTypeEnum, position: number, required: boolean, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, customValidation?: string | null, customValidationMessage?: string | null, options: Array<{ __typename?: 'FormQuestionOption', id: string, description?: string | null, position: number, score?: number | null, value: string }>, database?: { __typename?: 'FormQuestionDatabase', id: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'Database', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null, conditions: Array<{ __typename?: 'FormQuestionCondition', operator: string, value: string, question: { __typename?: 'FormQuestionConditionParentQuestion', id: string, title?: string | null } }> }> } };

export type CreatePipeDeadlineMutationVariables = Exact<{
  createDeadlineInput: CreateDeadlineInput;
  pipeId: Scalars['ID']['input'];
}>;


export type CreatePipeDeadlineMutation = { __typename?: 'Mutation', assignDeadlineToPipe: { __typename?: 'Deadline', id: string } };

export type UpdatePipeDeadlineMutationVariables = Exact<{
  updateDeadlineInput: UpdateDeadlineInput;
  pipeId: Scalars['ID']['input'];
}>;


export type UpdatePipeDeadlineMutation = { __typename?: 'Mutation', updateDeadlineToPipe: { __typename?: 'Deadline', id: string } };

export type DeletePipeDeadlineMutationVariables = Exact<{
  pipeId: Scalars['ID']['input'];
}>;


export type DeletePipeDeadlineMutation = { __typename?: 'Mutation', removeDeadlineFromPipe: boolean };

export type TransferPipeOwnershipMutationVariables = Exact<{
  input: TransferPipeOwnershipInput;
}>;


export type TransferPipeOwnershipMutation = { __typename?: 'Mutation', transferPipeOwnership: { __typename?: 'PipesMember', id: string, roleType: RoleTypeEnum, user: { __typename?: 'User', id: string, name: string, email: string } } };

export type InviteMemberMutationVariables = Exact<{
  input: InviteUsersToPipeInput;
}>;


export type InviteMemberMutation = { __typename?: 'Mutation', inviteUsersToPipe: { __typename?: 'InviteUsersToPipePayload', errors?: Array<string | null> | null, success: boolean, users: Array<{ __typename?: 'PipesMember', roleType: RoleTypeEnum, id: string, user: { __typename?: 'User', avatarUrl?: string | null, createdAt: string, email: string, id: string, name: string, updatedAt: string, roleType?: RoleTypeEnum | null } }> } };

export type RemoveMemberMutationVariables = Exact<{
  input: RemoveMemberFromPipeInput;
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMemberFromPipe: { __typename?: 'RemoveMemberFromPipePayload', errors?: Array<string | null> | null, success: boolean } };

export type PipeMembersQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  notTheseUsers?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PipeMembersQuery = { __typename?: 'Query', pipesMembers: { __typename?: 'PaginatedPipesMember', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes: Array<{ __typename?: 'PipesMember', roleType: RoleTypeEnum, id: string, user: { __typename?: 'User', avatarUrl?: string | null, createdAt: string, email: string, id: string, name: string, updatedAt: string, roleType?: RoleTypeEnum | null } }> } };

export type StagesQueryVariables = Exact<{
  params: StagesParamsInput;
}>;


export type StagesQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'Stage', id: string, name: string, description?: string | null, done?: boolean | null, deletedAt?: string | null, color?: string | null, index: number, confirmMoveCard?: ConfirmMoveCardEnum | null, canReceiveCardDirectlyFromDraft?: boolean | null, canMoveCardWithoutTasksBeingDone?: boolean | null, canReceiveCardWithoutTasksBeingDone?: boolean | null, moveCardToNextStageWhenDone?: boolean | null, reviewRequired?: boolean | null, reviewType?: ReviewTypeEnum | null, minimumReviewsRequired?: number | null, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string, name: string }>, pipe: { __typename?: 'Pipe', id: string }, form?: { __typename?: 'Form', id: string } | null, deadline?: { __typename?: 'Deadline', id: string, name: string, description?: string | null, archived: boolean, deadlineMinutes: number, deadlineDisplayUnit: string, deadlineRiskMinutes: number, deadlineRiskDisplayUnit: string, considerHoliday: boolean, hasOfficeHours: boolean, officeHours?: { [key: string]: any } | any[] | null, createdAt?: string | null } | null }> };

export type UpdateStageFormMutationVariables = Exact<{
  input: UpdateStageFormInput;
}>;


export type UpdateStageFormMutation = { __typename?: 'Mutation', updateStageForm: { __typename?: 'Form', id: string } };

export type CreateStageDeadlineMutationVariables = Exact<{
  createDeadlineInput: CreateDeadlineInput;
  stageId: Scalars['ID']['input'];
}>;


export type CreateStageDeadlineMutation = { __typename?: 'Mutation', assignDeadlineToStage: { __typename?: 'Deadline', id: string } };

export type UpdateStageDeadlineMutationVariables = Exact<{
  updateDeadlineInput: UpdateDeadlineInput;
  stageId: Scalars['ID']['input'];
}>;


export type UpdateStageDeadlineMutation = { __typename?: 'Mutation', updateDeadlineToStage: { __typename?: 'Deadline', id: string } };

export type DeleteStageDeadlineMutationVariables = Exact<{
  stageId: Scalars['ID']['input'];
}>;


export type DeleteStageDeadlineMutation = { __typename?: 'Mutation', removeDeadlineFromStage: boolean };

export type OrderStagesMutationVariables = Exact<{
  input: OrderStagesInput;
}>;


export type OrderStagesMutation = { __typename?: 'Mutation', orderStages: { __typename?: 'OrderStagesResult', success: boolean } };

export type CreateTemplateDeadlineMutationVariables = Exact<{
  input: CreateTemplateDeadlineInput;
}>;


export type CreateTemplateDeadlineMutation = { __typename?: 'Mutation', createTemplateDeadline: { __typename?: 'StageTemplate', id: string } | { __typename?: 'TemplateDeadline', id: string } | { __typename?: 'TemplateReview', id: string } | { __typename?: 'TemplateTask', id: string } };

export type UpdateTemplateDeadlineMutationVariables = Exact<{
  input: UpdateTemplateDeadlineInput;
}>;


export type UpdateTemplateDeadlineMutation = { __typename?: 'Mutation', updateTemplateDeadline: { __typename?: 'StageTemplate', id: string } | { __typename?: 'TemplateDeadline', id: string } | { __typename?: 'TemplateReview', id: string } | { __typename?: 'TemplateTask', id: string } };

export type TemplateDeadlineQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TemplateDeadlineQuery = { __typename?: 'Query', template: { __typename?: 'StageTemplate' } | { __typename?: 'TemplateDeadline', id: string, name: string, description?: string | null, deadlineMinutes: number, deadlineDisplayUnit: TemplateDeadlineTimeDisplayUnitEnum, deadlineRiskMinutes: number, deadlineRiskDisplayUnit: TemplateDeadlineTimeDisplayUnitEnum, considerHoliday: boolean, hasOfficeHours: boolean, officeHours?: { [key: string]: any } | any[] | null } | { __typename?: 'TemplateReview' } | { __typename?: 'TemplateTask' } };

export type TemplateReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TemplateReviewQuery = { __typename?: 'Query', template: { __typename?: 'StageTemplate', fields?: Array<{ __typename?: 'TemplateField', id: string, key: string, name: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, type: FieldTypeEnum, options?: Array<{ __typename?: 'TemplateFieldOption', label: string }> | null, conditions: Array<{ __typename?: 'TemplateFieldCondition', dependencyType: FieldConditionDependencyType, operator: FieldConditionOperator, expectedValueString?: string | null, expectedValueArray?: Array<string> | null, dependsOnField?: { __typename?: 'TemplateField', key: string } | null }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> | null } | { __typename?: 'TemplateDeadline', fields?: Array<{ __typename?: 'TemplateField', id: string, key: string, name: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, type: FieldTypeEnum, options?: Array<{ __typename?: 'TemplateFieldOption', label: string }> | null, conditions: Array<{ __typename?: 'TemplateFieldCondition', dependencyType: FieldConditionDependencyType, operator: FieldConditionOperator, expectedValueString?: string | null, expectedValueArray?: Array<string> | null, dependsOnField?: { __typename?: 'TemplateField', key: string } | null }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> | null } | { __typename?: 'TemplateReview', type: string, reviewType: ReviewTypeEnum, responseType: TemplateReviewResponseTypeEnum, pipeId: string, orientationMessage?: string | null, name: string, minimumReviewsRequired?: number | null, requiredCommentToApproveOrReject: boolean, id: string, description?: string | null, reviewers: Array<{ __typename?: 'TemplateReviewReviewer', position: number, user: { __typename?: 'User', email: string, avatarUrl?: string | null, id: string, name: string } }>, fields?: Array<{ __typename?: 'TemplateField', id: string, key: string, name: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, type: FieldTypeEnum, options?: Array<{ __typename?: 'TemplateFieldOption', label: string }> | null, conditions: Array<{ __typename?: 'TemplateFieldCondition', dependencyType: FieldConditionDependencyType, operator: FieldConditionOperator, expectedValueString?: string | null, expectedValueArray?: Array<string> | null, dependsOnField?: { __typename?: 'TemplateField', key: string } | null }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> | null } | { __typename?: 'TemplateTask', fields?: Array<{ __typename?: 'TemplateField', id: string, key: string, name: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, type: FieldTypeEnum, options?: Array<{ __typename?: 'TemplateFieldOption', label: string }> | null, conditions: Array<{ __typename?: 'TemplateFieldCondition', dependencyType: FieldConditionDependencyType, operator: FieldConditionOperator, expectedValueString?: string | null, expectedValueArray?: Array<string> | null, dependsOnField?: { __typename?: 'TemplateField', key: string } | null }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> | null } };

export type CreateTemplateReviewMutationVariables = Exact<{
  input: CreateTemplateReviewInput;
}>;


export type CreateTemplateReviewMutation = { __typename?: 'Mutation', createTemplateReview: { __typename?: 'StageTemplate', id: string } | { __typename?: 'TemplateDeadline', id: string } | { __typename?: 'TemplateReview', id: string } | { __typename?: 'TemplateTask', id: string } };

export type UpdateTemplateReviewMutationVariables = Exact<{
  input: UpdateTemplateReviewInput;
}>;


export type UpdateTemplateReviewMutation = { __typename?: 'Mutation', updateTemplateReview: { __typename?: 'StageTemplate', id: string } | { __typename?: 'TemplateDeadline', id: string } | { __typename?: 'TemplateReview', id: string } | { __typename?: 'TemplateTask', id: string } };

type TemplateFragment_StageTemplate_Fragment = { __typename?: 'StageTemplate', id: string, name: string, description?: string | null, type: string };

type TemplateFragment_TemplateDeadline_Fragment = { __typename?: 'TemplateDeadline', id: string, name: string, description?: string | null, type: string };

type TemplateFragment_TemplateReview_Fragment = { __typename?: 'TemplateReview', type: string, reviewType: ReviewTypeEnum, responseType: TemplateReviewResponseTypeEnum, pipeId: string, orientationMessage?: string | null, name: string, minimumReviewsRequired?: number | null, id: string, description?: string | null, reviewers: Array<{ __typename?: 'TemplateReviewReviewer', position: number, user: { __typename?: 'User', email: string, avatarUrl?: string | null, id: string, name: string } }> };

type TemplateFragment_TemplateTask_Fragment = { __typename?: 'TemplateTask', priority?: string | null, timeToDueUnit?: TemplateTaskTimeToDueUnitEnum | null, timeToDueValue?: number | null, timeToDueFlags?: number | null, id: string, name: string, description?: string | null, type: string, labels: Array<{ __typename?: 'Label', id: string, name: string, color: string }> };

export type TemplateFragmentFragment = TemplateFragment_StageTemplate_Fragment | TemplateFragment_TemplateDeadline_Fragment | TemplateFragment_TemplateReview_Fragment | TemplateFragment_TemplateTask_Fragment;

export type TemplatesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  filters: PaginatedTemplatesFilters;
}>;


export type TemplatesQuery = { __typename?: 'Query', templates: { __typename?: 'TemplatePaginated', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'StageTemplate', id: string, name: string, description?: string | null, type: string } | { __typename?: 'TemplateDeadline', id: string, name: string, description?: string | null, type: string } | { __typename?: 'TemplateReview', type: string, reviewType: ReviewTypeEnum, responseType: TemplateReviewResponseTypeEnum, pipeId: string, orientationMessage?: string | null, name: string, minimumReviewsRequired?: number | null, id: string, description?: string | null, reviewers: Array<{ __typename?: 'TemplateReviewReviewer', position: number, user: { __typename?: 'User', email: string, avatarUrl?: string | null, id: string, name: string } }> } | { __typename?: 'TemplateTask', priority?: string | null, timeToDueUnit?: TemplateTaskTimeToDueUnitEnum | null, timeToDueValue?: number | null, timeToDueFlags?: number | null, id: string, name: string, description?: string | null, type: string, labels: Array<{ __typename?: 'Label', id: string, name: string, color: string }> }> } };

export type TemplatesTasksQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type TemplatesTasksQuery = { __typename?: 'Query', templatesTasks: { __typename?: 'TemplatePaginated', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'StageTemplate' } | { __typename?: 'TemplateDeadline' } | { __typename?: 'TemplateReview' } | { __typename?: 'TemplateTask', id: string, name: string, description?: string | null, type: string, priority?: string | null, timeToDueUnit?: TemplateTaskTimeToDueUnitEnum | null, timeToDueValue?: number | null, timeToDueFlags?: number | null, labels: Array<{ __typename?: 'Label', id: string, name: string, color: string }> }> } };

export type RootTemplatesByStageQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RootTemplatesByStageQuery = { __typename?: 'Query', templatesByStage: { __typename?: 'ListTemplatesByStageResponse', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'StageTemplate', id: string, name: string, description?: string | null, type: string, children: Array<{ __typename?: 'StageTemplateChild', id: string, name: string }> }> } };

export type BatchTemplatesByStageQueryVariables = Exact<{
  data: GetBatchTemplatesByStageInput;
}>;


export type BatchTemplatesByStageQuery = { __typename?: 'Query', batchTemplatesByStage: Array<{ __typename?: 'StageTemplate', id: string, name: string, description?: string | null, type: string, children: Array<{ __typename?: 'StageTemplateChild', id: string, name: string }> }> };

export type CreateTemplateTaskMutationVariables = Exact<{
  input: CreateTemplateTaskInput;
}>;


export type CreateTemplateTaskMutation = { __typename?: 'Mutation', createTemplateTask: { __typename?: 'StageTemplate', id: string, name: string, description?: string | null, type: string } | { __typename?: 'TemplateDeadline', id: string, name: string, description?: string | null, type: string } | { __typename?: 'TemplateReview', type: string, reviewType: ReviewTypeEnum, responseType: TemplateReviewResponseTypeEnum, pipeId: string, orientationMessage?: string | null, name: string, minimumReviewsRequired?: number | null, id: string, description?: string | null, reviewers: Array<{ __typename?: 'TemplateReviewReviewer', position: number, user: { __typename?: 'User', email: string, avatarUrl?: string | null, id: string, name: string } }> } | { __typename?: 'TemplateTask', priority?: string | null, timeToDueUnit?: TemplateTaskTimeToDueUnitEnum | null, timeToDueValue?: number | null, timeToDueFlags?: number | null, id: string, name: string, description?: string | null, type: string, labels: Array<{ __typename?: 'Label', id: string, name: string, color: string }> } };

export type EditTemplateTaskMutationVariables = Exact<{
  input: EditTemplateTaskInput;
}>;


export type EditTemplateTaskMutation = { __typename?: 'Mutation', editTemplateTask: { __typename?: 'StageTemplate', id: string, name: string, description?: string | null, type: string } | { __typename?: 'TemplateDeadline', id: string, name: string, description?: string | null, type: string } | { __typename?: 'TemplateReview', type: string, reviewType: ReviewTypeEnum, responseType: TemplateReviewResponseTypeEnum, pipeId: string, orientationMessage?: string | null, name: string, minimumReviewsRequired?: number | null, id: string, description?: string | null, reviewers: Array<{ __typename?: 'TemplateReviewReviewer', position: number, user: { __typename?: 'User', email: string, avatarUrl?: string | null, id: string, name: string } }> } | { __typename?: 'TemplateTask', priority?: string | null, timeToDueUnit?: TemplateTaskTimeToDueUnitEnum | null, timeToDueValue?: number | null, timeToDueFlags?: number | null, id: string, name: string, description?: string | null, type: string, labels: Array<{ __typename?: 'Label', id: string, name: string, color: string }> } };

export type MoveCardAxisYMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
  nextCardId?: InputMaybe<Scalars['ID']['input']>;
  previousCardId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MoveCardAxisYMutation = { __typename?: 'Mutation', moveCard: { __typename?: 'Card', age: number, archived: boolean, createdAt: string, description?: string | null, id: string, late?: boolean | null, name: string, startedCurrentPhaseAt?: string | null, updatedAt: string } };

export type MoveCardAxisXMutationVariables = Exact<{
  moveCardToStageArgs: MoveCardToStageInput;
}>;


export type MoveCardAxisXMutation = { __typename?: 'Mutation', moveCardToStage: { __typename?: 'Card', id: string } };

export type GetStagesQueryVariables = Exact<{
  params: StagesParamsInput;
}>;


export type GetStagesQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'Stage', id: string, name: string, description?: string | null, index: number, color?: string | null, done?: boolean | null, canReceiveCardDirectlyFromDraft?: boolean | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, confirmMoveCard?: ConfirmMoveCardEnum | null, pipe: { __typename?: 'Pipe', id: string, name: string, startForm: { __typename?: 'Form', id: string } }, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string, name: string }>, cards: { __typename?: 'CardConnection', nodes: Array<{ __typename?: 'Card', age: number, id: string, name: string, index?: number | null, currentStage: { __typename?: 'Stage', id: string }, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }> }> } }> };

export type GetPipeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPipeQuery = { __typename?: 'Query', pipe: { __typename?: 'Pipe', id: string, icon?: string | null, name: string, description?: string | null, onlyAdminCanRemoveCards: boolean, onlyAssigneesCanEditCards: boolean, color?: string | null, updatedAt: string, private: boolean, deletedAt?: string | null, startForm: { __typename?: 'Form', id: string, name: string, type: string, questions: Array<{ __typename?: 'FormQuestion', id: string, title: string, type: LegacyFieldTypeEnum, required: boolean, position: number, helpText?: string | null, schema?: { [key: string]: any } | null, customValidation?: string | null, customValidationMessage?: string | null, conditions: Array<{ __typename?: 'FormQuestionCondition', value: string, operator: string, question: { __typename?: 'FormQuestionConditionParentQuestion', id: string, title?: string | null } }>, options: Array<{ __typename?: 'FormQuestionOption', value: string, id: string, description?: string | null }>, database?: { __typename?: 'FormQuestionDatabase', databaseLabelField: string } | null }> }, stages: Array<{ __typename?: 'Stage', id: string, name: string, canReceiveCardDirectlyFromDraft?: boolean | null, index: number, deletedAt?: string | null }>, permissions: { __typename?: 'PipePermissions', canDeleteCard: boolean, canDownloadFiles: boolean, canEditAnyCard: boolean, canEditCard: boolean, canEditPipe: boolean, canShowAllCards: boolean }, members: Array<{ __typename?: 'PipesMember', id: string, roleType: RoleTypeEnum, user: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } }> } };

export type MoveStageAxisXMutationVariables = Exact<{
  moveStageAxisInput: MoveStageAxisInput;
}>;


export type MoveStageAxisXMutation = { __typename?: 'Mutation', moveStageAxisX: { __typename?: 'Stage', id: string } };

export type GetStagesPartiallyQueryVariables = Exact<{
  params: StagesParamsInput;
}>;


export type GetStagesPartiallyQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'Stage', id: string, name: string, description?: string | null, index: number, color?: string | null, deletedAt?: string | null, done?: boolean | null, canReceiveCardDirectlyFromDraft?: boolean | null, canMoveCardWithoutTasksBeingDone?: boolean | null, canReceiveCardWithoutTasksBeingDone?: boolean | null, confirmMoveCard?: ConfirmMoveCardEnum | null, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string }> }> };

export type GetStagesCardsCountQueryVariables = Exact<{
  params: StagesParamsInput;
  cardsParams?: InputMaybe<FiltersCardsInput>;
}>;


export type GetStagesCardsCountQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'Stage', id: string, cardsCount?: number | null }> };

export type ViewBoardStagesQueryVariables = Exact<{
  params: StagesParamsInput;
}>;


export type ViewBoardStagesQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'Stage', id: string, name: string, index: number, confirmMoveCard?: ConfirmMoveCardEnum | null, color?: string | null, done?: boolean | null, canReceiveCardDirectlyFromDraft?: boolean | null, deletedAt?: string | null }> };

export type ViewBoardStageCardsCountQueryVariables = Exact<{
  params: StagesParamsInput;
  cardsParams?: InputMaybe<FiltersCardsInput>;
}>;


export type ViewBoardStageCardsCountQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'Stage', id: string, cardsCount?: number | null }> };

export type GetCardAutomationsQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type GetCardAutomationsQuery = { __typename?: 'Query', card: { __typename?: 'Card', id: string, name: string, automations: Array<{ __typename?: 'AutomationExecution', id: string, status: StageAutomationExecutionsActionsStatus, createdAt: string, automation: { __typename?: 'Automation', name: string, isSync: boolean }, actions: Array<{ __typename?: 'AutomationExecutionAction', id: string, lastHeartbeatAt?: string | null, status: StageAutomationExecutionsActionsStatus, type: StageAutomationActionTypeEnum, createdAt: string, logs: Array<{ __typename?: 'AutomationExecutionActionLog', id: string, status: StageAutomationExecutionsActionsStatus, message: string, createdAt: string }> }> }> } };

export type GetCardAutomationsForCacheQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type GetCardAutomationsForCacheQuery = { __typename?: 'Query', card: { __typename?: 'Card', id: string, automations: Array<{ __typename?: 'AutomationExecution', id: string, status: StageAutomationExecutionsActionsStatus, automation: { __typename?: 'Automation', isSync: boolean } }> } };

export type GetStageQueryVariables = Exact<{
  stageId: Scalars['ID']['input'];
  cardsParams?: InputMaybe<FiltersCardsInput>;
}>;


export type GetStageQuery = { __typename?: 'Query', stage: { __typename?: 'Stage', id: string, name: string, description?: string | null, index: number, color?: string | null, deletedAt?: string | null, done?: boolean | null, canReceiveCardDirectlyFromDraft?: boolean | null, canMoveCardWithoutTasksBeingDone?: boolean | null, canReceiveCardWithoutTasksBeingDone?: boolean | null, cardsCount?: number | null, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string }>, form?: { __typename?: 'Form', id: string } | null } };

export type GetUnopenedCardQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type GetUnopenedCardQuery = { __typename?: 'Query', card: { __typename?: 'Card', age: number, id: string, name: string, index?: number | null, locked: boolean, pipe: { __typename?: 'Pipe', id: string }, currentStage: { __typename?: 'Stage', id: string, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string }> }, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum, type: ReviewTypeEnum, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', avatarUrl?: string | null, name: string, email: string, id: string } }> } | null, commentCount: { __typename?: 'CardCommentCount', total: number, hasNew: boolean } } };

export type GetUnopenedCardsQueryVariables = Exact<{
  where?: InputMaybe<FiltersCardsInput>;
  sort?: InputMaybe<UnopenedCardsSortInput>;
  stageId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUnopenedCardsQuery = { __typename?: 'Query', unopenedCards: { __typename?: 'PaginationByOffsetUnopenedCards', suid: string, totalCount: number, items: Array<{ __typename?: 'Card', age: number, id: string, name: string, index?: number | null, pipe: { __typename?: 'Pipe', id: string }, currentStage: { __typename?: 'Stage', id: string, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string }> } }>, pageInfo: { __typename?: 'PageInfoOffset', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetUnopenedCardsHeavyQueryVariables = Exact<{
  where?: InputMaybe<FiltersCardsInput>;
  stageId: Scalars['ID']['input'];
}>;


export type GetUnopenedCardsHeavyQuery = { __typename?: 'Query', unopenedCards: { __typename?: 'PaginationByOffsetUnopenedCards', suid: string, items: Array<{ __typename?: 'Card', id: string, locked: boolean, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineAt?: string | null, deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum, type: ReviewTypeEnum, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', avatarUrl?: string | null, name: string, email: string, id: string } }> } | null, commentCount: { __typename?: 'CardCommentCount', total: number, hasNew: boolean } }> } };

export type ReviewsByPipeQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PaginatedReviewFilters>;
  sorts?: InputMaybe<PaginatedReviewSortOrderInput>;
}>;


export type ReviewsByPipeQuery = { __typename?: 'Query', reviewsByPipe: { __typename?: 'PaginatedReview', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Review', id: string, accountId: string, completedReviewsCount: number, createdAt: string, lastReviewedAt?: string | null, orientationMessage?: string | null, requestedById: string, status: ReviewStatusEnum, updatedAt: string, type: ReviewTypeEnum, card: { __typename?: 'Card', id: string, name: string, archived: boolean, pipe: { __typename?: 'Pipe', id: string, name: string } }, stage: { __typename?: 'Stage', id: string, name: string, color?: string | null, minimumReviewsRequired?: number | null }, requestedBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null }, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, reviewedAt?: string | null, user: { __typename?: 'User', id: string, avatarUrl?: string | null, email: string, name: string } }> }> } };

export type BulkUpdateReviewersMutationVariables = Exact<{
  input: BulkUpdateReviewersInput;
}>;


export type BulkUpdateReviewersMutation = { __typename?: 'Mutation', bulkUpdateReviewers: { __typename?: 'BulkUpdateReviewers', successCount: number, errorCount: number, updatedReviewIds: Array<string>, errors: Array<{ __typename?: 'ReviewersError', errorCode: string, message: string, reviewId: string }> } };

export type CardsInTableQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  filters?: InputMaybe<FiltersCardsInput>;
  sorts?: InputMaybe<Array<SortOrderInput> | SortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CardsInTableQuery = { __typename?: 'Query', cards: { __typename?: 'PaginatedCard', totalCount: number, nodes: Array<{ __typename?: 'Card', id: string, name: string, archived: boolean, createdAt: string, updatedAt: string, age: number, arrivedAt: string, duration?: number | null, currentStage: { __typename?: 'Stage', id: string, name: string, color?: string | null, minimumReviewsRequired?: number | null }, createdBy: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CardsInTableHeavyQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
  filters?: InputMaybe<FiltersCardsInput>;
}>;


export type CardsInTableHeavyQuery = { __typename?: 'Query', cards: { __typename?: 'PaginatedCard', nodes: Array<{ __typename?: 'Card', id: string, locked: boolean, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum, type: ReviewTypeEnum, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', avatarUrl?: string | null, name: string, email: string, id: string } }> } | null, fields: Array<{ __typename?: 'AttachmentField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'CheckboxesField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'CurrencyField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DatabaseField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DateField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DocumentField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DropdownField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'EmailField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'HourField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'MultipleChoiceField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'NumericField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'ParagraphField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'PhoneField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'ShortAnswerField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'SignatureField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> }> }> } };

export type CardInTableQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CardInTableQuery = { __typename?: 'Query', card: { __typename?: 'Card', id: string, name: string, archived: boolean, createdAt: string, updatedAt: string, age: number, arrivedAt: string, duration?: number | null, locked: boolean, currentStage: { __typename?: 'Stage', id: string, name: string, color?: string | null, minimumReviewsRequired?: number | null }, createdBy: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }, lastAssignees: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, lastReview?: { __typename?: 'Review', status: ReviewStatusEnum, type: ReviewTypeEnum, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, user: { __typename?: 'User', avatarUrl?: string | null, name: string, email: string, id: string } }> } | null, fields: Array<{ __typename?: 'AttachmentField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'CheckboxesField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'CurrencyField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DatabaseField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DateField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DocumentField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'DropdownField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'EmailField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'HourField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'MultipleChoiceField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'NumericField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'ParagraphField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'PhoneField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'ShortAnswerField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> } | { __typename?: 'SignatureField', title: string, value?: string | null, type: LegacyFieldTypeEnum, options: Array<{ __typename?: 'FieldOption', id: string, value: string }> }> } };

export type PipeGetCardsTasksQueryVariables = Exact<{
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
  where: CardTaskByPipeWhereInputDto;
  sort?: InputMaybe<Array<SortOrderInput> | SortOrderInput>;
}>;


export type PipeGetCardsTasksQuery = { __typename?: 'Query', cardsTasksByPipe: { __typename?: 'PaginatedCardTask', totalCount: number, nodes: Array<{ __typename?: 'CardTask', id: string, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, title: string, dueAt?: string | null, description?: string | null, completedAt?: string | null, createdAt: string, createdBy: { __typename?: 'User', id: string, name: string }, stage?: { __typename?: 'Stage', name: string, color?: string | null } | null, card: { __typename?: 'Card', id: string, name: string, currentStage: { __typename?: 'Stage', name: string, color?: string | null }, pipe: { __typename?: 'Pipe', id: string, name: string } }, assignees: Array<{ __typename?: 'CardTaskAssignee', user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }>, labels: Array<{ __typename?: 'CardTaskLabel', id: string, name: string, color: string }> }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } } };

export type BulkUpdateTaskAssigneesMutationVariables = Exact<{
  input: BulkUpdateTaskAssigneesInput;
}>;


export type BulkUpdateTaskAssigneesMutation = { __typename?: 'Mutation', bulkUpdateTaskAssignees: { __typename?: 'BulkUpdateTaskAssignees', successCount: number, errorCount: number, updatedTasks: Array<{ __typename?: 'CardTask', id: string, title: string }>, errors: Array<{ __typename?: 'TaskAssigneeError', errorCode: string, message: string, taskId: string }> } };

export type SolicitationFormsQueryVariables = Exact<{
  where: WhereSolicitationFormsInput;
  take?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
}>;


export type SolicitationFormsQuery = { __typename?: 'Query', solicitationForms: { __typename?: 'PaginatedSolicitationFormResponse', totalCount: number, items: Array<{ __typename?: 'Form', id: string, name: string, pipe?: { __typename?: 'Pipe', id: string, name: string, description?: string | null, startForm: { __typename?: 'Form', id: string, name: string, type: string } } | null }>, pageInfo: { __typename?: 'PageInfoOffset', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateSolicitationMutationVariables = Exact<{
  data: CreateCardInput;
}>;


export type CreateSolicitationMutation = { __typename?: 'Mutation', createSolicitation: { __typename?: 'Card', id: string } };

export type PipesQueryVariables = Exact<{
  filters?: InputMaybe<PaginatedPipeFilters>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedPipeSortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PipesQuery = { __typename?: 'Query', pipes: { __typename?: 'PaginatedPipe', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'PipeEdge', cursor: string, node: { __typename?: 'Pipe', id: string, icon?: string | null, name: string, color?: string | null, favorite?: boolean | null, deletedAt?: string | null, updatedAt: string, cardsCount: number, private: boolean, members: Array<{ __typename?: 'PipesMember', user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }> } }> } };

export type MyCardsByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyCardsByIdQuery = { __typename?: 'Query', card: { __typename?: 'Card', age: number, id: string, name: string, archived: boolean, createdAt: string, updatedAt: string, initialFormResponsible: CardInitialFormResponsible, arrivedAt: string, leftAt?: string | null, duration?: number | null, createdBy: { __typename?: 'User', id: string, email: string, avatarUrl?: string | null, name: string }, currentStage: { __typename?: 'Stage', id: string, color?: string | null, name: string, done?: boolean | null }, pipe: { __typename?: 'Pipe', id: string, name: string, color?: string | null }, lastAssignees: Array<{ __typename?: 'User', id: string, email: string, name: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', createdAt: string, label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string, cardFinishedAt?: string | null } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, commentCount: { __typename?: 'CardCommentCount', total: number, hasNew: boolean } } };

export type MyCardsQueryVariables = Exact<{
  filters?: InputMaybe<FiltersSelfCardsInput>;
  sort?: InputMaybe<Array<SortOrderInput> | SortOrderInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyCardsQuery = { __typename?: 'Query', selfCards: { __typename?: 'PaginatedCard', totalCount: number, edges: Array<{ __typename?: 'CardEdge', node: { __typename?: 'Card', age: number, id: string, name: string, archived: boolean, createdAt: string, updatedAt: string, initialFormResponsible: CardInitialFormResponsible, arrivedAt: string, leftAt?: string | null, duration?: number | null, createdBy: { __typename?: 'User', id: string, email: string, avatarUrl?: string | null, name: string }, currentStage: { __typename?: 'Stage', id: string, color?: string | null, name: string, done?: boolean | null }, pipe: { __typename?: 'Pipe', id: string, name: string, color?: string | null }, lastAssignees: Array<{ __typename?: 'User', id: string, email: string, name: string, avatarUrl?: string | null }>, labels: Array<{ __typename?: 'CardLabel', createdAt: string, label: { __typename?: 'Label', id: string, name: string, color: string } }>, pipeDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string, cardFinishedAt?: string | null } | null, currentStageDeadline?: { __typename?: 'RealDeadline', deadlineStartedAt?: string | null, deadlineRiskAt?: string | null, deadlineRaw?: { [key: string]: any } | any[] | null, deadlineAt?: string | null, status: string } | null, automations: Array<{ __typename?: 'AutomationExecution', status: StageAutomationExecutionsActionsStatus }>, commentCount: { __typename?: 'CardCommentCount', total: number, hasNew: boolean } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type OwnReviewsFieldsFragment = { __typename?: 'Review', id: string, accountId: string, completedReviewsCount: number, createdAt: string, lastReviewedAt?: string | null, orientationMessage?: string | null, requestedById: string, status: ReviewStatusEnum, updatedAt: string, type: ReviewTypeEnum, card: { __typename?: 'Card', id: string, name: string, archived: boolean, pipe: { __typename?: 'Pipe', id: string, name: string } }, stage: { __typename?: 'Stage', id: string, name: string, color?: string | null, minimumReviewsRequired?: number | null }, requestedBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null }, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, reviewedAt?: string | null, user: { __typename?: 'User', id: string, avatarUrl?: string | null, email: string, name: string } }> };

export type OwnReviewsQueryVariables = Exact<{
  filters?: InputMaybe<PaginatedReviewFilters>;
  sorts?: InputMaybe<PaginatedReviewSortOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OwnReviewsQuery = { __typename?: 'Query', ownReviews: { __typename?: 'PaginatedReview', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PaginatedReviewEdge', node: { __typename?: 'Review', id: string, accountId: string, completedReviewsCount: number, createdAt: string, lastReviewedAt?: string | null, orientationMessage?: string | null, requestedById: string, status: ReviewStatusEnum, updatedAt: string, type: ReviewTypeEnum, card: { __typename?: 'Card', id: string, name: string, archived: boolean, pipe: { __typename?: 'Pipe', id: string, name: string } }, stage: { __typename?: 'Stage', id: string, name: string, color?: string | null, minimumReviewsRequired?: number | null }, requestedBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null }, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, reviewedAt?: string | null, user: { __typename?: 'User', id: string, avatarUrl?: string | null, email: string, name: string } }> } }> } };

export type OwnReviewsByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OwnReviewsByIdQuery = { __typename?: 'Query', review: { __typename?: 'Review', id: string, accountId: string, completedReviewsCount: number, createdAt: string, lastReviewedAt?: string | null, orientationMessage?: string | null, requestedById: string, status: ReviewStatusEnum, updatedAt: string, type: ReviewTypeEnum, card: { __typename?: 'Card', id: string, name: string, archived: boolean, pipe: { __typename?: 'Pipe', id: string, name: string } }, stage: { __typename?: 'Stage', id: string, name: string, color?: string | null, minimumReviewsRequired?: number | null }, requestedBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null }, reviewers: Array<{ __typename?: 'Reviewer', id: string, status: ReviewerStatusEnum, reviewedAt?: string | null, user: { __typename?: 'User', id: string, avatarUrl?: string | null, email: string, name: string } }> } };

export type MySpaceCardTaskFragment = { __typename?: 'CardTask', id: string, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, title: string, dueAt?: string | null, description?: string | null, completedAt?: string | null, createdAt: string, createdBy: { __typename?: 'User', id: string, name: string }, stage?: { __typename?: 'Stage', name: string, color?: string | null } | null, card: { __typename?: 'Card', id: string, name: string, currentStage: { __typename?: 'Stage', name: string, color?: string | null }, pipe: { __typename?: 'Pipe', id: string, name: string } }, assignees: Array<{ __typename?: 'CardTaskAssignee', user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }>, labels: Array<{ __typename?: 'CardTaskLabel', id: string, name: string, color: string }> };

export type OwnCardsTasksQueryVariables = Exact<{
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
  where: CardTaskWhereInputDto;
  sort?: InputMaybe<CardTaskSortInputDto>;
}>;


export type OwnCardsTasksQuery = { __typename?: 'Query', cardsTasks: { __typename?: 'PaginatedCardTask', totalCount: number, nodes: Array<{ __typename?: 'CardTask', id: string, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, title: string, dueAt?: string | null, description?: string | null, completedAt?: string | null, createdAt: string, createdBy: { __typename?: 'User', id: string, name: string }, stage?: { __typename?: 'Stage', name: string, color?: string | null } | null, card: { __typename?: 'Card', id: string, name: string, currentStage: { __typename?: 'Stage', name: string, color?: string | null }, pipe: { __typename?: 'Pipe', id: string, name: string } }, assignees: Array<{ __typename?: 'CardTaskAssignee', user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }>, labels: Array<{ __typename?: 'CardTaskLabel', id: string, name: string, color: string }> }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } } };

export type OwnCardTaskByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OwnCardTaskByIdQuery = { __typename?: 'Query', cardTask: { __typename?: 'CardTask', id: string, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, title: string, dueAt?: string | null, description?: string | null, completedAt?: string | null, createdAt: string, createdBy: { __typename?: 'User', id: string, name: string }, stage?: { __typename?: 'Stage', name: string, color?: string | null } | null, card: { __typename?: 'Card', id: string, name: string, currentStage: { __typename?: 'Stage', name: string, color?: string | null }, pipe: { __typename?: 'Pipe', id: string, name: string } }, assignees: Array<{ __typename?: 'CardTaskAssignee', user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }>, labels: Array<{ __typename?: 'CardTaskLabel', id: string, name: string, color: string }> } };

export type GetModalCardTaskQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetModalCardTaskQuery = { __typename?: 'Query', cardTask: { __typename?: 'CardTask', id: string, priority?: CardTaskPriorityEnum | null, status: CardTaskStatusEnum, title: string, dueAt?: string | null, description?: string | null, completedAt?: string | null, createdAt: string, createdBy: { __typename?: 'User', id: string, name: string }, stage?: { __typename?: 'Stage', name: string, color?: string | null } | null, card: { __typename?: 'Card', id: string, name: string, currentStage: { __typename?: 'Stage', name: string, color?: string | null }, pipe: { __typename?: 'Pipe', id: string, name: string } }, assignees: Array<{ __typename?: 'CardTaskAssignee', user: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }>, labels: Array<{ __typename?: 'CardTaskLabel', id: string, name: string, color: string }> } };

export type GetCardTaskFilterPipesQueryVariables = Exact<{
  filters?: InputMaybe<PaginatedPipeFilters>;
}>;


export type GetCardTaskFilterPipesQuery = { __typename?: 'Query', pipes: { __typename?: 'PaginatedPipe', nodes: Array<{ __typename?: 'Pipe', id: string, name: string }> } };

export type GetCardTaskFilterPipeQueryVariables = Exact<{
  pipeId: Scalars['ID']['input'];
}>;


export type GetCardTaskFilterPipeQuery = { __typename?: 'Query', pipe: { __typename?: 'Pipe', id: string, name: string } };

export type GetCardTaskFilterStagesQueryVariables = Exact<{
  params: StagesParamsInput;
}>;


export type GetCardTaskFilterStagesQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'Stage', id: string, name: string }> };

export type NotificationPreferencesFragmentFragment = { __typename?: 'NotificationPreference', id: string, cardArchivedOrUnarchived: number, cardAssignedToMe: number, cardAssigneeTaskCompletedOrReopened: number, cardAssigneeTaskCreated: number, cardDeadlineNearOrExpired: number, cardMentionedInComment: number, cardMoved: number, cardMyApprovalRequired: number, pipeAddedToMe: number, cardCreated: number, security: number, solicitation: number, cardApprovalStatusChanged: number, dailyMySpaceSummary: number };

export type GetNotificationUserPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationUserPreferencesQuery = { __typename?: 'Query', notificationUserPreferences: { __typename?: 'NotificationUserPreference', id: string, preferences: { __typename?: 'NotificationPreference', id: string, cardArchivedOrUnarchived: number, cardAssignedToMe: number, cardAssigneeTaskCompletedOrReopened: number, cardAssigneeTaskCreated: number, cardDeadlineNearOrExpired: number, cardMentionedInComment: number, cardMoved: number, cardMyApprovalRequired: number, pipeAddedToMe: number, cardCreated: number, security: number, solicitation: number, cardApprovalStatusChanged: number, dailyMySpaceSummary: number }, user: { __typename?: 'User', id: string } } };

export type UpdateNotificationUserPreferenceMutationVariables = Exact<{
  input: UpdateNotificationUserPreferenceDto;
}>;


export type UpdateNotificationUserPreferenceMutation = { __typename?: 'Mutation', updateNotificationUserPreference: { __typename?: 'NotificationUserPreference', id: string, preferences: { __typename?: 'NotificationPreference', id: string, cardArchivedOrUnarchived: number, cardAssignedToMe: number, cardAssigneeTaskCompletedOrReopened: number, cardAssigneeTaskCreated: number, cardDeadlineNearOrExpired: number, cardMentionedInComment: number, cardMoved: number, cardMyApprovalRequired: number, pipeAddedToMe: number, cardCreated: number, security: number, solicitation: number, cardApprovalStatusChanged: number, dailyMySpaceSummary: number }, user: { __typename?: 'User', id: string } } };

export type GetNotificationPipePreferencesQueryVariables = Exact<{
  pipeId: Scalars['String']['input'];
}>;


export type GetNotificationPipePreferencesQuery = { __typename?: 'Query', notificationPipePreferences?: { __typename?: 'NotificationPipePreference', id: string, starred: boolean, enabled: boolean, pipe: { __typename?: 'Pipe', name: string }, preferences: { __typename?: 'NotificationPreference', id: string, cardArchivedOrUnarchived: number, cardAssignedToMe: number, cardAssigneeTaskCompletedOrReopened: number, cardAssigneeTaskCreated: number, cardDeadlineNearOrExpired: number, cardMentionedInComment: number, cardMoved: number, cardMyApprovalRequired: number, pipeAddedToMe: number, cardCreated: number, security: number, solicitation: number, cardApprovalStatusChanged: number, dailyMySpaceSummary: number }, user: { __typename?: 'User', id: string } } | null };

export type CreateNotificationPipePreferenceMutationVariables = Exact<{
  input: CreateNotificationPipePreferenceDto;
}>;


export type CreateNotificationPipePreferenceMutation = { __typename?: 'Mutation', createNotificationPipePreference: { __typename?: 'NotificationPipePreference', id: string, pipe: { __typename?: 'Pipe', name: string }, preferences: { __typename?: 'NotificationPreference', id: string, cardArchivedOrUnarchived: number, cardAssignedToMe: number, cardAssigneeTaskCompletedOrReopened: number, cardAssigneeTaskCreated: number, cardDeadlineNearOrExpired: number, cardMentionedInComment: number, cardMoved: number, cardMyApprovalRequired: number, pipeAddedToMe: number, cardCreated: number, security: number, solicitation: number, cardApprovalStatusChanged: number, dailyMySpaceSummary: number }, user: { __typename?: 'User', id: string } } };

export type UpdateNotificationPipePreferenceMutationVariables = Exact<{
  input: UpdateNotificationPipePreferenceDto;
}>;


export type UpdateNotificationPipePreferenceMutation = { __typename?: 'Mutation', updateNotificationPipePreference: { __typename?: 'NotificationPipePreference', id: string, pipe: { __typename?: 'Pipe', name: string }, preferences: { __typename?: 'NotificationPreference', id: string, cardArchivedOrUnarchived: number, cardAssignedToMe: number, cardAssigneeTaskCompletedOrReopened: number, cardAssigneeTaskCreated: number, cardDeadlineNearOrExpired: number, cardMentionedInComment: number, cardMoved: number, cardMyApprovalRequired: number, pipeAddedToMe: number, cardCreated: number, security: number, solicitation: number, cardApprovalStatusChanged: number, dailyMySpaceSummary: number }, user: { __typename?: 'User', id: string } } };

export type GetNotificationPipesQueryVariables = Exact<{
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNotificationPipesQuery = { __typename?: 'Query', notificationPipes: { __typename?: 'PaginatedNotificationPipe', totalCount: number, endCursor?: string | null, edges: Array<{ __typename?: 'Pipe', id: string, name: string, description?: string | null, icon?: string | null, notificationPreferences?: { __typename?: 'NotificationPipePreference', id: string, enabled: boolean, starred: boolean } | null }> } };

export type GetNotificationStarredPipesQueryVariables = Exact<{
  filters?: InputMaybe<PaginatedPipeFilters>;
}>;


export type GetNotificationStarredPipesQuery = { __typename?: 'Query', pipes: { __typename?: 'PaginatedPipe', nodes: Array<{ __typename?: 'Pipe', id: string, name: string }> } };

export type NotificationsQueryVariables = Exact<{
  where?: InputMaybe<NotificationWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'PaginationByOffsetNotification', items: Array<{ __typename?: 'Notification', createdAt: string, id: string, data?: { [key: string]: any } | any[] | null, favoritedAt?: string | null, readAt?: string | null, tags?: { [key: string]: any } | any[] | null, type: NotificationTypeEnum, updatedAt: string, userId: string, accountId: string, notificationData: { __typename?: 'NotificationData', id: string, comment?: string | null, ipAddress?: string | null, userAgent?: string | null, timestamp?: string | null, pipe?: { __typename?: 'Pipe', id: string, name: string } | null, card?: { __typename?: 'Card', id: string, name: string } | null, previousStage?: { __typename?: 'Stage', id: string, name: string } | null, currentStage?: { __typename?: 'Stage', id: string, name: string } | null, review?: { __typename?: 'Review', id: string } | null, task?: { __typename?: 'CardTask', id: string, title: string, status: CardTaskStatusEnum } | null, assignedBy?: { __typename?: 'StringValue', value: string } | { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null, commentedBy?: { __typename?: 'StringValue', value: string } | { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null, createdBy?: { __typename?: 'StringValue', value: string } | { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null, actionTakenBy?: { __typename?: 'StringValue', value: string } | { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfoOffset', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UpdateNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateNotificationInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: { __typename?: 'Notification', id: string, type: NotificationTypeEnum } };

export type NotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsCountQuery = { __typename?: 'Query', userNotifications?: { __typename?: 'UserNotification', count: number, countFavorites?: number | null } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: { __typename?: 'PasswordResetResult', success: boolean } };

export type ConfirmPasswordResetMutationVariables = Exact<{
  input: ConfirmPasswordResetInput;
}>;


export type ConfirmPasswordResetMutation = { __typename?: 'Mutation', confirmPasswordReset: { __typename?: 'PasswordResetResult', success: boolean } };

export type GetPublicFormQueryVariables = Exact<{
  hashedId: Scalars['String']['input'];
}>;


export type GetPublicFormQuery = { __typename?: 'Query', publicForm?: { __typename?: 'Form', id: string, name: string, questionsCount: number, questions: Array<{ __typename?: 'FormQuestion', id: string, type: LegacyFieldTypeEnum, position: number, required: boolean, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, customValidation?: string | null, customValidationMessage?: string | null, options: Array<{ __typename?: 'FormQuestionOption', id: string, description?: string | null, position: number, score?: number | null, value: string }>, database?: { __typename?: 'FormQuestionDatabase', id: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'Database', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null, conditions: Array<{ __typename?: 'FormQuestionCondition', operator: string, value: string, question: { __typename?: 'FormQuestionConditionParentQuestion', id: string, title?: string | null } }> }>, pipe?: { __typename?: 'Pipe', id: string, name: string, description?: string | null, color?: string | null, account: { __typename?: 'Account', id: string, name: string } } | null } | null };

export type PublicCreateCardMutationVariables = Exact<{
  input: CreateCardInput;
}>;


export type PublicCreateCardMutation = { __typename?: 'Mutation', publicCreateCard: { __typename?: 'Card', id: string } };

export type PublicPreSignedPostQueryVariables = Exact<{
  input: GetPublicPreSignedPostInput;
}>;


export type PublicPreSignedPostQuery = { __typename?: 'Query', publicPresignedPost: { __typename?: 'PublicPresignedPost', fields: { [key: string]: any }, url: string } };

export type AcceptInviteMutationVariables = Exact<{
  token: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite?: { __typename?: 'AuthenticatedUser', token?: string | null, realtimeToken?: string | null, mfaToken?: string | null, accountId?: string | null, user?: { __typename?: 'User', id: string, name: string, updatedAt: string, email: string, createdAt: string, avatarUrl?: string | null } | null, role?: { __typename?: 'Role', id: string, name: string, type: RoleTypeEnum, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'Permissions', id: string, scope: PermissionScope }> } } | null } | null };

export type GetInviteByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetInviteByTokenQuery = { __typename?: 'Query', getInviteByToken?: { __typename?: 'PublicUserInvite', id: string, email: string, acceptedAt?: string | null, status: UserInviteStatus, canUsePassword: boolean, account: { __typename?: 'AccountPublic', name: string } } | null };

export type PublicCardStageFormLinkQueryVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type PublicCardStageFormLinkQuery = { __typename?: 'Query', publicCardStageFormLink?: { __typename?: 'PublicCardStageFormLink', isRequiredAuthenticated: boolean, isEditable: boolean, customMessage?: string | null, expiredAt?: string | null, answeredAt?: string | null, answeredBy?: string | null, email?: string | null, publicLink: string, stage: { __typename?: 'Stage', id: string, name: string, pipe: { __typename?: 'Pipe', id: string, name: string, color?: string | null, account: { __typename?: 'Account', id: string, name: string } }, form?: { __typename?: 'Form', name: string } | null }, fields: Array<{ __typename: 'AttachmentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CheckboxesField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'CurrencyField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DatabaseField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DateField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DocumentField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'DropdownField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'EmailField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'HourField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'MultipleChoiceField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'NumericField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ParagraphField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'PhoneField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'ShortAnswerField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null } | { __typename: 'SignatureField', id?: string | null, type: LegacyFieldTypeEnum, title: string, helpText?: string | null, schema?: { [key: string]: any } | null, required: boolean, answeredAt?: string | null, position: number, value?: string | null, customValidation?: string | null, customValidationMessage?: string | null, conditions?: Array<{ __typename?: 'FieldCondition', question?: { [key: string]: any } | any[] | null, operator: string, value: string }> | null, options: Array<{ __typename?: 'FieldOption', id: string, position: string, value: string }>, database?: { __typename?: 'FieldDatabase', databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, database: { __typename?: 'FieldDatabaseInfo', id: string, name: string }, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> } | null };

export type PublicCardTaskFormLinkQueryVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type PublicCardTaskFormLinkQuery = { __typename?: 'Query', publicCardTaskFormLink?: { __typename?: 'PublicCardTaskFormLink', isRequiredAuthenticated: boolean, isEditable: boolean, customMessage?: string | null, expiredAt?: string | null, answeredAt?: string | null, answeredBy?: string | null, email?: string | null, publicLink: string, task?: { __typename?: 'CardTask', title: string } | null, card?: { __typename?: 'Card', name: string } | null, pipe: { __typename?: 'Pipe', id: string, name: string, color?: string | null }, account: { __typename?: 'AccountPublic', name: string }, fields: Array<{ __typename?: 'CardTaskField', createdAt: string, id: string, key: string, name: string, type: string, orientationMessage?: string | null, position?: number | null, required: boolean, updatedAt: string, value?: string | null, values: Array<string>, options: Array<{ __typename?: 'CardTaskFieldOption', label: string }>, conditions: Array<{ __typename?: 'CardTaskFieldCondition', operator: FieldConditionOperator, expectedValueString?: string | null, dependsOnField: { __typename?: 'CardTaskField', key: string } }> }> } | null };

export type PublicSendCardStageAuthLinkMutationVariables = Exact<{
  hash: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type PublicSendCardStageAuthLinkMutation = { __typename?: 'Mutation', publicSendCardStageAuthLink: boolean };

export type PublicSendCardTaskAuthLinkMutationVariables = Exact<{
  hash: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type PublicSendCardTaskAuthLinkMutation = { __typename?: 'Mutation', publicSendCardTaskAuthLink: boolean };

export type PublicAnswerCardStageFormMutationVariables = Exact<{
  hash: Scalars['String']['input'];
  fields: Array<UpdateFieldInput> | UpdateFieldInput;
}>;


export type PublicAnswerCardStageFormMutation = { __typename?: 'Mutation', publicAnswerCardStageForm: boolean };

export type PublicAnswerCardTaskFormMutationVariables = Exact<{
  hash: Scalars['String']['input'];
  fields: Array<AnswerCardTaskFieldInput> | AnswerCardTaskFieldInput;
}>;


export type PublicAnswerCardTaskFormMutation = { __typename?: 'Mutation', publicAnswerCardTaskForm: boolean };

export type AccountFeatureBySlugQueryVariables = Exact<{
  slug: FeatureSlug;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AccountFeatureBySlugQuery = { __typename?: 'Query', accountFeatureBySlug: { __typename?: 'AccountFeature', id: string, contractedPriceCents: number, licenseLimit?: number | null, feature: { __typename?: 'Feature', slug: FeatureSlug, entityType?: FeatureEntityType | null }, usageRecords: { __typename?: 'PaginatedAccountFeatureUsageRecord', totalCount: number } } };

export type ValidateInviteEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ValidateInviteEmailQuery = { __typename?: 'Query', validateInviteEmail: { __typename?: 'EmailValidation', isValid: boolean, reason?: string | null } };

export type CreateUserInviteMutationVariables = Exact<{
  input: CreateUserInviteInput;
}>;


export type CreateUserInviteMutation = { __typename?: 'Mutation', createUserInvite: { __typename?: 'UserInvite', id: string, token?: string | null } };

export type SetUserRoleMutationVariables = Exact<{
  roleType: RoleTypeEnum;
  userId: Scalars['String']['input'];
  roleEntityContext?: InputMaybe<RoleEntityContextInput>;
}>;


export type SetUserRoleMutation = { __typename?: 'Mutation', setUserRole: { __typename?: 'Role', id: string } };

export type UpdateUserLicenseTypeMutationVariables = Exact<{
  input: UpdateUserLicenseInput;
}>;


export type UpdateUserLicenseTypeMutation = { __typename?: 'Mutation', updateUserLicenseType: { __typename?: 'User', id: string } };

export type GetUserInvitesQueryVariables = Exact<{
  where?: InputMaybe<UserInviteWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<GetUsersInvitesSortOrderInput>;
}>;


export type GetUserInvitesQuery = { __typename?: 'Query', getUserInvites: { __typename?: 'PaginatedUserInvite', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'UserInvite', id: string, email: string, status: UserInviteStatus, acceptedAt?: string | null, createdAt: string, createdBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }> } };

export type ResendUserInviteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ResendUserInviteMutation = { __typename?: 'Mutation', resendUserInvite: { __typename?: 'UserInvite', id: string, token?: string | null } };

export type UserStatisticsForLicenseQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserStatisticsForLicenseQuery = { __typename?: 'Query', userStatisticsForLicense: { __typename?: 'UserStatisticsForLicense', id: string, pipesWhereRoleIsAboveReader: number, userGlobalRole?: RoleTypeEnum | null } };

export type AuthenticatedUserFieldsFragment = { __typename?: 'AuthenticatedUser', token?: string | null, realtimeToken?: string | null, mfaToken?: string | null, accountId?: string | null, user?: { __typename?: 'User', id: string, name: string, updatedAt: string, email: string, createdAt: string, avatarUrl?: string | null } | null, role?: { __typename?: 'Role', id: string, name: string, type: RoleTypeEnum, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'Permissions', id: string, scope: PermissionScope }> } } | null };

export type SignInMutationVariables = Exact<{
  input: SignInInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn: { __typename?: 'AuthenticatedUser', token?: string | null, realtimeToken?: string | null, mfaToken?: string | null, accountId?: string | null, user?: { __typename?: 'User', id: string, name: string, updatedAt: string, email: string, createdAt: string, avatarUrl?: string | null } | null, role?: { __typename?: 'Role', id: string, name: string, type: RoleTypeEnum, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'Permissions', id: string, scope: PermissionScope }> } } | null } };

export type SignInWithSecondStepMutationVariables = Exact<{
  input: SignInWithSecondStepInput;
}>;


export type SignInWithSecondStepMutation = { __typename?: 'Mutation', signInWithSecondStep: { __typename?: 'AuthenticatedUser', token?: string | null, realtimeToken?: string | null, mfaToken?: string | null, accountId?: string | null, user?: { __typename?: 'User', id: string, name: string, updatedAt: string, email: string, createdAt: string, avatarUrl?: string | null } | null, role?: { __typename?: 'Role', id: string, name: string, type: RoleTypeEnum, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'Permissions', id: string, scope: PermissionScope }> } } | null } };

export type RefreshAuthRoleQueryVariables = Exact<{
  roleEntityContext?: InputMaybe<RoleEntityContextInput>;
}>;


export type RefreshAuthRoleQuery = { __typename?: 'Query', refreshAuthRole?: { __typename?: 'RefreshAuthRole', globalRole?: { __typename?: 'Role', id: string, name: string, type: RoleTypeEnum, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'Permissions', id: string, scope: PermissionScope }> } } | null, pipeRole?: { __typename?: 'Role', id: string, name: string, type: RoleTypeEnum, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'Permissions', id: string, scope: PermissionScope }> } } | null, databaseRole?: { __typename?: 'Role', id: string, name: string, type: RoleTypeEnum, permissions: { __typename?: 'RolePermissionsConnection', nodes: Array<{ __typename?: 'Permissions', id: string, scope: PermissionScope }> } } | null } | null };

export type TemplatesDeadlinesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  pipeId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type TemplatesDeadlinesQuery = { __typename?: 'Query', templatesDeadlines: { __typename?: 'TemplatePaginated', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'StageTemplate' } | { __typename?: 'TemplateDeadline', id: string, name: string, description?: string | null, type: string, considerHoliday: boolean, deadlineMinutes: number, deadlineDisplayUnit: TemplateDeadlineTimeDisplayUnitEnum, deadlineRiskMinutes: number, deadlineRiskDisplayUnit: TemplateDeadlineTimeDisplayUnitEnum, hasOfficeHours: boolean } | { __typename?: 'TemplateReview' } | { __typename?: 'TemplateTask' }> } };

export type TemplateTaskQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type TemplateTaskQuery = { __typename?: 'Query', templateTask: { __typename?: 'StageTemplate', fields?: Array<{ __typename?: 'TemplateField', id: string, key: string, name: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, type: FieldTypeEnum, options?: Array<{ __typename?: 'TemplateFieldOption', label: string }> | null, conditions: Array<{ __typename?: 'TemplateFieldCondition', operator: FieldConditionOperator, expectedValueString?: string | null, dependsOnField?: { __typename?: 'TemplateField', key: string } | null }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> | null } | { __typename?: 'TemplateDeadline', fields?: Array<{ __typename?: 'TemplateField', id: string, key: string, name: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, type: FieldTypeEnum, options?: Array<{ __typename?: 'TemplateFieldOption', label: string }> | null, conditions: Array<{ __typename?: 'TemplateFieldCondition', operator: FieldConditionOperator, expectedValueString?: string | null, dependsOnField?: { __typename?: 'TemplateField', key: string } | null }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> | null } | { __typename?: 'TemplateReview', fields?: Array<{ __typename?: 'TemplateField', id: string, key: string, name: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, type: FieldTypeEnum, options?: Array<{ __typename?: 'TemplateFieldOption', label: string }> | null, conditions: Array<{ __typename?: 'TemplateFieldCondition', operator: FieldConditionOperator, expectedValueString?: string | null, dependsOnField?: { __typename?: 'TemplateField', key: string } | null }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> | null } | { __typename?: 'TemplateTask', description?: string | null, id: string, name: string, pipeId: string, priority?: string | null, status?: TemplateTaskStatusEnum | null, timeToDueUnit?: TemplateTaskTimeToDueUnitEnum | null, timeToDueValue?: number | null, timeToDueFlags?: number | null, type: string, requiredCommentToFinish: boolean, assignees?: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null }> | null, labels: Array<{ __typename?: 'Label', id: string, name: string, color: string }>, fields?: Array<{ __typename?: 'TemplateField', id: string, key: string, name: string, orientationMessage?: string | null, helpText?: string | null, schema?: { [key: string]: any } | null, position?: number | null, required: boolean, type: FieldTypeEnum, options?: Array<{ __typename?: 'TemplateFieldOption', label: string }> | null, conditions: Array<{ __typename?: 'TemplateFieldCondition', operator: FieldConditionOperator, expectedValueString?: string | null, dependsOnField?: { __typename?: 'TemplateField', key: string } | null }>, database?: { __typename?: 'SharedFieldDatabase', id: string, databaseId: string, databaseName: string, databaseSchemaVersionId: string, databaseLabelField: string, databaseDisplayFields: Array<string>, databaseSearchableFields: Array<string>, databaseFilters?: Array<{ __typename?: 'SharedFieldDatabaseFilter', field: string, operator: DatabaseRecordFilterByFieldOperators, value: string }> | null } | null }> | null } };

export type AttachTemplatesToStageMutationVariables = Exact<{
  stageId: Scalars['ID']['input'];
  templatesIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AttachTemplatesToStageMutation = { __typename?: 'Mutation', attachTemplatesToStage: Array<{ __typename?: 'StageTemplate', id: string, name: string, description?: string | null, type: string } | { __typename?: 'TemplateDeadline', id: string, name: string, description?: string | null, type: string } | { __typename?: 'TemplateReview', type: string, reviewType: ReviewTypeEnum, responseType: TemplateReviewResponseTypeEnum, pipeId: string, orientationMessage?: string | null, name: string, minimumReviewsRequired?: number | null, id: string, description?: string | null, reviewers: Array<{ __typename?: 'TemplateReviewReviewer', position: number, user: { __typename?: 'User', email: string, avatarUrl?: string | null, id: string, name: string } }> } | { __typename?: 'TemplateTask', priority?: string | null, timeToDueUnit?: TemplateTaskTimeToDueUnitEnum | null, timeToDueValue?: number | null, timeToDueFlags?: number | null, id: string, name: string, description?: string | null, type: string, labels: Array<{ __typename?: 'Label', id: string, name: string, color: string }> }> };

export type DetachTemplatesFromStageMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
}>;


export type DetachTemplatesFromStageMutation = { __typename?: 'Mutation', detachTemplateFromStage: boolean };

export type AllTemplatesIdsByStageIdQueryVariables = Exact<{
  stageId: Scalars['ID']['input'];
}>;


export type AllTemplatesIdsByStageIdQuery = { __typename?: 'Query', allTemplatesIdsByStage: Array<string> };

export type MenuCardMoveQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type MenuCardMoveQuery = { __typename?: 'Query', card: { __typename?: 'Card', id: string, pipe: { __typename?: 'Pipe', id: string }, currentStage: { __typename?: 'Stage', id: string, name: string, index: number, cardsCanBeMovedToStages: Array<{ __typename?: 'Stage', id: string }> } } };

export type CardsCommentsQueryVariables = Exact<{
  filters: PaginatedCardCommentFilters;
  attachmentsFilters: PaginatedCardAttachmentFilters;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<PaginatedCardCommentSortOrderInput>;
}>;


export type CardsCommentsQuery = { __typename?: 'Query', cardsComments: { __typename?: 'PaginatedCardComment', nodes: Array<{ __typename?: 'CardComment', id: string, createdAt: string, updatedAt: string, content: string, user: { __typename?: 'User', avatarUrl?: string | null, name: string, createdAt: string, updatedAt: string, id: string }, attachments: { __typename?: 'PaginatedCardAttachment', nodes: Array<{ __typename?: 'CardAttachment', createdAt: string, extension: string, id: string, name: string, path: string, preSignedUrl?: string | null, entityType?: string | null }> } }> } };

export type CreateCardCommentMutationVariables = Exact<{
  input: CreateCardCommentInput;
}>;


export type CreateCardCommentMutation = { __typename?: 'Mutation', createCardComment: { __typename?: 'CardComment', id: string } };

export type CreateCardCommentAttachmentMutationVariables = Exact<{
  input: CreateCardCommentAttachmentInput;
}>;


export type CreateCardCommentAttachmentMutation = { __typename?: 'Mutation', createCardCommentAttachment: { __typename?: 'CardComment', id: string } };

export type UpdateCardCommentMutationVariables = Exact<{
  input: UpdateCardCommentInput;
}>;


export type UpdateCardCommentMutation = { __typename?: 'Mutation', updateCardComment: { __typename?: 'CardComment', id: string } };

export type RemoveCardCommentAttachmentMutationVariables = Exact<{
  input: RemoveCardCommentAttachmentInput;
}>;


export type RemoveCardCommentAttachmentMutation = { __typename?: 'Mutation', removeCardCommentAttachment: { __typename?: 'CardComment', id: string } };

export const SharedFieldDatabaseFilterFieldsFragmentDoc = gql`
    fragment SharedFieldDatabaseFilterFields on SharedFieldDatabaseFilter {
  field
  operator
  value
}
    `;
export const SharedFieldDatabaseFieldsFragmentDoc = gql`
    fragment SharedFieldDatabaseFields on SharedFieldDatabase {
  id
  databaseId
  databaseName
  databaseSchemaVersionId
  databaseLabelField
  databaseDisplayFields
  databaseSearchableFields
  databaseFilters {
    ...SharedFieldDatabaseFilterFields
  }
}
    `;
export const FormQuestionFieldsFragmentDoc = gql`
    fragment FormQuestionFields on FormQuestion {
  id
  type
  options {
    id
    description
    position
    score
    value
  }
  position
  required
  title
  helpText
  schema
  customValidation
  customValidationMessage
  database {
    id
    database {
      id
      name
    }
    databaseSchemaVersionId
    databaseLabelField
    databaseDisplayFields
    databaseSearchableFields
    databaseFilters {
      ...SharedFieldDatabaseFilterFields
    }
  }
  conditions {
    operator
    question {
      id
      title
    }
    value
  }
}
    `;
export const FieldsFragmentDoc = gql`
    fragment Fields on FieldType {
  id
  type
  title
  helpText
  schema
  required
  answeredAt
  position
  value
  customValidation
  customValidationMessage
  conditions {
    question
    operator
    value
  }
  options {
    id
    position
    value
  }
  database {
    database {
      id
      name
    }
    databaseLabelField
    databaseDisplayFields
    databaseSearchableFields
    databaseFilters {
      ...SharedFieldDatabaseFilterFields
    }
  }
  __typename
}
    `;
export const CardOverviewFragmentDoc = gql`
    fragment CardOverview on Card {
  id
  name
  archived
  locked
  index
  age
  createdAt
  updatedAt
  description
  createdBy {
    id
    name
    email
    avatarUrl
  }
  initialFormResponsible
  fields {
    ...Fields
  }
  assignees: lastAssignees {
    id
    name
    email
    avatarUrl
  }
  currentStage {
    id
    name
    color
  }
}
    `;
export const CardFieldsOnStageColumnLightFragmentDoc = gql`
    fragment CardFieldsOnStageColumnLight on Card {
  age
  id
  name
  index
  pipe {
    id
  }
  currentStage {
    id
    cardsCanBeMovedToStages {
      id
    }
  }
}
    `;
export const CardFieldsOnStageColumnHeavyFragmentDoc = gql`
    fragment CardFieldsOnStageColumnHeavy on Card {
  locked
  lastAssignees {
    id
    name
    email
    avatarUrl
  }
  labels {
    label {
      id
      name
      color
    }
  }
  pipeDeadline {
    deadlineAt
    deadlineStartedAt
    deadlineRiskAt
    deadlineRaw
    status
  }
  currentStageDeadline {
    deadlineAt
    deadlineStartedAt
    deadlineRiskAt
    deadlineRaw
    status
  }
  automations {
    status
  }
  lastReview {
    status
    type
    reviewers {
      id
      status
      user {
        avatarUrl
        name
        email
        id
      }
    }
  }
  commentCount {
    total
    hasNew
  }
}
    `;
export const CardFieldsOnStageColumnFragmentDoc = gql`
    fragment CardFieldsOnStageColumn on Card {
  ...CardFieldsOnStageColumnLight
  ...CardFieldsOnStageColumnHeavy
}
    `;
export const CardFieldsOnTableLightFragmentDoc = gql`
    fragment CardFieldsOnTableLight on Card {
  id
  name
  archived
  currentStage {
    id
    name
    color
    minimumReviewsRequired
  }
  createdAt
  createdBy {
    id
    name
    email
    avatarUrl
  }
  updatedAt
  age
  arrivedAt
  duration
}
    `;
export const CardFieldsOnTableHeavyFragmentDoc = gql`
    fragment CardFieldsOnTableHeavy on Card {
  locked
  lastAssignees {
    id
    name
    email
    avatarUrl
  }
  labels {
    label {
      id
      name
      color
    }
  }
  pipeDeadline {
    deadlineStartedAt
    deadlineRiskAt
    deadlineRaw
    deadlineAt
    status
  }
  currentStageDeadline {
    deadlineStartedAt
    deadlineRiskAt
    deadlineRaw
    deadlineAt
    status
  }
  automations {
    status
  }
  lastReview {
    status
    type
    reviewers {
      id
      status
      user {
        avatarUrl
        name
        email
        id
      }
    }
  }
  fields {
    title
    value
    type
    options {
      id
      value
    }
  }
}
    `;
export const CardFieldsOnTableFragmentDoc = gql`
    fragment CardFieldsOnTable on Card {
  ...CardFieldsOnTableLight
  ...CardFieldsOnTableHeavy
}
    `;
export const MySpaceCardFieldsFragmentDoc = gql`
    fragment MySpaceCardFields on Card {
  age
  id
  name
  archived
  createdAt
  updatedAt
  initialFormResponsible
  createdBy {
    id
    email
    avatarUrl
    name
  }
  currentStage {
    id
    color
    name
    done
  }
  pipe {
    id
    name
    color
  }
  lastAssignees {
    id
    email
    name
    avatarUrl
  }
  labels {
    label {
      id
      name
      color
    }
    createdAt
  }
  pipeDeadline {
    deadlineStartedAt
    deadlineRiskAt
    deadlineRaw
    deadlineAt
    status
    cardFinishedAt
  }
  currentStageDeadline {
    deadlineStartedAt
    deadlineRiskAt
    deadlineRaw
    deadlineAt
    status
  }
  arrivedAt
  leftAt
  duration
  automations {
    status
  }
  commentCount {
    total
    hasNew
  }
}
    `;
export const DatabaseLogFieldsFragmentDoc = gql`
    fragment DatabaseLogFields on DatabaseLog {
  id
  record {
    id
  }
  details
  createdBy {
    id
    name
    avatarUrl
  }
  action
  reason
  createdAt
}
    `;
export const DatabaseMemberFieldsFragmentDoc = gql`
    fragment DatabaseMemberFields on DatabaseMember {
  user {
    avatarUrl
    createdAt
    email
    id
    name
    updatedAt
    roleType
  }
  createdAt
  roleType
  id
}
    `;
export const FieldDatabaseRecordFieldsFragmentDoc = gql`
    fragment FieldDatabaseRecordFields on DatabaseRecordRestricted {
  data
  id
  createdAt
  updatedAt
}
    `;
export const ReviewsFieldsFragmentDoc = gql`
    fragment ReviewsFields on Review {
  id
  accountId
  completedReviewsCount
  createdAt
  lastReviewedAt
  orientationMessage
  requestedById
  status
  updatedAt
  type
  card {
    id
    name
    archived
    pipe {
      id
      name
    }
  }
  stage {
    id
    name
    color
    minimumReviewsRequired
  }
  requestedBy {
    id
    name
    avatarUrl
  }
  reviewers {
    id
    status
    reviewedAt
    user {
      id
      avatarUrl
      email
      name
    }
  }
}
    `;
export const GetAndCreateCardTaskSharedFieldsFragmentDoc = gql`
    fragment GetAndCreateCardTaskSharedFields on CardTask {
  id
  priority
  status
  title
  dueAt
  description
  requiredCommentToFinish
  createdBy {
    id
    name
  }
  completedAt
  createdAt
  updatedAt
  card {
    readonly
    locked
    isAuthenticatedUserAssignee
    pipe {
      cardTaskReopenBehavior
    }
    lastReview {
      status
    }
  }
  assignees {
    user {
      id
    }
  }
  parentTask {
    id
    title
    description
    status
    fields {
      createdAt
      id
      key
      name
      type
      orientationMessage
      helpText
      schema
      position
      required
      updatedAt
      value
      values
      options {
        label
      }
      conditions {
        dependsOnField {
          key
        }
        operator
        expectedValueString
      }
      database {
        id
        databaseId
        databaseName
        databaseLabelField
        databaseDisplayFields
        databaseSearchableFields
        databaseFilters {
          ...SharedFieldDatabaseFilterFields
        }
      }
    }
  }
  stage {
    name
    color
  }
}
    `;
export const CardRelationBaseFieldsFragmentDoc = gql`
    fragment CardRelationBaseFields on CardRelationBase {
  id
  name
  parentCard {
    ... on CardRelationBase {
      id
    }
    __typename
  }
  childrenCards(filters: $filters) {
    nodes {
      ... on CardRelationBase {
        id
      }
      __typename
    }
  }
  __typename
}
    `;
export const AutomationFragmentFragmentDoc = gql`
    fragment AutomationFragment on Automation {
  direction: runDirection
  name
  id
  event
  description
  active
  runOnlyOnce
  archived
  isSync
  stage {
    id
    name
  }
  action {
    __typename
    id
    type
    ... on AutomationActionAssigneePersonData {
      typeAssignee
      assignees {
        name
        avatarUrl
        createdAt
        email
        id
      }
    }
    ... on AutomationActionCreateCardData {
      pipe {
        id
        name
      }
      stage {
        id
        name
      }
      description
      name
    }
    ... on AutomationActionHttpRequestData {
      url
      method
      headers
      expected_status_code
      authentication {
        authentication_type
        authentication_token
        authentication_api_key
        authentication_api_value
      }
      body
    }
    ... on RelatedCardAction {
      attributes
      fieldsMapping
      targetId
      targetStageId
    }
    ... on AutomationActionCreateTaskData {
      id
      type
      templates {
        priority
        title
        description
        dueAt {
          unit
          amount
        }
      }
    }
  }
}
    `;
export const TemplateFragmentFragmentDoc = gql`
    fragment TemplateFragment on Template {
  id
  name
  description
  type
  ... on TemplateTask {
    priority
    timeToDueUnit
    timeToDueValue
    timeToDueFlags
    labels {
      id
      name
      color
    }
  }
  ... on TemplateReview {
    type
    reviewType
    responseType
    pipeId
    orientationMessage
    name
    minimumReviewsRequired
    id
    description
    reviewers {
      user {
        email
        avatarUrl
        id
        name
      }
      position
    }
  }
}
    `;
export const OwnReviewsFieldsFragmentDoc = gql`
    fragment OwnReviewsFields on Review {
  id
  accountId
  completedReviewsCount
  createdAt
  lastReviewedAt
  orientationMessage
  requestedById
  status
  updatedAt
  type
  card {
    id
    name
    archived
    pipe {
      id
      name
    }
  }
  stage {
    id
    name
    color
    minimumReviewsRequired
  }
  requestedBy {
    id
    name
    avatarUrl
  }
  reviewers {
    id
    status
    reviewedAt
    user {
      id
      avatarUrl
      email
      name
    }
  }
}
    `;
export const MySpaceCardTaskFragmentDoc = gql`
    fragment MySpaceCardTask on CardTask {
  id
  priority
  status
  title
  dueAt
  description
  createdBy {
    id
    name
  }
  completedAt
  createdAt
  stage {
    name
    color
  }
  card {
    id
    name
    currentStage {
      name
      color
    }
    pipe {
      id
      name
    }
  }
  assignees {
    user {
      id
      name
      avatarUrl
    }
  }
  labels {
    id
    name
    color
  }
}
    `;
export const NotificationPreferencesFragmentFragmentDoc = gql`
    fragment NotificationPreferencesFragment on NotificationPreference {
  id
  cardArchivedOrUnarchived
  cardAssignedToMe
  cardAssigneeTaskCompletedOrReopened
  cardAssigneeTaskCreated
  cardDeadlineNearOrExpired
  cardMentionedInComment
  cardMoved
  cardMyApprovalRequired
  pipeAddedToMe
  cardCreated
  security
  solicitation
  cardApprovalStatusChanged
  dailyMySpaceSummary
}
    `;
export const AuthenticatedUserFieldsFragmentDoc = gql`
    fragment AuthenticatedUserFields on AuthenticatedUser {
  token
  realtimeToken
  mfaToken
  accountId
  user {
    id
    name
    updatedAt
    email
    createdAt
    avatarUrl
  }
  role {
    id
    name
    type
    permissions {
      nodes {
        id
        scope
      }
    }
  }
}
    `;
export const UsersDocument = gql`
    query Users($where: GetUsersWhereInput, $take: Int, $skip: Int, $sortOrder: GetUsersSortOrderInput) {
  getUsers(where: $where, take: $take, skip: $skip, sortOrder: $sortOrder) {
    nodes {
      id
      name
      email
      avatarUrl
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
    document = UsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardTaskByIdDocument = gql`
    query CardTaskById($id: String!) {
  cardTask(id: $id) {
    id
    card {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardTaskByIdGQL extends Apollo.Query<CardTaskByIdQuery, CardTaskByIdQueryVariables> {
    document = CardTaskByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePublicCardTaskFormLinkDocument = gql`
    mutation CreatePublicCardTaskFormLink($input: CreatePublicCardTaskFormLinkInput!) {
  createPublicCardTaskFormLink(input: $input) {
    publicLink
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePublicCardTaskFormLinkGQL extends Apollo.Mutation<CreatePublicCardTaskFormLinkMutation, CreatePublicCardTaskFormLinkMutationVariables> {
    document = CreatePublicCardTaskFormLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardTaskSharedLinkByTaskIdDocument = gql`
    query CardTaskSharedLinkByTaskId($taskId: String!) {
  cardTaskSharedLinkByTaskId(taskId: $taskId) {
    id
    publicLink
    invitedEmails
    isEditable
    isRequiredAuthenticated
    expiredAt
    customMessage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardTaskSharedLinkByTaskIdGQL extends Apollo.Query<CardTaskSharedLinkByTaskIdQuery, CardTaskSharedLinkByTaskIdQueryVariables> {
    document = CardTaskSharedLinkByTaskIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRolesDocument = gql`
    query GetRoles($skip: Int, $take: Int, $where: RolesWhereInput) {
  roles(skip: $skip, take: $take, where: $where) {
    nodes {
      id
      name
      createdAt
      description
      isLocked
      type
      updatedAt
      pipe {
        id
        name
      }
      users {
        nodes {
          id
          name
          email
          avatarUrl
        }
      }
      permissions {
        nodes {
          id
          title
          scope
          localizations
          description
          createdAt
        }
      }
      updatedBy {
        id
        name
        avatarUrl
        email
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRolesGQL extends Apollo.Query<GetRolesQuery, GetRolesQueryVariables> {
    document = GetRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRoleDocument = gql`
    query GetRole($roleId: String!, $usersSkip: Int, $usersTake: Int) {
  role(id: $roleId) {
    id
    name
    createdAt
    description
    isLocked
    type
    updatedAt
    pipe {
      id
      name
    }
    users(skip: $usersSkip, take: $usersTake) {
      nodes {
        id
        name
        email
        avatarUrl
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
    permissions {
      nodes {
        id
        title
        scope
        localizations
        description
        createdAt
      }
    }
    updatedBy {
      id
      name
      avatarUrl
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoleGQL extends Apollo.Query<GetRoleQuery, GetRoleQueryVariables> {
    document = GetRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssignableUsersForRoleDocument = gql`
    query GetAssignableUsersForRole($roleId: String!) {
  getAssignableUsersForRole(roleId: $roleId) {
    email
    id
    name
    updatedAt
    createdAt
    avatarUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssignableUsersForRoleGQL extends Apollo.Query<GetAssignableUsersForRoleQuery, GetAssignableUsersForRoleQueryVariables> {
    document = GetAssignableUsersForRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPermissionsDocument = gql`
    query GetPermissions($where: PermissionsWhere, $scope: PermissionScope) {
  permissions(where: $where) {
    id
    title
    description
    createdAt
    localizations
    scope
    children(scope: $scope) {
      id
      title
      description
      createdAt
      localizations
      scope
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPermissionsGQL extends Apollo.Query<GetPermissionsQuery, GetPermissionsQueryVariables> {
    document = GetPermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetBulkUserRoleDocument = gql`
    mutation SetBulkUserRole($userIds: [String!]!, $roleEntityContext: RoleEntityContextInput, $roleType: RoleTypeEnum!) {
  setBulkUserRole(
    userIds: $userIds
    roleEntityContext: $roleEntityContext
    roleType: $roleType
  ) {
    id
    users {
      nodes {
        id
        name
        email
        avatarUrl
        createdAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetBulkUserRoleGQL extends Apollo.Mutation<SetBulkUserRoleMutation, SetBulkUserRoleMutationVariables> {
    document = SetBulkUserRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetRolePermissionsDocument = gql`
    mutation SetRolePermissions($permissionIds: [String!]!, $roleId: String!) {
  setRolePermissions(permissionIds: $permissionIds, roleId: $roleId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetRolePermissionsGQL extends Apollo.Mutation<SetRolePermissionsMutation, SetRolePermissionsMutationVariables> {
    document = SetRolePermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserRoleDocument = gql`
    mutation RemoveUserRole($userId: String!, $roleEntityContext: RoleEntityContextInput) {
  removeUserRole(userId: $userId, roleEntityContext: $roleEntityContext)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserRoleGQL extends Apollo.Mutation<RemoveUserRoleMutation, RemoveUserRoleMutationVariables> {
    document = RemoveUserRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormQuestionsDocument = gql`
    query FormQuestions($id: ID!) {
  form(id: $id) {
    id
    name
    type
    questions {
      ...FormQuestionFields
    }
    questionsCount
  }
}
    ${FormQuestionFieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FormQuestionsGQL extends Apollo.Query<FormQuestionsQuery, FormQuestionsQueryVariables> {
    document = FormQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FieldDatabaseSchemaDocument = gql`
    query FieldDatabaseSchema($fieldId: ID!, $fieldSource: FieldSourceType!) {
  fieldDatabaseSchemaFields(fieldId: $fieldId, fieldSource: $fieldSource) {
    name
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FieldDatabaseSchemaGQL extends Apollo.Query<FieldDatabaseSchemaQuery, FieldDatabaseSchemaQueryVariables> {
    document = FieldDatabaseSchemaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FieldDatabaseRecordsDocument = gql`
    query FieldDatabaseRecords($fieldId: ID!, $fieldSource: FieldSourceType!, $currentAnswers: [CurrentAnswerInput!], $search: String, $skip: Int, $take: Int) {
  fieldDatabaseRecords(
    fieldId: $fieldId
    fieldSource: $fieldSource
    currentAnswers: $currentAnswers
    search: $search
    skip: $skip
    take: $take
  ) {
    edges {
      node {
        ...FieldDatabaseRecordFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${FieldDatabaseRecordFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FieldDatabaseRecordsGQL extends Apollo.Query<FieldDatabaseRecordsQuery, FieldDatabaseRecordsQueryVariables> {
    document = FieldDatabaseRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeDocument = gql`
    query Me($params: MeParamsInput) {
  me(params: $params) {
    roleInPipe(params: $params)
    name
    email
    avatarUrl
    loginProvider
    passwordChangedAt
    mfa {
      enabled
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    document = MeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPresignedProfileDocument = gql`
    query GetPresignedProfile($input: GetPresignedProfileInput!) {
  getPresignedProfile(input: $input) {
    fields
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPresignedProfileGQL extends Apollo.Query<GetPresignedProfileQuery, GetPresignedProfileQueryVariables> {
    document = GetPresignedProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    name
    avatarUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProfileGQL extends Apollo.Mutation<UpdateProfileMutation, UpdateProfileMutationVariables> {
    document = UpdateProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input) {
    passwordChangedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePasswordGQL extends Apollo.Mutation<UpdatePasswordMutation, UpdatePasswordMutationVariables> {
    document = UpdatePasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestMfaSecretDocument = gql`
    mutation RequestMfaSecret($input: RequestMfaSecretInput!) {
  requestMfaSecret(input: $input) {
    session
    secret
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestMfaSecretGQL extends Apollo.Mutation<RequestMfaSecretMutation, RequestMfaSecretMutationVariables> {
    document = RequestMfaSecretDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableMfaDocument = gql`
    mutation EnableMfa($input: EnableMfaInput!) {
  enableMfa(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableMfaGQL extends Apollo.Mutation<EnableMfaMutation, EnableMfaMutationVariables> {
    document = EnableMfaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableMfaDocument = gql`
    mutation DisableMfa($input: DisableMfaInput!) {
  disableMfa(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableMfaGQL extends Apollo.Mutation<DisableMfaMutation, DisableMfaMutationVariables> {
    document = DisableMfaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PipesQueryDocument = gql`
    query PipesQuery($filters: PaginatedPipeFilters, $skip: Int, $sorts: PaginatedPipeSortOrderInput, $take: Int) {
  pipes(filters: $filters, skip: $skip, sorts: $sorts, take: $take) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        id
        icon
        name
        color
        description
        deletedAt
        updatedAt
        cardsCount
        private
        startForm {
          id
        }
        members {
          id
          roleType
          user {
            avatarUrl
            email
            id
            name
          }
        }
        stages {
          id
          name
          index
          color
          done
        }
        permissions {
          canDeleteCard
          canDownloadFiles
          canEditAnyCard
          canEditPipe
          canShowAllCards
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PipesQueryGQL extends Apollo.Query<PipesQueryQuery, PipesQueryQueryVariables> {
    document = PipesQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePipeMutationDocument = gql`
    mutation createPipeMutation($createPipeInput: CreatePipeInput!) {
  createPipe(createPipeInput: $createPipeInput) {
    id
    name
    stages {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePipeMutationGQL extends Apollo.Mutation<CreatePipeMutationMutation, CreatePipeMutationMutationVariables> {
    document = CreatePipeMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePipeMutationDocument = gql`
    mutation updatePipeMutation($pipeId: ID!, $updatePipeInput: UpdatePipeInput!) {
  updatePipe(updatePipeInput: $updatePipeInput, pipeId: $pipeId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePipeMutationGQL extends Apollo.Mutation<UpdatePipeMutationMutation, UpdatePipeMutationMutationVariables> {
    document = UpdatePipeMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePipeMutationDocument = gql`
    mutation deletePipeMutation($id: ID!) {
  deletePipe(pipeId: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePipeMutationGQL extends Apollo.Mutation<DeletePipeMutationMutation, DeletePipeMutationMutationVariables> {
    document = DeletePipeMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UndeletePipeMutationDocument = gql`
    mutation undeletePipeMutation($id: ID!) {
  undeletePipe(pipeId: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UndeletePipeMutationGQL extends Apollo.Mutation<UndeletePipeMutationMutation, UndeletePipeMutationMutationVariables> {
    document = UndeletePipeMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRecoveryCodesDocument = gql`
    query GetRecoveryCodes($input: GetRecoveryCodesInput!) {
  recoveryCodes(input: $input) {
    code
    used
    usedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRecoveryCodesGQL extends Apollo.Query<GetRecoveryCodesQuery, GetRecoveryCodesQueryVariables> {
    document = GetRecoveryCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RecreateRecoveryCodesDocument = gql`
    mutation RecreateRecoveryCodes($input: RecreateRecoveryCodesInput!) {
  recreateRecoveryCodes(input: $input) {
    code
    used
    usedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RecreateRecoveryCodesGQL extends Apollo.Mutation<RecreateRecoveryCodesMutation, RecreateRecoveryCodesMutationVariables> {
    document = RecreateRecoveryCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StageDocument = gql`
    query Stage($id: ID!) {
  stage(id: $id) {
    canReceiveCardDirectlyFromDraft
    color
    createdAt
    deletedAt
    description
    done
    id
    index
    name
    confirmMoveCard
    canMoveCardWithoutTasksBeingDone
    canReceiveCardWithoutTasksBeingDone
    moveCardToNextStageWhenDone
    reviewRequired
    reviewType
    minimumReviewsRequired
    pipe {
      id
      startForm {
        id
      }
    }
    form {
      id
      name
    }
    cardsCanBeMovedToStages {
      id
      name
    }
    deadline {
      id
      name
      description
      archived
      deadlineMinutes
      deadlineDisplayUnit
      deadlineRiskMinutes
      deadlineRiskDisplayUnit
      considerHoliday
      hasOfficeHours
      officeHours
      createdAt
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StageGQL extends Apollo.Query<StageQuery, StageQueryVariables> {
    document = StageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveCardToStageDocument = gql`
    mutation MoveCardToStage($moveCardToStageArgs: MoveCardToStageInput!) {
  moveCardToStage(moveCardToStageArgs: $moveCardToStageArgs) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveCardToStageGQL extends Apollo.Mutation<MoveCardToStageMutation, MoveCardToStageMutationVariables> {
    document = MoveCardToStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStageDocument = gql`
    mutation DeleteStage($id: ID!) {
  deleteStage(stageId: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStageGQL extends Apollo.Mutation<DeleteStageMutation, DeleteStageMutationVariables> {
    document = DeleteStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UndeleteStageDocument = gql`
    mutation UndeleteStage($id: ID!) {
  undeleteStage(stageId: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UndeleteStageGQL extends Apollo.Mutation<UndeleteStageMutation, UndeleteStageMutationVariables> {
    document = UndeleteStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveStageDocument = gql`
    mutation MoveStage($direction: StageMoveDirection!, $moveStageId: ID!) {
  moveStage(direction: $direction, id: $moveStageId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveStageGQL extends Apollo.Mutation<MoveStageMutation, MoveStageMutationVariables> {
    document = MoveStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStageDocument = gql`
    mutation UpdateStage($updateStageInput: UpdateStageInput!) {
  updateStage(updateStageInput: $updateStageInput) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStageGQL extends Apollo.Mutation<UpdateStageMutation, UpdateStageMutationVariables> {
    document = UpdateStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStageDocument = gql`
    mutation CreateStage($createStageInput: CreateStageInput!) {
  createStage(createStageInput: $createStageInput) {
    canReceiveCardDirectlyFromDraft
    color
    createdAt
    description
    done
    id
    index
    name
    pipe {
      id
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStageGQL extends Apollo.Mutation<CreateStageMutation, CreateStageMutationVariables> {
    document = CreateStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserNotificationsDocument = gql`
    query UserNotifications {
  userNotifications {
    count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserNotificationsGQL extends Apollo.Query<UserNotificationsQuery, UserNotificationsQueryVariables> {
    document = UserNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersDocument = gql`
    query GetUsers($where: GetUsersWhereInput, $take: Int, $skip: Int, $sortOrder: GetUsersSortOrderInput) {
  getUsers(where: $where, take: $take, skip: $skip, sortOrder: $sortOrder) {
    nodes {
      id
      name
      roleType
      licenseType
      createdAt
      updatedAt
      lastSeenAt
      emailValidatedAt
      email
      avatarUrl
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersGQL extends Apollo.Query<GetUsersQuery, GetUsersQueryVariables> {
    document = GetUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersByIdsDocument = gql`
    query GetUsersByIds($ids: [ID!]!) {
  getUsersByIds(ids: $ids) {
    id
    name
    roleType
    createdAt
    updatedAt
    lastSeenAt
    emailValidatedAt
    email
    avatarUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersByIdsGQL extends Apollo.Query<GetUsersByIdsQuery, GetUsersByIdsQueryVariables> {
    document = GetUsersByIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicPreSignedGetDocument = gql`
    query PublicPreSignedGet($input: GetPublicPreSignedGetInput!) {
  publicPresignedGet(input: $input) {
    viewUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicPreSignedGetGQL extends Apollo.Query<PublicPreSignedGetQuery, PublicPreSignedGetQueryVariables> {
    document = PublicPreSignedGetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBulkActionDocument = gql`
    mutation CreateBulkAction($input: CreateBulkActionInput!) {
  createBulkAction(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBulkActionGQL extends Apollo.Mutation<CreateBulkActionMutation, CreateBulkActionMutationVariables> {
    document = CreateBulkActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBulkActionPresignedPostDocument = gql`
    query GetBulkActionPresignedPost($input: GetBulkActionPresignedPostInput!) {
  getBulkActionPresignedPost(input: $input) {
    url
    fields
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBulkActionPresignedPostGQL extends Apollo.Query<GetBulkActionPresignedPostQuery, GetBulkActionPresignedPostQueryVariables> {
    document = GetBulkActionPresignedPostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelBulkActionDocument = gql`
    mutation CancelBulkAction($input: CancelBulkActionInput!) {
  cancelBulkAction(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelBulkActionGQL extends Apollo.Mutation<CancelBulkActionMutation, CancelBulkActionMutationVariables> {
    document = CancelBulkActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DispatchBulkActionDocument = gql`
    mutation DispatchBulkAction($input: DispatchBulkActionInput!) {
  dispatchBulkAction(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DispatchBulkActionGQL extends Apollo.Mutation<DispatchBulkActionMutation, DispatchBulkActionMutationVariables> {
    document = DispatchBulkActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllPermissionsDocument = gql`
    query GetAllPermissions($where: PermissionsWhere) {
  permissions(where: $where) {
    id
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllPermissionsGQL extends Apollo.Query<GetAllPermissionsQuery, GetAllPermissionsQueryVariables> {
    document = GetAllPermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActiveFeatureFlagsDocument = gql`
    query GetActiveFeatureFlags {
  activeFeatureFlags {
    slug
    description
    active
    metadata
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActiveFeatureFlagsGQL extends Apollo.Query<GetActiveFeatureFlagsQuery, GetActiveFeatureFlagsQueryVariables> {
    document = GetActiveFeatureFlagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPipeQueryForRelatedCardDocument = gql`
    query GetPipeQueryForRelatedCard($filters: PaginatedPipeFilters, $skip: Int, $take: Int) {
  pipes(filters: $filters, skip: $skip, take: $take) {
    totalCount
    edges {
      node {
        id
        name
        startForm {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPipeQueryForRelatedCardGQL extends Apollo.Query<GetPipeQueryForRelatedCardQuery, GetPipeQueryForRelatedCardQueryVariables> {
    document = GetPipeQueryForRelatedCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AutomationExecutionsV2Document = gql`
    query AutomationExecutionsV2($filters: PaginatedAutomationV2ExecutionFilters, $skip: Int, $sorts: PaginatedAutomationV2ExecutionSortOrderInput, $take: Int) {
  automationExecutionsV2(
    filters: $filters
    skip: $skip
    sorts: $sorts
    take: $take
  ) {
    pageInfo {
      startCursor
      hasPreviousPage
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        completedAt
        context
        resultData
        startedAt
        automation {
          id
          name
          pipe {
            id
            name
          }
          trigger {
            type
            conditions {
              nodes {
                id
                property
                operator
                value
                values
                isInterpolated
              }
            }
          }
        }
        id
        status
        triggerData
        triggerType
        actions {
          nodes {
            actionIdInVersion
            completedAt
            error
            id
            inputData
            outputData
            startedAt
            status
            triggerIdInVersion
            typeInVersion
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AutomationExecutionsV2GQL extends Apollo.Query<AutomationExecutionsV2Query, AutomationExecutionsV2QueryVariables> {
    document = AutomationExecutionsV2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AutomationsActionMetadataDocument = gql`
    query AutomationsActionMetadata {
  automationV2ActionMetadata {
    label
    description
    properties
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AutomationsActionMetadataGQL extends Apollo.Query<AutomationsActionMetadataQuery, AutomationsActionMetadataQueryVariables> {
    document = AutomationsActionMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AutomationsContextMetadataDocument = gql`
    query AutomationsContextMetadata {
  automationV2ContextMetadata {
    path
    type
    category
    label
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AutomationsContextMetadataGQL extends Apollo.Query<AutomationsContextMetadataQuery, AutomationsContextMetadataQueryVariables> {
    document = AutomationsContextMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AutomationsTriggerMetadataDocument = gql`
    query AutomationsTriggerMetadata {
  automationV2TriggerMetadata {
    type
    properties
    label
    description
    conditions {
      type
      property
      label
      description
      allowedValues {
        value
        label
        description
      }
      allowedOperators
      autocompleteEntity
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AutomationsTriggerMetadataGQL extends Apollo.Query<AutomationsTriggerMetadataQuery, AutomationsTriggerMetadataQueryVariables> {
    document = AutomationsTriggerMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AutomationV2AutocompleteOptionsDocument = gql`
    query AutomationV2AutocompleteOptions($filters: PaginatedAutomationV2AutocompleteOptionFilters!, $take: Int, $skip: Int) {
  automationV2AutocompleteOptions(filters: $filters, take: $take, skip: $skip) {
    nodes {
      description
      label
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AutomationV2AutocompleteOptionsGQL extends Apollo.Query<AutomationV2AutocompleteOptionsQuery, AutomationV2AutocompleteOptionsQueryVariables> {
    document = AutomationV2AutocompleteOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAutomationV2Document = gql`
    mutation CreateAutomationV2($input: CreateAutomationV2Input!) {
  createAutomationV2(input: $input) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAutomationV2GQL extends Apollo.Mutation<CreateAutomationV2Mutation, CreateAutomationV2MutationVariables> {
    document = CreateAutomationV2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAutomationV2Document = gql`
    mutation UpdateAutomationV2($updateAutomationV2Id: ID!, $input: UpdateAutomationV2Input!) {
  updateAutomationV2(id: $updateAutomationV2Id, input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAutomationV2GQL extends Apollo.Mutation<UpdateAutomationV2Mutation, UpdateAutomationV2MutationVariables> {
    document = UpdateAutomationV2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAutomationV2RoleDocument = gql`
    mutation CreateAutomationV2Role($input: CreateAutomationRoleInput!) {
  createAutomationV2Role(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAutomationV2RoleGQL extends Apollo.Mutation<CreateAutomationV2RoleMutation, CreateAutomationV2RoleMutationVariables> {
    document = CreateAutomationV2RoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BatchUpsertAutomationV2DataDocument = gql`
    mutation BatchUpsertAutomationV2Data($input: BatchUpsertAutomationV2Input!) {
  batchUpsertAutomationV2Data(input: $input) {
    id
    description
    status
    updatedAt
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BatchUpsertAutomationV2DataGQL extends Apollo.Mutation<BatchUpsertAutomationV2DataMutation, BatchUpsertAutomationV2DataMutationVariables> {
    document = BatchUpsertAutomationV2DataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AutomationsV2Document = gql`
    query AutomationsV2($filters: PaginatedAutomationV2Filters, $sorts: PaginatedAutomationV2SortOrderInput, $skip: Int, $take: Int) {
  automationsV2(filters: $filters, sorts: $sorts, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      startCursor
      hasPreviousPage
      hasNextPage
      endCursor
    }
    edges {
      node {
        actions {
          nodes {
            type
          }
        }
        name
        description
        trigger {
          type
          conditions {
            nodes {
              property
            }
          }
        }
        updatedAt
        createdAt
        status
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AutomationsV2GQL extends Apollo.Query<AutomationsV2Query, AutomationsV2QueryVariables> {
    document = AutomationsV2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AutomationV2Document = gql`
    query AutomationV2($automationV2Id: ID!) {
  automationV2(id: $automationV2Id) {
    id
    name
    description
    trigger {
      id
      properties
      type
      conditions {
        nodes {
          values
          value
          property
          id
          operator
          isInterpolated
        }
      }
    }
    actions {
      nodes {
        type
        properties
        position
        id
      }
    }
    roles {
      nodes {
        id
        createdAt
        pipe {
          id
          name
        }
        database {
          id
          name
        }
        role {
          id
          name
          type
        }
      }
      totalCount
      pageInfo {
        hasNextPage
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AutomationV2GQL extends Apollo.Query<AutomationV2Query, AutomationV2QueryVariables> {
    document = AutomationV2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAutomationV2StatusDocument = gql`
    mutation UpdateAutomationV2Status($updateAutomationV2StatusId: ID!, $input: UpdateAutomationV2StatusInput!) {
  updateAutomationV2Status(id: $updateAutomationV2StatusId, input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAutomationV2StatusGQL extends Apollo.Mutation<UpdateAutomationV2StatusMutation, UpdateAutomationV2StatusMutationVariables> {
    document = UpdateAutomationV2StatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardTaskDocument = gql`
    query GetCardTask($id: String!) {
  cardTask(id: $id) {
    ...GetAndCreateCardTaskSharedFields
    stage {
      name
      color
    }
    resolutionComment {
      id
      createdBy {
        id
        name
      }
      createdAt
      comment
      type
    }
    labels {
      id
      name
      color
    }
  }
}
    ${GetAndCreateCardTaskSharedFieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardTaskGQL extends Apollo.Query<GetCardTaskQuery, GetCardTaskQueryVariables> {
    document = GetCardTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardTaskAssigneesDocument = gql`
    query CardTaskAssignees($cardTaskId: ID!) {
  cardTaskAssignees(cardTaskId: $cardTaskId) {
    nodes {
      createdAt
      id
      user {
        id
        name
        email
        avatarUrl
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardTaskAssigneesGQL extends Apollo.Query<CardTaskAssigneesQuery, CardTaskAssigneesQueryVariables> {
    document = CardTaskAssigneesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCardTaskDocument = gql`
    mutation CreateCardTask($input: CreateCardTaskInputDto!) {
  createCardTask(input: $input) {
    ...GetAndCreateCardTaskSharedFields
  }
}
    ${GetAndCreateCardTaskSharedFieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCardTaskGQL extends Apollo.Mutation<CreateCardTaskMutation, CreateCardTaskMutationVariables> {
    document = CreateCardTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCardTaskStatusDocument = gql`
    mutation UpdateCardTaskStatus($input: UpdateCardTaskStatusInputDto!) {
  updateCardTaskStatus(input: $input) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCardTaskStatusGQL extends Apollo.Mutation<UpdateCardTaskStatusMutation, UpdateCardTaskStatusMutationVariables> {
    document = UpdateCardTaskStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCardTaskDocument = gql`
    mutation UpdateCardTask($input: UpdateCardTaskInputDto!) {
  updateCardTask(input: $input) {
    id
    dueAt
    description
    priority
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCardTaskGQL extends Apollo.Mutation<UpdateCardTaskMutation, UpdateCardTaskMutationVariables> {
    document = UpdateCardTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCardTaskDocument = gql`
    mutation DeleteCardTask($id: String!) {
  deleteCardTask(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCardTaskGQL extends Apollo.Mutation<DeleteCardTaskMutation, DeleteCardTaskMutationVariables> {
    document = DeleteCardTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnswerCardTaskFieldDocument = gql`
    mutation AnswerCardTaskField($input: AnswerCardTaskFieldInput!) {
  answerCardTaskField(input: $input) {
    id
    name
    value
    values
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnswerCardTaskFieldGQL extends Apollo.Mutation<AnswerCardTaskFieldMutation, AnswerCardTaskFieldMutationVariables> {
    document = AnswerCardTaskFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCardTaskLabelDocument = gql`
    mutation AddCardTaskLabel($input: AddOrRemoveCardTaskLabelDto!) {
  addCardTaskLabel(input: $input) {
    id
    name
    color
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCardTaskLabelGQL extends Apollo.Mutation<AddCardTaskLabelMutation, AddCardTaskLabelMutationVariables> {
    document = AddCardTaskLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCardTaskLabelDocument = gql`
    mutation RemoveCardTaskLabel($input: AddOrRemoveCardTaskLabelDto!) {
  removeCardTaskLabel(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCardTaskLabelGQL extends Apollo.Mutation<RemoveCardTaskLabelMutation, RemoveCardTaskLabelMutationVariables> {
    document = RemoveCardTaskLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCardTaskAssigneesDocument = gql`
    mutation AddCardTaskAssignees($input: AddCardTaskAssigneesInput!) {
  addCardTaskAssignees(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCardTaskAssigneesGQL extends Apollo.Mutation<AddCardTaskAssigneesMutation, AddCardTaskAssigneesMutationVariables> {
    document = AddCardTaskAssigneesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCardTaskAssigneeDocument = gql`
    mutation RemoveCardTaskAssignee($input: AddCardTaskAssigneeInput!) {
  removeCardTaskAssignee(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCardTaskAssigneeGQL extends Apollo.Mutation<RemoveCardTaskAssigneeMutation, RemoveCardTaskAssigneeMutationVariables> {
    document = RemoveCardTaskAssigneeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDatabaseMemberDocument = gql`
    mutation CreateDatabaseMember($input: CreateDatabaseMemberInput!) {
  createDatabaseMember(input: $input) {
    ...DatabaseMemberFields
  }
}
    ${DatabaseMemberFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDatabaseMemberGQL extends Apollo.Mutation<CreateDatabaseMemberMutation, CreateDatabaseMemberMutationVariables> {
    document = CreateDatabaseMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDatabaseMemberDocument = gql`
    mutation UpdateDatabaseMember($input: UpdateDatabaseMemberInput!) {
  updateDatabaseMember(input: $input) {
    ...DatabaseMemberFields
  }
}
    ${DatabaseMemberFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDatabaseMemberGQL extends Apollo.Mutation<UpdateDatabaseMemberMutation, UpdateDatabaseMemberMutationVariables> {
    document = UpdateDatabaseMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDatabaseMemberDocument = gql`
    mutation DeleteDatabaseMember($input: DeleteDatabaseMemberInput!) {
  deleteDatabaseMember(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDatabaseMemberGQL extends Apollo.Mutation<DeleteDatabaseMemberMutation, DeleteDatabaseMemberMutationVariables> {
    document = DeleteDatabaseMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DatabaseMembersDocument = gql`
    query DatabaseMembers($filters: PaginatedDatabaseMemberFilters!, $skip: Int, $take: Int) {
  databaseMembers(filters: $filters, skip: $skip, take: $take) {
    pageInfo {
      hasNextPage
    }
    totalCount
    nodes {
      ...DatabaseMemberFields
    }
  }
}
    ${DatabaseMemberFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DatabaseMembersGQL extends Apollo.Query<DatabaseMembersQuery, DatabaseMembersQueryVariables> {
    document = DatabaseMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DatabaseLogsDocument = gql`
    query DatabaseLogs($skip: Int, $sorts: PaginatedDatabaseLogSortOrderInput, $take: Int, $filters: PaginatedDatabaseLogFilters!) {
  databaseLogs(filters: $filters, sorts: $sorts, take: $take, skip: $skip) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ...DatabaseLogFields
    }
  }
}
    ${DatabaseLogFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DatabaseLogsGQL extends Apollo.Query<DatabaseLogsQuery, DatabaseLogsQueryVariables> {
    document = DatabaseLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDatabaseRecordDocument = gql`
    mutation CreateDatabaseRecord($input: CreateRecordInput!) {
  createDatabaseRecord(input: $input) {
    data
    id
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDatabaseRecordGQL extends Apollo.Mutation<CreateDatabaseRecordMutation, CreateDatabaseRecordMutationVariables> {
    document = CreateDatabaseRecordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DatabaseRecordsDocument = gql`
    query DatabaseRecords($filters: PaginatedDatabaseRecordFilters!, $skip: Int, $sorts: PaginatedDatabaseRecordSortOrderInput, $take: Int) {
  databaseRecords(filters: $filters, skip: $skip, sorts: $sorts, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        data
        id
        createdAt
        updatedAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DatabaseRecordsGQL extends Apollo.Query<DatabaseRecordsQuery, DatabaseRecordsQueryVariables> {
    document = DatabaseRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DatabaseRecordDocument = gql`
    query DatabaseRecord($id: ID!) {
  databaseRecord(id: $id) {
    data
    id
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DatabaseRecordGQL extends Apollo.Query<DatabaseRecordQuery, DatabaseRecordQueryVariables> {
    document = DatabaseRecordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDatabaseRecordDocument = gql`
    mutation UpdateDatabaseRecord($input: UpdateRecordInput!) {
  updateDatabaseRecord(input: $input) {
    data
    id
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDatabaseRecordGQL extends Apollo.Mutation<UpdateDatabaseRecordMutation, UpdateDatabaseRecordMutationVariables> {
    document = UpdateDatabaseRecordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDatabaseRecordDocument = gql`
    mutation DeleteDatabaseRecord($id: ID!) {
  deleteDatabaseRecord(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDatabaseRecordGQL extends Apollo.Mutation<DeleteDatabaseRecordMutation, DeleteDatabaseRecordMutationVariables> {
    document = DeleteDatabaseRecordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DatabaseSchemaDocument = gql`
    query DatabaseSchema($databaseId: ID!) {
  databaseSchema(databaseId: $databaseId) {
    fields {
      id
      name
      displayName
      position
      primaryKey
      required
      type
      unique
      description
    }
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DatabaseSchemaGQL extends Apollo.Query<DatabaseSchemaQuery, DatabaseSchemaQueryVariables> {
    document = DatabaseSchemaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveDatabaseSchemaFieldDocument = gql`
    mutation RemoveDatabaseSchemaField($input: RemoveDatabaseSchemaFieldInput!) {
  removeDatabaseSchemaField(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDatabaseSchemaFieldGQL extends Apollo.Mutation<RemoveDatabaseSchemaFieldMutation, RemoveDatabaseSchemaFieldMutationVariables> {
    document = RemoveDatabaseSchemaFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddDatabaseSchemaFieldDocument = gql`
    mutation AddDatabaseSchemaField($input: AddDatabaseSchemaFieldInput!) {
  addDatabaseSchemaField(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddDatabaseSchemaFieldGQL extends Apollo.Mutation<AddDatabaseSchemaFieldMutation, AddDatabaseSchemaFieldMutationVariables> {
    document = AddDatabaseSchemaFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDatabaseSchemaFieldDocument = gql`
    mutation UpdateDatabaseSchemaField($input: UpdateDatabaseSchemaFieldInput!) {
  updateDatabaseSchemaField(input: $input) {
    id
    name
    position
    primaryKey
    required
    type
    unique
    displayName
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDatabaseSchemaFieldGQL extends Apollo.Mutation<UpdateDatabaseSchemaFieldMutation, UpdateDatabaseSchemaFieldMutationVariables> {
    document = UpdateDatabaseSchemaFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReorderDatabaseSchemaFieldsDocument = gql`
    mutation ReorderDatabaseSchemaFields($input: ReorderDatabaseSchemaFieldsInput!) {
  reorderDatabaseSchemaFields(input: $input) {
    id
    name
    displayName
    position
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReorderDatabaseSchemaFieldsGQL extends Apollo.Mutation<ReorderDatabaseSchemaFieldsMutation, ReorderDatabaseSchemaFieldsMutationVariables> {
    document = ReorderDatabaseSchemaFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDatabaseDocument = gql`
    mutation CreateDatabase($input: CreateDatabaseInput!) {
  createDatabase(input: $input) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDatabaseGQL extends Apollo.Mutation<CreateDatabaseMutation, CreateDatabaseMutationVariables> {
    document = CreateDatabaseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DatabasesDocument = gql`
    query Databases($filters: PaginatedDatabasesFilters, $skip: Int, $sorts: PaginatedDatabasesSortOrderInput, $take: Int) {
  databases(filters: $filters, skip: $skip, sorts: $sorts, take: $take) {
    edges {
      node {
        description
        id
        name
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DatabasesGQL extends Apollo.Query<DatabasesQuery, DatabasesQueryVariables> {
    document = DatabasesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DatabaseDocument = gql`
    query Database($databaseId: ID!) {
  database(id: $databaseId) {
    id
    name
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DatabaseGQL extends Apollo.Query<DatabaseQuery, DatabaseQueryVariables> {
    document = DatabaseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDatabaseDocument = gql`
    mutation UpdateDatabase($input: UpdateDatabaseInput!) {
  updateDatabase(input: $input) {
    id
    name
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDatabaseGQL extends Apollo.Mutation<UpdateDatabaseMutation, UpdateDatabaseMutationVariables> {
    document = UpdateDatabaseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportDatabasesDocument = gql`
    mutation ExportDatabases($input: ExportDatabaseInput!) {
  exportDatabases(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportDatabasesGQL extends Apollo.Mutation<ExportDatabasesMutation, ExportDatabasesMutationVariables> {
    document = ExportDatabasesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SolicitationDetailDocument = gql`
    query SolicitationDetail($id: String!, $skip: Int, $take: Int) {
  solicitationDetail(id: $id) {
    id
    name
    initialFormResponsible
    canAnswerInitialForm
    locked
    pipe {
      id
      name
      attachmentsTabVisibility
      startForm {
        id
        name
        type
      }
      allowCommentsWhenCardLocked
    }
    currentStage {
      id
      name
      color
      description
      done
    }
    fields {
      ...Fields
    }
    createdBy {
      id
      name
      email
      avatarUrl
    }
    createdAt
    pipeDeadline {
      deadlineAt
      deadlineStartedAt
      deadlineRiskAt
      deadlineRaw
      status
      cardFinishedAt
    }
    logs(skip: $skip, take: $take) {
      edges {
        node {
          id
          action: eventType
          actor {
            id
            name
            email
            avatarUrl
          }
          actorName
          newValue
          oldValue
          details
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
    lastReview {
      lastReviewedAt
      status
      type
      reviewers {
        id
        status
        user {
          id
          name
          avatarUrl
        }
      }
    }
    readonly
    assignees {
      id
      email
      name
      avatarUrl
    }
    commentCount {
      total
      hasNew
    }
  }
}
    ${FieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SolicitationDetailGQL extends Apollo.Query<SolicitationDetailQuery, SolicitationDetailQueryVariables> {
    document = SolicitationDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMoreSolicitationLogsDocument = gql`
    query GetMoreSolicitationLogs($id: String!, $skip: Int, $take: Int) {
  solicitationDetail(id: $id) {
    id
    logs(skip: $skip, take: $take) {
      edges {
        node {
          id
          action: eventType
          actor {
            id
            name
            email
            avatarUrl
          }
          actorName
          newValue
          oldValue
          details
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMoreSolicitationLogsGQL extends Apollo.Query<GetMoreSolicitationLogsQuery, GetMoreSolicitationLogsQueryVariables> {
    document = GetMoreSolicitationLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReturnCardToAssigneeDocument = gql`
    mutation ReturnCardToAssignee($cardId: ID!) {
  returnCardToAssignee(cardId: $cardId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReturnCardToAssigneeGQL extends Apollo.Mutation<ReturnCardToAssigneeMutation, ReturnCardToAssigneeMutationVariables> {
    document = ReturnCardToAssigneeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    id
    name
    description
    slug
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTeamGQL extends Apollo.Mutation<CreateTeamMutation, CreateTeamMutationVariables> {
    document = CreateTeamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    id
    name
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTeamGQL extends Apollo.Mutation<UpdateTeamMutation, UpdateTeamMutationVariables> {
    document = UpdateTeamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveTeamDocument = gql`
    mutation RemoveTeam($id: ID!) {
  removeTeam(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveTeamGQL extends Apollo.Mutation<RemoveTeamMutation, RemoveTeamMutationVariables> {
    document = RemoveTeamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTeamMemberDocument = gql`
    mutation CreateTeamMember($input: CreateTeamMemberInput!) {
  createTeamMember(input: $input) {
    id
    role
    user {
      id
      name
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTeamMemberGQL extends Apollo.Mutation<CreateTeamMemberMutation, CreateTeamMemberMutationVariables> {
    document = CreateTeamMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveTeamMemberDocument = gql`
    mutation RemoveTeamMember($input: RemoveTeamMemberInput!) {
  removeTeamMember(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveTeamMemberGQL extends Apollo.Mutation<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables> {
    document = RemoveTeamMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTeamsDocument = gql`
    query GetTeams($filters: PaginatedTeamFilters, $skip: Int, $take: Int, $sorts: PaginatedTeamSortOrderInput) {
  teams(filters: $filters, skip: $skip, take: $take, sorts: $sorts) {
    nodes {
      id
      name
      description
      slug
      user {
        email
      }
      createdAt
      updatedAt
      members(filters: {teamId: ""}) {
        totalCount
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTeamsGQL extends Apollo.Query<GetTeamsQuery, GetTeamsQueryVariables> {
    document = GetTeamsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTeamDocument = gql`
    query GetTeam($id: ID!) {
  team(id: $id) {
    id
    name
    description
    slug
    user {
      email
    }
    createdAt
    updatedAt
    members(filters: {teamId: $id}) {
      nodes {
        id
        role
        user {
          id
          name
          email
          avatarUrl
        }
        createdAt
      }
      totalCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTeamGQL extends Apollo.Query<GetTeamQuery, GetTeamQueryVariables> {
    document = GetTeamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTeamMembersDocument = gql`
    query GetTeamMembers($filters: PaginatedTeamMemberFilters!, $skip: Int, $take: Int, $sorts: PaginatedTeamMemberSortOrderInput) {
  teamMembers(filters: $filters, skip: $skip, take: $take, sorts: $sorts) {
    nodes {
      id
      role
      user {
        id
        name
        email
        avatarUrl
      }
      createdAt
    }
    pageInfo {
      hasNextPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTeamMembersGQL extends Apollo.Query<GetTeamMembersQuery, GetTeamMembersQueryVariables> {
    document = GetTeamMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardDetailDocument = gql`
    query GetCardDetail($cardId: ID!) {
  card(id: $cardId) {
    age
    archived
    createdAt
    updatedAt
    description
    id
    name
    readonly
    locked
    isForceLocked
    canAnswerInitialForm
    initialFormResponsible
    isSolicitation
    pipe {
      id
      name
      cardSolicitationFormUpdateBehavior
      allowCommentsWhenCardLocked
    }
    createdBy {
      id
      name
      email
    }
    labels {
      label {
        id
        name
        color
      }
    }
    lastAssignees {
      id
      name
      email
      avatarUrl
    }
    currentStage {
      id
      name
      index
      color
      reviewRequired
      reviewType
      minimumReviewsRequired
      form {
        id
      }
    }
    pipeDeadline {
      deadlineAt
      deadlineStartedAt
      deadlineRiskAt
      deadlineRaw
      status
    }
    currentStageDeadline {
      deadlineAt
      deadlineStartedAt
      deadlineRiskAt
      deadlineRaw
      status
    }
    taskCount {
      pending
    }
    commentCount {
      total
      hasNew
    }
    lastReview {
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardDetailGQL extends Apollo.Query<GetCardDetailQuery, GetCardDetailQueryVariables> {
    document = GetCardDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStartFormFieldsDocument = gql`
    query GetStartFormFields($cardId: ID!) {
  card(id: $cardId) {
    fields {
      ...Fields
    }
  }
}
    ${FieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStartFormFieldsGQL extends Apollo.Query<GetStartFormFieldsQuery, GetStartFormFieldsQueryVariables> {
    document = GetStartFormFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentStageFieldsDocument = gql`
    query GetCurrentStageFields($cardId: ID!) {
  currentStageFields(cardId: $cardId) {
    nodes {
      ...Fields
    }
  }
}
    ${FieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentStageFieldsGQL extends Apollo.Query<GetCurrentStageFieldsQuery, GetCurrentStageFieldsQueryVariables> {
    document = GetCurrentStageFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPreSignedDocument = gql`
    query GetPreSigned($key: String!) {
  getPreSigned(key: $key)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPreSignedGQL extends Apollo.Query<GetPreSignedQuery, GetPreSignedQueryVariables> {
    document = GetPreSignedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardHistoryInStageDocument = gql`
    query GetCardHistoryInStage($cardId: ID!, $stageId: ID!) {
  cardHistoryInStage(cardId: $cardId, stageId: $stageId) {
    fields {
      ...Fields
    }
  }
}
    ${FieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardHistoryInStageGQL extends Apollo.Query<GetCardHistoryInStageQuery, GetCardHistoryInStageQueryVariables> {
    document = GetCardHistoryInStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFieldDocument = gql`
    mutation UpdateField($input: UpdateFieldInput!) {
  updateField(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFieldGQL extends Apollo.Mutation<UpdateFieldMutation, UpdateFieldMutationVariables> {
    document = UpdateFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeCardNameDocument = gql`
    mutation ChangeCardName($input: ChangeCardNameInput!) {
  changeCardName(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeCardNameGQL extends Apollo.Mutation<ChangeCardNameMutation, ChangeCardNameMutationVariables> {
    document = ChangeCardNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCardDescriptionDocument = gql`
    mutation UpdateCardDescription($input: UpdateCardDescriptionInput!) {
  updateCardDescription(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCardDescriptionGQL extends Apollo.Mutation<UpdateCardDescriptionMutation, UpdateCardDescriptionMutationVariables> {
    document = UpdateCardDescriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveCardDocument = gql`
    mutation UnarchiveCard($id: ID!) {
  unarchiveCard(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveCardGQL extends Apollo.Mutation<UnarchiveCardMutation, UnarchiveCardMutationVariables> {
    document = UnarchiveCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveCardDocument = gql`
    mutation ArchiveCard($id: ID!) {
  archiveCard(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveCardGQL extends Apollo.Mutation<ArchiveCardMutation, ArchiveCardMutationVariables> {
    document = ArchiveCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddLabelCardDocument = gql`
    mutation AddLabelCard($input: CreateCardLabelInput!) {
  createCardLabel(input: $input) {
    label {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddLabelCardGQL extends Apollo.Mutation<AddLabelCardMutation, AddLabelCardMutationVariables> {
    document = AddLabelCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveLabelCardDocument = gql`
    mutation RemoveLabelCard($input: RemoveCardLabelInput!) {
  removeCardLabel(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveLabelCardGQL extends Apollo.Mutation<RemoveLabelCardMutation, RemoveLabelCardMutationVariables> {
    document = RemoveLabelCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LockCardDocument = gql`
    mutation LockCard($id: ID!) {
  lockCard(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LockCardGQL extends Apollo.Mutation<LockCardMutation, LockCardMutationVariables> {
    document = LockCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnlockCardDocument = gql`
    mutation UnlockCard($id: ID!) {
  unlockCard(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnlockCardGQL extends Apollo.Mutation<UnlockCardMutation, UnlockCardMutationVariables> {
    document = UnlockCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReturnCardToSolicitorDocument = gql`
    mutation ReturnCardToSolicitor($cardId: ID!) {
  returnCardToSolicitor(cardId: $cardId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReturnCardToSolicitorGQL extends Apollo.Mutation<ReturnCardToSolicitorMutation, ReturnCardToSolicitorMutationVariables> {
    document = ReturnCardToSolicitorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelCardToSolicitorDocument = gql`
    mutation CancelCardToSolicitor($cardId: ID!) {
  cancelCardToSolicitor(cardId: $cardId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelCardToSolicitorGQL extends Apollo.Mutation<CancelCardToSolicitorMutation, CancelCardToSolicitorMutationVariables> {
    document = CancelCardToSolicitorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkCardCommentsAsReadDocument = gql`
    mutation MarkCardCommentsAsRead($cardId: ID!) {
  markCardCommentsAsRead(cardId: $cardId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkCardCommentsAsReadGQL extends Apollo.Mutation<MarkCardCommentsAsReadMutation, MarkCardCommentsAsReadMutationVariables> {
    document = MarkCardCommentsAsReadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPreSignedPostDocument = gql`
    query GetPreSignedPost($input: CreatePreSignedPostInput!) {
  getPreSignedPost(input: $input) {
    fields
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPreSignedPostGQL extends Apollo.Query<GetPreSignedPostQuery, GetPreSignedPostQueryVariables> {
    document = GetPreSignedPostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCardAttachmentDocument = gql`
    mutation CreateCardAttachment($input: CreateCardAttachmentInput!) {
  createCardAttachment(input: $input) {
    id
    extension
    name
    path
    preSignedUrl
    size
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCardAttachmentGQL extends Apollo.Mutation<CreateCardAttachmentMutation, CreateCardAttachmentMutationVariables> {
    document = CreateCardAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardAttachmentsDocument = gql`
    query GetCardAttachments($filters: PaginatedCardAttachmentFilters!, $skip: Int, $take: Int, $sorts: PaginatedCardAttachmentSortOrderInput) {
  cardsAttachments(filters: $filters, skip: $skip, take: $take, sorts: $sorts) {
    nodes {
      createdAt
      extension
      id
      name
      path
      preSignedUrl
      entityType
      stage {
        id
        name
      }
      task {
        id
        name
      }
      reviewer {
        id
        name
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardAttachmentsGQL extends Apollo.Query<GetCardAttachmentsQuery, GetCardAttachmentsQueryVariables> {
    document = GetCardAttachmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCardAttachmentDocument = gql`
    mutation DeleteCardAttachment($id: ID!) {
  deleteCardAttachment(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCardAttachmentGQL extends Apollo.Mutation<DeleteCardAttachmentMutation, DeleteCardAttachmentMutationVariables> {
    document = DeleteCardAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSolicitationAttachmentsDocument = gql`
    query GetSolicitationAttachments($filters: PaginatedCardAttachmentFilters!, $skip: Int, $take: Int, $sorts: PaginatedCardAttachmentSortOrderInput) {
  solicitationAttachments(
    filters: $filters
    skip: $skip
    take: $take
    sorts: $sorts
  ) {
    nodes {
      createdAt
      extension
      id
      name
      path
      preSignedUrl
      entityType
      stage {
        id
        name
      }
      task {
        id
        name
      }
      reviewer {
        id
        name
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSolicitationAttachmentsGQL extends Apollo.Query<GetSolicitationAttachmentsQuery, GetSolicitationAttachmentsQueryVariables> {
    document = GetSolicitationAttachmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportCardAttachmentsMutationDocument = gql`
    mutation ExportCardAttachmentsMutation($cardId: ID!) {
  exportCardAttachments(cardId: $cardId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportCardAttachmentsMutationGQL extends Apollo.Mutation<ExportCardAttachmentsMutationMutation, ExportCardAttachmentsMutationMutationVariables> {
    document = ExportCardAttachmentsMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAssigneesDocument = gql`
    query SearchAssignees($pipeId: ID!, $searchTerm: String) {
  pipesMembers(pipeId: $pipeId, searchTerm: $searchTerm) {
    nodes {
      user {
        avatarUrl
        email
        id
        name
      }
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAssigneesGQL extends Apollo.Query<SearchAssigneesQuery, SearchAssigneesQueryVariables> {
    document = SearchAssigneesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCardAssigneeDocument = gql`
    mutation AddCardAssignee($input: CreateCardAssigneeInput!) {
  createCardAssignee(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCardAssigneeGQL extends Apollo.Mutation<AddCardAssigneeMutation, AddCardAssigneeMutationVariables> {
    document = AddCardAssigneeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardsAssigneesDocument = gql`
    query CardsAssignees($filters: PaginatedCardAssigneeFilters!, $take: Int) {
  cardsAssignees(filters: $filters, take: $take) {
    nodes {
      user {
        id
        name
        email
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardsAssigneesGQL extends Apollo.Query<CardsAssigneesQuery, CardsAssigneesQueryVariables> {
    document = CardsAssigneesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCardAssigneeDocument = gql`
    mutation RemoveCardAssignee($input: RemoveCardAssigneeInput!) {
  removeCardAssignee(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCardAssigneeGQL extends Apollo.Mutation<RemoveCardAssigneeMutation, RemoveCardAssigneeMutationVariables> {
    document = RemoveCardAssigneeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardHistoryDocument = gql`
    query GetCardHistory($cardId: ID!) {
  cardHistory(cardId: $cardId) {
    stage {
      nodes {
        cardArrivedAt
        cardId
        color
        index
        duration
        hasFields
        id
        isCurrentPhase
        name
        stageId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardHistoryGQL extends Apollo.Query<GetCardHistoryQuery, GetCardHistoryQueryVariables> {
    document = GetCardHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardStageTasksDocument = gql`
    query CardStageTasks($cardId: ID!, $cardStageEntryId: ID!, $hasFormSubmitted: Boolean) {
  cardStageTasks(
    cardId: $cardId
    cardStageEntryId: $cardStageEntryId
    hasFormSubmitted: $hasFormSubmitted
  ) {
    nodes {
      id
      dueAt
      completedAt
      description
      priority
      status
      formSubmittedAt
      formSubmittedBy {
        name
      }
      title
      createdAt
      createdBy {
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardStageTasksGQL extends Apollo.Query<CardStageTasksQuery, CardStageTasksQueryVariables> {
    document = CardStageTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLabelDocument = gql`
    mutation CreateLabel($createLabelInput: CreateLabelInput!) {
  createLabel(createLabelInput: $createLabelInput) {
    updatedAt
    name
    id
    createdAt
    color
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLabelGQL extends Apollo.Mutation<CreateLabelMutation, CreateLabelMutationVariables> {
    document = CreateLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLabelDocument = gql`
    mutation UpdateLabel($id: ID!, $data: UpdateLabelInput!) {
  updateLabel(id: $id, data: $data) {
    color
    createdAt
    id
    name
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLabelGQL extends Apollo.Mutation<UpdateLabelMutation, UpdateLabelMutationVariables> {
    document = UpdateLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLabelDocument = gql`
    mutation DeleteLabel($id: ID!) {
  deleteLabel(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLabelGQL extends Apollo.Mutation<DeleteLabelMutation, DeleteLabelMutationVariables> {
    document = DeleteLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLabelsDocument = gql`
    query GetLabels($pipeId: ID!, $searchTerm: String) {
  getLabels(pipeId: $pipeId, searchTerm: $searchTerm) {
    updatedAt
    name
    id
    createdAt
    color
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLabelsGQL extends Apollo.Query<GetLabelsQuery, GetLabelsQueryVariables> {
    document = GetLabelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersAccountDocument = gql`
    query UsersAccount($filters: UsersAccountFilters, $limit: Int, $offset: Int) {
  usersAccount(filters: $filters, limit: $limit, offset: $offset) {
    items {
      id
      name
      email
      avatarUrl
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersAccountGQL extends Apollo.Query<UsersAccountQuery, UsersAccountQueryVariables> {
    document = UsersAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestReviewDocument = gql`
    mutation RequestReview($input: RequestReviewInput!) {
  requestReview(input: $input) {
    id
    status
    reviewers {
      position
      status
      comment
      user {
        name
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestReviewGQL extends Apollo.Mutation<RequestReviewMutation, RequestReviewMutationVariables> {
    document = RequestReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelReviewDocument = gql`
    mutation CancelReview($input: CancelReviewInput!) {
  cancelReview(input: $input) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelReviewGQL extends Apollo.Mutation<CancelReviewMutation, CancelReviewMutationVariables> {
    document = CancelReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeReviewersDocument = gql`
    mutation ChangeReviewers($input: ChangeReviewersInput!) {
  changeReviewers(input: $input) {
    id
    reviewers {
      id
      user {
        id
        name
        email
        avatarUrl
      }
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeReviewersGQL extends Apollo.Mutation<ChangeReviewersMutation, ChangeReviewersMutationVariables> {
    document = ChangeReviewersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReviewDocument = gql`
    query Review($id: ID!) {
  review(id: $id) {
    id
    createdAt
    orientationMessage
    type
    status
    completedReviewsCount
    requiredCommentToApproveOrReject
    canCancel
    canApprove
    canReject
    canRequestReview
    metadata
    stage {
      name
      color
      minimumReviewsRequired
      pipe {
        id
      }
    }
    requestedBy {
      id
      name
      avatarUrl
    }
    reviewers {
      id
      fields {
        createdAt
        id
        key
        name
        type
        orientationMessage
        helpText
        schema
        position
        required
        updatedAt
        value
        values
        options {
          label
        }
        conditions {
          dependencyType
          dependsOnField {
            key
          }
          operator
          expectedValueString
          expectedValueArray
        }
        database {
          id
          databaseId
          databaseName
          databaseLabelField
          databaseDisplayFields
          databaseSearchableFields
          databaseFilters {
            ...SharedFieldDatabaseFilterFields
          }
        }
      }
      user {
        id
        avatarUrl
        name
        email
      }
      status
      position
      comment
      reviewedAt
    }
    card {
      ...CardOverview
      readonly
      pipe {
        id
      }
    }
  }
}
    ${SharedFieldDatabaseFilterFieldsFragmentDoc}
${CardOverviewFragmentDoc}
${FieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReviewGQL extends Apollo.Query<ReviewQuery, ReviewQueryVariables> {
    document = ReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RejectReviewDocument = gql`
    mutation RejectReview($input: RejectReviewInput!) {
  rejectReview(input: $input) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectReviewGQL extends Apollo.Mutation<RejectReviewMutation, RejectReviewMutationVariables> {
    document = RejectReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApproveReviewDocument = gql`
    mutation ApproveReview($input: ApproveReviewInput!) {
  approveReview(input: $input) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApproveReviewGQL extends Apollo.Mutation<ApproveReviewMutation, ApproveReviewMutationVariables> {
    document = ApproveReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestChangeReviewDocument = gql`
    mutation RequestChangeReview($input: RequestChangeReviewInput!) {
  requestChangeReview(input: $input) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestChangeReviewGQL extends Apollo.Mutation<RequestChangeReviewMutation, RequestChangeReviewMutationVariables> {
    document = RequestChangeReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFieldReviewerDocument = gql`
    mutation UpdateFieldReviewer($input: UpdateFieldReviewerInput!) {
  updateFieldReviewer(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFieldReviewerGQL extends Apollo.Mutation<UpdateFieldReviewerMutation, UpdateFieldReviewerMutationVariables> {
    document = UpdateFieldReviewerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendReviewRequestDocument = gql`
    mutation ResendReviewRequest($id: ID!) {
  resendReviewRequest(id: $id) {
    id
    status
    reviewedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendReviewRequestGQL extends Apollo.Mutation<ResendReviewRequestMutation, ResendReviewRequestMutationVariables> {
    document = ResendReviewRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardReviewRequestsDocument = gql`
    query CardReviewRequests($cardId: ID!) {
  cardReview(cardId: $cardId) {
    id
    currentStage {
      name
    }
    reviewRequests {
      id
      type
      status
      lastReviewedAt
      createdAt
      stage {
        name
      }
      reviewers {
        id
        status
        user {
          name
          avatarUrl
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardReviewRequestsGQL extends Apollo.Query<CardReviewRequestsQuery, CardReviewRequestsQueryVariables> {
    document = CardReviewRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardReviewDocument = gql`
    query CardReview($cardId: ID!) {
  cardReview(cardId: $cardId) {
    id
    canRequestReview
    reviewRequests {
      id
    }
    currentStage {
      reviewRequired
      minimumReviewsRequired
    }
    lastReview {
      id
      type
      status
      lastReviewedAt
      canCancel
      canApprove
      canReject
      stage {
        id
      }
      reviewers {
        id
        status
        user {
          name
          avatarUrl
          email
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardReviewGQL extends Apollo.Query<CardReviewQuery, CardReviewQueryVariables> {
    document = CardReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePublicCardStageFormLinkDocument = gql`
    mutation CreatePublicCardStageFormLink($input: CreatePublicCardStageFormLinkInput!) {
  createPublicCardStageFormLink(input: $input) {
    publicLink
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePublicCardStageFormLinkGQL extends Apollo.Mutation<CreatePublicCardStageFormLinkMutation, CreatePublicCardStageFormLinkMutationVariables> {
    document = CreatePublicCardStageFormLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardStageSharedLinkByCardIdDocument = gql`
    query CardStageSharedLinkByCardId($cardId: String!) {
  cardStageSharedLinkByCardId(cardId: $cardId) {
    id
    publicLink
    invitedEmails
    isEditable
    isRequiredAuthenticated
    expiredAt
    customMessage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardStageSharedLinkByCardIdGQL extends Apollo.Query<CardStageSharedLinkByCardIdQuery, CardStageSharedLinkByCardIdQueryVariables> {
    document = CardStageSharedLinkByCardIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardLogsDocument = gql`
    query CardLogs($params: CardLogsPaginateInput!) {
  cardLogs(params: $params) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        action: eventType
        actor {
          id
          name
          email
          avatarUrl
        }
        actorName
        newValue
        oldValue
        details
        reason
        createdAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardLogsGQL extends Apollo.Query<CardLogsQuery, CardLogsQueryVariables> {
    document = CardLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardRelationDocument = gql`
    query CardRelation($cardId: String!, $filters: PaginatedCardRelationFilters!, $labelsFilters: PaginatedCardLabelFilters!, $assigneesFilters: PaginatedCardAssigneeFilters!, $take: Int!) {
  cardRelation(cardId: $cardId) {
    ... on CardRelationRestricted {
      ...CardRelationBaseFields
    }
    ... on CardRelationComplete {
      ...CardRelationBaseFields
      pipe {
        id
        name
      }
      pipeDeadline {
        deadlineRiskAt
        deadlineAt
      }
      currentStageDeadline {
        deadlineRiskAt
        deadlineAt
      }
      currentStage {
        id
        name
        color
      }
      labels(filters: $labelsFilters, take: $take) {
        nodes {
          label {
            id
            name
            color
          }
        }
      }
      assignees(filters: $assigneesFilters, take: $take) {
        nodes {
          id
          user {
            id
            name
            avatarUrl
          }
        }
        totalCount
      }
    }
    __typename
  }
}
    ${CardRelationBaseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CardRelationGQL extends Apollo.Query<CardRelationQuery, CardRelationQueryVariables> {
    document = CardRelationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardsTasksDocument = gql`
    query GetCardsTasks($skip: Float!, $take: Float!, $where: CardTaskWhereInputDto!, $sort: CardTaskSortInputDto) {
  cardsTasks(skip: $skip, take: $take, where: $where, sort: $sort) {
    nodes {
      id
      priority
      status
      title
      dueAt
      description
      createdBy {
        id
        name
      }
      completedAt
      createdAt
      updatedAt
      stage {
        name
        color
      }
      assignees {
        user {
          id
          name
          avatarUrl
        }
      }
      labels {
        id
        name
        color
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardsTasksGQL extends Apollo.Query<GetCardsTasksQuery, GetCardsTasksQueryVariables> {
    document = GetCardsTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardTaskFieldsDocument = gql`
    query CardTaskFields($id: ID!) {
  cardTaskFields(id: $id) {
    createdAt
    id
    key
    name
    type
    orientationMessage
    helpText
    schema
    position
    required
    updatedAt
    value
    values
    options {
      label
    }
    conditions {
      dependsOnField {
        key
      }
      operator
      expectedValueString
    }
    database {
      id
      databaseId
      databaseName
      databaseLabelField
      databaseDisplayFields
      databaseSearchableFields
      databaseFilters {
        ...SharedFieldDatabaseFilterFields
      }
    }
  }
}
    ${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CardTaskFieldsGQL extends Apollo.Query<CardTaskFieldsQuery, CardTaskFieldsQueryVariables> {
    document = CardTaskFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPipeDocumentationDocument = gql`
    query GetPipeDocumentation($id: ID!) {
  pipe(pipeId: $id) {
    documentation {
      stages {
        automations {
          content
          title
          event
          actionType
        }
        content
        title
      }
      flux {
        content
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPipeDocumentationGQL extends Apollo.Query<GetPipeDocumentationQuery, GetPipeDocumentationQueryVariables> {
    document = GetPipeDocumentationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportCardsDocument = gql`
    mutation exportCards($exportCardInput: ExportCardInput!) {
  exportCards(exportCardInput: $exportCardInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportCardsGQL extends Apollo.Mutation<ExportCardsMutation, ExportCardsMutationVariables> {
    document = ExportCardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportTasksDocument = gql`
    mutation exportTasks($exportTaskInput: ExportTasksInput!) {
  exportTasks(exportTaskInput: $exportTaskInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportTasksGQL extends Apollo.Mutation<ExportTasksMutation, ExportTasksMutationVariables> {
    document = ExportTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportsByPipeIdDocument = gql`
    query reportsByPipeId($pipeId: ID!, $filters: FiltersReportsInput!) {
  reportsByPipeId(pipeId: $pipeId, filters: $filters) {
    form {
      id
      name
    }
    stages {
      id
      name
      color
    }
    isStartForm
    answersCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportsByPipeIdGQL extends Apollo.Query<ReportsByPipeIdQuery, ReportsByPipeIdQueryVariables> {
    document = ReportsByPipeIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportDetailsDocument = gql`
    query reportDetails($formId: ID!, $pipeId: ID!, $filters: FiltersReportsDetailsInput!) {
  reportDetails(formId: $formId, pipeId: $pipeId, filters: $filters) {
    title
    type
    position
    values {
      ... on OpenChoiceAnswer {
        value
        answeredAt
      }
      ... on FixedChoiceAnswer {
        value
        count
      }
      ... on CheckboxAnswer {
        values
        count
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportDetailsGQL extends Apollo.Query<ReportDetailsQuery, ReportDetailsQueryVariables> {
    document = ReportDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSearchLabelsDocument = gql`
    query GetSearchLabels($pipeId: ID!, $searchTerm: String) {
  getLabels(pipeId: $pipeId, searchTerm: $searchTerm) {
    id
    name
    color
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSearchLabelsGQL extends Apollo.Query<GetSearchLabelsQuery, GetSearchLabelsQueryVariables> {
    document = GetSearchLabelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadSearchLabelsDocument = gql`
    query LoadSearchLabels($labelsIds: [ID!]!, $pipeId: ID!) {
  getLabelsByIds(labelsIds: $labelsIds, pipeId: $pipeId) {
    id
    name
    color
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadSearchLabelsGQL extends Apollo.Query<LoadSearchLabelsQuery, LoadSearchLabelsQueryVariables> {
    document = LoadSearchLabelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSearchPipesMembersDocument = gql`
    query GetSearchPipesMembers($searchTerm: String, $take: Int, $skip: Int, $pipeId: ID!, $notTheseUsers: [ID!]) {
  pipesMembers(
    searchTerm: $searchTerm
    take: $take
    skip: $skip
    pipeId: $pipeId
    notTheseUsers: $notTheseUsers
  ) {
    totalCount
    nodes {
      id
      user {
        id
        name
        avatarUrl
        email
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSearchPipesMembersGQL extends Apollo.Query<GetSearchPipesMembersQuery, GetSearchPipesMembersQueryVariables> {
    document = GetSearchPipesMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadPipesMembersDocument = gql`
    query LoadPipesMembers($ids: [ID!]!, $pipeId: ID!) {
  pipesMembersByIds(ids: $ids, pipeId: $pipeId) {
    id
    user {
      id
      name
      avatarUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadPipesMembersGQL extends Apollo.Query<LoadPipesMembersQuery, LoadPipesMembersQueryVariables> {
    document = LoadPipesMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCardDocument = gql`
    mutation CreateCard($input: CreateCardInput!) {
  createCard(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCardGQL extends Apollo.Mutation<CreateCardMutation, CreateCardMutationVariables> {
    document = CreateCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddFormToStageDocument = gql`
    mutation AddFormToStage($formId: ID!, $stageId: ID!) {
  addFormToStage(formId: $formId, stageId: $stageId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddFormToStageGQL extends Apollo.Mutation<AddFormToStageMutation, AddFormToStageMutationVariables> {
    document = AddFormToStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePipeDocument = gql`
    mutation ArchivePipe($pipeId: ID!) {
  deletePipe(pipeId: $pipeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePipeGQL extends Apollo.Mutation<ArchivePipeMutation, ArchivePipeMutationVariables> {
    document = ArchivePipeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPipeSettingsDocument = gql`
    query GetPipeSettings($id: ID!) {
  pipe(pipeId: $id) {
    id
    name
    description
    icon
    color
    private
    onlyAdminCanRemoveCards
    onlyAssigneesCanEditCards
    cardVisibilityBehavior
    relatedCardVisibilityBehavior
    cardTaskReopenBehavior
    cardInitialFormUpdateBehavior
    cardSolicitationFormUpdateBehavior
    allowCommentsWhenCardLocked
    attachmentsTabVisibility
    updatedAt
    deletedAt
    startForm {
      id
      name
      type
      hashedId
      teamMembersCanViewOthersSolicitations
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPipeSettingsGQL extends Apollo.Query<GetPipeSettingsQuery, GetPipeSettingsQueryVariables> {
    document = GetPipeSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PipeDeadlineDocument = gql`
    query PipeDeadline($pipeId: ID!) {
  pipeDeadline: pipe(pipeId: $pipeId) {
    id
    deadline {
      id
      name
      description
      archived
      deadlineMinutes
      deadlineDisplayUnit
      deadlineRiskMinutes
      deadlineRiskDisplayUnit
      considerHoliday
      hasOfficeHours
      officeHours
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PipeDeadlineGQL extends Apollo.Query<PipeDeadlineQuery, PipeDeadlineQueryVariables> {
    document = PipeDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFormUserAccessDocument = gql`
    query GetFormUserAccess($formId: ID!) {
  formUserAccess(formId: $formId) {
    id
    name
    email
    avatarUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFormUserAccessGQL extends Apollo.Query<GetFormUserAccessQuery, GetFormUserAccessQueryVariables> {
    document = GetFormUserAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFormTeamAccessDocument = gql`
    query GetFormTeamAccess($formId: ID!) {
  formTeamAccess(formId: $formId) {
    id
    name
    slug
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFormTeamAccessGQL extends Apollo.Query<GetFormTeamAccessQuery, GetFormTeamAccessQueryVariables> {
    document = GetFormTeamAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFormUserAccessDocument = gql`
    mutation UpdateFormUserAccess($input: UpdateFormUserAccessInput!) {
  updateFormUserAccess(input: $input) {
    success
    usersCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFormUserAccessGQL extends Apollo.Mutation<UpdateFormUserAccessMutation, UpdateFormUserAccessMutationVariables> {
    document = UpdateFormUserAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFormTeamAccessDocument = gql`
    mutation UpdateFormTeamAccess($input: UpdateFormTeamAccessInput!) {
  updateFormTeamAccess(input: $input) {
    success
    teamsCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFormTeamAccessGQL extends Apollo.Mutation<UpdateFormTeamAccessMutation, UpdateFormTeamAccessMutationVariables> {
    document = UpdateFormTeamAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPipesAutomationDocument = gql`
    query GetPipesAutomation {
  pipes {
    edges {
      node {
        id
        icon
        name
        stages {
          id
          name
        }
        startForm {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPipesAutomationGQL extends Apollo.Query<GetPipesAutomationQuery, GetPipesAutomationQueryVariables> {
    document = GetPipesAutomationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOnStagesAutomationDocument = gql`
    query GetOnStagesAutomation($params: StagesParamsInput!) {
  stages(params: $params) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOnStagesAutomationGQL extends Apollo.Query<GetOnStagesAutomationQuery, GetOnStagesAutomationQueryVariables> {
    document = GetOnStagesAutomationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAutomationDocument = gql`
    mutation CreateAutomation($createAutomationInput: CreateAutomationInput!) {
  createAutomation(createAutomationInput: $createAutomationInput) {
    ...AutomationFragment
  }
}
    ${AutomationFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAutomationGQL extends Apollo.Mutation<CreateAutomationMutation, CreateAutomationMutationVariables> {
    document = CreateAutomationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAutomationsOnPipeDocument = gql`
    query GetAutomationsOnPipe($params: AutomationsWhereInput!) {
  automations(params: $params) {
    ...AutomationFragment
  }
}
    ${AutomationFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAutomationsOnPipeGQL extends Apollo.Query<GetAutomationsOnPipeQuery, GetAutomationsOnPipeQueryVariables> {
    document = GetAutomationsOnPipeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAutomationDocument = gql`
    mutation UpdateAutomation($updateAutomationInput: UpdateAutomationInput!) {
  updateAutomation(updateAutomationInput: $updateAutomationInput) {
    ...AutomationFragment
  }
}
    ${AutomationFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAutomationGQL extends Apollo.Mutation<UpdateAutomationMutation, UpdateAutomationMutationVariables> {
    document = UpdateAutomationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleArchiveAutomationDocument = gql`
    mutation ToggleArchiveAutomation($id: ID!) {
  toggleArchiveAutomation(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleArchiveAutomationGQL extends Apollo.Mutation<ToggleArchiveAutomationMutation, ToggleArchiveAutomationMutationVariables> {
    document = ToggleArchiveAutomationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AutomationDocument = gql`
    query Automation($id: ID!) {
  automation(id: $id) {
    id
    name
    description
    active
    runOnlyOnce
    archived
    event
    isSync
    stage {
      id
      name
    }
    action {
      __typename
      id
      type
      ... on AutomationActionAssigneePersonData {
        typeAssignee
        assignees {
          name
          avatarUrl
          createdAt
          email
          id
        }
      }
      ... on AutomationActionCreateCardData {
        pipe {
          id
          name
        }
        stage {
          id
          name
        }
        description
        name
      }
      ... on AutomationActionHttpRequestData {
        url
        method
        headers
        expected_status_code
        authentication {
          authentication_type
          authentication_token
          authentication_api_key
          authentication_api_value
        }
        body
      }
      ... on RelatedCardAction {
        attributes
        fieldsMapping
        targetId
        targetStageId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AutomationGQL extends Apollo.Query<AutomationQuery, AutomationQueryVariables> {
    document = AutomationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentFormFieldsDocument = gql`
    query GetCurrentFormFields($id: ID!) {
  form(id: $id) {
    id
    name
    type
    questions {
      ...FormQuestionFields
    }
    questionsCount
  }
}
    ${FormQuestionFieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentFormFieldsGQL extends Apollo.Query<GetCurrentFormFieldsQuery, GetCurrentFormFieldsQueryVariables> {
    document = GetCurrentFormFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInitialFormDocument = gql`
    mutation UpdateInitialForm($input: UpdateInitialFormInput!) {
  updateInitialForm(input: $input) {
    id
    name
    type
    teamMembersCanViewOthersSolicitations
    hashedId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInitialFormGQL extends Apollo.Mutation<UpdateInitialFormMutation, UpdateInitialFormMutationVariables> {
    document = UpdateInitialFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormDocument = gql`
    query Form($id: ID!) {
  form(id: $id) {
    id
    name
    type
    hashedId
    questions {
      ...FormQuestionFields
    }
    questionsCount
  }
}
    ${FormQuestionFieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FormGQL extends Apollo.Query<FormQuery, FormQueryVariables> {
    document = FormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePipeDeadlineDocument = gql`
    mutation CreatePipeDeadline($createDeadlineInput: CreateDeadlineInput!, $pipeId: ID!) {
  assignDeadlineToPipe(createDeadlineInput: $createDeadlineInput, pipeId: $pipeId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePipeDeadlineGQL extends Apollo.Mutation<CreatePipeDeadlineMutation, CreatePipeDeadlineMutationVariables> {
    document = CreatePipeDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePipeDeadlineDocument = gql`
    mutation UpdatePipeDeadline($updateDeadlineInput: UpdateDeadlineInput!, $pipeId: ID!) {
  updateDeadlineToPipe(updateDeadlineInput: $updateDeadlineInput, pipeId: $pipeId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePipeDeadlineGQL extends Apollo.Mutation<UpdatePipeDeadlineMutation, UpdatePipeDeadlineMutationVariables> {
    document = UpdatePipeDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePipeDeadlineDocument = gql`
    mutation DeletePipeDeadline($pipeId: ID!) {
  removeDeadlineFromPipe(pipeId: $pipeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePipeDeadlineGQL extends Apollo.Mutation<DeletePipeDeadlineMutation, DeletePipeDeadlineMutationVariables> {
    document = DeletePipeDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransferPipeOwnershipDocument = gql`
    mutation TransferPipeOwnership($input: TransferPipeOwnershipInput!) {
  transferPipeOwnership(input: $input) {
    id
    user {
      id
      name
      email
    }
    roleType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TransferPipeOwnershipGQL extends Apollo.Mutation<TransferPipeOwnershipMutation, TransferPipeOwnershipMutationVariables> {
    document = TransferPipeOwnershipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteMemberDocument = gql`
    mutation InviteMember($input: InviteUsersToPipeInput!) {
  inviteUsersToPipe(inviteUsersToPipe: $input) {
    errors
    success
    users {
      user {
        avatarUrl
        createdAt
        email
        id
        name
        updatedAt
        roleType
      }
      roleType
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteMemberGQL extends Apollo.Mutation<InviteMemberMutation, InviteMemberMutationVariables> {
    document = InviteMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveMemberDocument = gql`
    mutation RemoveMember($input: RemoveMemberFromPipeInput!) {
  removeMemberFromPipe(removeMemberFromPipe: $input) {
    errors
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveMemberGQL extends Apollo.Mutation<RemoveMemberMutation, RemoveMemberMutationVariables> {
    document = RemoveMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PipeMembersDocument = gql`
    query PipeMembers($pipeId: ID!, $searchTerm: String, $notTheseUsers: [ID!], $skip: Int, $take: Int) {
  pipesMembers(
    pipeId: $pipeId
    searchTerm: $searchTerm
    notTheseUsers: $notTheseUsers
    skip: $skip
    take: $take
  ) {
    pageInfo {
      hasNextPage
    }
    totalCount
    nodes {
      user {
        avatarUrl
        createdAt
        email
        id
        name
        updatedAt
        roleType
      }
      roleType
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PipeMembersGQL extends Apollo.Query<PipeMembersQuery, PipeMembersQueryVariables> {
    document = PipeMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StagesDocument = gql`
    query Stages($params: StagesParamsInput!) {
  stages(params: $params) {
    id
    name
    description
    done
    deletedAt
    cardsCanBeMovedToStages {
      id
      name
    }
    pipe {
      id
    }
    form {
      id
    }
    color
    index
    confirmMoveCard
    canReceiveCardDirectlyFromDraft
    canMoveCardWithoutTasksBeingDone
    canReceiveCardWithoutTasksBeingDone
    moveCardToNextStageWhenDone
    reviewRequired
    reviewType
    minimumReviewsRequired
    cardsCanBeMovedToStages {
      id
    }
    deadline {
      id
      name
      description
      archived
      deadlineMinutes
      deadlineDisplayUnit
      deadlineRiskMinutes
      deadlineRiskDisplayUnit
      considerHoliday
      hasOfficeHours
      officeHours
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StagesGQL extends Apollo.Query<StagesQuery, StagesQueryVariables> {
    document = StagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStageFormDocument = gql`
    mutation UpdateStageForm($input: UpdateStageFormInput!) {
  updateStageForm(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStageFormGQL extends Apollo.Mutation<UpdateStageFormMutation, UpdateStageFormMutationVariables> {
    document = UpdateStageFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStageDeadlineDocument = gql`
    mutation CreateStageDeadline($createDeadlineInput: CreateDeadlineInput!, $stageId: ID!) {
  assignDeadlineToStage(
    createDeadlineInput: $createDeadlineInput
    stageId: $stageId
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStageDeadlineGQL extends Apollo.Mutation<CreateStageDeadlineMutation, CreateStageDeadlineMutationVariables> {
    document = CreateStageDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStageDeadlineDocument = gql`
    mutation UpdateStageDeadline($updateDeadlineInput: UpdateDeadlineInput!, $stageId: ID!) {
  updateDeadlineToStage(
    updateDeadlineInput: $updateDeadlineInput
    stageId: $stageId
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStageDeadlineGQL extends Apollo.Mutation<UpdateStageDeadlineMutation, UpdateStageDeadlineMutationVariables> {
    document = UpdateStageDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStageDeadlineDocument = gql`
    mutation DeleteStageDeadline($stageId: ID!) {
  removeDeadlineFromStage(stageId: $stageId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStageDeadlineGQL extends Apollo.Mutation<DeleteStageDeadlineMutation, DeleteStageDeadlineMutationVariables> {
    document = DeleteStageDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderStagesDocument = gql`
    mutation OrderStages($input: OrderStagesInput!) {
  orderStages(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderStagesGQL extends Apollo.Mutation<OrderStagesMutation, OrderStagesMutationVariables> {
    document = OrderStagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateDeadlineDocument = gql`
    mutation CreateTemplateDeadline($input: CreateTemplateDeadlineInput!) {
  createTemplateDeadline(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateDeadlineGQL extends Apollo.Mutation<CreateTemplateDeadlineMutation, CreateTemplateDeadlineMutationVariables> {
    document = CreateTemplateDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTemplateDeadlineDocument = gql`
    mutation UpdateTemplateDeadline($input: UpdateTemplateDeadlineInput!) {
  updateTemplateDeadline(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTemplateDeadlineGQL extends Apollo.Mutation<UpdateTemplateDeadlineMutation, UpdateTemplateDeadlineMutationVariables> {
    document = UpdateTemplateDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplateDeadlineDocument = gql`
    query TemplateDeadline($id: ID!) {
  template(id: $id) {
    ... on TemplateDeadline {
      id
      name
      description
      deadlineMinutes
      deadlineDisplayUnit
      deadlineRiskMinutes
      deadlineRiskDisplayUnit
      considerHoliday
      hasOfficeHours
      officeHours
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateDeadlineGQL extends Apollo.Query<TemplateDeadlineQuery, TemplateDeadlineQueryVariables> {
    document = TemplateDeadlineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplateReviewDocument = gql`
    query TemplateReview($id: ID!) {
  template(id: $id) {
    ... on TemplateReview {
      type
      reviewType
      responseType
      pipeId
      orientationMessage
      name
      minimumReviewsRequired
      requiredCommentToApproveOrReject
      id
      description
      reviewers {
        user {
          email
          avatarUrl
          id
          name
        }
        position
      }
    }
    fields {
      id
      key
      name
      orientationMessage
      helpText
      schema
      position
      required
      type
      options {
        label
      }
      conditions {
        dependsOnField {
          key
        }
        dependencyType
        operator
        expectedValueString
        expectedValueArray
      }
      database {
        ...SharedFieldDatabaseFields
      }
    }
  }
}
    ${SharedFieldDatabaseFieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateReviewGQL extends Apollo.Query<TemplateReviewQuery, TemplateReviewQueryVariables> {
    document = TemplateReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateReviewDocument = gql`
    mutation CreateTemplateReview($input: CreateTemplateReviewInput!) {
  createTemplateReview(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateReviewGQL extends Apollo.Mutation<CreateTemplateReviewMutation, CreateTemplateReviewMutationVariables> {
    document = CreateTemplateReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTemplateReviewDocument = gql`
    mutation UpdateTemplateReview($input: UpdateTemplateReviewInput!) {
  updateTemplateReview(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTemplateReviewGQL extends Apollo.Mutation<UpdateTemplateReviewMutation, UpdateTemplateReviewMutationVariables> {
    document = UpdateTemplateReviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplatesDocument = gql`
    query Templates($take: Int, $skip: Int, $filters: PaginatedTemplatesFilters!) {
  templates(take: $take, skip: $skip, filters: $filters) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ...TemplateFragment
    }
  }
}
    ${TemplateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplatesGQL extends Apollo.Query<TemplatesQuery, TemplatesQueryVariables> {
    document = TemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplatesTasksDocument = gql`
    query TemplatesTasks($take: Int, $skip: Int, $pipeId: ID!, $searchTerm: String) {
  templatesTasks(
    take: $take
    skip: $skip
    pipeId: $pipeId
    searchTerm: $searchTerm
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ... on TemplateTask {
        id
        name
        description
        type
        priority
        timeToDueUnit
        timeToDueValue
        timeToDueFlags
        labels {
          id
          name
          color
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplatesTasksGQL extends Apollo.Query<TemplatesTasksQuery, TemplatesTasksQueryVariables> {
    document = TemplatesTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RootTemplatesByStageDocument = gql`
    query RootTemplatesByStage($pipeId: ID!, $stageId: ID!, $after: ID) {
  templatesByStage(pipeId: $pipeId, stageId: $stageId, after: $after) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ...TemplateFragment
      children {
        id
        name
      }
    }
  }
}
    ${TemplateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RootTemplatesByStageGQL extends Apollo.Query<RootTemplatesByStageQuery, RootTemplatesByStageQueryVariables> {
    document = RootTemplatesByStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BatchTemplatesByStageDocument = gql`
    query BatchTemplatesByStage($data: GetBatchTemplatesByStageInput!) {
  batchTemplatesByStage(data: $data) {
    ...TemplateFragment
    children {
      id
      name
    }
  }
}
    ${TemplateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BatchTemplatesByStageGQL extends Apollo.Query<BatchTemplatesByStageQuery, BatchTemplatesByStageQueryVariables> {
    document = BatchTemplatesByStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateTaskDocument = gql`
    mutation CreateTemplateTask($input: CreateTemplateTaskInput!) {
  createTemplateTask(input: $input) {
    ...TemplateFragment
  }
}
    ${TemplateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateTaskGQL extends Apollo.Mutation<CreateTemplateTaskMutation, CreateTemplateTaskMutationVariables> {
    document = CreateTemplateTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditTemplateTaskDocument = gql`
    mutation EditTemplateTask($input: EditTemplateTaskInput!) {
  editTemplateTask(input: $input) {
    ...TemplateFragment
  }
}
    ${TemplateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EditTemplateTaskGQL extends Apollo.Mutation<EditTemplateTaskMutation, EditTemplateTaskMutationVariables> {
    document = EditTemplateTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveCardAxisYDocument = gql`
    mutation MoveCardAxisY($cardId: ID!, $nextCardId: ID, $previousCardId: ID) {
  moveCard(
    cardId: $cardId
    nextCardId: $nextCardId
    previousCardId: $previousCardId
  ) {
    age
    archived
    createdAt
    description
    id
    late
    name
    startedCurrentPhaseAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveCardAxisYGQL extends Apollo.Mutation<MoveCardAxisYMutation, MoveCardAxisYMutationVariables> {
    document = MoveCardAxisYDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveCardAxisXDocument = gql`
    mutation MoveCardAxisX($moveCardToStageArgs: MoveCardToStageInput!) {
  moveCardToStage(moveCardToStageArgs: $moveCardToStageArgs) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveCardAxisXGQL extends Apollo.Mutation<MoveCardAxisXMutation, MoveCardAxisXMutationVariables> {
    document = MoveCardAxisXDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStagesDocument = gql`
    query GetStages($params: StagesParamsInput!) {
  stages(params: $params) {
    id
    name
    description
    pipe {
      id
      name
      startForm {
        id
      }
    }
    index
    color
    done
    canReceiveCardDirectlyFromDraft
    createdAt
    updatedAt
    deletedAt
    confirmMoveCard
    cardsCanBeMovedToStages {
      id
      name
    }
    cards {
      nodes {
        age
        id
        name
        index
        currentStage {
          id
        }
        lastAssignees {
          id
          name
          email
          avatarUrl
        }
        labels {
          label {
            id
            name
            color
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStagesGQL extends Apollo.Query<GetStagesQuery, GetStagesQueryVariables> {
    document = GetStagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPipeDocument = gql`
    query GetPipe($id: ID!) {
  pipe(pipeId: $id) {
    id
    icon
    name
    description
    onlyAdminCanRemoveCards
    onlyAssigneesCanEditCards
    color
    updatedAt
    private
    deletedAt
    startForm {
      id
      name
      type
      questions {
        id
        title
        type
        required
        position
        helpText
        schema
        customValidation
        customValidationMessage
        conditions {
          value
          operator
          question {
            id
            title
          }
        }
        options {
          value
          id
          description
        }
        database {
          databaseLabelField
        }
      }
    }
    stages {
      id
      name
      canReceiveCardDirectlyFromDraft
      index
      deletedAt
    }
    permissions {
      canDeleteCard
      canDownloadFiles
      canEditAnyCard
      canEditCard
      canEditPipe
      canShowAllCards
    }
    members {
      id
      roleType
      user {
        id
        name
        email
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPipeGQL extends Apollo.Query<GetPipeQuery, GetPipeQueryVariables> {
    document = GetPipeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveStageAxisXDocument = gql`
    mutation MoveStageAxisX($moveStageAxisInput: MoveStageAxisInput!) {
  moveStageAxisX(input: $moveStageAxisInput) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveStageAxisXGQL extends Apollo.Mutation<MoveStageAxisXMutation, MoveStageAxisXMutationVariables> {
    document = MoveStageAxisXDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStagesPartiallyDocument = gql`
    query GetStagesPartially($params: StagesParamsInput!) {
  stages(params: $params) {
    id
    name
    description
    index
    color
    deletedAt
    done
    canReceiveCardDirectlyFromDraft
    canMoveCardWithoutTasksBeingDone
    canReceiveCardWithoutTasksBeingDone
    confirmMoveCard
    cardsCanBeMovedToStages {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStagesPartiallyGQL extends Apollo.Query<GetStagesPartiallyQuery, GetStagesPartiallyQueryVariables> {
    document = GetStagesPartiallyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStagesCardsCountDocument = gql`
    query GetStagesCardsCount($params: StagesParamsInput!, $cardsParams: FiltersCardsInput) {
  stages(params: $params) {
    id
    cardsCount(filters: $cardsParams)
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStagesCardsCountGQL extends Apollo.Query<GetStagesCardsCountQuery, GetStagesCardsCountQueryVariables> {
    document = GetStagesCardsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ViewBoardStagesDocument = gql`
    query ViewBoardStages($params: StagesParamsInput!) {
  stages(params: $params) {
    id
    name
    index
    confirmMoveCard
    color
    done
    canReceiveCardDirectlyFromDraft
    deletedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ViewBoardStagesGQL extends Apollo.Query<ViewBoardStagesQuery, ViewBoardStagesQueryVariables> {
    document = ViewBoardStagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ViewBoardStageCardsCountDocument = gql`
    query ViewBoardStageCardsCount($params: StagesParamsInput!, $cardsParams: FiltersCardsInput) {
  stages(params: $params) {
    id
    cardsCount(filters: $cardsParams)
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ViewBoardStageCardsCountGQL extends Apollo.Query<ViewBoardStageCardsCountQuery, ViewBoardStageCardsCountQueryVariables> {
    document = ViewBoardStageCardsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardAutomationsDocument = gql`
    query GetCardAutomations($cardId: ID!) {
  card(id: $cardId) {
    id
    name
    automations {
      id
      status
      createdAt
      automation {
        name
        isSync
      }
      actions {
        id
        lastHeartbeatAt
        status
        type
        createdAt
        logs {
          id
          status
          message
          createdAt
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardAutomationsGQL extends Apollo.Query<GetCardAutomationsQuery, GetCardAutomationsQueryVariables> {
    document = GetCardAutomationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardAutomationsForCacheDocument = gql`
    query GetCardAutomationsForCache($cardId: ID!) {
  card(id: $cardId) {
    id
    automations {
      id
      status
      automation {
        isSync
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardAutomationsForCacheGQL extends Apollo.Query<GetCardAutomationsForCacheQuery, GetCardAutomationsForCacheQueryVariables> {
    document = GetCardAutomationsForCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStageDocument = gql`
    query GetStage($stageId: ID!, $cardsParams: FiltersCardsInput) {
  stage(id: $stageId) {
    id
    name
    description
    index
    color
    deletedAt
    done
    canReceiveCardDirectlyFromDraft
    canMoveCardWithoutTasksBeingDone
    canReceiveCardWithoutTasksBeingDone
    cardsCanBeMovedToStages {
      id
    }
    cardsCount
    form {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStageGQL extends Apollo.Query<GetStageQuery, GetStageQueryVariables> {
    document = GetStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnopenedCardDocument = gql`
    query GetUnopenedCard($cardId: ID!) {
  card(id: $cardId) {
    ...CardFieldsOnStageColumn
  }
}
    ${CardFieldsOnStageColumnFragmentDoc}
${CardFieldsOnStageColumnLightFragmentDoc}
${CardFieldsOnStageColumnHeavyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnopenedCardGQL extends Apollo.Query<GetUnopenedCardQuery, GetUnopenedCardQueryVariables> {
    document = GetUnopenedCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnopenedCardsDocument = gql`
    query GetUnopenedCards($where: FiltersCardsInput, $sort: UnopenedCardsSortInput, $stageId: ID!, $skip: Int, $take: Int) {
  unopenedCards(
    where: $where
    stageId: $stageId
    skip: $skip
    take: $take
    sort: $sort
  ) {
    suid
    items {
      ...CardFieldsOnStageColumnLight
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CardFieldsOnStageColumnLightFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnopenedCardsGQL extends Apollo.Query<GetUnopenedCardsQuery, GetUnopenedCardsQueryVariables> {
    document = GetUnopenedCardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnopenedCardsHeavyDocument = gql`
    query GetUnopenedCardsHeavy($where: FiltersCardsInput, $stageId: ID!) {
  unopenedCards(where: $where, stageId: $stageId, skip: 0, take: 250) {
    suid
    items {
      id
      ...CardFieldsOnStageColumnHeavy
    }
  }
}
    ${CardFieldsOnStageColumnHeavyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnopenedCardsHeavyGQL extends Apollo.Query<GetUnopenedCardsHeavyQuery, GetUnopenedCardsHeavyQueryVariables> {
    document = GetUnopenedCardsHeavyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReviewsByPipeDocument = gql`
    query ReviewsByPipe($pipeId: ID!, $take: Int, $skip: Int, $filters: PaginatedReviewFilters, $sorts: PaginatedReviewSortOrderInput) {
  reviewsByPipe(
    pipeId: $pipeId
    filters: $filters
    take: $take
    skip: $skip
    sorts: $sorts
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ...ReviewsFields
    }
  }
}
    ${ReviewsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReviewsByPipeGQL extends Apollo.Query<ReviewsByPipeQuery, ReviewsByPipeQueryVariables> {
    document = ReviewsByPipeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkUpdateReviewersDocument = gql`
    mutation bulkUpdateReviewers($input: BulkUpdateReviewersInput!) {
  bulkUpdateReviewers(input: $input) {
    successCount
    errorCount
    updatedReviewIds
    errors {
      errorCode
      message
      reviewId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkUpdateReviewersGQL extends Apollo.Mutation<BulkUpdateReviewersMutation, BulkUpdateReviewersMutationVariables> {
    document = BulkUpdateReviewersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardsInTableDocument = gql`
    query CardsInTable($pipeId: ID!, $filters: FiltersCardsInput, $sorts: [SortOrderInput!], $take: Int = 10, $skip: Int = 0) {
  cards(
    pipeId: $pipeId
    filters: $filters
    sorts: $sorts
    take: $take
    skip: $skip
  ) {
    nodes {
      ...CardFieldsOnTableLight
    }
    totalCount
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CardFieldsOnTableLightFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CardsInTableGQL extends Apollo.Query<CardsInTableQuery, CardsInTableQueryVariables> {
    document = CardsInTableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardsInTableHeavyDocument = gql`
    query CardsInTableHeavy($pipeId: ID!, $filters: FiltersCardsInput) {
  cards(pipeId: $pipeId, filters: $filters, take: 250, skip: 0) {
    nodes {
      id
      ...CardFieldsOnTableHeavy
    }
  }
}
    ${CardFieldsOnTableHeavyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CardsInTableHeavyGQL extends Apollo.Query<CardsInTableHeavyQuery, CardsInTableHeavyQueryVariables> {
    document = CardsInTableHeavyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardInTableDocument = gql`
    query CardInTable($id: ID!) {
  card(id: $id) {
    ...CardFieldsOnTable
  }
}
    ${CardFieldsOnTableFragmentDoc}
${CardFieldsOnTableLightFragmentDoc}
${CardFieldsOnTableHeavyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CardInTableGQL extends Apollo.Query<CardInTableQuery, CardInTableQueryVariables> {
    document = CardInTableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PipeGetCardsTasksDocument = gql`
    query PipeGetCardsTasks($skip: Float!, $take: Float!, $where: CardTaskByPipeWhereInputDto!, $sort: [SortOrderInput!]) {
  cardsTasksByPipe(skip: $skip, take: $take, where: $where, sort: $sort) {
    nodes {
      id
      priority
      status
      title
      dueAt
      description
      createdBy {
        id
        name
      }
      completedAt
      createdAt
      stage {
        name
        color
      }
      card {
        id
        name
        currentStage {
          name
          color
        }
        pipe {
          id
          name
        }
      }
      assignees {
        user {
          id
          name
          avatarUrl
        }
      }
      labels {
        id
        name
        color
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PipeGetCardsTasksGQL extends Apollo.Query<PipeGetCardsTasksQuery, PipeGetCardsTasksQueryVariables> {
    document = PipeGetCardsTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkUpdateTaskAssigneesDocument = gql`
    mutation BulkUpdateTaskAssignees($input: BulkUpdateTaskAssigneesInput!) {
  bulkUpdateTaskAssignees(input: $input) {
    successCount
    errorCount
    updatedTasks {
      id
      title
    }
    errors {
      errorCode
      message
      taskId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkUpdateTaskAssigneesGQL extends Apollo.Mutation<BulkUpdateTaskAssigneesMutation, BulkUpdateTaskAssigneesMutationVariables> {
    document = BulkUpdateTaskAssigneesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SolicitationFormsDocument = gql`
    query SolicitationForms($where: WhereSolicitationFormsInput!, $take: Float, $skip: Float) {
  solicitationForms(where: $where, take: $take, skip: $skip) {
    items {
      id
      name
      pipe {
        id
        name
        description
        startForm {
          id
          name
          type
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SolicitationFormsGQL extends Apollo.Query<SolicitationFormsQuery, SolicitationFormsQueryVariables> {
    document = SolicitationFormsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSolicitationDocument = gql`
    mutation CreateSolicitation($data: CreateCardInput!) {
  createSolicitation(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSolicitationGQL extends Apollo.Mutation<CreateSolicitationMutation, CreateSolicitationMutationVariables> {
    document = CreateSolicitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PipesDocument = gql`
    query Pipes($filters: PaginatedPipeFilters, $skip: Int, $sorts: PaginatedPipeSortOrderInput, $take: Int) {
  pipes(filters: $filters, skip: $skip, sorts: $sorts, take: $take) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        id
        icon
        name
        color
        favorite
        deletedAt
        updatedAt
        cardsCount
        private
        members {
          user {
            id
            name
            avatarUrl
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PipesGQL extends Apollo.Query<PipesQuery, PipesQueryVariables> {
    document = PipesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyCardsByIdDocument = gql`
    query MyCardsById($id: ID!) {
  card(id: $id) {
    ...MySpaceCardFields
  }
}
    ${MySpaceCardFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MyCardsByIdGQL extends Apollo.Query<MyCardsByIdQuery, MyCardsByIdQueryVariables> {
    document = MyCardsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyCardsDocument = gql`
    query MyCards($filters: FiltersSelfCardsInput, $sort: [SortOrderInput!], $take: Int = 10, $skip: Int = 0) {
  selfCards(filters: $filters, sort: $sort, take: $take, skip: $skip) {
    edges {
      node {
        ...MySpaceCardFields
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    ${MySpaceCardFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MyCardsGQL extends Apollo.Query<MyCardsQuery, MyCardsQueryVariables> {
    document = MyCardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OwnReviewsDocument = gql`
    query OwnReviews($filters: PaginatedReviewFilters, $sorts: PaginatedReviewSortOrderInput, $skip: Int, $take: Int) {
  ownReviews(filters: $filters, sorts: $sorts, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...OwnReviewsFields
      }
    }
  }
}
    ${OwnReviewsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OwnReviewsGQL extends Apollo.Query<OwnReviewsQuery, OwnReviewsQueryVariables> {
    document = OwnReviewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OwnReviewsByIdDocument = gql`
    query OwnReviewsById($id: ID!) {
  review(id: $id) {
    ...OwnReviewsFields
  }
}
    ${OwnReviewsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OwnReviewsByIdGQL extends Apollo.Query<OwnReviewsByIdQuery, OwnReviewsByIdQueryVariables> {
    document = OwnReviewsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OwnCardsTasksDocument = gql`
    query OwnCardsTasks($skip: Float!, $take: Float!, $where: CardTaskWhereInputDto!, $sort: CardTaskSortInputDto) {
  cardsTasks(skip: $skip, take: $take, where: $where, sort: $sort) {
    nodes {
      ...MySpaceCardTask
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
    totalCount
  }
}
    ${MySpaceCardTaskFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OwnCardsTasksGQL extends Apollo.Query<OwnCardsTasksQuery, OwnCardsTasksQueryVariables> {
    document = OwnCardsTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OwnCardTaskByIdDocument = gql`
    query OwnCardTaskById($id: String!) {
  cardTask(id: $id) {
    ...MySpaceCardTask
  }
}
    ${MySpaceCardTaskFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OwnCardTaskByIdGQL extends Apollo.Query<OwnCardTaskByIdQuery, OwnCardTaskByIdQueryVariables> {
    document = OwnCardTaskByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetModalCardTaskDocument = gql`
    query GetModalCardTask($id: String!) {
  cardTask(id: $id) {
    id
    priority
    status
    title
    dueAt
    description
    createdBy {
      id
      name
    }
    completedAt
    createdAt
    stage {
      name
      color
    }
    card {
      id
      name
      currentStage {
        name
        color
      }
      pipe {
        id
        name
      }
    }
    assignees {
      user {
        id
        name
        avatarUrl
      }
    }
    labels {
      id
      name
      color
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetModalCardTaskGQL extends Apollo.Query<GetModalCardTaskQuery, GetModalCardTaskQueryVariables> {
    document = GetModalCardTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardTaskFilterPipesDocument = gql`
    query GetCardTaskFilterPipes($filters: PaginatedPipeFilters) {
  pipes(filters: $filters) {
    nodes {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardTaskFilterPipesGQL extends Apollo.Query<GetCardTaskFilterPipesQuery, GetCardTaskFilterPipesQueryVariables> {
    document = GetCardTaskFilterPipesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardTaskFilterPipeDocument = gql`
    query GetCardTaskFilterPipe($pipeId: ID!) {
  pipe(pipeId: $pipeId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardTaskFilterPipeGQL extends Apollo.Query<GetCardTaskFilterPipeQuery, GetCardTaskFilterPipeQueryVariables> {
    document = GetCardTaskFilterPipeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCardTaskFilterStagesDocument = gql`
    query GetCardTaskFilterStages($params: StagesParamsInput!) {
  stages(params: $params) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCardTaskFilterStagesGQL extends Apollo.Query<GetCardTaskFilterStagesQuery, GetCardTaskFilterStagesQueryVariables> {
    document = GetCardTaskFilterStagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationUserPreferencesDocument = gql`
    query GetNotificationUserPreferences {
  notificationUserPreferences {
    id
    preferences {
      ...NotificationPreferencesFragment
    }
    user {
      id
    }
  }
}
    ${NotificationPreferencesFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationUserPreferencesGQL extends Apollo.Query<GetNotificationUserPreferencesQuery, GetNotificationUserPreferencesQueryVariables> {
    document = GetNotificationUserPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationUserPreferenceDocument = gql`
    mutation UpdateNotificationUserPreference($input: UpdateNotificationUserPreferenceDto!) {
  updateNotificationUserPreference(input: $input) {
    id
    preferences {
      ...NotificationPreferencesFragment
    }
    user {
      id
    }
  }
}
    ${NotificationPreferencesFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationUserPreferenceGQL extends Apollo.Mutation<UpdateNotificationUserPreferenceMutation, UpdateNotificationUserPreferenceMutationVariables> {
    document = UpdateNotificationUserPreferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationPipePreferencesDocument = gql`
    query GetNotificationPipePreferences($pipeId: String!) {
  notificationPipePreferences(pipeId: $pipeId) {
    id
    starred
    enabled
    pipe {
      name
    }
    preferences {
      ...NotificationPreferencesFragment
    }
    user {
      id
    }
  }
}
    ${NotificationPreferencesFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationPipePreferencesGQL extends Apollo.Query<GetNotificationPipePreferencesQuery, GetNotificationPipePreferencesQueryVariables> {
    document = GetNotificationPipePreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNotificationPipePreferenceDocument = gql`
    mutation CreateNotificationPipePreference($input: CreateNotificationPipePreferenceDto!) {
  createNotificationPipePreference(input: $input) {
    id
    pipe {
      name
    }
    preferences {
      ...NotificationPreferencesFragment
    }
    user {
      id
    }
  }
}
    ${NotificationPreferencesFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNotificationPipePreferenceGQL extends Apollo.Mutation<CreateNotificationPipePreferenceMutation, CreateNotificationPipePreferenceMutationVariables> {
    document = CreateNotificationPipePreferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationPipePreferenceDocument = gql`
    mutation UpdateNotificationPipePreference($input: UpdateNotificationPipePreferenceDto!) {
  updateNotificationPipePreference(input: $input) {
    id
    pipe {
      name
    }
    preferences {
      ...NotificationPreferencesFragment
    }
    user {
      id
    }
  }
}
    ${NotificationPreferencesFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationPipePreferenceGQL extends Apollo.Mutation<UpdateNotificationPipePreferenceMutation, UpdateNotificationPipePreferenceMutationVariables> {
    document = UpdateNotificationPipePreferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationPipesDocument = gql`
    query GetNotificationPipes($nextCursor: String, $search: String) {
  notificationPipes(nextCursor: $nextCursor, search: $search) {
    totalCount
    endCursor
    edges {
      id
      name
      description
      icon
      notificationPreferences {
        id
        enabled
        starred
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationPipesGQL extends Apollo.Query<GetNotificationPipesQuery, GetNotificationPipesQueryVariables> {
    document = GetNotificationPipesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationStarredPipesDocument = gql`
    query GetNotificationStarredPipes($filters: PaginatedPipeFilters) {
  pipes(filters: $filters) {
    nodes {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationStarredPipesGQL extends Apollo.Query<GetNotificationStarredPipesQuery, GetNotificationStarredPipesQueryVariables> {
    document = GetNotificationStarredPipesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationsDocument = gql`
    query Notifications($where: NotificationWhereInput, $skip: Int, $take: Int) {
  notifications(where: $where, skip: $skip, take: $take) {
    items {
      createdAt
      id
      data
      favoritedAt
      readAt
      tags
      type
      updatedAt
      userId
      accountId
      notificationData {
        id
        comment
        ipAddress
        userAgent
        pipe {
          id
          name
        }
        card {
          id
          name
        }
        previousStage {
          id
          name
        }
        currentStage {
          id
          name
        }
        review {
          id
        }
        task {
          id
          title
          status
        }
        assignedBy {
          ... on User {
            id
            name
            avatarUrl
          }
          ... on StringValue {
            value
          }
        }
        commentedBy {
          ... on User {
            id
            name
            avatarUrl
          }
          ... on StringValue {
            value
          }
        }
        createdBy {
          ... on User {
            id
            name
            avatarUrl
          }
          ... on StringValue {
            value
          }
        }
        actionTakenBy {
          ... on User {
            id
            name
            avatarUrl
          }
          ... on StringValue {
            value
          }
        }
        timestamp
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationsGQL extends Apollo.Query<NotificationsQuery, NotificationsQueryVariables> {
    document = NotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationDocument = gql`
    mutation UpdateNotification($id: String!, $input: UpdateNotificationInput!) {
  updateNotification(id: $id, input: $input) {
    id
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationGQL extends Apollo.Mutation<UpdateNotificationMutation, UpdateNotificationMutationVariables> {
    document = UpdateNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationsCountDocument = gql`
    query NotificationsCount {
  userNotifications {
    count
    countFavorites
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationsCountGQL extends Apollo.Query<NotificationsCountQuery, NotificationsCountQueryVariables> {
    document = NotificationsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
  requestPasswordReset(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestPasswordResetGQL extends Apollo.Mutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables> {
    document = RequestPasswordResetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmPasswordResetDocument = gql`
    mutation ConfirmPasswordReset($input: ConfirmPasswordResetInput!) {
  confirmPasswordReset(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmPasswordResetGQL extends Apollo.Mutation<ConfirmPasswordResetMutation, ConfirmPasswordResetMutationVariables> {
    document = ConfirmPasswordResetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPublicFormDocument = gql`
    query GetPublicForm($hashedId: String!) {
  publicForm(hashedId: $hashedId) {
    id
    name
    questions {
      ...FormQuestionFields
    }
    questionsCount
    pipe {
      id
      name
      description
      color
      account {
        id
        name
      }
    }
  }
}
    ${FormQuestionFieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPublicFormGQL extends Apollo.Query<GetPublicFormQuery, GetPublicFormQueryVariables> {
    document = GetPublicFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicCreateCardDocument = gql`
    mutation PublicCreateCard($input: CreateCardInput!) {
  publicCreateCard(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicCreateCardGQL extends Apollo.Mutation<PublicCreateCardMutation, PublicCreateCardMutationVariables> {
    document = PublicCreateCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicPreSignedPostDocument = gql`
    query PublicPreSignedPost($input: GetPublicPreSignedPostInput!) {
  publicPresignedPost(input: $input) {
    fields
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicPreSignedPostGQL extends Apollo.Query<PublicPreSignedPostQuery, PublicPreSignedPostQueryVariables> {
    document = PublicPreSignedPostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($token: String!, $name: String, $password: String) {
  acceptInvite(token: $token, name: $name, password: $password) {
    ...AuthenticatedUserFields
  }
}
    ${AuthenticatedUserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptInviteGQL extends Apollo.Mutation<AcceptInviteMutation, AcceptInviteMutationVariables> {
    document = AcceptInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInviteByTokenDocument = gql`
    query GetInviteByToken($token: String!) {
  getInviteByToken(token: $token) {
    id
    email
    account {
      name
    }
    acceptedAt
    status
    canUsePassword
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInviteByTokenGQL extends Apollo.Query<GetInviteByTokenQuery, GetInviteByTokenQueryVariables> {
    document = GetInviteByTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicCardStageFormLinkDocument = gql`
    query PublicCardStageFormLink($hash: String!) {
  publicCardStageFormLink(hash: $hash) {
    stage {
      id
      name
      pipe {
        id
        name
        color
        account {
          id
          name
        }
      }
      form {
        name
      }
    }
    isRequiredAuthenticated
    isEditable
    customMessage
    expiredAt
    answeredAt
    answeredBy
    email
    publicLink
    fields {
      ...Fields
    }
  }
}
    ${FieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicCardStageFormLinkGQL extends Apollo.Query<PublicCardStageFormLinkQuery, PublicCardStageFormLinkQueryVariables> {
    document = PublicCardStageFormLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicCardTaskFormLinkDocument = gql`
    query PublicCardTaskFormLink($hash: String!) {
  publicCardTaskFormLink(hash: $hash) {
    task {
      title
    }
    card {
      name
    }
    pipe {
      id
      name
      color
    }
    account {
      name
    }
    fields {
      createdAt
      id
      key
      name
      type
      orientationMessage
      position
      required
      updatedAt
      value
      values
      options {
        label
      }
      conditions {
        dependsOnField {
          key
        }
        operator
        expectedValueString
      }
    }
    isRequiredAuthenticated
    isEditable
    customMessage
    expiredAt
    answeredAt
    answeredBy
    email
    publicLink
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicCardTaskFormLinkGQL extends Apollo.Query<PublicCardTaskFormLinkQuery, PublicCardTaskFormLinkQueryVariables> {
    document = PublicCardTaskFormLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicSendCardStageAuthLinkDocument = gql`
    mutation PublicSendCardStageAuthLink($hash: String!, $email: String!) {
  publicSendCardStageAuthLink(hash: $hash, email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicSendCardStageAuthLinkGQL extends Apollo.Mutation<PublicSendCardStageAuthLinkMutation, PublicSendCardStageAuthLinkMutationVariables> {
    document = PublicSendCardStageAuthLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicSendCardTaskAuthLinkDocument = gql`
    mutation PublicSendCardTaskAuthLink($hash: String!, $email: String!) {
  publicSendCardTaskAuthLink(hash: $hash, email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicSendCardTaskAuthLinkGQL extends Apollo.Mutation<PublicSendCardTaskAuthLinkMutation, PublicSendCardTaskAuthLinkMutationVariables> {
    document = PublicSendCardTaskAuthLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicAnswerCardStageFormDocument = gql`
    mutation PublicAnswerCardStageForm($hash: String!, $fields: [UpdateFieldInput!]!) {
  publicAnswerCardStageForm(hash: $hash, fields: $fields)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicAnswerCardStageFormGQL extends Apollo.Mutation<PublicAnswerCardStageFormMutation, PublicAnswerCardStageFormMutationVariables> {
    document = PublicAnswerCardStageFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicAnswerCardTaskFormDocument = gql`
    mutation PublicAnswerCardTaskForm($hash: String!, $fields: [AnswerCardTaskFieldInput!]!) {
  publicAnswerCardTaskForm(hash: $hash, fields: $fields)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicAnswerCardTaskFormGQL extends Apollo.Mutation<PublicAnswerCardTaskFormMutation, PublicAnswerCardTaskFormMutationVariables> {
    document = PublicAnswerCardTaskFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountFeatureBySlugDocument = gql`
    query AccountFeatureBySlug($slug: FeatureSlug!, $take: Int) {
  accountFeatureBySlug(slug: $slug) {
    id
    contractedPriceCents
    licenseLimit
    feature {
      slug
      entityType
    }
    usageRecords(take: $take) {
      totalCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountFeatureBySlugGQL extends Apollo.Query<AccountFeatureBySlugQuery, AccountFeatureBySlugQueryVariables> {
    document = AccountFeatureBySlugDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateInviteEmailDocument = gql`
    query ValidateInviteEmail($email: String!) {
  validateInviteEmail(email: $email) {
    isValid
    reason
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateInviteEmailGQL extends Apollo.Query<ValidateInviteEmailQuery, ValidateInviteEmailQueryVariables> {
    document = ValidateInviteEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserInviteDocument = gql`
    mutation CreateUserInvite($input: CreateUserInviteInput!) {
  createUserInvite(input: $input) {
    id
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserInviteGQL extends Apollo.Mutation<CreateUserInviteMutation, CreateUserInviteMutationVariables> {
    document = CreateUserInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetUserRoleDocument = gql`
    mutation SetUserRole($roleType: RoleTypeEnum!, $userId: String!, $roleEntityContext: RoleEntityContextInput) {
  setUserRole(
    roleType: $roleType
    userId: $userId
    roleEntityContext: $roleEntityContext
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetUserRoleGQL extends Apollo.Mutation<SetUserRoleMutation, SetUserRoleMutationVariables> {
    document = SetUserRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserLicenseTypeDocument = gql`
    mutation UpdateUserLicenseType($input: UpdateUserLicenseInput!) {
  updateUserLicenseType(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserLicenseTypeGQL extends Apollo.Mutation<UpdateUserLicenseTypeMutation, UpdateUserLicenseTypeMutationVariables> {
    document = UpdateUserLicenseTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserInvitesDocument = gql`
    query GetUserInvites($where: UserInviteWhereInput, $skip: Int, $take: Int, $sortOrder: GetUsersInvitesSortOrderInput) {
  getUserInvites(where: $where, skip: $skip, take: $take, sortOrder: $sortOrder) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      id
      email
      status
      acceptedAt
      createdBy {
        id
        name
        avatarUrl
      }
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserInvitesGQL extends Apollo.Query<GetUserInvitesQuery, GetUserInvitesQueryVariables> {
    document = GetUserInvitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendUserInviteDocument = gql`
    mutation ResendUserInvite($id: String!) {
  resendUserInvite(id: $id) {
    id
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendUserInviteGQL extends Apollo.Mutation<ResendUserInviteMutation, ResendUserInviteMutationVariables> {
    document = ResendUserInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserStatisticsForLicenseDocument = gql`
    query UserStatisticsForLicense($userId: ID!) {
  userStatisticsForLicense(userId: $userId) {
    id
    pipesWhereRoleIsAboveReader
    userGlobalRole
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserStatisticsForLicenseGQL extends Apollo.Query<UserStatisticsForLicenseQuery, UserStatisticsForLicenseQueryVariables> {
    document = UserStatisticsForLicenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignInDocument = gql`
    mutation SignIn($input: SignInInput!) {
  signIn(input: $input) {
    ...AuthenticatedUserFields
  }
}
    ${AuthenticatedUserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SignInGQL extends Apollo.Mutation<SignInMutation, SignInMutationVariables> {
    document = SignInDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignInWithSecondStepDocument = gql`
    mutation SignInWithSecondStep($input: SignInWithSecondStepInput!) {
  signInWithSecondStep(input: $input) {
    ...AuthenticatedUserFields
  }
}
    ${AuthenticatedUserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SignInWithSecondStepGQL extends Apollo.Mutation<SignInWithSecondStepMutation, SignInWithSecondStepMutationVariables> {
    document = SignInWithSecondStepDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshAuthRoleDocument = gql`
    query RefreshAuthRole($roleEntityContext: RoleEntityContextInput) {
  refreshAuthRole(roleEntityContext: $roleEntityContext) {
    globalRole {
      id
      name
      type
      permissions {
        nodes {
          id
          scope
        }
      }
    }
    pipeRole {
      id
      name
      type
      permissions {
        nodes {
          id
          scope
        }
      }
    }
    databaseRole {
      id
      name
      type
      permissions {
        nodes {
          id
          scope
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshAuthRoleGQL extends Apollo.Query<RefreshAuthRoleQuery, RefreshAuthRoleQueryVariables> {
    document = RefreshAuthRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplatesDeadlinesDocument = gql`
    query TemplatesDeadlines($take: Int, $skip: Int, $pipeId: ID!, $searchTerm: String) {
  templatesDeadlines(
    take: $take
    skip: $skip
    pipeId: $pipeId
    searchTerm: $searchTerm
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ... on TemplateDeadline {
        id
        name
        description
        type
        considerHoliday
        deadlineMinutes
        deadlineDisplayUnit
        deadlineRiskMinutes
        deadlineRiskDisplayUnit
        hasOfficeHours
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplatesDeadlinesGQL extends Apollo.Query<TemplatesDeadlinesQuery, TemplatesDeadlinesQueryVariables> {
    document = TemplatesDeadlinesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplateTaskDocument = gql`
    query TemplateTask($templateId: ID!) {
  templateTask(id: $templateId) {
    ... on TemplateTask {
      assignees {
        id
        name
        email
        avatarUrl
      }
      description
      id
      name
      pipeId
      priority
      status
      timeToDueUnit
      timeToDueValue
      timeToDueFlags
      type
      requiredCommentToFinish
      labels {
        id
        name
        color
      }
    }
    fields {
      id
      key
      name
      orientationMessage
      helpText
      schema
      position
      required
      type
      options {
        label
      }
      conditions {
        dependsOnField {
          key
        }
        operator
        expectedValueString
      }
      database {
        ...SharedFieldDatabaseFields
      }
    }
  }
}
    ${SharedFieldDatabaseFieldsFragmentDoc}
${SharedFieldDatabaseFilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateTaskGQL extends Apollo.Query<TemplateTaskQuery, TemplateTaskQueryVariables> {
    document = TemplateTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttachTemplatesToStageDocument = gql`
    mutation AttachTemplatesToStage($stageId: ID!, $templatesIds: [ID!]!, $parentId: ID) {
  attachTemplatesToStage(
    stageId: $stageId
    templatesIds: $templatesIds
    parentId: $parentId
  ) {
    ...TemplateFragment
  }
}
    ${TemplateFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AttachTemplatesToStageGQL extends Apollo.Mutation<AttachTemplatesToStageMutation, AttachTemplatesToStageMutationVariables> {
    document = AttachTemplatesToStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DetachTemplatesFromStageDocument = gql`
    mutation DetachTemplatesFromStage($templateId: ID!, $stageId: ID!) {
  detachTemplateFromStage(templateId: $templateId, stageId: $stageId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DetachTemplatesFromStageGQL extends Apollo.Mutation<DetachTemplatesFromStageMutation, DetachTemplatesFromStageMutationVariables> {
    document = DetachTemplatesFromStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllTemplatesIdsByStageIdDocument = gql`
    query AllTemplatesIdsByStageId($stageId: ID!) {
  allTemplatesIdsByStage(stageId: $stageId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllTemplatesIdsByStageIdGQL extends Apollo.Query<AllTemplatesIdsByStageIdQuery, AllTemplatesIdsByStageIdQueryVariables> {
    document = AllTemplatesIdsByStageIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MenuCardMoveDocument = gql`
    query MenuCardMove($cardId: ID!) {
  card(id: $cardId) {
    id
    pipe {
      id
    }
    currentStage {
      id
      name
      index
      cardsCanBeMovedToStages {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MenuCardMoveGQL extends Apollo.Query<MenuCardMoveQuery, MenuCardMoveQueryVariables> {
    document = MenuCardMoveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CardsCommentsDocument = gql`
    query CardsComments($filters: PaginatedCardCommentFilters!, $attachmentsFilters: PaginatedCardAttachmentFilters!, $skip: Int, $take: Int, $sorts: PaginatedCardCommentSortOrderInput) {
  cardsComments(filters: $filters, take: $take, sorts: $sorts, skip: $skip) {
    nodes {
      user {
        avatarUrl
        name
        createdAt
        updatedAt
        id
      }
      id
      createdAt
      updatedAt
      content
      attachments(filters: $attachmentsFilters, take: 5, skip: 0) {
        nodes {
          createdAt
          extension
          id
          name
          path
          preSignedUrl
          entityType
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CardsCommentsGQL extends Apollo.Query<CardsCommentsQuery, CardsCommentsQueryVariables> {
    document = CardsCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCardCommentDocument = gql`
    mutation CreateCardComment($input: CreateCardCommentInput!) {
  createCardComment(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCardCommentGQL extends Apollo.Mutation<CreateCardCommentMutation, CreateCardCommentMutationVariables> {
    document = CreateCardCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCardCommentAttachmentDocument = gql`
    mutation CreateCardCommentAttachment($input: CreateCardCommentAttachmentInput!) {
  createCardCommentAttachment(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCardCommentAttachmentGQL extends Apollo.Mutation<CreateCardCommentAttachmentMutation, CreateCardCommentAttachmentMutationVariables> {
    document = CreateCardCommentAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCardCommentDocument = gql`
    mutation UpdateCardComment($input: UpdateCardCommentInput!) {
  updateCardComment(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCardCommentGQL extends Apollo.Mutation<UpdateCardCommentMutation, UpdateCardCommentMutationVariables> {
    document = UpdateCardCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCardCommentAttachmentDocument = gql`
    mutation RemoveCardCommentAttachment($input: RemoveCardCommentAttachmentInput!) {
  removeCardCommentAttachment(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCardCommentAttachmentGQL extends Apollo.Mutation<RemoveCardCommentAttachmentMutation, RemoveCardCommentAttachmentMutationVariables> {
    document = RemoveCardCommentAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }